(() => {
  var nu = Object.defineProperty, su = Object.defineProperties;
  var ru = Object.getOwnPropertyDescriptors;
  var wo = Object.getOwnPropertySymbols;
  var ou = Object.prototype.hasOwnProperty, au = Object.prototype.propertyIsEnumerable;
  var Me = Math.pow, Ss = (e, t, i) => t in e ? nu(e, t, { enumerable: true, configurable: true, writable: true, value: i }) : e[t] = i, Ae = (e, t) => {
    for (var i in t || (t = {})) ou.call(t, i) && Ss(e, i, t[i]);
    if (wo) for (var i of wo(t)) au.call(t, i) && Ss(e, i, t[i]);
    return e;
  }, bi = (e, t) => su(e, ru(t));
  var ie = (e, t, i) => Ss(e, typeof t != "symbol" ? t + "" : t, i);
  function lu(e, t) {
    if (typeof e == "undefined" || !e.document) throw new Error("jQuery requires a window with a document");
    var i = [], n = Object.getPrototypeOf, r = i.slice, o = i.flat ? function(s) {
      return i.flat.call(s);
    } : function(s) {
      return i.concat.apply([], s);
    }, c = i.push, u = i.indexOf, l = {}, m = l.toString, v = l.hasOwnProperty, y = v.toString, E = y.call(Object), h = {};
    function g(s) {
      return s == null ? s + "" : typeof s == "object" ? l[m.call(s)] || "object" : typeof s;
    }
    function C(s) {
      return s != null && s === s.window;
    }
    function _(s) {
      var a = !!s && s.length, d = g(s);
      return typeof s == "function" || C(s) ? false : d === "array" || a === 0 || typeof a == "number" && a > 0 && a - 1 in s;
    }
    var p = e.document, S = { type: true, src: true, nonce: true, noModule: true };
    function w(s, a, d) {
      d = d || p;
      var b, T = d.createElement("script");
      T.text = s;
      for (b in S) a && a[b] && (T[b] = a[b]);
      d.head.appendChild(T).parentNode && T.parentNode.removeChild(T);
    }
    var I = "4.0.0", L = /HTML$/i, f = function(s, a) {
      return new f.fn.init(s, a);
    };
    f.fn = f.prototype = { jquery: I, constructor: f, length: 0, toArray: function() {
      return r.call(this);
    }, get: function(s) {
      return s == null ? r.call(this) : s < 0 ? this[s + this.length] : this[s];
    }, pushStack: function(s) {
      var a = f.merge(this.constructor(), s);
      return a.prevObject = this, a;
    }, each: function(s) {
      return f.each(this, s);
    }, map: function(s) {
      return this.pushStack(f.map(this, function(a, d) {
        return s.call(a, d, a);
      }));
    }, slice: function() {
      return this.pushStack(r.apply(this, arguments));
    }, first: function() {
      return this.eq(0);
    }, last: function() {
      return this.eq(-1);
    }, even: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return (a + 1) % 2;
      }));
    }, odd: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return a % 2;
      }));
    }, eq: function(s) {
      var a = this.length, d = +s + (s < 0 ? a : 0);
      return this.pushStack(d >= 0 && d < a ? [this[d]] : []);
    }, end: function() {
      return this.prevObject || this.constructor();
    } }, f.extend = f.fn.extend = function() {
      var s, a, d, b, T, x, A = arguments[0] || {}, M = 1, O = arguments.length, z = false;
      for (typeof A == "boolean" && (z = A, A = arguments[M] || {}, M++), typeof A != "object" && typeof A != "function" && (A = {}), M === O && (A = this, M--); M < O; M++) if ((s = arguments[M]) != null) for (a in s) b = s[a], !(a === "__proto__" || A === b) && (z && b && (f.isPlainObject(b) || (T = Array.isArray(b))) ? (d = A[a], T && !Array.isArray(d) ? x = [] : !T && !f.isPlainObject(d) ? x = {} : x = d, T = false, A[a] = f.extend(z, x, b)) : b !== void 0 && (A[a] = b));
      return A;
    }, f.extend({ expando: "jQuery" + (I + Math.random()).replace(/\D/g, ""), isReady: true, error: function(s) {
      throw new Error(s);
    }, noop: function() {
    }, isPlainObject: function(s) {
      var a, d;
      return !s || m.call(s) !== "[object Object]" ? false : (a = n(s), a ? (d = v.call(a, "constructor") && a.constructor, typeof d == "function" && y.call(d) === E) : true);
    }, isEmptyObject: function(s) {
      var a;
      for (a in s) return false;
      return true;
    }, globalEval: function(s, a, d) {
      w(s, { nonce: a && a.nonce }, d);
    }, each: function(s, a) {
      var d, b = 0;
      if (_(s)) for (d = s.length; b < d && a.call(s[b], b, s[b]) !== false; b++) ;
      else for (b in s) if (a.call(s[b], b, s[b]) === false) break;
      return s;
    }, text: function(s) {
      var a, d = "", b = 0, T = s.nodeType;
      if (!T) for (; a = s[b++]; ) d += f.text(a);
      return T === 1 || T === 11 ? s.textContent : T === 9 ? s.documentElement.textContent : T === 3 || T === 4 ? s.nodeValue : d;
    }, makeArray: function(s, a) {
      var d = a || [];
      return s != null && (_(Object(s)) ? f.merge(d, typeof s == "string" ? [s] : s) : c.call(d, s)), d;
    }, inArray: function(s, a, d) {
      return a == null ? -1 : u.call(a, s, d);
    }, isXMLDoc: function(s) {
      var a = s && s.namespaceURI, d = s && (s.ownerDocument || s).documentElement;
      return !L.test(a || d && d.nodeName || "HTML");
    }, contains: function(s, a) {
      var d = a && a.parentNode;
      return s === d || !!(d && d.nodeType === 1 && (s.contains ? s.contains(d) : s.compareDocumentPosition && s.compareDocumentPosition(d) & 16));
    }, merge: function(s, a) {
      for (var d = +a.length, b = 0, T = s.length; b < d; b++) s[T++] = a[b];
      return s.length = T, s;
    }, grep: function(s, a, d) {
      for (var b, T = [], x = 0, A = s.length, M = !d; x < A; x++) b = !a(s[x], x), b !== M && T.push(s[x]);
      return T;
    }, map: function(s, a, d) {
      var b, T, x = 0, A = [];
      if (_(s)) for (b = s.length; x < b; x++) T = a(s[x], x, d), T != null && A.push(T);
      else for (x in s) T = a(s[x], x, d), T != null && A.push(T);
      return o(A);
    }, guid: 1, support: h }), typeof Symbol == "function" && (f.fn[Symbol.iterator] = i[Symbol.iterator]), f.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(s, a) {
      l["[object " + a + "]"] = a.toLowerCase();
    });
    function P(s, a) {
      return s.nodeName && s.nodeName.toLowerCase() === a.toLowerCase();
    }
    var D = i.pop, R = "[\\x20\\t\\r\\n\\f]", N = p.documentMode, $ = N && new RegExp(":enabled|:disabled|\\[" + R + "*name" + R + "*=" + R + `*(?:''|"")`), V = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"), B = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", X = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), Z = new RegExp(R + "|>"), F = /[+~]/, W = p.documentElement, Y = W.matches || W.msMatchesSelector;
    function J() {
      var s = [];
      function a(d, b) {
        return s.push(d + " ") > f.expr.cacheLength && delete a[s.shift()], a[d + " "] = b;
      }
      return a;
    }
    function oe(s) {
      return s && typeof s.getElementsByTagName != "undefined" && s;
    }
    var he = "\\[" + R + "*(" + B + ")(?:" + R + "*([*^$|!~]?=)" + R + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + B + "))|)" + R + "*\\]", _e = ":(" + B + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + he + ")*)|.*)\\)|)", Ee = { ID: new RegExp("^#(" + B + ")"), CLASS: new RegExp("^\\.(" + B + ")"), TAG: new RegExp("^(" + B + "|[*])"), ATTR: new RegExp("^" + he), PSEUDO: new RegExp("^" + _e), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i") }, U = new RegExp(_e), Q = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])", "g"), ee = function(s, a) {
      var d = "0x" + s.slice(1) - 65536;
      return a || (d < 0 ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, d & 1023 | 56320));
    };
    function K(s) {
      return s.replace(Q, ee);
    }
    function se(s) {
      f.error("Syntax error, unrecognized expression: " + s);
    }
    var Se = new RegExp("^" + R + "*," + R + "*"), Ge = J();
    function Ce(s, a) {
      var d, b, T, x, A, M, O, z = Ge[s + " "];
      if (z) return a ? 0 : z.slice(0);
      for (A = s, M = [], O = f.expr.preFilter; A; ) {
        (!d || (b = Se.exec(A))) && (b && (A = A.slice(b[0].length) || A), M.push(T = [])), d = false, (b = X.exec(A)) && (d = b.shift(), T.push({ value: d, type: b[0].replace(V, " ") }), A = A.slice(d.length));
        for (x in Ee) (b = f.expr.match[x].exec(A)) && (!O[x] || (b = O[x](b))) && (d = b.shift(), T.push({ value: d, type: x, matches: b }), A = A.slice(d.length));
        if (!d) break;
      }
      return a ? A.length : A ? se(s) : Ge(s, M).slice(0);
    }
    var Ze = { ATTR: function(s) {
      return s[1] = K(s[1]), s[3] = K(s[3] || s[4] || s[5] || ""), s[2] === "~=" && (s[3] = " " + s[3] + " "), s.slice(0, 4);
    }, CHILD: function(s) {
      return s[1] = s[1].toLowerCase(), s[1].slice(0, 3) === "nth" ? (s[3] || se(s[0]), s[4] = +(s[4] ? s[5] + (s[6] || 1) : 2 * (s[3] === "even" || s[3] === "odd")), s[5] = +(s[7] + s[8] || s[3] === "odd")) : s[3] && se(s[0]), s;
    }, PSEUDO: function(s) {
      var a, d = !s[6] && s[2];
      return Ee.CHILD.test(s[0]) ? null : (s[3] ? s[2] = s[4] || s[5] || "" : d && U.test(d) && (a = Ce(d, true)) && (a = d.indexOf(")", d.length - a) - d.length) && (s[0] = s[0].slice(0, a), s[2] = d.slice(0, a)), s.slice(0, 3));
    } };
    function ge(s) {
      for (var a = 0, d = s.length, b = ""; a < d; a++) b += s[a].value;
      return b;
    }
    function be(s, a, d, b, T, x, A) {
      var M = 0, O = s.length, z = d == null;
      if (g(d) === "object") {
        T = true;
        for (M in d) be(s, a, M, d[M], true, x, A);
      } else if (b !== void 0 && (T = true, typeof b != "function" && (A = true), z && (A ? (a.call(s, b), a = null) : (z = a, a = function(H, j, k) {
        return z.call(f(H), k);
      })), a)) for (; M < O; M++) a(s[M], d, A ? b : b.call(s[M], M, a(s[M], d)));
      return T ? s : z ? a.call(s) : O ? a(s[0], d) : x;
    }
    var Oe = /[^\x20\t\r\n\f]+/g;
    f.fn.extend({ attr: function(s, a) {
      return be(this, f.attr, s, a, arguments.length > 1);
    }, removeAttr: function(s) {
      return this.each(function() {
        f.removeAttr(this, s);
      });
    } }), f.extend({ attr: function(s, a, d) {
      var b, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) {
        if (typeof s.getAttribute == "undefined") return f.prop(s, a, d);
        if ((x !== 1 || !f.isXMLDoc(s)) && (T = f.attrHooks[a.toLowerCase()]), d !== void 0) {
          if (d === null || d === false && a.toLowerCase().indexOf("aria-") !== 0) {
            f.removeAttr(s, a);
            return;
          }
          return T && "set" in T && (b = T.set(s, d, a)) !== void 0 ? b : (s.setAttribute(a, d), d);
        }
        return T && "get" in T && (b = T.get(s, a)) !== null ? b : (b = s.getAttribute(a), b == null ? void 0 : b);
      }
    }, attrHooks: {}, removeAttr: function(s, a) {
      var d, b = 0, T = a && a.match(Oe);
      if (T && s.nodeType === 1) for (; d = T[b++]; ) s.removeAttribute(d);
    } }), N && (f.attrHooks.type = { set: function(s, a) {
      if (a === "radio" && P(s, "input")) {
        var d = s.value;
        return s.setAttribute("type", a), d && (s.value = d), a;
      }
    } });
    var Et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function st(s, a) {
      return a ? s === "\0" ? "�" : s.slice(0, -1) + "\\" + s.charCodeAt(s.length - 1).toString(16) + " " : "\\" + s;
    }
    f.escapeSelector = function(s) {
      return (s + "").replace(Et, st);
    };
    var dt = i.sort, Lt = i.splice, De;
    function ft(s, a) {
      if (s === a) return De = true, 0;
      var d = !s.compareDocumentPosition - !a.compareDocumentPosition;
      return d || (d = (s.ownerDocument || s) == (a.ownerDocument || a) ? s.compareDocumentPosition(a) : 1, d & 1 ? s == p || s.ownerDocument == p && f.contains(p, s) ? -1 : a == p || a.ownerDocument == p && f.contains(p, a) ? 1 : 0 : d & 4 ? -1 : 1);
    }
    f.uniqueSort = function(s) {
      var a, d = [], b = 0, T = 0;
      if (De = false, dt.call(s, ft), De) {
        for (; a = s[T++]; ) a === s[T] && (b = d.push(T));
        for (; b--; ) Lt.call(s, d[b], 1);
      }
      return s;
    }, f.fn.uniqueSort = function() {
      return this.pushStack(f.uniqueSort(r.apply(this)));
    };
    var je, rt, Te, St, we, $e = 0, ht = 0, Dr = J(), zr = J(), an = J(), ec = new RegExp(R + "+", "g"), tc = new RegExp("^" + B + "$"), $r = f.extend({ needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i") }, Ee), ic = /^(?:input|select|textarea|button)$/i, nc = /^h\d$/i, sc = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rc = function() {
      li();
    }, oc = ln(function(s) {
      return s.disabled === true && P(s, "fieldset");
    }, { dir: "parentNode", next: "legend" });
    function ot(s, a, d, b) {
      var T, x, A, M, O, z, H, j = a && a.ownerDocument, k = a ? a.nodeType : 9;
      if (d = d || [], typeof s != "string" || !s || k !== 1 && k !== 9 && k !== 11) return d;
      if (!b && (li(a), a = a || Te, we)) {
        if (k !== 11 && (O = sc.exec(s))) if (T = O[1]) {
          if (k === 9) return (A = a.getElementById(T)) && c.call(d, A), d;
          if (j && (A = j.getElementById(T)) && f.contains(a, A)) return c.call(d, A), d;
        } else {
          if (O[2]) return c.apply(d, a.getElementsByTagName(s)), d;
          if ((T = O[3]) && a.getElementsByClassName) return c.apply(d, a.getElementsByClassName(T)), d;
        }
        if (!an[s + " "] && (!$ || !$.test(s))) {
          if (H = s, j = a, k === 1 && (Z.test(s) || X.test(s))) {
            for (j = F.test(s) && oe(a.parentNode) || a, (j != a || N) && ((M = a.getAttribute("id")) ? M = f.escapeSelector(M) : a.setAttribute("id", M = f.expando)), z = Ce(s), x = z.length; x--; ) z[x] = (M ? "#" + M : ":scope") + " " + ge(z[x]);
            H = z.join(",");
          }
          try {
            return c.apply(d, j.querySelectorAll(H)), d;
          } catch (G) {
            an(s, true);
          } finally {
            M === f.expando && a.removeAttribute("id");
          }
        }
      }
      return Rr(s.replace(V, "$1"), a, d, b);
    }
    function pt(s) {
      return s[f.expando] = true, s;
    }
    function ac(s) {
      return function(a) {
        return P(a, "input") && a.type === s;
      };
    }
    function lc(s) {
      return function(a) {
        return (P(a, "input") || P(a, "button")) && a.type === s;
      };
    }
    function Nr(s) {
      return function(a) {
        return "form" in a ? a.parentNode && a.disabled === false ? "label" in a ? "label" in a.parentNode ? a.parentNode.disabled === s : a.disabled === s : a.isDisabled === s || a.isDisabled !== !s && oc(a) === s : a.disabled === s : "label" in a ? a.disabled === s : false;
      };
    }
    function jt(s) {
      return pt(function(a) {
        return a = +a, pt(function(d, b) {
          for (var T, x = s([], d.length, a), A = x.length; A--; ) d[T = x[A]] && (d[T] = !(b[T] = d[T]));
        });
      });
    }
    function li(s) {
      var a, d = s ? s.ownerDocument || s : p;
      d == Te || d.nodeType !== 9 || (Te = d, St = Te.documentElement, we = !f.isXMLDoc(Te), N && p != Te && (a = Te.defaultView) && a.top !== a && a.addEventListener("unload", rc));
    }
    ot.matches = function(s, a) {
      return ot(s, null, null, a);
    }, ot.matchesSelector = function(s, a) {
      if (li(s), we && !an[a + " "] && (!$ || !$.test(a))) try {
        return Y.call(s, a);
      } catch (d) {
        an(a, true);
      }
      return ot(a, Te, null, [s]).length > 0;
    }, f.expr = { cacheLength: 50, createPseudo: pt, match: $r, find: { ID: function(s, a) {
      if (typeof a.getElementById != "undefined" && we) {
        var d = a.getElementById(s);
        return d ? [d] : [];
      }
    }, TAG: function(s, a) {
      return typeof a.getElementsByTagName != "undefined" ? a.getElementsByTagName(s) : a.querySelectorAll(s);
    }, CLASS: function(s, a) {
      if (typeof a.getElementsByClassName != "undefined" && we) return a.getElementsByClassName(s);
    } }, relative: { ">": { dir: "parentNode", first: true }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: true }, "~": { dir: "previousSibling" } }, preFilter: Ze, filter: { ID: function(s) {
      var a = K(s);
      return function(d) {
        return d.getAttribute("id") === a;
      };
    }, TAG: function(s) {
      var a = K(s).toLowerCase();
      return s === "*" ? function() {
        return true;
      } : function(d) {
        return P(d, a);
      };
    }, CLASS: function(s) {
      var a = Dr[s + " "];
      return a || (a = new RegExp("(^|" + R + ")" + s + "(" + R + "|$)")) && Dr(s, function(d) {
        return a.test(typeof d.className == "string" && d.className || typeof d.getAttribute != "undefined" && d.getAttribute("class") || "");
      });
    }, ATTR: function(s, a, d) {
      return function(b) {
        var T = f.attr(b, s);
        return T == null ? a === "!=" : a ? (T += "", a === "=" ? T === d : a === "!=" ? T !== d : a === "^=" ? d && T.indexOf(d) === 0 : a === "*=" ? d && T.indexOf(d) > -1 : a === "$=" ? d && T.slice(-d.length) === d : a === "~=" ? (" " + T.replace(ec, " ") + " ").indexOf(d) > -1 : a === "|=" ? T === d || T.slice(0, d.length + 1) === d + "-" : false) : true;
      };
    }, CHILD: function(s, a, d, b, T) {
      var x = s.slice(0, 3) !== "nth", A = s.slice(-4) !== "last", M = a === "of-type";
      return b === 1 && T === 0 ? function(O) {
        return !!O.parentNode;
      } : function(O, z, H) {
        var j, k, G, te, le, ae = x !== A ? "nextSibling" : "previousSibling", ve = O.parentNode, pe = M && O.nodeName.toLowerCase(), Ve = !H && !M, ze = false;
        if (ve) {
          if (x) {
            for (; ae; ) {
              for (G = O; G = G[ae]; ) if (M ? P(G, pe) : G.nodeType === 1) return false;
              le = ae = s === "only" && !le && "nextSibling";
            }
            return true;
          }
          if (le = [A ? ve.firstChild : ve.lastChild], A && Ve) {
            for (k = ve[f.expando] || (ve[f.expando] = {}), j = k[s] || [], te = j[0] === $e && j[1], ze = te && j[2], G = te && ve.childNodes[te]; G = ++te && G && G[ae] || (ze = te = 0) || le.pop(); ) if (G.nodeType === 1 && ++ze && G === O) {
              k[s] = [$e, te, ze];
              break;
            }
          } else if (Ve && (k = O[f.expando] || (O[f.expando] = {}), j = k[s] || [], te = j[0] === $e && j[1], ze = te), ze === false) for (; (G = ++te && G && G[ae] || (ze = te = 0) || le.pop()) && !((M ? P(G, pe) : G.nodeType === 1) && ++ze && (Ve && (k = G[f.expando] || (G[f.expando] = {}), k[s] = [$e, ze]), G === O)); ) ;
          return ze -= T, ze === b || ze % b === 0 && ze / b >= 0;
        }
      };
    }, PSEUDO: function(s, a) {
      var d = f.expr.pseudos[s] || f.expr.setFilters[s.toLowerCase()] || se("unsupported pseudo: " + s);
      return d[f.expando] ? d(a) : d;
    } }, pseudos: { not: pt(function(s) {
      var a = [], d = [], b = ss(s.replace(V, "$1"));
      return b[f.expando] ? pt(function(T, x, A, M) {
        for (var O, z = b(T, null, M, []), H = T.length; H--; ) (O = z[H]) && (T[H] = !(x[H] = O));
      }) : function(T, x, A) {
        return a[0] = T, b(a, null, A, d), a[0] = null, !d.pop();
      };
    }), has: pt(function(s) {
      return function(a) {
        return ot(s, a).length > 0;
      };
    }), contains: pt(function(s) {
      return s = K(s), function(a) {
        return (a.textContent || f.text(a)).indexOf(s) > -1;
      };
    }), lang: pt(function(s) {
      return tc.test(s || "") || se("unsupported lang: " + s), s = K(s).toLowerCase(), function(a) {
        var d;
        do
          if (d = we ? a.lang : a.getAttribute("xml:lang") || a.getAttribute("lang")) return d = d.toLowerCase(), d === s || d.indexOf(s + "-") === 0;
        while ((a = a.parentNode) && a.nodeType === 1);
        return false;
      };
    }), target: function(s) {
      var a = e.location && e.location.hash;
      return a && a.slice(1) === s.id;
    }, root: function(s) {
      return s === St;
    }, focus: function(s) {
      return s === Te.activeElement && Te.hasFocus() && !!(s.type || s.href || ~s.tabIndex);
    }, enabled: Nr(false), disabled: Nr(true), checked: function(s) {
      return P(s, "input") && !!s.checked || P(s, "option") && !!s.selected;
    }, selected: function(s) {
      return N && s.parentNode && s.parentNode.selectedIndex, s.selected === true;
    }, empty: function(s) {
      for (s = s.firstChild; s; s = s.nextSibling) if (s.nodeType < 6) return false;
      return true;
    }, parent: function(s) {
      return !f.expr.pseudos.empty(s);
    }, header: function(s) {
      return nc.test(s.nodeName);
    }, input: function(s) {
      return ic.test(s.nodeName);
    }, button: function(s) {
      return P(s, "input") && s.type === "button" || P(s, "button");
    }, text: function(s) {
      return P(s, "input") && s.type === "text";
    }, first: jt(function() {
      return [0];
    }), last: jt(function(s, a) {
      return [a - 1];
    }), eq: jt(function(s, a, d) {
      return [d < 0 ? d + a : d];
    }), even: jt(function(s, a) {
      for (var d = 0; d < a; d += 2) s.push(d);
      return s;
    }), odd: jt(function(s, a) {
      for (var d = 1; d < a; d += 2) s.push(d);
      return s;
    }), lt: jt(function(s, a, d) {
      var b;
      for (d < 0 ? b = d + a : d > a ? b = a : b = d; --b >= 0; ) s.push(b);
      return s;
    }), gt: jt(function(s, a, d) {
      for (var b = d < 0 ? d + a : d; ++b < a; ) s.push(b);
      return s;
    }) } }, f.expr.pseudos.nth = f.expr.pseudos.eq;
    for (je in { radio: true, checkbox: true, file: true, password: true, image: true }) f.expr.pseudos[je] = ac(je);
    for (je in { submit: true, reset: true }) f.expr.pseudos[je] = lc(je);
    function kr() {
    }
    kr.prototype = f.expr.pseudos, f.expr.setFilters = new kr();
    function ln(s, a, d) {
      var b = a.dir, T = a.next, x = T || b, A = d && x === "parentNode", M = ht++;
      return a.first ? function(O, z, H) {
        for (; O = O[b]; ) if (O.nodeType === 1 || A) return s(O, z, H);
        return false;
      } : function(O, z, H) {
        var j, k, G = [$e, M];
        if (H) {
          for (; O = O[b]; ) if ((O.nodeType === 1 || A) && s(O, z, H)) return true;
        } else for (; O = O[b]; ) if (O.nodeType === 1 || A) if (k = O[f.expando] || (O[f.expando] = {}), T && P(O, T)) O = O[b] || O;
        else {
          if ((j = k[x]) && j[0] === $e && j[1] === M) return G[2] = j[2];
          if (k[x] = G, G[2] = s(O, z, H)) return true;
        }
        return false;
      };
    }
    function ts(s) {
      return s.length > 1 ? function(a, d, b) {
        for (var T = s.length; T--; ) if (!s[T](a, d, b)) return false;
        return true;
      } : s[0];
    }
    function cc(s, a, d) {
      for (var b = 0, T = a.length; b < T; b++) ot(s, a[b], d);
      return d;
    }
    function cn(s, a, d, b, T) {
      for (var x, A = [], M = 0, O = s.length, z = a != null; M < O; M++) (x = s[M]) && (!d || d(x, b, T)) && (A.push(x), z && a.push(M));
      return A;
    }
    function is(s, a, d, b, T, x) {
      return b && !b[f.expando] && (b = is(b)), T && !T[f.expando] && (T = is(T, x)), pt(function(A, M, O, z) {
        var H, j, k, G, te = [], le = [], ae = M.length, ve = A || cc(a || "*", O.nodeType ? [O] : O, []), pe = s && (A || !a) ? cn(ve, te, s, O, z) : ve;
        if (d ? (G = T || (A ? s : ae || b) ? [] : M, d(pe, G, O, z)) : G = pe, b) for (H = cn(G, le), b(H, [], O, z), j = H.length; j--; ) (k = H[j]) && (G[le[j]] = !(pe[le[j]] = k));
        if (A) {
          if (T || s) {
            if (T) {
              for (H = [], j = G.length; j--; ) (k = G[j]) && H.push(pe[j] = k);
              T(null, G = [], H, z);
            }
            for (j = G.length; j--; ) (k = G[j]) && (H = T ? u.call(A, k) : te[j]) > -1 && (A[H] = !(M[H] = k));
          }
        } else G = cn(G === M ? G.splice(ae, G.length) : G), T ? T(null, M, G, z) : c.apply(M, G);
      });
    }
    function ns(s) {
      for (var a, d, b, T = s.length, x = f.expr.relative[s[0].type], A = x || f.expr.relative[" "], M = x ? 1 : 0, O = ln(function(j) {
        return j === a;
      }, A, true), z = ln(function(j) {
        return u.call(a, j) > -1;
      }, A, true), H = [function(j, k, G) {
        var te = !x && (G || k != rt) || ((a = k).nodeType ? O(j, k, G) : z(j, k, G));
        return a = null, te;
      }]; M < T; M++) if (d = f.expr.relative[s[M].type]) H = [ln(ts(H), d)];
      else {
        if (d = f.expr.filter[s[M].type].apply(null, s[M].matches), d[f.expando]) {
          for (b = ++M; b < T && !f.expr.relative[s[b].type]; b++) ;
          return is(M > 1 && ts(H), M > 1 && ge(s.slice(0, M - 1).concat({ value: s[M - 2].type === " " ? "*" : "" })).replace(V, "$1"), d, M < b && ns(s.slice(M, b)), b < T && ns(s = s.slice(b)), b < T && ge(s));
        }
        H.push(d);
      }
      return ts(H);
    }
    function uc(s, a) {
      var d = a.length > 0, b = s.length > 0, T = function(x, A, M, O, z) {
        var H, j, k, G = 0, te = "0", le = x && [], ae = [], ve = rt, pe = x || b && f.expr.find.TAG("*", z), Ve = $e += ve == null ? 1 : Math.random() || 0.1;
        for (z && (rt = A == Te || A || z); (H = pe[te]) != null; te++) {
          if (b && H) {
            for (j = 0, !A && H.ownerDocument != Te && (li(H), M = !we); k = s[j++]; ) if (k(H, A || Te, M)) {
              c.call(O, H);
              break;
            }
            z && ($e = Ve);
          }
          d && ((H = !k && H) && G--, x && le.push(H));
        }
        if (G += te, d && te !== G) {
          for (j = 0; k = a[j++]; ) k(le, ae, A, M);
          if (x) {
            if (G > 0) for (; te--; ) le[te] || ae[te] || (ae[te] = D.call(O));
            ae = cn(ae);
          }
          c.apply(O, ae), z && !x && ae.length > 0 && G + a.length > 1 && f.uniqueSort(O);
        }
        return z && ($e = Ve, rt = ve), le;
      };
      return d ? pt(T) : T;
    }
    function ss(s, a) {
      var d, b = [], T = [], x = zr[s + " "];
      if (!x) {
        for (a || (a = Ce(s)), d = a.length; d--; ) x = ns(a[d]), x[f.expando] ? b.push(x) : T.push(x);
        x = zr(s, uc(T, b)), x.selector = s;
      }
      return x;
    }
    function Rr(s, a, d, b) {
      var T, x, A, M, O, z = typeof s == "function" && s, H = !b && Ce(s = z.selector || s);
      if (d = d || [], H.length === 1) {
        if (x = H[0] = H[0].slice(0), x.length > 2 && (A = x[0]).type === "ID" && a.nodeType === 9 && we && f.expr.relative[x[1].type]) {
          if (a = (f.expr.find.ID(K(A.matches[0]), a) || [])[0], a) z && (a = a.parentNode);
          else return d;
          s = s.slice(x.shift().value.length);
        }
        for (T = $r.needsContext.test(s) ? 0 : x.length; T-- && (A = x[T], !f.expr.relative[M = A.type]); ) if ((O = f.expr.find[M]) && (b = O(K(A.matches[0]), F.test(x[0].type) && oe(a.parentNode) || a))) {
          if (x.splice(T, 1), s = b.length && ge(x), !s) return c.apply(d, b), d;
          break;
        }
      }
      return (z || ss(s, H))(b, a, !we, d, !a || F.test(s) && oe(a.parentNode) || a), d;
    }
    li(), f.find = ot, ot.compile = ss, ot.select = Rr, ot.setDocument = li, ot.tokenize = Ce;
    function ci(s, a, d) {
      for (var b = [], T = d !== void 0; (s = s[a]) && s.nodeType !== 9; ) if (s.nodeType === 1) {
        if (T && f(s).is(d)) break;
        b.push(s);
      }
      return b;
    }
    function Hr(s, a) {
      for (var d = []; s; s = s.nextSibling) s.nodeType === 1 && s !== a && d.push(s);
      return d;
    }
    var Vr = f.expr.match.needsContext, Br = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Wr(s) {
      return s[0] === "<" && s[s.length - 1] === ">" && s.length >= 3;
    }
    function rs(s, a, d) {
      return typeof a == "function" ? f.grep(s, function(b, T) {
        return !!a.call(b, T, b) !== d;
      }) : a.nodeType ? f.grep(s, function(b) {
        return b === a !== d;
      }) : typeof a != "string" ? f.grep(s, function(b) {
        return u.call(a, b) > -1 !== d;
      }) : f.filter(a, s, d);
    }
    f.filter = function(s, a, d) {
      var b = a[0];
      return d && (s = ":not(" + s + ")"), a.length === 1 && b.nodeType === 1 ? f.find.matchesSelector(b, s) ? [b] : [] : f.find.matches(s, f.grep(a, function(T) {
        return T.nodeType === 1;
      }));
    }, f.fn.extend({ find: function(s) {
      var a, d, b = this.length, T = this;
      if (typeof s != "string") return this.pushStack(f(s).filter(function() {
        for (a = 0; a < b; a++) if (f.contains(T[a], this)) return true;
      }));
      for (d = this.pushStack([]), a = 0; a < b; a++) f.find(s, T[a], d);
      return b > 1 ? f.uniqueSort(d) : d;
    }, filter: function(s) {
      return this.pushStack(rs(this, s || [], false));
    }, not: function(s) {
      return this.pushStack(rs(this, s || [], true));
    }, is: function(s) {
      return !!rs(this, typeof s == "string" && Vr.test(s) ? f(s) : s || [], false).length;
    } });
    var un, dc = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, fc = f.fn.init = function(s, a) {
      var d, b;
      if (!s) return this;
      if (s.nodeType) return this[0] = s, this.length = 1, this;
      if (typeof s == "function") return un.ready !== void 0 ? un.ready(s) : s(f);
      if (d = s + "", Wr(d)) d = [null, s, null];
      else if (typeof s == "string") d = dc.exec(s);
      else return f.makeArray(s, this);
      if (d && (d[1] || !a)) if (d[1]) {
        if (a = a instanceof f ? a[0] : a, f.merge(this, f.parseHTML(d[1], a && a.nodeType ? a.ownerDocument || a : p, true)), Br.test(d[1]) && f.isPlainObject(a)) for (d in a) typeof this[d] == "function" ? this[d](a[d]) : this.attr(d, a[d]);
        return this;
      } else return b = p.getElementById(d[2]), b && (this[0] = b, this.length = 1), this;
      else return !a || a.jquery ? (a || un).find(s) : this.constructor(a).find(s);
    };
    fc.prototype = f.fn, un = f(p);
    var hc = /^(?:parents|prev(?:Until|All))/, pc = { children: true, contents: true, next: true, prev: true };
    f.fn.extend({ has: function(s) {
      var a = f(s, this), d = a.length;
      return this.filter(function() {
        for (var b = 0; b < d; b++) if (f.contains(this, a[b])) return true;
      });
    }, closest: function(s, a) {
      var d, b = 0, T = this.length, x = [], A = typeof s != "string" && f(s);
      if (!Vr.test(s)) {
        for (; b < T; b++) for (d = this[b]; d && d !== a; d = d.parentNode) if (d.nodeType < 11 && (A ? A.index(d) > -1 : d.nodeType === 1 && f.find.matchesSelector(d, s))) {
          x.push(d);
          break;
        }
      }
      return this.pushStack(x.length > 1 ? f.uniqueSort(x) : x);
    }, index: function(s) {
      return s ? typeof s == "string" ? u.call(f(s), this[0]) : u.call(this, s.jquery ? s[0] : s) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function(s, a) {
      return this.pushStack(f.uniqueSort(f.merge(this.get(), f(s, a))));
    }, addBack: function(s) {
      return this.add(s == null ? this.prevObject : this.prevObject.filter(s));
    } });
    function Fr(s, a) {
      for (; (s = s[a]) && s.nodeType !== 1; ) ;
      return s;
    }
    f.each({ parent: function(s) {
      var a = s.parentNode;
      return a && a.nodeType !== 11 ? a : null;
    }, parents: function(s) {
      return ci(s, "parentNode");
    }, parentsUntil: function(s, a, d) {
      return ci(s, "parentNode", d);
    }, next: function(s) {
      return Fr(s, "nextSibling");
    }, prev: function(s) {
      return Fr(s, "previousSibling");
    }, nextAll: function(s) {
      return ci(s, "nextSibling");
    }, prevAll: function(s) {
      return ci(s, "previousSibling");
    }, nextUntil: function(s, a, d) {
      return ci(s, "nextSibling", d);
    }, prevUntil: function(s, a, d) {
      return ci(s, "previousSibling", d);
    }, siblings: function(s) {
      return Hr((s.parentNode || {}).firstChild, s);
    }, children: function(s) {
      return Hr(s.firstChild);
    }, contents: function(s) {
      return s.contentDocument != null && n(s.contentDocument) ? s.contentDocument : (P(s, "template") && (s = s.content || s), f.merge([], s.childNodes));
    } }, function(s, a) {
      f.fn[s] = function(d, b) {
        var T = f.map(this, a, d);
        return s.slice(-5) !== "Until" && (b = d), b && typeof b == "string" && (T = f.filter(b, T)), this.length > 1 && (pc[s] || f.uniqueSort(T), hc.test(s) && T.reverse()), this.pushStack(T);
      };
    });
    function mc(s) {
      var a = {};
      return f.each(s.match(Oe) || [], function(d, b) {
        a[b] = true;
      }), a;
    }
    f.Callbacks = function(s) {
      s = typeof s == "string" ? mc(s) : f.extend({}, s);
      var a, d, b, T, x = [], A = [], M = -1, O = function() {
        for (T = T || s.once, b = a = true; A.length; M = -1) for (d = A.shift(); ++M < x.length; ) x[M].apply(d[0], d[1]) === false && s.stopOnFalse && (M = x.length, d = false);
        s.memory || (d = false), a = false, T && (d ? x = [] : x = "");
      }, z = { add: function() {
        return x && (d && !a && (M = x.length - 1, A.push(d)), (function H(j) {
          f.each(j, function(k, G) {
            typeof G == "function" ? (!s.unique || !z.has(G)) && x.push(G) : G && G.length && g(G) !== "string" && H(G);
          });
        })(arguments), d && !a && O()), this;
      }, remove: function() {
        return f.each(arguments, function(H, j) {
          for (var k; (k = f.inArray(j, x, k)) > -1; ) x.splice(k, 1), k <= M && M--;
        }), this;
      }, has: function(H) {
        return H ? f.inArray(H, x) > -1 : x.length > 0;
      }, empty: function() {
        return x && (x = []), this;
      }, disable: function() {
        return T = A = [], x = d = "", this;
      }, disabled: function() {
        return !x;
      }, lock: function() {
        return T = A = [], !d && !a && (x = d = ""), this;
      }, locked: function() {
        return !!T;
      }, fireWith: function(H, j) {
        return T || (j = j || [], j = [H, j.slice ? j.slice() : j], A.push(j), a || O()), this;
      }, fire: function() {
        return z.fireWith(this, arguments), this;
      }, fired: function() {
        return !!b;
      } };
      return z;
    };
    function ui(s) {
      return s;
    }
    function dn(s) {
      throw s;
    }
    function Gr(s, a, d, b) {
      var T;
      try {
        s && typeof (T = s.promise) == "function" ? T.call(s).done(a).fail(d) : s && typeof (T = s.then) == "function" ? T.call(s, a, d) : a.apply(void 0, [s].slice(b));
      } catch (x) {
        d(x);
      }
    }
    f.extend({ Deferred: function(s) {
      var a = [["notify", "progress", f.Callbacks("memory"), f.Callbacks("memory"), 2], ["resolve", "done", f.Callbacks("once memory"), f.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", f.Callbacks("once memory"), f.Callbacks("once memory"), 1, "rejected"]], d = "pending", b = { state: function() {
        return d;
      }, always: function() {
        return T.done(arguments).fail(arguments), this;
      }, catch: function(x) {
        return b.then(null, x);
      }, pipe: function() {
        var x = arguments;
        return f.Deferred(function(A) {
          f.each(a, function(M, O) {
            var z = typeof x[O[4]] == "function" && x[O[4]];
            T[O[1]](function() {
              var H = z && z.apply(this, arguments);
              H && typeof H.promise == "function" ? H.promise().progress(A.notify).done(A.resolve).fail(A.reject) : A[O[0] + "With"](this, z ? [H] : arguments);
            });
          }), x = null;
        }).promise();
      }, then: function(x, A, M) {
        var O = 0;
        function z(H, j, k, G) {
          return function() {
            var te = this, le = arguments, ae = function() {
              var pe, Ve;
              if (!(H < O)) {
                if (pe = k.apply(te, le), pe === j.promise()) throw new TypeError("Thenable self-resolution");
                Ve = pe && (typeof pe == "object" || typeof pe == "function") && pe.then, typeof Ve == "function" ? G ? Ve.call(pe, z(O, j, ui, G), z(O, j, dn, G)) : (O++, Ve.call(pe, z(O, j, ui, G), z(O, j, dn, G), z(O, j, ui, j.notifyWith))) : (k !== ui && (te = void 0, le = [pe]), (G || j.resolveWith)(te, le));
              }
            }, ve = G ? ae : function() {
              try {
                ae();
              } catch (pe) {
                f.Deferred.exceptionHook && f.Deferred.exceptionHook(pe, ve.error), H + 1 >= O && (k !== dn && (te = void 0, le = [pe]), j.rejectWith(te, le));
              }
            };
            H ? ve() : (f.Deferred.getErrorHook && (ve.error = f.Deferred.getErrorHook()), e.setTimeout(ve));
          };
        }
        return f.Deferred(function(H) {
          a[0][3].add(z(0, H, typeof M == "function" ? M : ui, H.notifyWith)), a[1][3].add(z(0, H, typeof x == "function" ? x : ui)), a[2][3].add(z(0, H, typeof A == "function" ? A : dn));
        }).promise();
      }, promise: function(x) {
        return x != null ? f.extend(x, b) : b;
      } }, T = {};
      return f.each(a, function(x, A) {
        var M = A[2], O = A[5];
        b[A[1]] = M.add, O && M.add(function() {
          d = O;
        }, a[3 - x][2].disable, a[3 - x][3].disable, a[0][2].lock, a[0][3].lock), M.add(A[3].fire), T[A[0]] = function() {
          return T[A[0] + "With"](this === T ? void 0 : this, arguments), this;
        }, T[A[0] + "With"] = M.fireWith;
      }), b.promise(T), s && s.call(T, T), T;
    }, when: function(s) {
      var a = arguments.length, d = a, b = Array(d), T = r.call(arguments), x = f.Deferred(), A = function(M) {
        return function(O) {
          b[M] = this, T[M] = arguments.length > 1 ? r.call(arguments) : O, --a || x.resolveWith(b, T);
        };
      };
      if (a <= 1 && (Gr(s, x.done(A(d)).resolve, x.reject, !a), x.state() === "pending" || typeof (T[d] && T[d].then) == "function")) return x.then();
      for (; d--; ) Gr(T[d], A(d), x.reject);
      return x.promise();
    } });
    var gc = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    f.Deferred.exceptionHook = function(s, a) {
      s && gc.test(s.name) && e.console.warn("jQuery.Deferred exception", s, a);
    }, f.readyException = function(s) {
      e.setTimeout(function() {
        throw s;
      });
    };
    var os = f.Deferred();
    f.fn.ready = function(s) {
      return os.then(s).catch(function(a) {
        f.readyException(a);
      }), this;
    }, f.extend({ isReady: false, readyWait: 1, ready: function(s) {
      (s === true ? --f.readyWait : f.isReady) || (f.isReady = true, !(s !== true && --f.readyWait > 0) && os.resolveWith(p, [f]));
    } }), f.ready.then = os.then;
    function fn() {
      p.removeEventListener("DOMContentLoaded", fn), e.removeEventListener("load", fn), f.ready();
    }
    p.readyState !== "loading" ? e.setTimeout(f.ready) : (p.addEventListener("DOMContentLoaded", fn), e.addEventListener("load", fn));
    var vc = /-([a-z])/g;
    function yc(s, a) {
      return a.toUpperCase();
    }
    function Yt(s) {
      return s.replace(vc, yc);
    }
    function Ri(s) {
      return s.nodeType === 1 || s.nodeType === 9 || !+s.nodeType;
    }
    function Hi() {
      this.expando = f.expando + Hi.uid++;
    }
    Hi.uid = 1, Hi.prototype = { cache: function(s) {
      var a = s[this.expando];
      return a || (a = /* @__PURE__ */ Object.create(null), Ri(s) && (s.nodeType ? s[this.expando] = a : Object.defineProperty(s, this.expando, { value: a, configurable: true }))), a;
    }, set: function(s, a, d) {
      var b, T = this.cache(s);
      if (typeof a == "string") T[Yt(a)] = d;
      else for (b in a) T[Yt(b)] = a[b];
      return d;
    }, get: function(s, a) {
      return a === void 0 ? this.cache(s) : s[this.expando] && s[this.expando][Yt(a)];
    }, access: function(s, a, d) {
      return a === void 0 || a && typeof a == "string" && d === void 0 ? this.get(s, a) : (this.set(s, a, d), d !== void 0 ? d : a);
    }, remove: function(s, a) {
      var d, b = s[this.expando];
      if (b !== void 0) {
        if (a !== void 0) for (Array.isArray(a) ? a = a.map(Yt) : (a = Yt(a), a = a in b ? [a] : a.match(Oe) || []), d = a.length; d--; ) delete b[a[d]];
        (a === void 0 || f.isEmptyObject(b)) && (s.nodeType ? s[this.expando] = void 0 : delete s[this.expando]);
      }
    }, hasData: function(s) {
      var a = s[this.expando];
      return a !== void 0 && !f.isEmptyObject(a);
    } };
    var ce = new Hi(), Re = new Hi(), bc = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Ec = /[A-Z]/g;
    function Sc(s) {
      return s === "true" ? true : s === "false" ? false : s === "null" ? null : s === +s + "" ? +s : bc.test(s) ? JSON.parse(s) : s;
    }
    function jr(s, a, d) {
      var b;
      if (d === void 0 && s.nodeType === 1) if (b = "data-" + a.replace(Ec, "-$&").toLowerCase(), d = s.getAttribute(b), typeof d == "string") {
        try {
          d = Sc(d);
        } catch (T) {
        }
        Re.set(s, a, d);
      } else d = void 0;
      return d;
    }
    f.extend({ hasData: function(s) {
      return Re.hasData(s) || ce.hasData(s);
    }, data: function(s, a, d) {
      return Re.access(s, a, d);
    }, removeData: function(s, a) {
      Re.remove(s, a);
    }, _data: function(s, a, d) {
      return ce.access(s, a, d);
    }, _removeData: function(s, a) {
      ce.remove(s, a);
    } }), f.fn.extend({ data: function(s, a) {
      var d, b, T, x = this[0], A = x && x.attributes;
      if (s === void 0) {
        if (this.length && (T = Re.get(x), x.nodeType === 1 && !ce.get(x, "hasDataAttrs"))) {
          for (d = A.length; d--; ) A[d] && (b = A[d].name, b.indexOf("data-") === 0 && (b = Yt(b.slice(5)), jr(x, b, T[b])));
          ce.set(x, "hasDataAttrs", true);
        }
        return T;
      }
      return typeof s == "object" ? this.each(function() {
        Re.set(this, s);
      }) : be(this, function(M) {
        var O;
        if (x && M === void 0) return O = Re.get(x, s), O !== void 0 || (O = jr(x, s), O !== void 0) ? O : void 0;
        this.each(function() {
          Re.set(this, s, M);
        });
      }, null, a, arguments.length > 1, null, true);
    }, removeData: function(s) {
      return this.each(function() {
        Re.remove(this, s);
      });
    } }), f.extend({ queue: function(s, a, d) {
      var b;
      if (s) return a = (a || "fx") + "queue", b = ce.get(s, a), d && (!b || Array.isArray(d) ? b = ce.set(s, a, f.makeArray(d)) : b.push(d)), b || [];
    }, dequeue: function(s, a) {
      a = a || "fx";
      var d = f.queue(s, a), b = d.length, T = d.shift(), x = f._queueHooks(s, a), A = function() {
        f.dequeue(s, a);
      };
      T === "inprogress" && (T = d.shift(), b--), T && (a === "fx" && d.unshift("inprogress"), delete x.stop, T.call(s, A, x)), !b && x && x.empty.fire();
    }, _queueHooks: function(s, a) {
      var d = a + "queueHooks";
      return ce.get(s, d) || ce.set(s, d, { empty: f.Callbacks("once memory").add(function() {
        ce.remove(s, [a + "queue", d]);
      }) });
    } }), f.fn.extend({ queue: function(s, a) {
      var d = 2;
      return typeof s != "string" && (a = s, s = "fx", d--), arguments.length < d ? f.queue(this[0], s) : a === void 0 ? this : this.each(function() {
        var b = f.queue(this, s, a);
        f._queueHooks(this, s), s === "fx" && b[0] !== "inprogress" && f.dequeue(this, s);
      });
    }, dequeue: function(s) {
      return this.each(function() {
        f.dequeue(this, s);
      });
    }, clearQueue: function(s) {
      return this.queue(s || "fx", []);
    }, promise: function(s, a) {
      var d, b = 1, T = f.Deferred(), x = this, A = this.length, M = function() {
        --b || T.resolveWith(x, [x]);
      };
      for (typeof s != "string" && (a = s, s = void 0), s = s || "fx"; A--; ) d = ce.get(x[A], s + "queueHooks"), d && d.empty && (b++, d.empty.add(M));
      return M(), T.promise(a);
    } });
    var Yr = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Vi = new RegExp("^(?:([+-])=|)(" + Yr + ")([a-z%]*)$", "i"), Pt = ["Top", "Right", "Bottom", "Left"];
    function hn(s, a) {
      return s = a || s, s.style.display === "none" || s.style.display === "" && f.css(s, "display") === "none";
    }
    var Tc = /^[a-z]/, _c = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function pn(s) {
      return Tc.test(s) && _c.test(s[0].toUpperCase() + s.slice(1));
    }
    function Xr(s, a, d, b) {
      var T, x, A = 20, M = b ? function() {
        return b.cur();
      } : function() {
        return f.css(s, a, "");
      }, O = M(), z = d && d[3] || (pn(a) ? "px" : ""), H = s.nodeType && (!pn(a) || z !== "px" && +O) && Vi.exec(f.css(s, a));
      if (H && H[3] !== z) {
        for (O = O / 2, z = z || H[3], H = +O || 1; A--; ) f.style(s, a, H + z), (1 - x) * (1 - (x = M() / O || 0.5)) <= 0 && (A = 0), H = H / x;
        H = H * 2, f.style(s, a, H + z), d = d || [];
      }
      return d && (H = +H || +O || 0, T = d[1] ? H + (d[1] + 1) * d[2] : +d[2], b && (b.unit = z, b.start = H, b.end = T)), T;
    }
    var xc = /^-ms-/;
    function as(s) {
      return Yt(s.replace(xc, "ms-"));
    }
    var qr = {};
    function Cc(s) {
      var a, d = s.ownerDocument, b = s.nodeName, T = qr[b];
      return T || (a = d.body.appendChild(d.createElement(b)), T = f.css(a, "display"), a.parentNode.removeChild(a), T === "none" && (T = "block"), qr[b] = T, T);
    }
    function di(s, a) {
      for (var d, b, T = [], x = 0, A = s.length; x < A; x++) b = s[x], b.style && (d = b.style.display, a ? (d === "none" && (T[x] = ce.get(b, "display") || null, T[x] || (b.style.display = "")), b.style.display === "" && hn(b) && (T[x] = Cc(b))) : d !== "none" && (T[x] = "none", ce.set(b, "display", d)));
      for (x = 0; x < A; x++) T[x] != null && (s[x].style.display = T[x]);
      return s;
    }
    f.fn.extend({ show: function() {
      return di(this, true);
    }, hide: function() {
      return di(this);
    }, toggle: function(s) {
      return typeof s == "boolean" ? s ? this.show() : this.hide() : this.each(function() {
        hn(this) ? f(this).show() : f(this).hide();
      });
    } });
    var Bi = function(s) {
      return f.contains(s.ownerDocument, s) || s.getRootNode(wc) === s.ownerDocument;
    }, wc = { composed: true };
    W.getRootNode || (Bi = function(s) {
      return f.contains(s.ownerDocument, s);
    });
    var Ur = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, Tt = { thead: ["table"], col: ["colgroup", "table"], tr: ["tbody", "table"], td: ["tr", "tbody", "table"] };
    Tt.tbody = Tt.tfoot = Tt.colgroup = Tt.caption = Tt.thead, Tt.th = Tt.td;
    function He(s, a) {
      var d;
      return typeof s.getElementsByTagName != "undefined" ? d = i.slice.call(s.getElementsByTagName(a || "*")) : typeof s.querySelectorAll != "undefined" ? d = s.querySelectorAll(a || "*") : d = [], a === void 0 || a && P(s, a) ? f.merge([s], d) : d;
    }
    var Kr = /^$|^module$|\/(?:java|ecma)script/i;
    function ls(s, a) {
      for (var d = 0, b = s.length; d < b; d++) ce.set(s[d], "globalEval", !a || ce.get(a[d], "globalEval"));
    }
    var Ac = /<|&#?\w+;/;
    function Zr(s, a, d, b, T) {
      for (var x, A, M, O, z, H, j = a.createDocumentFragment(), k = [], G = 0, te = s.length; G < te; G++) if (x = s[G], x || x === 0) if (g(x) === "object" && (x.nodeType || _(x))) f.merge(k, x.nodeType ? [x] : x);
      else if (!Ac.test(x)) k.push(a.createTextNode(x));
      else {
        for (A = A || j.appendChild(a.createElement("div")), M = (Ur.exec(x) || ["", ""])[1].toLowerCase(), O = Tt[M] || i, H = O.length; --H > -1; ) A = A.appendChild(a.createElement(O[H]));
        A.innerHTML = f.htmlPrefilter(x), f.merge(k, A.childNodes), A = j.firstChild, A.textContent = "";
      }
      for (j.textContent = "", G = 0; x = k[G++]; ) {
        if (b && f.inArray(x, b) > -1) {
          T && T.push(x);
          continue;
        }
        if (z = Bi(x), A = He(j.appendChild(x), "script"), z && ls(A), d) for (H = 0; x = A[H++]; ) Kr.test(x.type || "") && d.push(x);
      }
      return j;
    }
    function Ic(s) {
      return s.type = (s.getAttribute("type") !== null) + "/" + s.type, s;
    }
    function Oc(s) {
      return (s.type || "").slice(0, 5) === "true/" ? s.type = s.type.slice(5) : s.removeAttribute("type"), s;
    }
    function fi(s, a, d, b) {
      a = o(a);
      var T, x, A, M, O, z, H = 0, j = s.length, k = j - 1, G = a[0], te = typeof G == "function";
      if (te) return s.each(function(le) {
        var ae = s.eq(le);
        a[0] = G.call(this, le, ae.html()), fi(ae, a, d, b);
      });
      if (j && (T = Zr(a, s[0].ownerDocument, false, s, b), x = T.firstChild, T.childNodes.length === 1 && (T = x), x || b)) {
        for (A = f.map(He(T, "script"), Ic), M = A.length; H < j; H++) O = T, H !== k && (O = f.clone(O, true, true), M && f.merge(A, He(O, "script"))), d.call(s[H], O, H);
        if (M) for (z = A[A.length - 1].ownerDocument, f.map(A, Oc), H = 0; H < M; H++) O = A[H], Kr.test(O.type || "") && !ce.get(O, "globalEval") && f.contains(z, O) && (O.src && (O.type || "").toLowerCase() !== "module" ? f._evalUrl && !O.noModule && f._evalUrl(O.src, { nonce: O.nonce, crossOrigin: O.crossOrigin }, z) : w(O.textContent, O, z));
      }
      return s;
    }
    var mn = /^(?:checkbox|radio)$/i, Qr = /^([^.]*)(?:\.(.+)|)/;
    function hi() {
      return true;
    }
    function pi() {
      return false;
    }
    function cs(s, a, d, b, T, x) {
      var A, M;
      if (typeof a == "object") {
        typeof d != "string" && (b = b || d, d = void 0);
        for (M in a) cs(s, M, d, b, a[M], x);
        return s;
      }
      if (b == null && T == null ? (T = d, b = d = void 0) : T == null && (typeof d == "string" ? (T = b, b = void 0) : (T = b, b = d, d = void 0)), T === false) T = pi;
      else if (!T) return s;
      return x === 1 && (A = T, T = function(O) {
        return f().off(O), A.apply(this, arguments);
      }, T.guid = A.guid || (A.guid = f.guid++)), s.each(function() {
        f.event.add(this, a, T, b, d);
      });
    }
    f.event = { add: function(s, a, d, b, T) {
      var x, A, M, O, z, H, j, k, G, te, le, ae = ce.get(s);
      if (Ri(s)) for (d.handler && (x = d, d = x.handler, T = x.selector), T && f.find.matchesSelector(W, T), d.guid || (d.guid = f.guid++), (O = ae.events) || (O = ae.events = /* @__PURE__ */ Object.create(null)), (A = ae.handle) || (A = ae.handle = function(ve) {
        return typeof f != "undefined" && f.event.triggered !== ve.type ? f.event.dispatch.apply(s, arguments) : void 0;
      }), a = (a || "").match(Oe) || [""], z = a.length; z--; ) M = Qr.exec(a[z]) || [], G = le = M[1], te = (M[2] || "").split(".").sort(), G && (j = f.event.special[G] || {}, G = (T ? j.delegateType : j.bindType) || G, j = f.event.special[G] || {}, H = f.extend({ type: G, origType: le, data: b, handler: d, guid: d.guid, selector: T, needsContext: T && f.expr.match.needsContext.test(T), namespace: te.join(".") }, x), (k = O[G]) || (k = O[G] = [], k.delegateCount = 0, (!j.setup || j.setup.call(s, b, te, A) === false) && s.addEventListener && s.addEventListener(G, A)), j.add && (j.add.call(s, H), H.handler.guid || (H.handler.guid = d.guid)), T ? k.splice(k.delegateCount++, 0, H) : k.push(H));
    }, remove: function(s, a, d, b, T) {
      var x, A, M, O, z, H, j, k, G, te, le, ae = ce.hasData(s) && ce.get(s);
      if (!(!ae || !(O = ae.events))) {
        for (a = (a || "").match(Oe) || [""], z = a.length; z--; ) {
          if (M = Qr.exec(a[z]) || [], G = le = M[1], te = (M[2] || "").split(".").sort(), !G) {
            for (G in O) f.event.remove(s, G + a[z], d, b, true);
            continue;
          }
          for (j = f.event.special[G] || {}, G = (b ? j.delegateType : j.bindType) || G, k = O[G] || [], M = M[2] && new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)"), A = x = k.length; x--; ) H = k[x], (T || le === H.origType) && (!d || d.guid === H.guid) && (!M || M.test(H.namespace)) && (!b || b === H.selector || b === "**" && H.selector) && (k.splice(x, 1), H.selector && k.delegateCount--, j.remove && j.remove.call(s, H));
          A && !k.length && ((!j.teardown || j.teardown.call(s, te, ae.handle) === false) && f.removeEvent(s, G, ae.handle), delete O[G]);
        }
        f.isEmptyObject(O) && ce.remove(s, "handle events");
      }
    }, dispatch: function(s) {
      var a, d, b, T, x, A, M = new Array(arguments.length), O = f.event.fix(s), z = (ce.get(this, "events") || /* @__PURE__ */ Object.create(null))[O.type] || [], H = f.event.special[O.type] || {};
      for (M[0] = O, a = 1; a < arguments.length; a++) M[a] = arguments[a];
      if (O.delegateTarget = this, !(H.preDispatch && H.preDispatch.call(this, O) === false)) {
        for (A = f.event.handlers.call(this, O, z), a = 0; (T = A[a++]) && !O.isPropagationStopped(); ) for (O.currentTarget = T.elem, d = 0; (x = T.handlers[d++]) && !O.isImmediatePropagationStopped(); ) (!O.rnamespace || x.namespace === false || O.rnamespace.test(x.namespace)) && (O.handleObj = x, O.data = x.data, b = ((f.event.special[x.origType] || {}).handle || x.handler).apply(T.elem, M), b !== void 0 && (O.result = b) === false && (O.preventDefault(), O.stopPropagation()));
        return H.postDispatch && H.postDispatch.call(this, O), O.result;
      }
    }, handlers: function(s, a) {
      var d, b, T, x, A, M = [], O = a.delegateCount, z = s.target;
      if (O && !(s.type === "click" && s.button >= 1)) {
        for (; z !== this; z = z.parentNode || this) if (z.nodeType === 1 && !(s.type === "click" && z.disabled === true)) {
          for (x = [], A = {}, d = 0; d < O; d++) b = a[d], T = b.selector + " ", A[T] === void 0 && (A[T] = b.needsContext ? f(T, this).index(z) > -1 : f.find(T, this, null, [z]).length), A[T] && x.push(b);
          x.length && M.push({ elem: z, handlers: x });
        }
      }
      return z = this, O < a.length && M.push({ elem: z, handlers: a.slice(O) }), M;
    }, addProp: function(s, a) {
      Object.defineProperty(f.Event.prototype, s, { enumerable: true, configurable: true, get: typeof a == "function" ? function() {
        if (this.originalEvent) return a(this.originalEvent);
      } : function() {
        if (this.originalEvent) return this.originalEvent[s];
      }, set: function(d) {
        Object.defineProperty(this, s, { enumerable: true, configurable: true, writable: true, value: d });
      } });
    }, fix: function(s) {
      return s[f.expando] ? s : new f.Event(s);
    }, special: f.extend(/* @__PURE__ */ Object.create(null), { load: { noBubble: true }, click: { setup: function(s) {
      var a = this || s;
      return mn.test(a.type) && a.click && P(a, "input") && gn(a, "click", true), false;
    }, trigger: function(s) {
      var a = this || s;
      return mn.test(a.type) && a.click && P(a, "input") && gn(a, "click"), true;
    }, _default: function(s) {
      var a = s.target;
      return mn.test(a.type) && a.click && P(a, "input") && ce.get(a, "click") || P(a, "a");
    } }, beforeunload: { postDispatch: function(s) {
      s.result !== void 0 && s.preventDefault();
    } } }) };
    function gn(s, a, d) {
      if (!d) {
        ce.get(s, a) === void 0 && f.event.add(s, a, hi);
        return;
      }
      ce.set(s, a, false), f.event.add(s, a, { namespace: false, handler: function(b) {
        var T, x = ce.get(this, a);
        if (b.isTrigger & 1 && this[a]) {
          if (x.length) (f.event.special[a] || {}).delegateType && b.stopPropagation();
          else if (x = r.call(arguments), ce.set(this, a, x), this[a](), T = ce.get(this, a), ce.set(this, a, false), x !== T) return b.stopImmediatePropagation(), b.preventDefault(), T && T.value;
        } else x.length && (ce.set(this, a, { value: f.event.trigger(x[0], x.slice(1), this) }), b.stopPropagation(), b.isImmediatePropagationStopped = hi);
      } });
    }
    f.removeEvent = function(s, a, d) {
      s.removeEventListener && s.removeEventListener(a, d);
    }, f.Event = function(s, a) {
      if (!(this instanceof f.Event)) return new f.Event(s, a);
      s && s.type ? (this.originalEvent = s, this.type = s.type, this.isDefaultPrevented = s.defaultPrevented ? hi : pi, this.target = s.target, this.currentTarget = s.currentTarget, this.relatedTarget = s.relatedTarget) : this.type = s, a && f.extend(this, a), this.timeStamp = s && s.timeStamp || Date.now(), this[f.expando] = true;
    }, f.Event.prototype = { constructor: f.Event, isDefaultPrevented: pi, isPropagationStopped: pi, isImmediatePropagationStopped: pi, isSimulated: false, preventDefault: function() {
      var s = this.originalEvent;
      this.isDefaultPrevented = hi, s && !this.isSimulated && s.preventDefault();
    }, stopPropagation: function() {
      var s = this.originalEvent;
      this.isPropagationStopped = hi, s && !this.isSimulated && s.stopPropagation();
    }, stopImmediatePropagation: function() {
      var s = this.originalEvent;
      this.isImmediatePropagationStopped = hi, s && !this.isSimulated && s.stopImmediatePropagation(), this.stopPropagation();
    } }, f.each({ altKey: true, bubbles: true, cancelable: true, changedTouches: true, ctrlKey: true, detail: true, eventPhase: true, metaKey: true, pageX: true, pageY: true, shiftKey: true, view: true, char: true, code: true, charCode: true, key: true, keyCode: true, button: true, buttons: true, clientX: true, clientY: true, offsetX: true, offsetY: true, pointerId: true, pointerType: true, screenX: true, screenY: true, targetTouches: true, toElement: true, touches: true, which: true }, f.event.addProp), f.each({ focus: "focusin", blur: "focusout" }, function(s, a) {
      function d(b) {
        var T = f.event.fix(b);
        T.type = b.type === "focusin" ? "focus" : "blur", T.isSimulated = true, T.target === T.currentTarget && ce.get(this, "handle")(T);
      }
      f.event.special[s] = { setup: function() {
        if (gn(this, s, true), N) this.addEventListener(a, d);
        else return false;
      }, trigger: function() {
        return gn(this, s), true;
      }, teardown: function() {
        if (N) this.removeEventListener(a, d);
        else return false;
      }, _default: function(b) {
        return ce.get(b.target, s);
      }, delegateType: a };
    }), f.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(s, a) {
      f.event.special[s] = { delegateType: a, bindType: a, handle: function(d) {
        var b, T = this, x = d.relatedTarget, A = d.handleObj;
        return (!x || x !== T && !f.contains(T, x)) && (d.type = A.origType, b = A.handler.apply(this, arguments), d.type = a), b;
      } };
    }), f.fn.extend({ on: function(s, a, d, b) {
      return cs(this, s, a, d, b);
    }, one: function(s, a, d, b) {
      return cs(this, s, a, d, b, 1);
    }, off: function(s, a, d) {
      var b, T;
      if (s && s.preventDefault && s.handleObj) return b = s.handleObj, f(s.delegateTarget).off(b.namespace ? b.origType + "." + b.namespace : b.origType, b.selector, b.handler), this;
      if (typeof s == "object") {
        for (T in s) this.off(T, a, s[T]);
        return this;
      }
      return (a === false || typeof a == "function") && (d = a, a = void 0), d === false && (d = pi), this.each(function() {
        f.event.remove(this, s, d, a);
      });
    } });
    var Mc = /<script|<style|<link/i;
    function Jr(s, a) {
      return P(s, "table") && P(a.nodeType !== 11 ? a : a.firstChild, "tr") && f(s).children("tbody")[0] || s;
    }
    function eo(s, a) {
      var d, b, T, x = ce.get(s, "events");
      if (a.nodeType === 1) {
        if (x) {
          ce.remove(a, "handle events");
          for (d in x) for (b = 0, T = x[d].length; b < T; b++) f.event.add(a, d, x[d][b]);
        }
        Re.hasData(s) && Re.set(a, f.extend({}, Re.get(s)));
      }
    }
    function to(s, a, d) {
      for (var b, T = a ? f.filter(a, s) : s, x = 0; (b = T[x]) != null; x++) !d && b.nodeType === 1 && f.cleanData(He(b)), b.parentNode && (d && Bi(b) && ls(He(b, "script")), b.parentNode.removeChild(b));
      return s;
    }
    f.extend({ htmlPrefilter: function(s) {
      return s;
    }, clone: function(s, a, d) {
      var b, T, x, A, M = s.cloneNode(true), O = Bi(s);
      if (N && (s.nodeType === 1 || s.nodeType === 11) && !f.isXMLDoc(s)) for (A = He(M), x = He(s), b = 0, T = x.length; b < T; b++) P(A[b], "textarea") && (A[b].defaultValue = x[b].defaultValue);
      if (a) if (d) for (x = x || He(s), A = A || He(M), b = 0, T = x.length; b < T; b++) eo(x[b], A[b]);
      else eo(s, M);
      return A = He(M, "script"), A.length > 0 && ls(A, !O && He(s, "script")), M;
    }, cleanData: function(s) {
      for (var a, d, b, T = f.event.special, x = 0; (d = s[x]) !== void 0; x++) if (Ri(d)) {
        if (a = d[ce.expando]) {
          if (a.events) for (b in a.events) T[b] ? f.event.remove(d, b) : f.removeEvent(d, b, a.handle);
          d[ce.expando] = void 0;
        }
        d[Re.expando] && (d[Re.expando] = void 0);
      }
    } }), f.fn.extend({ detach: function(s) {
      return to(this, s, true);
    }, remove: function(s) {
      return to(this, s);
    }, text: function(s) {
      return be(this, function(a) {
        return a === void 0 ? f.text(this) : this.empty().each(function() {
          (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = a);
        });
      }, null, s, arguments.length);
    }, append: function() {
      return fi(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Jr(this, s);
          a.appendChild(s);
        }
      });
    }, prepend: function() {
      return fi(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Jr(this, s);
          a.insertBefore(s, a.firstChild);
        }
      });
    }, before: function() {
      return fi(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this);
      });
    }, after: function() {
      return fi(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this.nextSibling);
      });
    }, empty: function() {
      for (var s, a = 0; (s = this[a]) != null; a++) s.nodeType === 1 && (f.cleanData(He(s, false)), s.textContent = "");
      return this;
    }, clone: function(s, a) {
      return s = s == null ? false : s, a = a == null ? s : a, this.map(function() {
        return f.clone(this, s, a);
      });
    }, html: function(s) {
      return be(this, function(a) {
        var d = this[0] || {}, b = 0, T = this.length;
        if (a === void 0 && d.nodeType === 1) return d.innerHTML;
        if (typeof a == "string" && !Mc.test(a) && !Tt[(Ur.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = f.htmlPrefilter(a);
          try {
            for (; b < T; b++) d = this[b] || {}, d.nodeType === 1 && (f.cleanData(He(d, false)), d.innerHTML = a);
            d = 0;
          } catch (x) {
          }
        }
        d && this.empty().append(a);
      }, null, s, arguments.length);
    }, replaceWith: function() {
      var s = [];
      return fi(this, arguments, function(a) {
        var d = this.parentNode;
        f.inArray(this, s) < 0 && (f.cleanData(He(this)), d && d.replaceChild(a, this));
      }, s);
    } }), f.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(s, a) {
      f.fn[s] = function(d) {
        for (var b, T = [], x = f(d), A = x.length - 1, M = 0; M <= A; M++) b = M === A ? this : this.clone(true), f(x[M])[a](b), c.apply(T, b);
        return this.pushStack(T);
      };
    });
    var Lc = new RegExp("^(" + Yr + ")(?!px)[a-z%]+$", "i"), us = /^--/;
    function vn(s) {
      var a = s.ownerDocument.defaultView;
      return a || (a = e), a.getComputedStyle(s);
    }
    function Pc(s, a, d) {
      var b, T, x = {};
      for (T in a) x[T] = s.style[T], s.style[T] = a[T];
      b = d.call(s);
      for (T in a) s.style[T] = x[T];
      return b;
    }
    function io(s, a, d) {
      var b, T = us.test(a);
      return d = d || vn(s), d && (b = d.getPropertyValue(a) || d[a], T && b && (b = b.replace(V, "$1") || void 0), b === "" && !Bi(s) && (b = f.style(s, a))), b !== void 0 ? b + "" : b;
    }
    var no = ["Webkit", "Moz", "ms"], so = p.createElement("div").style;
    function Dc(s) {
      for (var a = s[0].toUpperCase() + s.slice(1), d = no.length; d--; ) if (s = no[d] + a, s in so) return s;
    }
    function ds(s) {
      return s in so ? s : Dc(s) || s;
    }
    var ro, oo, Dt = p.createElement("table");
    function ao() {
      if (!(!Dt || !Dt.style)) {
        var s, a = p.createElement("col"), d = p.createElement("tr"), b = p.createElement("td");
        if (Dt.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0", d.style.cssText = "box-sizing:content-box;border:1px solid;height:1px", b.style.cssText = "height:9px;width:9px;padding:0", a.span = 2, W.appendChild(Dt).appendChild(a).parentNode.appendChild(d).appendChild(b).parentNode.appendChild(b.cloneNode(true)), Dt.offsetWidth === 0) {
          W.removeChild(Dt);
          return;
        }
        s = e.getComputedStyle(d), oo = N || Math.round(parseFloat(e.getComputedStyle(a).width)) === 18, ro = Math.round(parseFloat(s.height) + parseFloat(s.borderTopWidth) + parseFloat(s.borderBottomWidth)) === d.offsetHeight, W.removeChild(Dt), Dt = null;
      }
    }
    f.extend(h, { reliableTrDimensions: function() {
      return ao(), ro;
    }, reliableColDimensions: function() {
      return ao(), oo;
    } });
    var zc = { position: "absolute", visibility: "hidden", display: "block" }, lo = { letterSpacing: "0", fontWeight: "400" };
    function co(s, a, d) {
      var b = Vi.exec(a);
      return b ? Math.max(0, b[2] - (d || 0)) + (b[3] || "px") : a;
    }
    function uo(s, a, d, b, T, x) {
      var A = a === "width" ? 1 : 0, M = 0, O = 0, z = 0;
      if (d === (b ? "border" : "content")) return 0;
      for (; A < 4; A += 2) d === "margin" && (z += f.css(s, d + Pt[A], true, T)), b ? (d === "content" && (O -= f.css(s, "padding" + Pt[A], true, T)), d !== "margin" && (O -= f.css(s, "border" + Pt[A] + "Width", true, T))) : (O += f.css(s, "padding" + Pt[A], true, T), d !== "padding" ? O += f.css(s, "border" + Pt[A] + "Width", true, T) : M += f.css(s, "border" + Pt[A] + "Width", true, T));
      return !b && x >= 0 && (O += Math.max(0, Math.ceil(s["offset" + a[0].toUpperCase() + a.slice(1)] - x - O - M - 0.5)) || 0), O + z;
    }
    function fo(s, a, d) {
      var b = vn(s), T = N || d, x = T && f.css(s, "boxSizing", false, b) === "border-box", A = x, M = io(s, a, b), O = "offset" + a[0].toUpperCase() + a.slice(1);
      if (Lc.test(M)) {
        if (!d) return M;
        M = "auto";
      }
      return (M === "auto" || N && x || !h.reliableColDimensions() && P(s, "col") || !h.reliableTrDimensions() && P(s, "tr")) && s.getClientRects().length && (x = f.css(s, "boxSizing", false, b) === "border-box", A = O in s, A && (M = s[O])), M = parseFloat(M) || 0, M + uo(s, a, d || (x ? "border" : "content"), A, b, M) + "px";
    }
    f.extend({ cssHooks: {}, style: function(s, a, d, b) {
      if (!(!s || s.nodeType === 3 || s.nodeType === 8 || !s.style)) {
        var T, x, A, M = as(a), O = us.test(a), z = s.style;
        if (O || (a = ds(M)), A = f.cssHooks[a] || f.cssHooks[M], d !== void 0) {
          if (x = typeof d, x === "string" && (T = Vi.exec(d)) && T[1] && (d = Xr(s, a, T), x = "number"), d == null || d !== d) return;
          x === "number" && (d += T && T[3] || (pn(M) ? "px" : "")), N && d === "" && a.indexOf("background") === 0 && (z[a] = "inherit"), (!A || !("set" in A) || (d = A.set(s, d, b)) !== void 0) && (O ? z.setProperty(a, d) : z[a] = d);
        } else return A && "get" in A && (T = A.get(s, false, b)) !== void 0 ? T : z[a];
      }
    }, css: function(s, a, d, b) {
      var T, x, A, M = as(a), O = us.test(a);
      return O || (a = ds(M)), A = f.cssHooks[a] || f.cssHooks[M], A && "get" in A && (T = A.get(s, true, d)), T === void 0 && (T = io(s, a, b)), T === "normal" && a in lo && (T = lo[a]), d === "" || d ? (x = parseFloat(T), d === true || isFinite(x) ? x || 0 : T) : T;
    } }), f.each(["height", "width"], function(s, a) {
      f.cssHooks[a] = { get: function(d, b, T) {
        if (b) return f.css(d, "display") === "none" ? Pc(d, zc, function() {
          return fo(d, a, T);
        }) : fo(d, a, T);
      }, set: function(d, b, T) {
        var x, A = vn(d), M = T && f.css(d, "boxSizing", false, A) === "border-box", O = T ? uo(d, a, T, M, A) : 0;
        return O && (x = Vi.exec(b)) && (x[3] || "px") !== "px" && (d.style[a] = b, b = f.css(d, a)), co(d, b, O);
      } };
    }), f.each({ margin: "", padding: "", border: "Width" }, function(s, a) {
      f.cssHooks[s + a] = { expand: function(d) {
        for (var b = 0, T = {}, x = typeof d == "string" ? d.split(" ") : [d]; b < 4; b++) T[s + Pt[b] + a] = x[b] || x[b - 2] || x[0];
        return T;
      } }, s !== "margin" && (f.cssHooks[s + a].set = co);
    }), f.fn.extend({ css: function(s, a) {
      return be(this, function(d, b, T) {
        var x, A, M = {}, O = 0;
        if (Array.isArray(b)) {
          for (x = vn(d), A = b.length; O < A; O++) M[b[O]] = f.css(d, b[O], false, x);
          return M;
        }
        return T !== void 0 ? f.style(d, b, T) : f.css(d, b);
      }, s, a, arguments.length > 1);
    } });
    function Qe(s, a, d, b, T) {
      return new Qe.prototype.init(s, a, d, b, T);
    }
    f.Tween = Qe, Qe.prototype = { constructor: Qe, init: function(s, a, d, b, T, x) {
      this.elem = s, this.prop = d, this.easing = T || f.easing._default, this.options = a, this.start = this.now = this.cur(), this.end = b, this.unit = x || (pn(d) ? "px" : "");
    }, cur: function() {
      var s = Qe.propHooks[this.prop];
      return s && s.get ? s.get(this) : Qe.propHooks._default.get(this);
    }, run: function(s) {
      var a, d = Qe.propHooks[this.prop];
      return this.options.duration ? this.pos = a = f.easing[this.easing](s, this.options.duration * s, 0, 1, this.options.duration) : this.pos = a = s, this.now = (this.end - this.start) * a + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), d && d.set ? d.set(this) : Qe.propHooks._default.set(this), this;
    } }, Qe.prototype.init.prototype = Qe.prototype, Qe.propHooks = { _default: { get: function(s) {
      var a;
      return s.elem.nodeType !== 1 || s.elem[s.prop] != null && s.elem.style[s.prop] == null ? s.elem[s.prop] : (a = f.css(s.elem, s.prop, ""), !a || a === "auto" ? 0 : a);
    }, set: function(s) {
      f.fx.step[s.prop] ? f.fx.step[s.prop](s) : s.elem.nodeType === 1 && (f.cssHooks[s.prop] || s.elem.style[ds(s.prop)] != null) ? f.style(s.elem, s.prop, s.now + s.unit) : s.elem[s.prop] = s.now;
    } } }, f.easing = { linear: function(s) {
      return s;
    }, swing: function(s) {
      return 0.5 - Math.cos(s * Math.PI) / 2;
    }, _default: "swing" }, f.fx = Qe.prototype.init, f.fx.step = {};
    var mi, yn, $c = /^(?:toggle|show|hide)$/, Nc = /queueHooks$/;
    function fs() {
      yn && (p.hidden === false && e.requestAnimationFrame ? e.requestAnimationFrame(fs) : e.setTimeout(fs, 13), f.fx.tick());
    }
    function ho() {
      return e.setTimeout(function() {
        mi = void 0;
      }), mi = Date.now();
    }
    function bn(s, a) {
      var d, b = 0, T = { height: s };
      for (a = a ? 1 : 0; b < 4; b += 2 - a) d = Pt[b], T["margin" + d] = T["padding" + d] = s;
      return a && (T.opacity = T.width = s), T;
    }
    function po(s, a, d) {
      for (var b, T = (at.tweeners[a] || []).concat(at.tweeners["*"]), x = 0, A = T.length; x < A; x++) if (b = T[x].call(d, a, s)) return b;
    }
    function kc(s, a, d) {
      var b, T, x, A, M, O, z, H, j = "width" in a || "height" in a, k = this, G = {}, te = s.style, le = s.nodeType && hn(s), ae = ce.get(s, "fxshow");
      d.queue || (A = f._queueHooks(s, "fx"), A.unqueued == null && (A.unqueued = 0, M = A.empty.fire, A.empty.fire = function() {
        A.unqueued || M();
      }), A.unqueued++, k.always(function() {
        k.always(function() {
          A.unqueued--, f.queue(s, "fx").length || A.empty.fire();
        });
      }));
      for (b in a) if (T = a[b], $c.test(T)) {
        if (delete a[b], x = x || T === "toggle", T === (le ? "hide" : "show")) if (T === "show" && ae && ae[b] !== void 0) le = true;
        else continue;
        G[b] = ae && ae[b] || f.style(s, b);
      }
      if (O = !f.isEmptyObject(a), !(!O && f.isEmptyObject(G))) {
        j && s.nodeType === 1 && (d.overflow = [te.overflow, te.overflowX, te.overflowY], z = ae && ae.display, z == null && (z = ce.get(s, "display")), H = f.css(s, "display"), H === "none" && (z ? H = z : (di([s], true), z = s.style.display || z, H = f.css(s, "display"), di([s]))), (H === "inline" || H === "inline-block" && z != null) && f.css(s, "float") === "none" && (O || (k.done(function() {
          te.display = z;
        }), z == null && (H = te.display, z = H === "none" ? "" : H)), te.display = "inline-block")), d.overflow && (te.overflow = "hidden", k.always(function() {
          te.overflow = d.overflow[0], te.overflowX = d.overflow[1], te.overflowY = d.overflow[2];
        })), O = false;
        for (b in G) O || (ae ? "hidden" in ae && (le = ae.hidden) : ae = ce.set(s, "fxshow", { display: z }), x && (ae.hidden = !le), le && di([s], true), k.done(function() {
          le || di([s]), ce.remove(s, "fxshow");
          for (b in G) f.style(s, b, G[b]);
        })), O = po(le ? ae[b] : 0, b, k), b in ae || (ae[b] = O.start, le && (O.end = O.start, O.start = 0));
      }
    }
    function Rc(s, a) {
      var d, b, T, x, A;
      for (d in s) if (b = as(d), T = a[b], x = s[d], Array.isArray(x) && (T = x[1], x = s[d] = x[0]), d !== b && (s[b] = x, delete s[d]), A = f.cssHooks[b], A && "expand" in A) {
        x = A.expand(x), delete s[b];
        for (d in x) d in s || (s[d] = x[d], a[d] = T);
      } else a[b] = T;
    }
    function at(s, a, d) {
      var b, T, x = 0, A = at.prefilters.length, M = f.Deferred().always(function() {
        delete O.elem;
      }), O = function() {
        if (T) return false;
        for (var j = mi || ho(), k = Math.max(0, z.startTime + z.duration - j), G = 1 - (k / z.duration || 0), te = 0, le = z.tweens.length; te < le; te++) z.tweens[te].run(G);
        return M.notifyWith(s, [z, G, k]), G < 1 && le ? k : (le || M.notifyWith(s, [z, 1, 0]), M.resolveWith(s, [z]), false);
      }, z = M.promise({ elem: s, props: f.extend({}, a), opts: f.extend(true, { specialEasing: {}, easing: f.easing._default }, d), originalProperties: a, originalOptions: d, startTime: mi || ho(), duration: d.duration, tweens: [], createTween: function(j, k) {
        var G = f.Tween(s, z.opts, j, k, z.opts.specialEasing[j] || z.opts.easing);
        return z.tweens.push(G), G;
      }, stop: function(j) {
        var k = 0, G = j ? z.tweens.length : 0;
        if (T) return this;
        for (T = true; k < G; k++) z.tweens[k].run(1);
        return j ? (M.notifyWith(s, [z, 1, 0]), M.resolveWith(s, [z, j])) : M.rejectWith(s, [z, j]), this;
      } }), H = z.props;
      for (Rc(H, z.opts.specialEasing); x < A; x++) if (b = at.prefilters[x].call(z, s, H, z.opts), b) return typeof b.stop == "function" && (f._queueHooks(z.elem, z.opts.queue).stop = b.stop.bind(b)), b;
      return f.map(H, po, z), typeof z.opts.start == "function" && z.opts.start.call(s, z), z.progress(z.opts.progress).done(z.opts.done, z.opts.complete).fail(z.opts.fail).always(z.opts.always), f.fx.timer(f.extend(O, { elem: s, anim: z, queue: z.opts.queue })), z;
    }
    f.Animation = f.extend(at, { tweeners: { "*": [function(s, a) {
      var d = this.createTween(s, a);
      return Xr(d.elem, s, Vi.exec(a), d), d;
    }] }, tweener: function(s, a) {
      typeof s == "function" ? (a = s, s = ["*"]) : s = s.match(Oe);
      for (var d, b = 0, T = s.length; b < T; b++) d = s[b], at.tweeners[d] = at.tweeners[d] || [], at.tweeners[d].unshift(a);
    }, prefilters: [kc], prefilter: function(s, a) {
      a ? at.prefilters.unshift(s) : at.prefilters.push(s);
    } }), f.speed = function(s, a, d) {
      var b = s && typeof s == "object" ? f.extend({}, s) : { complete: d || a || typeof s == "function" && s, duration: s, easing: d && a || a && typeof a != "function" && a };
      return f.fx.off ? b.duration = 0 : typeof b.duration != "number" && (b.duration in f.fx.speeds ? b.duration = f.fx.speeds[b.duration] : b.duration = f.fx.speeds._default), (b.queue == null || b.queue === true) && (b.queue = "fx"), b.old = b.complete, b.complete = function() {
        typeof b.old == "function" && b.old.call(this), b.queue && f.dequeue(this, b.queue);
      }, b;
    }, f.fn.extend({ fadeTo: function(s, a, d, b) {
      return this.filter(hn).css("opacity", 0).show().end().animate({ opacity: a }, s, d, b);
    }, animate: function(s, a, d, b) {
      var T = f.isEmptyObject(s), x = f.speed(a, d, b), A = function() {
        var M = at(this, f.extend({}, s), x);
        (T || ce.get(this, "finish")) && M.stop(true);
      };
      return A.finish = A, T || x.queue === false ? this.each(A) : this.queue(x.queue, A);
    }, stop: function(s, a, d) {
      var b = function(T) {
        var x = T.stop;
        delete T.stop, x(d);
      };
      return typeof s != "string" && (d = a, a = s, s = void 0), a && this.queue(s || "fx", []), this.each(function() {
        var T = true, x = s != null && s + "queueHooks", A = f.timers, M = ce.get(this);
        if (x) M[x] && M[x].stop && b(M[x]);
        else for (x in M) M[x] && M[x].stop && Nc.test(x) && b(M[x]);
        for (x = A.length; x--; ) A[x].elem === this && (s == null || A[x].queue === s) && (A[x].anim.stop(d), T = false, A.splice(x, 1));
        (T || !d) && f.dequeue(this, s);
      });
    }, finish: function(s) {
      return s !== false && (s = s || "fx"), this.each(function() {
        var a, d = ce.get(this), b = d[s + "queue"], T = d[s + "queueHooks"], x = f.timers, A = b ? b.length : 0;
        for (d.finish = true, f.queue(this, s, []), T && T.stop && T.stop.call(this, true), a = x.length; a--; ) x[a].elem === this && x[a].queue === s && (x[a].anim.stop(true), x.splice(a, 1));
        for (a = 0; a < A; a++) b[a] && b[a].finish && b[a].finish.call(this);
        delete d.finish;
      });
    } }), f.each(["toggle", "show", "hide"], function(s, a) {
      var d = f.fn[a];
      f.fn[a] = function(b, T, x) {
        return b == null || typeof b == "boolean" ? d.apply(this, arguments) : this.animate(bn(a, true), b, T, x);
      };
    }), f.each({ slideDown: bn("show"), slideUp: bn("hide"), slideToggle: bn("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(s, a) {
      f.fn[s] = function(d, b, T) {
        return this.animate(a, d, b, T);
      };
    }), f.timers = [], f.fx.tick = function() {
      var s, a = 0, d = f.timers;
      for (mi = Date.now(); a < d.length; a++) s = d[a], !s() && d[a] === s && d.splice(a--, 1);
      d.length || f.fx.stop(), mi = void 0;
    }, f.fx.timer = function(s) {
      f.timers.push(s), f.fx.start();
    }, f.fx.start = function() {
      yn || (yn = true, fs());
    }, f.fx.stop = function() {
      yn = null;
    }, f.fx.speeds = { slow: 600, fast: 200, _default: 400 }, f.fn.delay = function(s, a) {
      return s = f.fx && f.fx.speeds[s] || s, a = a || "fx", this.queue(a, function(d, b) {
        var T = e.setTimeout(d, s);
        b.stop = function() {
          e.clearTimeout(T);
        };
      });
    };
    var Hc = /^(?:input|select|textarea|button)$/i, Vc = /^(?:a|area)$/i;
    f.fn.extend({ prop: function(s, a) {
      return be(this, f.prop, s, a, arguments.length > 1);
    }, removeProp: function(s) {
      return this.each(function() {
        delete this[f.propFix[s] || s];
      });
    } }), f.extend({ prop: function(s, a, d) {
      var b, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) return (x !== 1 || !f.isXMLDoc(s)) && (a = f.propFix[a] || a, T = f.propHooks[a]), d !== void 0 ? T && "set" in T && (b = T.set(s, d, a)) !== void 0 ? b : s[a] = d : T && "get" in T && (b = T.get(s, a)) !== null ? b : s[a];
    }, propHooks: { tabIndex: { get: function(s) {
      var a = s.getAttribute("tabindex");
      return a ? parseInt(a, 10) : Hc.test(s.nodeName) || Vc.test(s.nodeName) && s.href ? 0 : -1;
    } } }, propFix: { for: "htmlFor", class: "className" } }), N && (f.propHooks.selected = { get: function(s) {
      var a = s.parentNode;
      return a && a.parentNode && a.parentNode.selectedIndex, null;
    }, set: function(s) {
      var a = s.parentNode;
      a && (a.selectedIndex, a.parentNode && a.parentNode.selectedIndex);
    } }), f.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
      f.propFix[this.toLowerCase()] = this;
    });
    function Xt(s) {
      var a = s.match(Oe) || [];
      return a.join(" ");
    }
    function gi(s) {
      return s.getAttribute && s.getAttribute("class") || "";
    }
    function hs(s) {
      return Array.isArray(s) ? s : typeof s == "string" ? s.match(Oe) || [] : [];
    }
    f.fn.extend({ addClass: function(s) {
      var a, d, b, T, x, A;
      return typeof s == "function" ? this.each(function(M) {
        f(this).addClass(s.call(this, M, gi(this)));
      }) : (a = hs(s), a.length ? this.each(function() {
        if (b = gi(this), d = this.nodeType === 1 && " " + Xt(b) + " ", d) {
          for (x = 0; x < a.length; x++) T = a[x], d.indexOf(" " + T + " ") < 0 && (d += T + " ");
          A = Xt(d), b !== A && this.setAttribute("class", A);
        }
      }) : this);
    }, removeClass: function(s) {
      var a, d, b, T, x, A;
      return typeof s == "function" ? this.each(function(M) {
        f(this).removeClass(s.call(this, M, gi(this)));
      }) : arguments.length ? (a = hs(s), a.length ? this.each(function() {
        if (b = gi(this), d = this.nodeType === 1 && " " + Xt(b) + " ", d) {
          for (x = 0; x < a.length; x++) for (T = a[x]; d.indexOf(" " + T + " ") > -1; ) d = d.replace(" " + T + " ", " ");
          A = Xt(d), b !== A && this.setAttribute("class", A);
        }
      }) : this) : this.attr("class", "");
    }, toggleClass: function(s, a) {
      var d, b, T, x;
      return typeof s == "function" ? this.each(function(A) {
        f(this).toggleClass(s.call(this, A, gi(this), a), a);
      }) : typeof a == "boolean" ? a ? this.addClass(s) : this.removeClass(s) : (d = hs(s), d.length ? this.each(function() {
        for (x = f(this), T = 0; T < d.length; T++) b = d[T], x.hasClass(b) ? x.removeClass(b) : x.addClass(b);
      }) : this);
    }, hasClass: function(s) {
      var a, d, b = 0;
      for (a = " " + s + " "; d = this[b++]; ) if (d.nodeType === 1 && (" " + Xt(gi(d)) + " ").indexOf(a) > -1) return true;
      return false;
    } }), f.fn.extend({ val: function(s) {
      var a, d, b, T = this[0];
      return arguments.length ? (b = typeof s == "function", this.each(function(x) {
        var A;
        this.nodeType === 1 && (b ? A = s.call(this, x, f(this).val()) : A = s, A == null ? A = "" : typeof A == "number" ? A += "" : Array.isArray(A) && (A = f.map(A, function(M) {
          return M == null ? "" : M + "";
        })), a = f.valHooks[this.type] || f.valHooks[this.nodeName.toLowerCase()], (!a || !("set" in a) || a.set(this, A, "value") === void 0) && (this.value = A));
      })) : T ? (a = f.valHooks[T.type] || f.valHooks[T.nodeName.toLowerCase()], a && "get" in a && (d = a.get(T, "value")) !== void 0 ? d : (d = T.value, d == null ? "" : d)) : void 0;
    } }), f.extend({ valHooks: { select: { get: function(s) {
      var a, d, b, T = s.options, x = s.selectedIndex, A = s.type === "select-one", M = A ? null : [], O = A ? x + 1 : T.length;
      for (x < 0 ? b = O : b = A ? x : 0; b < O; b++) if (d = T[b], d.selected && !d.disabled && (!d.parentNode.disabled || !P(d.parentNode, "optgroup"))) {
        if (a = f(d).val(), A) return a;
        M.push(a);
      }
      return M;
    }, set: function(s, a) {
      for (var d, b, T = s.options, x = f.makeArray(a), A = T.length; A--; ) b = T[A], (b.selected = f.inArray(f(b).val(), x) > -1) && (d = true);
      return d || (s.selectedIndex = -1), x;
    } } } }), N && (f.valHooks.option = { get: function(s) {
      var a = s.getAttribute("value");
      return a != null ? a : Xt(f.text(s));
    } }), f.each(["radio", "checkbox"], function() {
      f.valHooks[this] = { set: function(s, a) {
        if (Array.isArray(a)) return s.checked = f.inArray(f(s).val(), a) > -1;
      } };
    });
    var mo = /^(?:focusinfocus|focusoutblur)$/, go = function(s) {
      s.stopPropagation();
    };
    f.extend(f.event, { trigger: function(s, a, d, b) {
      var T, x, A, M, O, z, H, j, k = [d || p], G = v.call(s, "type") ? s.type : s, te = v.call(s, "namespace") ? s.namespace.split(".") : [];
      if (x = j = A = d = d || p, !(d.nodeType === 3 || d.nodeType === 8) && !mo.test(G + f.event.triggered) && (G.indexOf(".") > -1 && (te = G.split("."), G = te.shift(), te.sort()), O = G.indexOf(":") < 0 && "on" + G, s = s[f.expando] ? s : new f.Event(G, typeof s == "object" && s), s.isTrigger = b ? 2 : 3, s.namespace = te.join("."), s.rnamespace = s.namespace ? new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, s.result = void 0, s.target || (s.target = d), a = a == null ? [s] : f.makeArray(a, [s]), H = f.event.special[G] || {}, !(!b && H.trigger && H.trigger.apply(d, a) === false))) {
        if (!b && !H.noBubble && !C(d)) {
          for (M = H.delegateType || G, mo.test(M + G) || (x = x.parentNode); x; x = x.parentNode) k.push(x), A = x;
          A === (d.ownerDocument || p) && k.push(A.defaultView || A.parentWindow || e);
        }
        for (T = 0; (x = k[T++]) && !s.isPropagationStopped(); ) j = x, s.type = T > 1 ? M : H.bindType || G, z = (ce.get(x, "events") || /* @__PURE__ */ Object.create(null))[s.type] && ce.get(x, "handle"), z && z.apply(x, a), z = O && x[O], z && z.apply && Ri(x) && (s.result = z.apply(x, a), s.result === false && s.preventDefault());
        return s.type = G, !b && !s.isDefaultPrevented() && (!H._default || H._default.apply(k.pop(), a) === false) && Ri(d) && O && typeof d[G] == "function" && !C(d) && (A = d[O], A && (d[O] = null), f.event.triggered = G, s.isPropagationStopped() && j.addEventListener(G, go), d[G](), s.isPropagationStopped() && j.removeEventListener(G, go), f.event.triggered = void 0, A && (d[O] = A)), s.result;
      }
    }, simulate: function(s, a, d) {
      var b = f.extend(new f.Event(), d, { type: s, isSimulated: true });
      f.event.trigger(b, null, a);
    } }), f.fn.extend({ trigger: function(s, a) {
      return this.each(function() {
        f.event.trigger(s, a, this);
      });
    }, triggerHandler: function(s, a) {
      var d = this[0];
      if (d) return f.event.trigger(s, a, d, true);
    } });
    var Wi = e.location, vo = { guid: Date.now() }, ps = /\?/;
    f.parseXML = function(s) {
      var a, d;
      if (!s || typeof s != "string") return null;
      try {
        a = new e.DOMParser().parseFromString(s, "text/xml");
      } catch (b) {
      }
      return d = a && a.getElementsByTagName("parsererror")[0], (!a || d) && f.error("Invalid XML: " + (d ? f.map(d.childNodes, function(b) {
        return b.textContent;
      }).join(`
`) : s)), a;
    };
    var Bc = /\[\]$/, yo = /\r?\n/g, Wc = /^(?:submit|button|image|reset|file)$/i, Fc = /^(?:input|select|textarea|keygen)/i;
    function ms(s, a, d, b) {
      var T;
      if (Array.isArray(a)) f.each(a, function(x, A) {
        d || Bc.test(s) ? b(s, A) : ms(s + "[" + (typeof A == "object" && A != null ? x : "") + "]", A, d, b);
      });
      else if (!d && g(a) === "object") for (T in a) ms(s + "[" + T + "]", a[T], d, b);
      else b(s, a);
    }
    f.param = function(s, a) {
      var d, b = [], T = function(x, A) {
        var M = typeof A == "function" ? A() : A;
        b[b.length] = encodeURIComponent(x) + "=" + encodeURIComponent(M == null ? "" : M);
      };
      if (s == null) return "";
      if (Array.isArray(s) || s.jquery && !f.isPlainObject(s)) f.each(s, function() {
        T(this.name, this.value);
      });
      else for (d in s) ms(d, s[d], a, T);
      return b.join("&");
    }, f.fn.extend({ serialize: function() {
      return f.param(this.serializeArray());
    }, serializeArray: function() {
      return this.map(function() {
        var s = f.prop(this, "elements");
        return s ? f.makeArray(s) : this;
      }).filter(function() {
        var s = this.type;
        return this.name && !f(this).is(":disabled") && Fc.test(this.nodeName) && !Wc.test(s) && (this.checked || !mn.test(s));
      }).map(function(s, a) {
        var d = f(this).val();
        return d == null ? null : Array.isArray(d) ? f.map(d, function(b) {
          return { name: a.name, value: b.replace(yo, `\r
`) };
        }) : { name: a.name, value: d.replace(yo, `\r
`) };
      }).get();
    } });
    var Gc = /%20/g, jc = /#.*$/, Yc = /([?&])_=[^&]*/, Xc = /^(.*?):[ \t]*([^\r\n]*)$/mg, qc = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, Uc = /^(?:GET|HEAD)$/, Kc = /^\/\//, bo = {}, gs = {}, Eo = "*/".concat("*"), vs = p.createElement("a");
    vs.href = Wi.href;
    function So(s) {
      return function(a, d) {
        typeof a != "string" && (d = a, a = "*");
        var b, T = 0, x = a.toLowerCase().match(Oe) || [];
        if (typeof d == "function") for (; b = x[T++]; ) b[0] === "+" ? (b = b.slice(1) || "*", (s[b] = s[b] || []).unshift(d)) : (s[b] = s[b] || []).push(d);
      };
    }
    function To(s, a, d, b) {
      var T = {}, x = s === gs;
      function A(M) {
        var O;
        return T[M] = true, f.each(s[M] || [], function(z, H) {
          var j = H(a, d, b);
          if (typeof j == "string" && !x && !T[j]) return a.dataTypes.unshift(j), A(j), false;
          if (x) return !(O = j);
        }), O;
      }
      return A(a.dataTypes[0]) || !T["*"] && A("*");
    }
    function ys(s, a) {
      var d, b, T = f.ajaxSettings.flatOptions || {};
      for (d in a) a[d] !== void 0 && ((T[d] ? s : b || (b = {}))[d] = a[d]);
      return b && f.extend(true, s, b), s;
    }
    function Zc(s, a, d) {
      for (var b, T, x, A, M = s.contents, O = s.dataTypes; O[0] === "*"; ) O.shift(), b === void 0 && (b = s.mimeType || a.getResponseHeader("Content-Type"));
      if (b) {
        for (T in M) if (M[T] && M[T].test(b)) {
          O.unshift(T);
          break;
        }
      }
      if (O[0] in d) x = O[0];
      else {
        for (T in d) {
          if (!O[0] || s.converters[T + " " + O[0]]) {
            x = T;
            break;
          }
          A || (A = T);
        }
        x = x || A;
      }
      if (x) return x !== O[0] && O.unshift(x), d[x];
    }
    function Qc(s, a, d, b) {
      var T, x, A, M, O, z = {}, H = s.dataTypes.slice();
      if (H[1]) for (A in s.converters) z[A.toLowerCase()] = s.converters[A];
      for (x = H.shift(); x; ) if (s.responseFields[x] && (d[s.responseFields[x]] = a), !O && b && s.dataFilter && (a = s.dataFilter(a, s.dataType)), O = x, x = H.shift(), x) {
        if (x === "*") x = O;
        else if (O !== "*" && O !== x) {
          if (A = z[O + " " + x] || z["* " + x], !A) {
            for (T in z) if (M = T.split(" "), M[1] === x && (A = z[O + " " + M[0]] || z["* " + M[0]], A)) {
              A === true ? A = z[T] : z[T] !== true && (x = M[0], H.unshift(M[1]));
              break;
            }
          }
          if (A !== true) if (A && s.throws) a = A(a);
          else try {
            a = A(a);
          } catch (j) {
            return { state: "parsererror", error: A ? j : "No conversion from " + O + " to " + x };
          }
        }
      }
      return { state: "success", data: a };
    }
    f.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: Wi.href, type: "GET", isLocal: qc.test(Wi.protocol), global: true, processData: true, async: true, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Eo, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": true, "text json": JSON.parse, "text xml": f.parseXML }, flatOptions: { url: true, context: true } }, ajaxSetup: function(s, a) {
      return a ? ys(ys(s, f.ajaxSettings), a) : ys(f.ajaxSettings, s);
    }, ajaxPrefilter: So(bo), ajaxTransport: So(gs), ajax: function(s, a) {
      typeof s == "object" && (a = s, s = void 0), a = a || {};
      var d, b, T, x, A, M, O, z, H, j, k = f.ajaxSetup({}, a), G = k.context || k, te = k.context && (G.nodeType || G.jquery) ? f(G) : f.event, le = f.Deferred(), ae = f.Callbacks("once memory"), ve = k.statusCode || {}, pe = {}, Ve = {}, ze = "canceled", de = { readyState: 0, getResponseHeader: function(fe) {
        var xe;
        if (O) {
          if (!x) for (x = {}; xe = Xc.exec(T); ) x[xe[1].toLowerCase() + " "] = (x[xe[1].toLowerCase() + " "] || []).concat(xe[2]);
          xe = x[fe.toLowerCase() + " "];
        }
        return xe == null ? null : xe.join(", ");
      }, getAllResponseHeaders: function() {
        return O ? T : null;
      }, setRequestHeader: function(fe, xe) {
        return O == null && (fe = Ve[fe.toLowerCase()] = Ve[fe.toLowerCase()] || fe, pe[fe] = xe), this;
      }, overrideMimeType: function(fe) {
        return O == null && (k.mimeType = fe), this;
      }, statusCode: function(fe) {
        var xe;
        if (fe) if (O) de.always(fe[de.status]);
        else for (xe in fe) ve[xe] = [ve[xe], fe[xe]];
        return this;
      }, abort: function(fe) {
        var xe = fe || ze;
        return d && d.abort(xe), En(0, xe), this;
      } };
      if (le.promise(de), k.url = ((s || k.url || Wi.href) + "").replace(Kc, Wi.protocol + "//"), k.type = a.method || a.type || k.method || k.type, k.dataTypes = (k.dataType || "*").toLowerCase().match(Oe) || [""], k.crossDomain == null) {
        M = p.createElement("a");
        try {
          M.href = k.url, M.href = M.href, k.crossDomain = vs.protocol + "//" + vs.host != M.protocol + "//" + M.host;
        } catch (fe) {
          k.crossDomain = true;
        }
      }
      if (To(bo, k, a, de), k.data && k.processData && typeof k.data != "string" && (k.data = f.param(k.data, k.traditional)), O) return de;
      z = f.event && k.global, z && f.active++ === 0 && f.event.trigger("ajaxStart"), k.type = k.type.toUpperCase(), k.hasContent = !Uc.test(k.type), b = k.url.replace(jc, ""), k.hasContent ? k.data && k.processData && (k.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (k.data = k.data.replace(Gc, "+")) : (j = k.url.slice(b.length), k.data && (k.processData || typeof k.data == "string") && (b += (ps.test(b) ? "&" : "?") + k.data, delete k.data), k.cache === false && (b = b.replace(Yc, "$1"), j = (ps.test(b) ? "&" : "?") + "_=" + vo.guid++ + j), k.url = b + j), k.ifModified && (f.lastModified[b] && de.setRequestHeader("If-Modified-Since", f.lastModified[b]), f.etag[b] && de.setRequestHeader("If-None-Match", f.etag[b])), (k.data && k.hasContent && k.contentType !== false || a.contentType) && de.setRequestHeader("Content-Type", k.contentType), de.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + (k.dataTypes[0] !== "*" ? ", " + Eo + "; q=0.01" : "") : k.accepts["*"]);
      for (H in k.headers) de.setRequestHeader(H, k.headers[H]);
      if (k.beforeSend && (k.beforeSend.call(G, de, k) === false || O)) return de.abort();
      if (ze = "abort", ae.add(k.complete), de.done(k.success), de.fail(k.error), d = To(gs, k, a, de), !d) En(-1, "No Transport");
      else {
        if (de.readyState = 1, z && te.trigger("ajaxSend", [de, k]), O) return de;
        k.async && k.timeout > 0 && (A = e.setTimeout(function() {
          de.abort("timeout");
        }, k.timeout));
        try {
          O = false, d.send(pe, En);
        } catch (fe) {
          if (O) throw fe;
          En(-1, fe);
        }
      }
      function En(fe, xe, Co, iu) {
        var zt, Es, Fi, vi, yi, mt = xe;
        O || (O = true, A && e.clearTimeout(A), d = void 0, T = iu || "", de.readyState = fe > 0 ? 4 : 0, zt = fe >= 200 && fe < 300 || fe === 304, Co && (vi = Zc(k, de, Co)), !zt && f.inArray("script", k.dataTypes) > -1 && f.inArray("json", k.dataTypes) < 0 && (k.converters["text script"] = function() {
        }), vi = Qc(k, vi, de, zt), zt ? (k.ifModified && (yi = de.getResponseHeader("Last-Modified"), yi && (f.lastModified[b] = yi), yi = de.getResponseHeader("etag"), yi && (f.etag[b] = yi)), fe === 204 || k.type === "HEAD" ? mt = "nocontent" : fe === 304 ? mt = "notmodified" : (mt = vi.state, Es = vi.data, Fi = vi.error, zt = !Fi)) : (Fi = mt, (fe || !mt) && (mt = "error", fe < 0 && (fe = 0))), de.status = fe, de.statusText = (xe || mt) + "", zt ? le.resolveWith(G, [Es, mt, de]) : le.rejectWith(G, [de, mt, Fi]), de.statusCode(ve), ve = void 0, z && te.trigger(zt ? "ajaxSuccess" : "ajaxError", [de, k, zt ? Es : Fi]), ae.fireWith(G, [de, mt]), z && (te.trigger("ajaxComplete", [de, k]), --f.active || f.event.trigger("ajaxStop")));
      }
      return de;
    }, getJSON: function(s, a, d) {
      return f.get(s, a, d, "json");
    }, getScript: function(s, a) {
      return f.get(s, void 0, a, "script");
    } }), f.each(["get", "post"], function(s, a) {
      f[a] = function(d, b, T, x) {
        return (typeof b == "function" || b === null) && (x = x || T, T = b, b = void 0), f.ajax(f.extend({ url: d, type: a, dataType: x, data: b, success: T }, f.isPlainObject(d) && d));
      };
    }), f.ajaxPrefilter(function(s) {
      var a;
      for (a in s.headers) a.toLowerCase() === "content-type" && (s.contentType = s.headers[a] || "");
    }), f._evalUrl = function(s, a, d) {
      return f.ajax({ url: s, type: "GET", dataType: "script", cache: true, async: false, global: false, scriptAttrs: a.crossOrigin ? { crossOrigin: a.crossOrigin } : void 0, converters: { "text script": function() {
      } }, dataFilter: function(b) {
        f.globalEval(b, a, d);
      } });
    }, f.fn.extend({ wrapAll: function(s) {
      var a;
      return this[0] && (typeof s == "function" && (s = s.call(this[0])), a = f(s, this[0].ownerDocument).eq(0).clone(true), this[0].parentNode && a.insertBefore(this[0]), a.map(function() {
        for (var d = this; d.firstElementChild; ) d = d.firstElementChild;
        return d;
      }).append(this)), this;
    }, wrapInner: function(s) {
      return typeof s == "function" ? this.each(function(a) {
        f(this).wrapInner(s.call(this, a));
      }) : this.each(function() {
        var a = f(this), d = a.contents();
        d.length ? d.wrapAll(s) : a.append(s);
      });
    }, wrap: function(s) {
      var a = typeof s == "function";
      return this.each(function(d) {
        f(this).wrapAll(a ? s.call(this, d) : s);
      });
    }, unwrap: function(s) {
      return this.parent(s).not("body").each(function() {
        f(this).replaceWith(this.childNodes);
      }), this;
    } }), f.expr.pseudos.hidden = function(s) {
      return !f.expr.pseudos.visible(s);
    }, f.expr.pseudos.visible = function(s) {
      return !!(s.offsetWidth || s.offsetHeight || s.getClientRects().length);
    }, f.ajaxSettings.xhr = function() {
      return new e.XMLHttpRequest();
    };
    var Jc = { 0: 200 };
    f.ajaxTransport(function(s) {
      var a;
      return { send: function(d, b) {
        var T, x = s.xhr();
        if (x.open(s.type, s.url, s.async, s.username, s.password), s.xhrFields) for (T in s.xhrFields) x[T] = s.xhrFields[T];
        s.mimeType && x.overrideMimeType && x.overrideMimeType(s.mimeType), !s.crossDomain && !d["X-Requested-With"] && (d["X-Requested-With"] = "XMLHttpRequest");
        for (T in d) x.setRequestHeader(T, d[T]);
        a = function(A) {
          return function() {
            a && (a = x.onload = x.onerror = x.onabort = x.ontimeout = null, A === "abort" ? x.abort() : A === "error" ? b(x.status, x.statusText) : b(Jc[x.status] || x.status, x.statusText, (x.responseType || "text") === "text" ? { text: x.responseText } : { binary: x.response }, x.getAllResponseHeaders()));
          };
        }, x.onload = a(), x.onabort = x.onerror = x.ontimeout = a("error"), a = a("abort");
        try {
          x.send(s.hasContent && s.data || null);
        } catch (A) {
          if (a) throw A;
        }
      }, abort: function() {
        a && a();
      } };
    });
    function _o(s) {
      return s.scriptAttrs || !s.headers && (s.crossDomain || s.async && f.inArray("json", s.dataTypes) < 0);
    }
    f.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, converters: { "text script": function(s) {
      return f.globalEval(s), s;
    } } }), f.ajaxPrefilter("script", function(s) {
      s.cache === void 0 && (s.cache = false), _o(s) && (s.type = "GET");
    }), f.ajaxTransport("script", function(s) {
      if (_o(s)) {
        var a, d;
        return { send: function(b, T) {
          a = f("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", d = function(x) {
            a.remove(), d = null, x && T(x.type === "error" ? 404 : 200, x.type);
          }), p.head.appendChild(a[0]);
        }, abort: function() {
          d && d();
        } };
      }
    });
    var xo = [], bs = /(=)\?(?=&|$)|\?\?/;
    f.ajaxSetup({ jsonp: "callback", jsonpCallback: function() {
      var s = xo.pop() || f.expando + "_" + vo.guid++;
      return this[s] = true, s;
    } }), f.ajaxPrefilter("jsonp", function(s, a, d) {
      var b, T, x, A = s.jsonp !== false && (bs.test(s.url) ? "url" : typeof s.data == "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && bs.test(s.data) && "data");
      return b = s.jsonpCallback = typeof s.jsonpCallback == "function" ? s.jsonpCallback() : s.jsonpCallback, A ? s[A] = s[A].replace(bs, "$1" + b) : s.jsonp !== false && (s.url += (ps.test(s.url) ? "&" : "?") + s.jsonp + "=" + b), s.converters["script json"] = function() {
        return x || f.error(b + " was not called"), x[0];
      }, s.dataTypes[0] = "json", T = e[b], e[b] = function() {
        x = arguments;
      }, d.always(function() {
        T === void 0 ? f(e).removeProp(b) : e[b] = T, s[b] && (s.jsonpCallback = a.jsonpCallback, xo.push(b)), x && typeof T == "function" && T(x[0]), x = T = void 0;
      }), "script";
    }), f.ajaxPrefilter(function(s, a) {
      typeof s.data != "string" && !f.isPlainObject(s.data) && !Array.isArray(s.data) && !("processData" in a) && (s.processData = false), s.data instanceof e.FormData && (s.contentType = false);
    }), f.parseHTML = function(s, a, d) {
      if (typeof s != "string" && !Wr(s + "")) return [];
      typeof a == "boolean" && (d = a, a = false);
      var b, T;
      return a || (a = new e.DOMParser().parseFromString("", "text/html")), b = Br.exec(s), T = !d && [], b ? [a.createElement(b[1])] : (b = Zr([s], a, T), T && T.length && f(T).remove(), f.merge([], b.childNodes));
    }, f.fn.load = function(s, a, d) {
      var b, T, x, A = this, M = s.indexOf(" ");
      return M > -1 && (b = Xt(s.slice(M)), s = s.slice(0, M)), typeof a == "function" ? (d = a, a = void 0) : a && typeof a == "object" && (T = "POST"), A.length > 0 && f.ajax({ url: s, type: T || "GET", dataType: "html", data: a }).done(function(O) {
        x = arguments, A.html(b ? f("<div>").append(f.parseHTML(O)).find(b) : O);
      }).always(d && function(O, z) {
        A.each(function() {
          d.apply(this, x || [O.responseText, z, O]);
        });
      }), this;
    }, f.expr.pseudos.animated = function(s) {
      return f.grep(f.timers, function(a) {
        return s === a.elem;
      }).length;
    }, f.offset = { setOffset: function(s, a, d) {
      var b, T, x, A, M, O, z, H = f.css(s, "position"), j = f(s), k = {};
      H === "static" && (s.style.position = "relative"), M = j.offset(), x = f.css(s, "top"), O = f.css(s, "left"), z = (H === "absolute" || H === "fixed") && (x + O).indexOf("auto") > -1, z ? (b = j.position(), A = b.top, T = b.left) : (A = parseFloat(x) || 0, T = parseFloat(O) || 0), typeof a == "function" && (a = a.call(s, d, f.extend({}, M))), a.top != null && (k.top = a.top - M.top + A), a.left != null && (k.left = a.left - M.left + T), "using" in a ? a.using.call(s, k) : j.css(k);
    } }, f.fn.extend({ offset: function(s) {
      if (arguments.length) return s === void 0 ? this : this.each(function(T) {
        f.offset.setOffset(this, s, T);
      });
      var a, d, b = this[0];
      if (b) return b.getClientRects().length ? (a = b.getBoundingClientRect(), d = b.ownerDocument.defaultView, { top: a.top + d.pageYOffset, left: a.left + d.pageXOffset }) : { top: 0, left: 0 };
    }, position: function() {
      if (this[0]) {
        var s, a, d, b = this[0], T = { top: 0, left: 0 };
        if (f.css(b, "position") === "fixed") a = b.getBoundingClientRect();
        else {
          for (a = this.offset(), d = b.ownerDocument, s = b.offsetParent || d.documentElement; s && s !== d.documentElement && f.css(s, "position") === "static"; ) s = s.offsetParent || d.documentElement;
          s && s !== b && s.nodeType === 1 && f.css(s, "position") !== "static" && (T = f(s).offset(), T.top += f.css(s, "borderTopWidth", true), T.left += f.css(s, "borderLeftWidth", true));
        }
        return { top: a.top - T.top - f.css(b, "marginTop", true), left: a.left - T.left - f.css(b, "marginLeft", true) };
      }
    }, offsetParent: function() {
      return this.map(function() {
        for (var s = this.offsetParent; s && f.css(s, "position") === "static"; ) s = s.offsetParent;
        return s || W;
      });
    } }), f.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(s, a) {
      var d = a === "pageYOffset";
      f.fn[s] = function(b) {
        return be(this, function(T, x, A) {
          var M;
          if (C(T) ? M = T : T.nodeType === 9 && (M = T.defaultView), A === void 0) return M ? M[a] : T[x];
          M ? M.scrollTo(d ? M.pageXOffset : A, d ? A : M.pageYOffset) : T[x] = A;
        }, s, b, arguments.length);
      };
    }), f.each({ Height: "height", Width: "width" }, function(s, a) {
      f.each({ padding: "inner" + s, content: a, "": "outer" + s }, function(d, b) {
        f.fn[b] = function(T, x) {
          var A = arguments.length && (d || typeof T != "boolean"), M = d || (T === true || x === true ? "margin" : "border");
          return be(this, function(O, z, H) {
            var j;
            return C(O) ? b.indexOf("outer") === 0 ? O["inner" + s] : O.document.documentElement["client" + s] : O.nodeType === 9 ? (j = O.documentElement, Math.max(O.body["scroll" + s], j["scroll" + s], O.body["offset" + s], j["offset" + s], j["client" + s])) : H === void 0 ? f.css(O, z, M) : f.style(O, z, H, M);
          }, a, A ? T : void 0, A);
        };
      });
    }), f.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(s, a) {
      f.fn[a] = function(d) {
        return this.on(a, d);
      };
    }), f.fn.extend({ bind: function(s, a, d) {
      return this.on(s, null, a, d);
    }, unbind: function(s, a) {
      return this.off(s, null, a);
    }, delegate: function(s, a, d, b) {
      return this.on(a, s, d, b);
    }, undelegate: function(s, a, d) {
      return arguments.length === 1 ? this.off(s, "**") : this.off(a, s || "**", d);
    }, hover: function(s, a) {
      return this.on("mouseenter", s).on("mouseleave", a || s);
    } }), f.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(s, a) {
      f.fn[a] = function(d, b) {
        return arguments.length > 0 ? this.on(a, null, d, b) : this.trigger(a);
      };
    }), f.proxy = function(s, a) {
      var d, b, T;
      if (typeof a == "string" && (d = s[a], a = s, s = d), typeof s == "function") return b = r.call(arguments, 2), T = function() {
        return s.apply(a || this, b.concat(r.call(arguments)));
      }, T.guid = s.guid = s.guid || f.guid++, T;
    }, f.holdReady = function(s) {
      s ? f.readyWait++ : f.ready(true);
    }, f.expr[":"] = f.expr.filters = f.expr.pseudos, typeof define == "function" && define.amd && define("jquery", [], function() {
      return f;
    });
    var eu = e.jQuery, tu = e.$;
    return f.noConflict = function(s) {
      return e.$ === f && (e.$ = tu), s && e.jQuery === f && (e.jQuery = eu), f;
    }, f;
  }
  var cu = lu(window);
  window.jQuery = window.$ = cu;
  var Ne = "top", qe = "bottom", Ue = "right", ke = "left", Gn = "auto", zi = [Ne, qe, Ue, ke], ei = "start", wi = "end", za = "clippingParents", gr = "viewport", Ti = "popper", $a = "reference", or = zi.reduce(function(e, t) {
    return e.concat([t + "-" + ei, t + "-" + wi]);
  }, []), vr = [].concat(zi, [Gn]).reduce(function(e, t) {
    return e.concat([t, t + "-" + ei, t + "-" + wi]);
  }, []), Na = "beforeRead", ka = "read", Ra = "afterRead", Ha = "beforeMain", Va = "main", Ba = "afterMain", Wa = "beforeWrite", Fa = "write", Ga = "afterWrite", ja = [Na, ka, Ra, Ha, Va, Ba, Wa, Fa, Ga];
  function yt(e) {
    return e ? (e.nodeName || "").toLowerCase() : null;
  }
  function Ke(e) {
    if (e == null) return window;
    if (e.toString() !== "[object Window]") {
      var t = e.ownerDocument;
      return t && t.defaultView || window;
    }
    return e;
  }
  function ti(e) {
    var t = Ke(e).Element;
    return e instanceof t || e instanceof Element;
  }
  function et(e) {
    var t = Ke(e).HTMLElement;
    return e instanceof t || e instanceof HTMLElement;
  }
  function yr(e) {
    if (typeof ShadowRoot == "undefined") return false;
    var t = Ke(e).ShadowRoot;
    return e instanceof t || e instanceof ShadowRoot;
  }
  function uu(e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function(i) {
      var n = t.styles[i] || {}, r = t.attributes[i] || {}, o = t.elements[i];
      !et(o) || !yt(o) || (Object.assign(o.style, n), Object.keys(r).forEach(function(c) {
        var u = r[c];
        u === false ? o.removeAttribute(c) : o.setAttribute(c, u === true ? "" : u);
      }));
    });
  }
  function du(e) {
    var t = e.state, i = { popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
    return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
      Object.keys(t.elements).forEach(function(n) {
        var r = t.elements[n], o = t.attributes[n] || {}, c = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : i[n]), u = c.reduce(function(l, m) {
          return l[m] = "", l;
        }, {});
        !et(r) || !yt(r) || (Object.assign(r.style, u), Object.keys(o).forEach(function(l) {
          r.removeAttribute(l);
        }));
      });
    };
  }
  const Ya = { name: "applyStyles", enabled: true, phase: "write", fn: uu, effect: du, requires: ["computeStyles"] };
  function vt(e) {
    return e.split("-")[0];
  }
  var Zt = Math.max, Dn = Math.min, Ai = Math.round;
  function ar() {
    var e = navigator.userAgentData;
    return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
      return t.brand + "/" + t.version;
    }).join(" ") : navigator.userAgent;
  }
  function Xa() {
    return !/^((?!chrome|android).)*safari/i.test(ar());
  }
  function Ii(e, t, i) {
    t === void 0 && (t = false), i === void 0 && (i = false);
    var n = e.getBoundingClientRect(), r = 1, o = 1;
    t && et(e) && (r = e.offsetWidth > 0 && Ai(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Ai(n.height) / e.offsetHeight || 1);
    var c = ti(e) ? Ke(e) : window, u = c.visualViewport, l = !Xa() && i, m = (n.left + (l && u ? u.offsetLeft : 0)) / r, v = (n.top + (l && u ? u.offsetTop : 0)) / o, y = n.width / r, E = n.height / o;
    return { width: y, height: E, top: v, right: m + y, bottom: v + E, left: m, x: m, y: v };
  }
  function br(e) {
    var t = Ii(e), i = e.offsetWidth, n = e.offsetHeight;
    return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), { x: e.offsetLeft, y: e.offsetTop, width: i, height: n };
  }
  function qa(e, t) {
    var i = t.getRootNode && t.getRootNode();
    if (e.contains(t)) return true;
    if (i && yr(i)) {
      var n = t;
      do {
        if (n && e.isSameNode(n)) return true;
        n = n.parentNode || n.host;
      } while (n);
    }
    return false;
  }
  function It(e) {
    return Ke(e).getComputedStyle(e);
  }
  function fu(e) {
    return ["table", "td", "th"].indexOf(yt(e)) >= 0;
  }
  function Wt(e) {
    return ((ti(e) ? e.ownerDocument : e.document) || window.document).documentElement;
  }
  function jn(e) {
    return yt(e) === "html" ? e : e.assignedSlot || e.parentNode || (yr(e) ? e.host : null) || Wt(e);
  }
  function Ao(e) {
    return !et(e) || It(e).position === "fixed" ? null : e.offsetParent;
  }
  function hu(e) {
    var t = /firefox/i.test(ar()), i = /Trident/i.test(ar());
    if (i && et(e)) {
      var n = It(e);
      if (n.position === "fixed") return null;
    }
    var r = jn(e);
    for (yr(r) && (r = r.host); et(r) && ["html", "body"].indexOf(yt(r)) < 0; ) {
      var o = It(r);
      if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none") return r;
      r = r.parentNode;
    }
    return null;
  }
  function Ji(e) {
    for (var t = Ke(e), i = Ao(e); i && fu(i) && It(i).position === "static"; ) i = Ao(i);
    return i && (yt(i) === "html" || yt(i) === "body" && It(i).position === "static") ? t : i || hu(e) || t;
  }
  function Er(e) {
    return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
  }
  function Ui(e, t, i) {
    return Zt(e, Dn(t, i));
  }
  function pu(e, t, i) {
    var n = Ui(e, t, i);
    return n > i ? i : n;
  }
  function Ua() {
    return { top: 0, right: 0, bottom: 0, left: 0 };
  }
  function Ka(e) {
    return Object.assign({}, Ua(), e);
  }
  function Za(e, t) {
    return t.reduce(function(i, n) {
      return i[n] = e, i;
    }, {});
  }
  var mu = function(t, i) {
    return t = typeof t == "function" ? t(Object.assign({}, i.rects, { placement: i.placement })) : t, Ka(typeof t != "number" ? t : Za(t, zi));
  };
  function gu(e) {
    var t, i = e.state, n = e.name, r = e.options, o = i.elements.arrow, c = i.modifiersData.popperOffsets, u = vt(i.placement), l = Er(u), m = [ke, Ue].indexOf(u) >= 0, v = m ? "height" : "width";
    if (!(!o || !c)) {
      var y = mu(r.padding, i), E = br(o), h = l === "y" ? Ne : ke, g = l === "y" ? qe : Ue, C = i.rects.reference[v] + i.rects.reference[l] - c[l] - i.rects.popper[v], _ = c[l] - i.rects.reference[l], p = Ji(o), S = p ? l === "y" ? p.clientHeight || 0 : p.clientWidth || 0 : 0, w = C / 2 - _ / 2, I = y[h], L = S - E[v] - y[g], f = S / 2 - E[v] / 2 + w, P = Ui(I, f, L), D = l;
      i.modifiersData[n] = (t = {}, t[D] = P, t.centerOffset = P - f, t);
    }
  }
  function vu(e) {
    var t = e.state, i = e.options, n = i.element, r = n === void 0 ? "[data-popper-arrow]" : n;
    r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || qa(t.elements.popper, r) && (t.elements.arrow = r));
  }
  const Qa = { name: "arrow", enabled: true, phase: "main", fn: gu, effect: vu, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
  function Oi(e) {
    return e.split("-")[1];
  }
  var yu = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
  function bu(e, t) {
    var i = e.x, n = e.y, r = t.devicePixelRatio || 1;
    return { x: Ai(i * r) / r || 0, y: Ai(n * r) / r || 0 };
  }
  function Io(e) {
    var t, i = e.popper, n = e.popperRect, r = e.placement, o = e.variation, c = e.offsets, u = e.position, l = e.gpuAcceleration, m = e.adaptive, v = e.roundOffsets, y = e.isFixed, E = c.x, h = E === void 0 ? 0 : E, g = c.y, C = g === void 0 ? 0 : g, _ = typeof v == "function" ? v({ x: h, y: C }) : { x: h, y: C };
    h = _.x, C = _.y;
    var p = c.hasOwnProperty("x"), S = c.hasOwnProperty("y"), w = ke, I = Ne, L = window;
    if (m) {
      var f = Ji(i), P = "clientHeight", D = "clientWidth";
      if (f === Ke(i) && (f = Wt(i), It(f).position !== "static" && u === "absolute" && (P = "scrollHeight", D = "scrollWidth")), f = f, r === Ne || (r === ke || r === Ue) && o === wi) {
        I = qe;
        var R = y && f === L && L.visualViewport ? L.visualViewport.height : f[P];
        C -= R - n.height, C *= l ? 1 : -1;
      }
      if (r === ke || (r === Ne || r === qe) && o === wi) {
        w = Ue;
        var N = y && f === L && L.visualViewport ? L.visualViewport.width : f[D];
        h -= N - n.width, h *= l ? 1 : -1;
      }
    }
    var $ = Object.assign({ position: u }, m && yu), V = v === true ? bu({ x: h, y: C }, Ke(i)) : { x: h, y: C };
    if (h = V.x, C = V.y, l) {
      var B;
      return Object.assign({}, $, (B = {}, B[I] = S ? "0" : "", B[w] = p ? "0" : "", B.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + C + "px)" : "translate3d(" + h + "px, " + C + "px, 0)", B));
    }
    return Object.assign({}, $, (t = {}, t[I] = S ? C + "px" : "", t[w] = p ? h + "px" : "", t.transform = "", t));
  }
  function Eu(e) {
    var t = e.state, i = e.options, n = i.gpuAcceleration, r = n === void 0 ? true : n, o = i.adaptive, c = o === void 0 ? true : o, u = i.roundOffsets, l = u === void 0 ? true : u, m = { placement: vt(t.placement), variation: Oi(t.placement), popper: t.elements.popper, popperRect: t.rects.popper, gpuAcceleration: r, isFixed: t.options.strategy === "fixed" };
    t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Io(Object.assign({}, m, { offsets: t.modifiersData.popperOffsets, position: t.options.strategy, adaptive: c, roundOffsets: l })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Io(Object.assign({}, m, { offsets: t.modifiersData.arrow, position: "absolute", adaptive: false, roundOffsets: l })))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
  }
  const Ja = { name: "computeStyles", enabled: true, phase: "beforeWrite", fn: Eu, data: {} };
  var Sn = { passive: true };
  function Su(e) {
    var t = e.state, i = e.instance, n = e.options, r = n.scroll, o = r === void 0 ? true : r, c = n.resize, u = c === void 0 ? true : c, l = Ke(t.elements.popper), m = [].concat(t.scrollParents.reference, t.scrollParents.popper);
    return o && m.forEach(function(v) {
      v.addEventListener("scroll", i.update, Sn);
    }), u && l.addEventListener("resize", i.update, Sn), function() {
      o && m.forEach(function(v) {
        v.removeEventListener("scroll", i.update, Sn);
      }), u && l.removeEventListener("resize", i.update, Sn);
    };
  }
  const el = { name: "eventListeners", enabled: true, phase: "write", fn: function() {
  }, effect: Su, data: {} };
  var Tu = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function In(e) {
    return e.replace(/left|right|bottom|top/g, function(t) {
      return Tu[t];
    });
  }
  var _u = { start: "end", end: "start" };
  function Oo(e) {
    return e.replace(/start|end/g, function(t) {
      return _u[t];
    });
  }
  function Sr(e) {
    var t = Ke(e), i = t.pageXOffset, n = t.pageYOffset;
    return { scrollLeft: i, scrollTop: n };
  }
  function Tr(e) {
    return Ii(Wt(e)).left + Sr(e).scrollLeft;
  }
  function xu(e, t) {
    var i = Ke(e), n = Wt(e), r = i.visualViewport, o = n.clientWidth, c = n.clientHeight, u = 0, l = 0;
    if (r) {
      o = r.width, c = r.height;
      var m = Xa();
      (m || !m && t === "fixed") && (u = r.offsetLeft, l = r.offsetTop);
    }
    return { width: o, height: c, x: u + Tr(e), y: l };
  }
  function Cu(e) {
    var t, i = Wt(e), n = Sr(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, o = Zt(i.scrollWidth, i.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), c = Zt(i.scrollHeight, i.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), u = -n.scrollLeft + Tr(e), l = -n.scrollTop;
    return It(r || i).direction === "rtl" && (u += Zt(i.clientWidth, r ? r.clientWidth : 0) - o), { width: o, height: c, x: u, y: l };
  }
  function _r(e) {
    var t = It(e), i = t.overflow, n = t.overflowX, r = t.overflowY;
    return /auto|scroll|overlay|hidden/.test(i + r + n);
  }
  function tl(e) {
    return ["html", "body", "#document"].indexOf(yt(e)) >= 0 ? e.ownerDocument.body : et(e) && _r(e) ? e : tl(jn(e));
  }
  function Ki(e, t) {
    var i;
    t === void 0 && (t = []);
    var n = tl(e), r = n === ((i = e.ownerDocument) == null ? void 0 : i.body), o = Ke(n), c = r ? [o].concat(o.visualViewport || [], _r(n) ? n : []) : n, u = t.concat(c);
    return r ? u : u.concat(Ki(jn(c)));
  }
  function lr(e) {
    return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
  }
  function wu(e, t) {
    var i = Ii(e, false, t === "fixed");
    return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
  }
  function Mo(e, t, i) {
    return t === gr ? lr(xu(e, i)) : ti(t) ? wu(t, i) : lr(Cu(Wt(e)));
  }
  function Au(e) {
    var t = Ki(jn(e)), i = ["absolute", "fixed"].indexOf(It(e).position) >= 0, n = i && et(e) ? Ji(e) : e;
    return ti(n) ? t.filter(function(r) {
      return ti(r) && qa(r, n) && yt(r) !== "body";
    }) : [];
  }
  function Iu(e, t, i, n) {
    var r = t === "clippingParents" ? Au(e) : [].concat(t), o = [].concat(r, [i]), c = o[0], u = o.reduce(function(l, m) {
      var v = Mo(e, m, n);
      return l.top = Zt(v.top, l.top), l.right = Dn(v.right, l.right), l.bottom = Dn(v.bottom, l.bottom), l.left = Zt(v.left, l.left), l;
    }, Mo(e, c, n));
    return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
  }
  function il(e) {
    var t = e.reference, i = e.element, n = e.placement, r = n ? vt(n) : null, o = n ? Oi(n) : null, c = t.x + t.width / 2 - i.width / 2, u = t.y + t.height / 2 - i.height / 2, l;
    switch (r) {
      case Ne:
        l = { x: c, y: t.y - i.height };
        break;
      case qe:
        l = { x: c, y: t.y + t.height };
        break;
      case Ue:
        l = { x: t.x + t.width, y: u };
        break;
      case ke:
        l = { x: t.x - i.width, y: u };
        break;
      default:
        l = { x: t.x, y: t.y };
    }
    var m = r ? Er(r) : null;
    if (m != null) {
      var v = m === "y" ? "height" : "width";
      switch (o) {
        case ei:
          l[m] = l[m] - (t[v] / 2 - i[v] / 2);
          break;
        case wi:
          l[m] = l[m] + (t[v] / 2 - i[v] / 2);
          break;
      }
    }
    return l;
  }
  function Mi(e, t) {
    t === void 0 && (t = {});
    var i = t, n = i.placement, r = n === void 0 ? e.placement : n, o = i.strategy, c = o === void 0 ? e.strategy : o, u = i.boundary, l = u === void 0 ? za : u, m = i.rootBoundary, v = m === void 0 ? gr : m, y = i.elementContext, E = y === void 0 ? Ti : y, h = i.altBoundary, g = h === void 0 ? false : h, C = i.padding, _ = C === void 0 ? 0 : C, p = Ka(typeof _ != "number" ? _ : Za(_, zi)), S = E === Ti ? $a : Ti, w = e.rects.popper, I = e.elements[g ? S : E], L = Iu(ti(I) ? I : I.contextElement || Wt(e.elements.popper), l, v, c), f = Ii(e.elements.reference), P = il({ reference: f, element: w, placement: r }), D = lr(Object.assign({}, w, P)), R = E === Ti ? D : f, N = { top: L.top - R.top + p.top, bottom: R.bottom - L.bottom + p.bottom, left: L.left - R.left + p.left, right: R.right - L.right + p.right }, $ = e.modifiersData.offset;
    if (E === Ti && $) {
      var V = $[r];
      Object.keys(N).forEach(function(B) {
        var X = [Ue, qe].indexOf(B) >= 0 ? 1 : -1, Z = [Ne, qe].indexOf(B) >= 0 ? "y" : "x";
        N[B] += V[Z] * X;
      });
    }
    return N;
  }
  function Ou(e, t) {
    t === void 0 && (t = {});
    var i = t, n = i.placement, r = i.boundary, o = i.rootBoundary, c = i.padding, u = i.flipVariations, l = i.allowedAutoPlacements, m = l === void 0 ? vr : l, v = Oi(n), y = v ? u ? or : or.filter(function(g) {
      return Oi(g) === v;
    }) : zi, E = y.filter(function(g) {
      return m.indexOf(g) >= 0;
    });
    E.length === 0 && (E = y);
    var h = E.reduce(function(g, C) {
      return g[C] = Mi(e, { placement: C, boundary: r, rootBoundary: o, padding: c })[vt(C)], g;
    }, {});
    return Object.keys(h).sort(function(g, C) {
      return h[g] - h[C];
    });
  }
  function Mu(e) {
    if (vt(e) === Gn) return [];
    var t = In(e);
    return [Oo(e), t, Oo(t)];
  }
  function Lu(e) {
    var t = e.state, i = e.options, n = e.name;
    if (!t.modifiersData[n]._skip) {
      for (var r = i.mainAxis, o = r === void 0 ? true : r, c = i.altAxis, u = c === void 0 ? true : c, l = i.fallbackPlacements, m = i.padding, v = i.boundary, y = i.rootBoundary, E = i.altBoundary, h = i.flipVariations, g = h === void 0 ? true : h, C = i.allowedAutoPlacements, _ = t.options.placement, p = vt(_), S = p === _, w = l || (S || !g ? [In(_)] : Mu(_)), I = [_].concat(w).reduce(function(U, Q) {
        return U.concat(vt(Q) === Gn ? Ou(t, { placement: Q, boundary: v, rootBoundary: y, padding: m, flipVariations: g, allowedAutoPlacements: C }) : Q);
      }, []), L = t.rects.reference, f = t.rects.popper, P = /* @__PURE__ */ new Map(), D = true, R = I[0], N = 0; N < I.length; N++) {
        var $ = I[N], V = vt($), B = Oi($) === ei, X = [Ne, qe].indexOf(V) >= 0, Z = X ? "width" : "height", F = Mi(t, { placement: $, boundary: v, rootBoundary: y, altBoundary: E, padding: m }), W = X ? B ? Ue : ke : B ? qe : Ne;
        L[Z] > f[Z] && (W = In(W));
        var Y = In(W), J = [];
        if (o && J.push(F[V] <= 0), u && J.push(F[W] <= 0, F[Y] <= 0), J.every(function(U) {
          return U;
        })) {
          R = $, D = false;
          break;
        }
        P.set($, J);
      }
      if (D) for (var oe = g ? 3 : 1, he = function(Q) {
        var ee = I.find(function(K) {
          var se = P.get(K);
          if (se) return se.slice(0, Q).every(function(Se) {
            return Se;
          });
        });
        if (ee) return R = ee, "break";
      }, _e = oe; _e > 0; _e--) {
        var Ee = he(_e);
        if (Ee === "break") break;
      }
      t.placement !== R && (t.modifiersData[n]._skip = true, t.placement = R, t.reset = true);
    }
  }
  const nl = { name: "flip", enabled: true, phase: "main", fn: Lu, requiresIfExists: ["offset"], data: { _skip: false } };
  function Lo(e, t, i) {
    return i === void 0 && (i = { x: 0, y: 0 }), { top: e.top - t.height - i.y, right: e.right - t.width + i.x, bottom: e.bottom - t.height + i.y, left: e.left - t.width - i.x };
  }
  function Po(e) {
    return [Ne, Ue, qe, ke].some(function(t) {
      return e[t] >= 0;
    });
  }
  function Pu(e) {
    var t = e.state, i = e.name, n = t.rects.reference, r = t.rects.popper, o = t.modifiersData.preventOverflow, c = Mi(t, { elementContext: "reference" }), u = Mi(t, { altBoundary: true }), l = Lo(c, n), m = Lo(u, r, o), v = Po(l), y = Po(m);
    t.modifiersData[i] = { referenceClippingOffsets: l, popperEscapeOffsets: m, isReferenceHidden: v, hasPopperEscaped: y }, t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-reference-hidden": v, "data-popper-escaped": y });
  }
  const sl = { name: "hide", enabled: true, phase: "main", requiresIfExists: ["preventOverflow"], fn: Pu };
  function Du(e, t, i) {
    var n = vt(e), r = [ke, Ne].indexOf(n) >= 0 ? -1 : 1, o = typeof i == "function" ? i(Object.assign({}, t, { placement: e })) : i, c = o[0], u = o[1];
    return c = c || 0, u = (u || 0) * r, [ke, Ue].indexOf(n) >= 0 ? { x: u, y: c } : { x: c, y: u };
  }
  function zu(e) {
    var t = e.state, i = e.options, n = e.name, r = i.offset, o = r === void 0 ? [0, 0] : r, c = vr.reduce(function(v, y) {
      return v[y] = Du(y, t.rects, o), v;
    }, {}), u = c[t.placement], l = u.x, m = u.y;
    t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += m), t.modifiersData[n] = c;
  }
  const rl = { name: "offset", enabled: true, phase: "main", requires: ["popperOffsets"], fn: zu };
  function $u(e) {
    var t = e.state, i = e.name;
    t.modifiersData[i] = il({ reference: t.rects.reference, element: t.rects.popper, placement: t.placement });
  }
  const ol = { name: "popperOffsets", enabled: true, phase: "read", fn: $u, data: {} };
  function Nu(e) {
    return e === "x" ? "y" : "x";
  }
  function ku(e) {
    var t = e.state, i = e.options, n = e.name, r = i.mainAxis, o = r === void 0 ? true : r, c = i.altAxis, u = c === void 0 ? false : c, l = i.boundary, m = i.rootBoundary, v = i.altBoundary, y = i.padding, E = i.tether, h = E === void 0 ? true : E, g = i.tetherOffset, C = g === void 0 ? 0 : g, _ = Mi(t, { boundary: l, rootBoundary: m, padding: y, altBoundary: v }), p = vt(t.placement), S = Oi(t.placement), w = !S, I = Er(p), L = Nu(I), f = t.modifiersData.popperOffsets, P = t.rects.reference, D = t.rects.popper, R = typeof C == "function" ? C(Object.assign({}, t.rects, { placement: t.placement })) : C, N = typeof R == "number" ? { mainAxis: R, altAxis: R } : Object.assign({ mainAxis: 0, altAxis: 0 }, R), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, V = { x: 0, y: 0 };
    if (f) {
      if (o) {
        var B, X = I === "y" ? Ne : ke, Z = I === "y" ? qe : Ue, F = I === "y" ? "height" : "width", W = f[I], Y = W + _[X], J = W - _[Z], oe = h ? -D[F] / 2 : 0, he = S === ei ? P[F] : D[F], _e = S === ei ? -D[F] : -P[F], Ee = t.elements.arrow, U = h && Ee ? br(Ee) : { width: 0, height: 0 }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ua(), ee = Q[X], K = Q[Z], se = Ui(0, P[F], U[F]), Se = w ? P[F] / 2 - oe - se - ee - N.mainAxis : he - se - ee - N.mainAxis, Ge = w ? -P[F] / 2 + oe + se + K + N.mainAxis : _e + se + K + N.mainAxis, Ce = t.elements.arrow && Ji(t.elements.arrow), Ze = Ce ? I === "y" ? Ce.clientTop || 0 : Ce.clientLeft || 0 : 0, ge = (B = $ == null ? void 0 : $[I]) != null ? B : 0, be = W + Se - ge - Ze, Oe = W + Ge - ge, Et = Ui(h ? Dn(Y, be) : Y, W, h ? Zt(J, Oe) : J);
        f[I] = Et, V[I] = Et - W;
      }
      if (u) {
        var st, dt = I === "x" ? Ne : ke, Lt = I === "x" ? qe : Ue, De = f[L], ft = L === "y" ? "height" : "width", je = De + _[dt], rt = De - _[Lt], Te = [Ne, ke].indexOf(p) !== -1, St = (st = $ == null ? void 0 : $[L]) != null ? st : 0, we = Te ? je : De - P[ft] - D[ft] - St + N.altAxis, $e = Te ? De + P[ft] + D[ft] - St - N.altAxis : rt, ht = h && Te ? pu(we, De, $e) : Ui(h ? we : je, De, h ? $e : rt);
        f[L] = ht, V[L] = ht - De;
      }
      t.modifiersData[n] = V;
    }
  }
  const al = { name: "preventOverflow", enabled: true, phase: "main", fn: ku, requiresIfExists: ["offset"] };
  function Ru(e) {
    return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
  }
  function Hu(e) {
    return e === Ke(e) || !et(e) ? Sr(e) : Ru(e);
  }
  function Vu(e) {
    var t = e.getBoundingClientRect(), i = Ai(t.width) / e.offsetWidth || 1, n = Ai(t.height) / e.offsetHeight || 1;
    return i !== 1 || n !== 1;
  }
  function Bu(e, t, i) {
    i === void 0 && (i = false);
    var n = et(t), r = et(t) && Vu(t), o = Wt(t), c = Ii(e, r, i), u = { scrollLeft: 0, scrollTop: 0 }, l = { x: 0, y: 0 };
    return (n || !n && !i) && ((yt(t) !== "body" || _r(o)) && (u = Hu(t)), et(t) ? (l = Ii(t, true), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = Tr(o))), { x: c.left + u.scrollLeft - l.x, y: c.top + u.scrollTop - l.y, width: c.width, height: c.height };
  }
  function Wu(e) {
    var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), n = [];
    e.forEach(function(o) {
      t.set(o.name, o);
    });
    function r(o) {
      i.add(o.name);
      var c = [].concat(o.requires || [], o.requiresIfExists || []);
      c.forEach(function(u) {
        if (!i.has(u)) {
          var l = t.get(u);
          l && r(l);
        }
      }), n.push(o);
    }
    return e.forEach(function(o) {
      i.has(o.name) || r(o);
    }), n;
  }
  function Fu(e) {
    var t = Wu(e);
    return ja.reduce(function(i, n) {
      return i.concat(t.filter(function(r) {
        return r.phase === n;
      }));
    }, []);
  }
  function Gu(e) {
    var t;
    return function() {
      return t || (t = new Promise(function(i) {
        Promise.resolve().then(function() {
          t = void 0, i(e());
        });
      })), t;
    };
  }
  function ju(e) {
    var t = e.reduce(function(i, n) {
      var r = i[n.name];
      return i[n.name] = r ? Object.assign({}, r, n, { options: Object.assign({}, r.options, n.options), data: Object.assign({}, r.data, n.data) }) : n, i;
    }, {});
    return Object.keys(t).map(function(i) {
      return t[i];
    });
  }
  var Do = { placement: "bottom", modifiers: [], strategy: "absolute" };
  function zo() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    return !t.some(function(n) {
      return !(n && typeof n.getBoundingClientRect == "function");
    });
  }
  function ll(e) {
    e === void 0 && (e = {});
    var t = e, i = t.defaultModifiers, n = i === void 0 ? [] : i, r = t.defaultOptions, o = r === void 0 ? Do : r;
    return function(u, l, m) {
      m === void 0 && (m = o);
      var v = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, Do, o), modifiersData: {}, elements: { reference: u, popper: l }, attributes: {}, styles: {} }, y = [], E = false, h = { state: v, setOptions: function(p) {
        var S = typeof p == "function" ? p(v.options) : p;
        C(), v.options = Object.assign({}, o, v.options, S), v.scrollParents = { reference: ti(u) ? Ki(u) : u.contextElement ? Ki(u.contextElement) : [], popper: Ki(l) };
        var w = Fu(ju([].concat(n, v.options.modifiers)));
        return v.orderedModifiers = w.filter(function(I) {
          return I.enabled;
        }), g(), h.update();
      }, forceUpdate: function() {
        if (!E) {
          var p = v.elements, S = p.reference, w = p.popper;
          if (zo(S, w)) {
            v.rects = { reference: Bu(S, Ji(w), v.options.strategy === "fixed"), popper: br(w) }, v.reset = false, v.placement = v.options.placement, v.orderedModifiers.forEach(function(N) {
              return v.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var I = 0; I < v.orderedModifiers.length; I++) {
              if (v.reset === true) {
                v.reset = false, I = -1;
                continue;
              }
              var L = v.orderedModifiers[I], f = L.fn, P = L.options, D = P === void 0 ? {} : P, R = L.name;
              typeof f == "function" && (v = f({ state: v, options: D, name: R, instance: h }) || v);
            }
          }
        }
      }, update: Gu(function() {
        return new Promise(function(_) {
          h.forceUpdate(), _(v);
        });
      }), destroy: function() {
        C(), E = true;
      } };
      if (!zo(u, l)) return h;
      h.setOptions(m).then(function(_) {
        !E && m.onFirstUpdate && m.onFirstUpdate(_);
      });
      function g() {
        v.orderedModifiers.forEach(function(_) {
          var p = _.name, S = _.options, w = S === void 0 ? {} : S, I = _.effect;
          if (typeof I == "function") {
            var L = I({ state: v, name: p, instance: h, options: w }), f = function() {
            };
            y.push(L || f);
          }
        });
      }
      function C() {
        y.forEach(function(_) {
          return _();
        }), y = [];
      }
      return h;
    };
  }
  var Yu = [el, ol, Ja, Ya, rl, nl, al, Qa, sl], xr = ll({ defaultModifiers: Yu });
  const cl = Object.freeze(Object.defineProperty({ __proto__: null, afterMain: Ba, afterRead: Ra, afterWrite: Ga, applyStyles: Ya, arrow: Qa, auto: Gn, basePlacements: zi, beforeMain: Ha, beforeRead: Na, beforeWrite: Wa, bottom: qe, clippingParents: za, computeStyles: Ja, createPopper: xr, detectOverflow: Mi, end: wi, eventListeners: el, flip: nl, hide: sl, left: ke, main: Va, modifierPhases: ja, offset: rl, placements: vr, popper: Ti, popperGenerator: ll, popperOffsets: ol, preventOverflow: al, read: ka, reference: $a, right: Ue, start: ei, top: Ne, variationPlacements: or, viewport: gr, write: Fa }, Symbol.toStringTag, { value: "Module" }));
  const $t = /* @__PURE__ */ new Map(), Ts = { set(e, t, i) {
    $t.has(e) || $t.set(e, /* @__PURE__ */ new Map());
    const n = $t.get(e);
    if (!n.has(t) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(t, i);
  }, get(e, t) {
    return $t.has(e) && $t.get(e).get(t) || null;
  }, remove(e, t) {
    if (!$t.has(e)) return;
    const i = $t.get(e);
    i.delete(t), i.size === 0 && $t.delete(e);
  } }, Xu = 1e6, qu = 1e3, cr = "transitionend", ul = (e) => (e && window.CSS && window.CSS.escape && (e = e.replace(/#([^\s"#']+)/g, (t, i) => `#${CSS.escape(i)}`)), e), Uu = (e) => e == null ? `${e}` : Object.prototype.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase(), Ku = (e) => {
    do
      e += Math.floor(Math.random() * Xu);
    while (document.getElementById(e));
    return e;
  }, Zu = (e) => {
    if (!e) return 0;
    let { transitionDuration: t, transitionDelay: i } = window.getComputedStyle(e);
    const n = Number.parseFloat(t), r = Number.parseFloat(i);
    return !n && !r ? 0 : (t = t.split(",")[0], i = i.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(i)) * qu);
  }, dl = (e) => {
    e.dispatchEvent(new Event(cr));
  }, wt = (e) => !e || typeof e != "object" ? false : (typeof e.jquery != "undefined" && (e = e[0]), typeof e.nodeType != "undefined"), Vt = (e) => wt(e) ? e.jquery ? e[0] : e : typeof e == "string" && e.length > 0 ? document.querySelector(ul(e)) : null, $i = (e) => {
    if (!wt(e) || e.getClientRects().length === 0) return false;
    const t = getComputedStyle(e).getPropertyValue("visibility") === "visible", i = e.closest("details:not([open])");
    if (!i) return t;
    if (i !== e) {
      const n = e.closest("summary");
      if (n && n.parentNode !== i || n === null) return false;
    }
    return t;
  }, Bt = (e) => !e || e.nodeType !== Node.ELEMENT_NODE || e.classList.contains("disabled") ? true : typeof e.disabled != "undefined" ? e.disabled : e.hasAttribute("disabled") && e.getAttribute("disabled") !== "false", fl = (e) => {
    if (!document.documentElement.attachShadow) return null;
    if (typeof e.getRootNode == "function") {
      const t = e.getRootNode();
      return t instanceof ShadowRoot ? t : null;
    }
    return e instanceof ShadowRoot ? e : e.parentNode ? fl(e.parentNode) : null;
  }, zn = () => {
  }, en = (e) => {
    e.offsetHeight;
  }, hl = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, _s = [], Qu = (e) => {
    document.readyState === "loading" ? (_s.length || document.addEventListener("DOMContentLoaded", () => {
      for (const t of _s) t();
    }), _s.push(e)) : e();
  }, tt = () => document.documentElement.dir === "rtl", nt = (e) => {
    Qu(() => {
      const t = hl();
      if (t) {
        const i = e.NAME, n = t.fn[i];
        t.fn[i] = e.jQueryInterface, t.fn[i].Constructor = e, t.fn[i].noConflict = () => (t.fn[i] = n, e.jQueryInterface);
      }
    });
  }, Fe = (e, t = [], i = e) => typeof e == "function" ? e.call(...t) : i, pl = (e, t, i = true) => {
    if (!i) {
      Fe(e);
      return;
    }
    const r = Zu(t) + 5;
    let o = false;
    const c = ({ target: u }) => {
      u === t && (o = true, t.removeEventListener(cr, c), Fe(e));
    };
    t.addEventListener(cr, c), setTimeout(() => {
      o || dl(t);
    }, r);
  }, Cr = (e, t, i, n) => {
    const r = e.length;
    let o = e.indexOf(t);
    return o === -1 ? !i && n ? e[r - 1] : e[0] : (o += i ? 1 : -1, n && (o = (o + r) % r), e[Math.max(0, Math.min(o, r - 1))]);
  }, Ju = /[^.]*(?=\..*)\.|.*/, ed = /\..*/, td = /::\d+$/, xs = {};
  let $o = 1;
  const ml = { mouseenter: "mouseover", mouseleave: "mouseout" }, id = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
  function gl(e, t) {
    return t && `${t}::${$o++}` || e.uidEvent || $o++;
  }
  function vl(e) {
    const t = gl(e);
    return e.uidEvent = t, xs[t] = xs[t] || {}, xs[t];
  }
  function nd(e, t) {
    return function i(n) {
      return wr(n, { delegateTarget: e }), i.oneOff && q.off(e, n.type, t), t.apply(e, [n]);
    };
  }
  function sd(e, t, i) {
    return function n(r) {
      const o = e.querySelectorAll(t);
      for (let { target: c } = r; c && c !== this; c = c.parentNode) for (const u of o) if (u === c) return wr(r, { delegateTarget: c }), n.oneOff && q.off(e, r.type, t, i), i.apply(c, [r]);
    };
  }
  function yl(e, t, i = null) {
    return Object.values(e).find((n) => n.callable === t && n.delegationSelector === i);
  }
  function bl(e, t, i) {
    const n = typeof t == "string", r = n ? i : t || i;
    let o = El(e);
    return id.has(o) || (o = e), [n, r, o];
  }
  function No(e, t, i, n, r) {
    if (typeof t != "string" || !e) return;
    let [o, c, u] = bl(t, i, n);
    t in ml && (c = /* @__PURE__ */ ((g) => function(C) {
      if (!C.relatedTarget || C.relatedTarget !== C.delegateTarget && !C.delegateTarget.contains(C.relatedTarget)) return g.call(this, C);
    })(c));
    const l = vl(e), m = l[u] || (l[u] = {}), v = yl(m, c, o ? i : null);
    if (v) {
      v.oneOff = v.oneOff && r;
      return;
    }
    const y = gl(c, t.replace(Ju, "")), E = o ? sd(e, i, c) : nd(e, c);
    E.delegationSelector = o ? i : null, E.callable = c, E.oneOff = r, E.uidEvent = y, m[y] = E, e.addEventListener(u, E, o);
  }
  function ur(e, t, i, n, r) {
    const o = yl(t[i], n, r);
    o && (e.removeEventListener(i, o, !!r), delete t[i][o.uidEvent]);
  }
  function rd(e, t, i, n) {
    const r = t[i] || {};
    for (const [o, c] of Object.entries(r)) o.includes(n) && ur(e, t, i, c.callable, c.delegationSelector);
  }
  function El(e) {
    return e = e.replace(ed, ""), ml[e] || e;
  }
  const q = { on(e, t, i, n) {
    No(e, t, i, n, false);
  }, one(e, t, i, n) {
    No(e, t, i, n, true);
  }, off(e, t, i, n) {
    if (typeof t != "string" || !e) return;
    const [r, o, c] = bl(t, i, n), u = c !== t, l = vl(e), m = l[c] || {}, v = t.startsWith(".");
    if (typeof o != "undefined") {
      if (!Object.keys(m).length) return;
      ur(e, l, c, o, r ? i : null);
      return;
    }
    if (v) for (const y of Object.keys(l)) rd(e, l, y, t.slice(1));
    for (const [y, E] of Object.entries(m)) {
      const h = y.replace(td, "");
      (!u || t.includes(h)) && ur(e, l, c, E.callable, E.delegationSelector);
    }
  }, trigger(e, t, i) {
    if (typeof t != "string" || !e) return null;
    const n = hl(), r = El(t), o = t !== r;
    let c = null, u = true, l = true, m = false;
    o && n && (c = n.Event(t, i), n(e).trigger(c), u = !c.isPropagationStopped(), l = !c.isImmediatePropagationStopped(), m = c.isDefaultPrevented());
    const v = wr(new Event(t, { bubbles: u, cancelable: true }), i);
    return m && v.preventDefault(), l && e.dispatchEvent(v), v.defaultPrevented && c && c.preventDefault(), v;
  } };
  function wr(e, t = {}) {
    for (const [i, n] of Object.entries(t)) try {
      e[i] = n;
    } catch (r) {
      Object.defineProperty(e, i, { configurable: true, get() {
        return n;
      } });
    }
    return e;
  }
  function ko(e) {
    if (e === "true") return true;
    if (e === "false") return false;
    if (e === Number(e).toString()) return Number(e);
    if (e === "" || e === "null") return null;
    if (typeof e != "string") return e;
    try {
      return JSON.parse(decodeURIComponent(e));
    } catch (t) {
      return e;
    }
  }
  function Cs(e) {
    return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
  }
  const At = { setDataAttribute(e, t, i) {
    e.setAttribute(`data-bs-${Cs(t)}`, i);
  }, removeDataAttribute(e, t) {
    e.removeAttribute(`data-bs-${Cs(t)}`);
  }, getDataAttributes(e) {
    if (!e) return {};
    const t = {}, i = Object.keys(e.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of i) {
      let r = n.replace(/^bs/, "");
      r = r.charAt(0).toLowerCase() + r.slice(1), t[r] = ko(e.dataset[n]);
    }
    return t;
  }, getDataAttribute(e, t) {
    return ko(e.getAttribute(`data-bs-${Cs(t)}`));
  } };
  class tn {
    static get Default() {
      return {};
    }
    static get DefaultType() {
      return {};
    }
    static get NAME() {
      throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(t) {
      return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    _configAfterMerge(t) {
      return t;
    }
    _mergeConfigObj(t, i) {
      const n = wt(i) ? At.getDataAttribute(i, "config") : {};
      return Ae(Ae(Ae(Ae({}, this.constructor.Default), typeof n == "object" ? n : {}), wt(i) ? At.getDataAttributes(i) : {}), typeof t == "object" ? t : {});
    }
    _typeCheckConfig(t, i = this.constructor.DefaultType) {
      for (const [n, r] of Object.entries(i)) {
        const o = t[n], c = wt(o) ? "element" : Uu(o);
        if (!new RegExp(r).test(c)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${c}" but expected type "${r}".`);
      }
    }
  }
  const od = "5.3.8";
  class ut extends tn {
    constructor(t, i) {
      super(), t = Vt(t), t && (this._element = t, this._config = this._getConfig(i), Ts.set(this._element, this.constructor.DATA_KEY, this));
    }
    dispose() {
      Ts.remove(this._element, this.constructor.DATA_KEY), q.off(this._element, this.constructor.EVENT_KEY);
      for (const t of Object.getOwnPropertyNames(this)) this[t] = null;
    }
    _queueCallback(t, i, n = true) {
      pl(t, i, n);
    }
    _getConfig(t) {
      return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    static getInstance(t) {
      return Ts.get(Vt(t), this.DATA_KEY);
    }
    static getOrCreateInstance(t, i = {}) {
      return this.getInstance(t) || new this(t, typeof i == "object" ? i : null);
    }
    static get VERSION() {
      return od;
    }
    static get DATA_KEY() {
      return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
      return `.${this.DATA_KEY}`;
    }
    static eventName(t) {
      return `${t}${this.EVENT_KEY}`;
    }
  }
  const ws = (e) => {
    let t = e.getAttribute("data-bs-target");
    if (!t || t === "#") {
      let i = e.getAttribute("href");
      if (!i || !i.includes("#") && !i.startsWith(".")) return null;
      i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), t = i && i !== "#" ? i.trim() : null;
    }
    return t ? t.split(",").map((i) => ul(i)).join(",") : null;
  }, ne = { find(e, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, e));
  }, findOne(e, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, e);
  }, children(e, t) {
    return [].concat(...e.children).filter((i) => i.matches(t));
  }, parents(e, t) {
    const i = [];
    let n = e.parentNode.closest(t);
    for (; n; ) i.push(n), n = n.parentNode.closest(t);
    return i;
  }, prev(e, t) {
    let i = e.previousElementSibling;
    for (; i; ) {
      if (i.matches(t)) return [i];
      i = i.previousElementSibling;
    }
    return [];
  }, next(e, t) {
    let i = e.nextElementSibling;
    for (; i; ) {
      if (i.matches(t)) return [i];
      i = i.nextElementSibling;
    }
    return [];
  }, focusableChildren(e) {
    const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((i) => `${i}:not([tabindex^="-"])`).join(",");
    return this.find(t, e).filter((i) => !Bt(i) && $i(i));
  }, getSelectorFromElement(e) {
    const t = ws(e);
    return t && ne.findOne(t) ? t : null;
  }, getElementFromSelector(e) {
    const t = ws(e);
    return t ? ne.findOne(t) : null;
  }, getMultipleElementsFromSelector(e) {
    const t = ws(e);
    return t ? ne.find(t) : [];
  } }, Yn = (e, t = "hide") => {
    const i = `click.dismiss${e.EVENT_KEY}`, n = e.NAME;
    q.on(document, i, `[data-bs-dismiss="${n}"]`, function(r) {
      if (["A", "AREA"].includes(this.tagName) && r.preventDefault(), Bt(this)) return;
      const o = ne.getElementFromSelector(this) || this.closest(`.${n}`);
      e.getOrCreateInstance(o)[t]();
    });
  }, ad = "alert", ld = "bs.alert", Sl = `.${ld}`, cd = `close${Sl}`, ud = `closed${Sl}`, dd = "fade", fd = "show";
  class Xn extends ut {
    static get NAME() {
      return ad;
    }
    close() {
      if (q.trigger(this._element, cd).defaultPrevented) return;
      this._element.classList.remove(fd);
      const i = this._element.classList.contains(dd);
      this._queueCallback(() => this._destroyElement(), this._element, i);
    }
    _destroyElement() {
      this._element.remove(), q.trigger(this._element, ud), this.dispose();
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Xn.getOrCreateInstance(this);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  Yn(Xn, "close");
  nt(Xn);
  const hd = "button", pd = "bs.button", md = `.${pd}`, gd = ".data-api", vd = "active", Ro = '[data-bs-toggle="button"]', yd = `click${md}${gd}`;
  class qn extends ut {
    static get NAME() {
      return hd;
    }
    toggle() {
      this._element.setAttribute("aria-pressed", this._element.classList.toggle(vd));
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = qn.getOrCreateInstance(this);
        t === "toggle" && i[t]();
      });
    }
  }
  q.on(document, yd, Ro, (e) => {
    e.preventDefault();
    const t = e.target.closest(Ro);
    qn.getOrCreateInstance(t).toggle();
  });
  nt(qn);
  const bd = "swipe", Ni = ".bs.swipe", Ed = `touchstart${Ni}`, Sd = `touchmove${Ni}`, Td = `touchend${Ni}`, _d = `pointerdown${Ni}`, xd = `pointerup${Ni}`, Cd = "touch", wd = "pen", Ad = "pointer-event", Id = 40, Od = { endCallback: null, leftCallback: null, rightCallback: null }, Md = { endCallback: "(function|null)", leftCallback: "(function|null)", rightCallback: "(function|null)" };
  class $n extends tn {
    constructor(t, i) {
      super(), this._element = t, !(!t || !$n.isSupported()) && (this._config = this._getConfig(i), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
    }
    static get Default() {
      return Od;
    }
    static get DefaultType() {
      return Md;
    }
    static get NAME() {
      return bd;
    }
    dispose() {
      q.off(this._element, Ni);
    }
    _start(t) {
      if (!this._supportPointerEvents) {
        this._deltaX = t.touches[0].clientX;
        return;
      }
      this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX);
    }
    _end(t) {
      this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), Fe(this._config.endCallback);
    }
    _move(t) {
      this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
      const t = Math.abs(this._deltaX);
      if (t <= Id) return;
      const i = t / this._deltaX;
      this._deltaX = 0, i && Fe(i > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
      this._supportPointerEvents ? (q.on(this._element, _d, (t) => this._start(t)), q.on(this._element, xd, (t) => this._end(t)), this._element.classList.add(Ad)) : (q.on(this._element, Ed, (t) => this._start(t)), q.on(this._element, Sd, (t) => this._move(t)), q.on(this._element, Td, (t) => this._end(t)));
    }
    _eventIsPointerPenTouch(t) {
      return this._supportPointerEvents && (t.pointerType === wd || t.pointerType === Cd);
    }
    static isSupported() {
      return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
  }
  const Ld = "carousel", Pd = "bs.carousel", Ft = `.${Pd}`, Tl = ".data-api", Dd = "ArrowLeft", zd = "ArrowRight", $d = 500, Gi = "next", Ei = "prev", _i = "left", On = "right", Nd = `slide${Ft}`, As = `slid${Ft}`, kd = `keydown${Ft}`, Rd = `mouseenter${Ft}`, Hd = `mouseleave${Ft}`, Vd = `dragstart${Ft}`, Bd = `load${Ft}${Tl}`, Wd = `click${Ft}${Tl}`, _l = "carousel", Tn = "active", Fd = "slide", Gd = "carousel-item-end", jd = "carousel-item-start", Yd = "carousel-item-next", Xd = "carousel-item-prev", xl = ".active", Cl = ".carousel-item", qd = xl + Cl, Ud = ".carousel-item img", Kd = ".carousel-indicators", Zd = "[data-bs-slide], [data-bs-slide-to]", Qd = '[data-bs-ride="carousel"]', Jd = { [Dd]: On, [zd]: _i }, ef = { interval: 5e3, keyboard: true, pause: "hover", ride: false, touch: true, wrap: true }, tf = { interval: "(number|boolean)", keyboard: "boolean", pause: "(string|boolean)", ride: "(boolean|string)", touch: "boolean", wrap: "boolean" };
  class nn extends ut {
    constructor(t, i) {
      super(t, i), this._interval = null, this._activeElement = null, this._isSliding = false, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = ne.findOne(Kd, this._element), this._addEventListeners(), this._config.ride === _l && this.cycle();
    }
    static get Default() {
      return ef;
    }
    static get DefaultType() {
      return tf;
    }
    static get NAME() {
      return Ld;
    }
    next() {
      this._slide(Gi);
    }
    nextWhenVisible() {
      !document.hidden && $i(this._element) && this.next();
    }
    prev() {
      this._slide(Ei);
    }
    pause() {
      this._isSliding && dl(this._element), this._clearInterval();
    }
    cycle() {
      this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
      if (this._config.ride) {
        if (this._isSliding) {
          q.one(this._element, As, () => this.cycle());
          return;
        }
        this.cycle();
      }
    }
    to(t) {
      const i = this._getItems();
      if (t > i.length - 1 || t < 0) return;
      if (this._isSliding) {
        q.one(this._element, As, () => this.to(t));
        return;
      }
      const n = this._getItemIndex(this._getActive());
      if (n === t) return;
      const r = t > n ? Gi : Ei;
      this._slide(r, i[t]);
    }
    dispose() {
      this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
    }
    _configAfterMerge(t) {
      return t.defaultInterval = t.interval, t;
    }
    _addEventListeners() {
      this._config.keyboard && q.on(this._element, kd, (t) => this._keydown(t)), this._config.pause === "hover" && (q.on(this._element, Rd, () => this.pause()), q.on(this._element, Hd, () => this._maybeEnableCycle())), this._config.touch && $n.isSupported() && this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
      for (const n of ne.find(Ud, this._element)) q.on(n, Vd, (r) => r.preventDefault());
      const i = { leftCallback: () => this._slide(this._directionToOrder(_i)), rightCallback: () => this._slide(this._directionToOrder(On)), endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), $d + this._config.interval));
      } };
      this._swipeHelper = new $n(this._element, i);
    }
    _keydown(t) {
      if (/input|textarea/i.test(t.target.tagName)) return;
      const i = Jd[t.key];
      i && (t.preventDefault(), this._slide(this._directionToOrder(i)));
    }
    _getItemIndex(t) {
      return this._getItems().indexOf(t);
    }
    _setActiveIndicatorElement(t) {
      if (!this._indicatorsElement) return;
      const i = ne.findOne(xl, this._indicatorsElement);
      i.classList.remove(Tn), i.removeAttribute("aria-current");
      const n = ne.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
      n && (n.classList.add(Tn), n.setAttribute("aria-current", "true"));
    }
    _updateInterval() {
      const t = this._activeElement || this._getActive();
      if (!t) return;
      const i = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
      this._config.interval = i || this._config.defaultInterval;
    }
    _slide(t, i = null) {
      if (this._isSliding) return;
      const n = this._getActive(), r = t === Gi, o = i || Cr(this._getItems(), n, r, this._config.wrap);
      if (o === n) return;
      const c = this._getItemIndex(o), u = (h) => q.trigger(this._element, h, { relatedTarget: o, direction: this._orderToDirection(t), from: this._getItemIndex(n), to: c });
      if (u(Nd).defaultPrevented || !n || !o) return;
      const m = !!this._interval;
      this.pause(), this._isSliding = true, this._setActiveIndicatorElement(c), this._activeElement = o;
      const v = r ? jd : Gd, y = r ? Yd : Xd;
      o.classList.add(y), en(o), n.classList.add(v), o.classList.add(v);
      const E = () => {
        o.classList.remove(v, y), o.classList.add(Tn), n.classList.remove(Tn, y, v), this._isSliding = false, u(As);
      };
      this._queueCallback(E, n, this._isAnimated()), m && this.cycle();
    }
    _isAnimated() {
      return this._element.classList.contains(Fd);
    }
    _getActive() {
      return ne.findOne(qd, this._element);
    }
    _getItems() {
      return ne.find(Cl, this._element);
    }
    _clearInterval() {
      this._interval && (clearInterval(this._interval), this._interval = null);
    }
    _directionToOrder(t) {
      return tt() ? t === _i ? Ei : Gi : t === _i ? Gi : Ei;
    }
    _orderToDirection(t) {
      return tt() ? t === Ei ? _i : On : t === Ei ? On : _i;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = nn.getOrCreateInstance(this, t);
        if (typeof t == "number") {
          i.to(t);
          return;
        }
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(document, Wd, Zd, function(e) {
    const t = ne.getElementFromSelector(this);
    if (!t || !t.classList.contains(_l)) return;
    e.preventDefault();
    const i = nn.getOrCreateInstance(t), n = this.getAttribute("data-bs-slide-to");
    if (n) {
      i.to(n), i._maybeEnableCycle();
      return;
    }
    if (At.getDataAttribute(this, "slide") === "next") {
      i.next(), i._maybeEnableCycle();
      return;
    }
    i.prev(), i._maybeEnableCycle();
  });
  q.on(window, Bd, () => {
    const e = ne.find(Qd);
    for (const t of e) nn.getOrCreateInstance(t);
  });
  nt(nn);
  const nf = "collapse", sf = "bs.collapse", sn = `.${sf}`, rf = ".data-api", of = `show${sn}`, af = `shown${sn}`, lf = `hide${sn}`, cf = `hidden${sn}`, uf = `click${sn}${rf}`, Is = "show", Ci = "collapse", _n = "collapsing", df = "collapsed", ff = `:scope .${Ci} .${Ci}`, hf = "collapse-horizontal", pf = "width", mf = "height", gf = ".collapse.show, .collapse.collapsing", dr = '[data-bs-toggle="collapse"]', vf = { parent: null, toggle: true }, yf = { parent: "(null|element)", toggle: "boolean" };
  class Li extends ut {
    constructor(t, i) {
      super(t, i), this._isTransitioning = false, this._triggerArray = [];
      const n = ne.find(dr);
      for (const r of n) {
        const o = ne.getSelectorFromElement(r), c = ne.find(o).filter((u) => u === this._element);
        o !== null && c.length && this._triggerArray.push(r);
      }
      this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
    }
    static get Default() {
      return vf;
    }
    static get DefaultType() {
      return yf;
    }
    static get NAME() {
      return nf;
    }
    toggle() {
      this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (this._isTransitioning || this._isShown()) return;
      let t = [];
      if (this._config.parent && (t = this._getFirstLevelChildren(gf).filter((u) => u !== this._element).map((u) => Li.getOrCreateInstance(u, { toggle: false }))), t.length && t[0]._isTransitioning || q.trigger(this._element, of).defaultPrevented) return;
      for (const u of t) u.hide();
      const n = this._getDimension();
      this._element.classList.remove(Ci), this._element.classList.add(_n), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, true), this._isTransitioning = true;
      const r = () => {
        this._isTransitioning = false, this._element.classList.remove(_n), this._element.classList.add(Ci, Is), this._element.style[n] = "", q.trigger(this._element, af);
      }, c = `scroll${n[0].toUpperCase() + n.slice(1)}`;
      this._queueCallback(r, this._element, true), this._element.style[n] = `${this._element[c]}px`;
    }
    hide() {
      if (this._isTransitioning || !this._isShown() || q.trigger(this._element, lf).defaultPrevented) return;
      const i = this._getDimension();
      this._element.style[i] = `${this._element.getBoundingClientRect()[i]}px`, en(this._element), this._element.classList.add(_n), this._element.classList.remove(Ci, Is);
      for (const r of this._triggerArray) {
        const o = ne.getElementFromSelector(r);
        o && !this._isShown(o) && this._addAriaAndCollapsedClass([r], false);
      }
      this._isTransitioning = true;
      const n = () => {
        this._isTransitioning = false, this._element.classList.remove(_n), this._element.classList.add(Ci), q.trigger(this._element, cf);
      };
      this._element.style[i] = "", this._queueCallback(n, this._element, true);
    }
    _isShown(t = this._element) {
      return t.classList.contains(Is);
    }
    _configAfterMerge(t) {
      return t.toggle = !!t.toggle, t.parent = Vt(t.parent), t;
    }
    _getDimension() {
      return this._element.classList.contains(hf) ? pf : mf;
    }
    _initializeChildren() {
      if (!this._config.parent) return;
      const t = this._getFirstLevelChildren(dr);
      for (const i of t) {
        const n = ne.getElementFromSelector(i);
        n && this._addAriaAndCollapsedClass([i], this._isShown(n));
      }
    }
    _getFirstLevelChildren(t) {
      const i = ne.find(ff, this._config.parent);
      return ne.find(t, this._config.parent).filter((n) => !i.includes(n));
    }
    _addAriaAndCollapsedClass(t, i) {
      if (t.length) for (const n of t) n.classList.toggle(df, !i), n.setAttribute("aria-expanded", i);
    }
    static jQueryInterface(t) {
      const i = {};
      return typeof t == "string" && /show|hide/.test(t) && (i.toggle = false), this.each(function() {
        const n = Li.getOrCreateInstance(this, i);
        if (typeof t == "string") {
          if (typeof n[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          n[t]();
        }
      });
    }
  }
  q.on(document, uf, dr, function(e) {
    (e.target.tagName === "A" || e.delegateTarget && e.delegateTarget.tagName === "A") && e.preventDefault();
    for (const t of ne.getMultipleElementsFromSelector(this)) Li.getOrCreateInstance(t, { toggle: false }).toggle();
  });
  nt(Li);
  const Ho = "dropdown", bf = "bs.dropdown", si = `.${bf}`, Ar = ".data-api", Ef = "Escape", Vo = "Tab", Sf = "ArrowUp", Bo = "ArrowDown", Tf = 2, _f = `hide${si}`, xf = `hidden${si}`, Cf = `show${si}`, wf = `shown${si}`, wl = `click${si}${Ar}`, Al = `keydown${si}${Ar}`, Af = `keyup${si}${Ar}`, xi = "show", If = "dropup", Of = "dropend", Mf = "dropstart", Lf = "dropup-center", Pf = "dropdown-center", Ut = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', Df = `${Ut}.${xi}`, Mn = ".dropdown-menu", zf = ".navbar", $f = ".navbar-nav", Nf = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", kf = tt() ? "top-end" : "top-start", Rf = tt() ? "top-start" : "top-end", Hf = tt() ? "bottom-end" : "bottom-start", Vf = tt() ? "bottom-start" : "bottom-end", Bf = tt() ? "left-start" : "right-start", Wf = tt() ? "right-start" : "left-start", Ff = "top", Gf = "bottom", jf = { autoClose: true, boundary: "clippingParents", display: "dynamic", offset: [0, 2], popperConfig: null, reference: "toggle" }, Yf = { autoClose: "(boolean|string)", boundary: "(string|element)", display: "string", offset: "(array|string|function)", popperConfig: "(null|object|function)", reference: "(string|element|object)" };
  class lt extends ut {
    constructor(t, i) {
      super(t, i), this._popper = null, this._parent = this._element.parentNode, this._menu = ne.next(this._element, Mn)[0] || ne.prev(this._element, Mn)[0] || ne.findOne(Mn, this._parent), this._inNavbar = this._detectNavbar();
    }
    static get Default() {
      return jf;
    }
    static get DefaultType() {
      return Yf;
    }
    static get NAME() {
      return Ho;
    }
    toggle() {
      return this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (Bt(this._element) || this._isShown()) return;
      const t = { relatedTarget: this._element };
      if (!q.trigger(this._element, Cf, t).defaultPrevented) {
        if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest($f)) for (const n of [].concat(...document.body.children)) q.on(n, "mouseover", zn);
        this._element.focus(), this._element.setAttribute("aria-expanded", true), this._menu.classList.add(xi), this._element.classList.add(xi), q.trigger(this._element, wf, t);
      }
    }
    hide() {
      if (Bt(this._element) || !this._isShown()) return;
      const t = { relatedTarget: this._element };
      this._completeHide(t);
    }
    dispose() {
      this._popper && this._popper.destroy(), super.dispose();
    }
    update() {
      this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
    }
    _completeHide(t) {
      if (!q.trigger(this._element, _f, t).defaultPrevented) {
        if ("ontouchstart" in document.documentElement) for (const n of [].concat(...document.body.children)) q.off(n, "mouseover", zn);
        this._popper && this._popper.destroy(), this._menu.classList.remove(xi), this._element.classList.remove(xi), this._element.setAttribute("aria-expanded", "false"), At.removeDataAttribute(this._menu, "popper"), q.trigger(this._element, xf, t);
      }
    }
    _getConfig(t) {
      if (t = super._getConfig(t), typeof t.reference == "object" && !wt(t.reference) && typeof t.reference.getBoundingClientRect != "function") throw new TypeError(`${Ho.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
      return t;
    }
    _createPopper() {
      if (typeof cl == "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
      let t = this._element;
      this._config.reference === "parent" ? t = this._parent : wt(this._config.reference) ? t = Vt(this._config.reference) : typeof this._config.reference == "object" && (t = this._config.reference);
      const i = this._getPopperConfig();
      this._popper = xr(t, this._menu, i);
    }
    _isShown() {
      return this._menu.classList.contains(xi);
    }
    _getPlacement() {
      const t = this._parent;
      if (t.classList.contains(Of)) return Bf;
      if (t.classList.contains(Mf)) return Wf;
      if (t.classList.contains(Lf)) return Ff;
      if (t.classList.contains(Pf)) return Gf;
      const i = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
      return t.classList.contains(If) ? i ? Rf : kf : i ? Vf : Hf;
    }
    _detectNavbar() {
      return this._element.closest(zf) !== null;
    }
    _getOffset() {
      const { offset: t } = this._config;
      return typeof t == "string" ? t.split(",").map((i) => Number.parseInt(i, 10)) : typeof t == "function" ? (i) => t(i, this._element) : t;
    }
    _getPopperConfig() {
      const t = { placement: this._getPlacement(), modifiers: [{ name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "offset", options: { offset: this._getOffset() } }] };
      return (this._inNavbar || this._config.display === "static") && (At.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [{ name: "applyStyles", enabled: false }]), Ae(Ae({}, t), Fe(this._config.popperConfig, [void 0, t]));
    }
    _selectMenuItem({ key: t, target: i }) {
      const n = ne.find(Nf, this._menu).filter((r) => $i(r));
      n.length && Cr(n, i, t === Bo, !n.includes(i)).focus();
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = lt.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
    static clearMenus(t) {
      if (t.button === Tf || t.type === "keyup" && t.key !== Vo) return;
      const i = ne.find(Df);
      for (const n of i) {
        const r = lt.getInstance(n);
        if (!r || r._config.autoClose === false) continue;
        const o = t.composedPath(), c = o.includes(r._menu);
        if (o.includes(r._element) || r._config.autoClose === "inside" && !c || r._config.autoClose === "outside" && c || r._menu.contains(t.target) && (t.type === "keyup" && t.key === Vo || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
        const u = { relatedTarget: r._element };
        t.type === "click" && (u.clickEvent = t), r._completeHide(u);
      }
    }
    static dataApiKeydownHandler(t) {
      const i = /input|textarea/i.test(t.target.tagName), n = t.key === Ef, r = [Sf, Bo].includes(t.key);
      if (!r && !n || i && !n) return;
      t.preventDefault();
      const o = this.matches(Ut) ? this : ne.prev(this, Ut)[0] || ne.next(this, Ut)[0] || ne.findOne(Ut, t.delegateTarget.parentNode), c = lt.getOrCreateInstance(o);
      if (r) {
        t.stopPropagation(), c.show(), c._selectMenuItem(t);
        return;
      }
      c._isShown() && (t.stopPropagation(), c.hide(), o.focus());
    }
  }
  q.on(document, Al, Ut, lt.dataApiKeydownHandler);
  q.on(document, Al, Mn, lt.dataApiKeydownHandler);
  q.on(document, wl, lt.clearMenus);
  q.on(document, Af, lt.clearMenus);
  q.on(document, wl, Ut, function(e) {
    e.preventDefault(), lt.getOrCreateInstance(this).toggle();
  });
  nt(lt);
  const Il = "backdrop", Xf = "fade", Wo = "show", Fo = `mousedown.bs.${Il}`, qf = { className: "modal-backdrop", clickCallback: null, isAnimated: false, isVisible: true, rootElement: "body" }, Uf = { className: "string", clickCallback: "(function|null)", isAnimated: "boolean", isVisible: "boolean", rootElement: "(element|string)" };
  class Ol extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t), this._isAppended = false, this._element = null;
    }
    static get Default() {
      return qf;
    }
    static get DefaultType() {
      return Uf;
    }
    static get NAME() {
      return Il;
    }
    show(t) {
      if (!this._config.isVisible) {
        Fe(t);
        return;
      }
      this._append();
      const i = this._getElement();
      this._config.isAnimated && en(i), i.classList.add(Wo), this._emulateAnimation(() => {
        Fe(t);
      });
    }
    hide(t) {
      if (!this._config.isVisible) {
        Fe(t);
        return;
      }
      this._getElement().classList.remove(Wo), this._emulateAnimation(() => {
        this.dispose(), Fe(t);
      });
    }
    dispose() {
      this._isAppended && (q.off(this._element, Fo), this._element.remove(), this._isAppended = false);
    }
    _getElement() {
      if (!this._element) {
        const t = document.createElement("div");
        t.className = this._config.className, this._config.isAnimated && t.classList.add(Xf), this._element = t;
      }
      return this._element;
    }
    _configAfterMerge(t) {
      return t.rootElement = Vt(t.rootElement), t;
    }
    _append() {
      if (this._isAppended) return;
      const t = this._getElement();
      this._config.rootElement.append(t), q.on(t, Fo, () => {
        Fe(this._config.clickCallback);
      }), this._isAppended = true;
    }
    _emulateAnimation(t) {
      pl(t, this._getElement(), this._config.isAnimated);
    }
  }
  const Kf = "focustrap", Zf = "bs.focustrap", Nn = `.${Zf}`, Qf = `focusin${Nn}`, Jf = `keydown.tab${Nn}`, eh = "Tab", th = "forward", Go = "backward", ih = { autofocus: true, trapElement: null }, nh = { autofocus: "boolean", trapElement: "element" };
  class Ml extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t), this._isActive = false, this._lastTabNavDirection = null;
    }
    static get Default() {
      return ih;
    }
    static get DefaultType() {
      return nh;
    }
    static get NAME() {
      return Kf;
    }
    activate() {
      this._isActive || (this._config.autofocus && this._config.trapElement.focus(), q.off(document, Nn), q.on(document, Qf, (t) => this._handleFocusin(t)), q.on(document, Jf, (t) => this._handleKeydown(t)), this._isActive = true);
    }
    deactivate() {
      this._isActive && (this._isActive = false, q.off(document, Nn));
    }
    _handleFocusin(t) {
      const { trapElement: i } = this._config;
      if (t.target === document || t.target === i || i.contains(t.target)) return;
      const n = ne.focusableChildren(i);
      n.length === 0 ? i.focus() : this._lastTabNavDirection === Go ? n[n.length - 1].focus() : n[0].focus();
    }
    _handleKeydown(t) {
      t.key === eh && (this._lastTabNavDirection = t.shiftKey ? Go : th);
    }
  }
  const jo = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Yo = ".sticky-top", xn = "padding-right", Xo = "margin-right";
  class fr {
    constructor() {
      this._element = document.body;
    }
    getWidth() {
      const t = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - t);
    }
    hide() {
      const t = this.getWidth();
      this._disableOverFlow(), this._setElementAttributes(this._element, xn, (i) => i + t), this._setElementAttributes(jo, xn, (i) => i + t), this._setElementAttributes(Yo, Xo, (i) => i - t);
    }
    reset() {
      this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, xn), this._resetElementAttributes(jo, xn), this._resetElementAttributes(Yo, Xo);
    }
    isOverflowing() {
      return this.getWidth() > 0;
    }
    _disableOverFlow() {
      this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
    }
    _setElementAttributes(t, i, n) {
      const r = this.getWidth(), o = (c) => {
        if (c !== this._element && window.innerWidth > c.clientWidth + r) return;
        this._saveInitialAttribute(c, i);
        const u = window.getComputedStyle(c).getPropertyValue(i);
        c.style.setProperty(i, `${n(Number.parseFloat(u))}px`);
      };
      this._applyManipulationCallback(t, o);
    }
    _saveInitialAttribute(t, i) {
      const n = t.style.getPropertyValue(i);
      n && At.setDataAttribute(t, i, n);
    }
    _resetElementAttributes(t, i) {
      const n = (r) => {
        const o = At.getDataAttribute(r, i);
        if (o === null) {
          r.style.removeProperty(i);
          return;
        }
        At.removeDataAttribute(r, i), r.style.setProperty(i, o);
      };
      this._applyManipulationCallback(t, n);
    }
    _applyManipulationCallback(t, i) {
      if (wt(t)) {
        i(t);
        return;
      }
      for (const n of ne.find(t, this._element)) i(n);
    }
  }
  const sh = "modal", rh = "bs.modal", it = `.${rh}`, oh = ".data-api", ah = "Escape", lh = `hide${it}`, ch = `hidePrevented${it}`, Ll = `hidden${it}`, Pl = `show${it}`, uh = `shown${it}`, dh = `resize${it}`, fh = `click.dismiss${it}`, hh = `mousedown.dismiss${it}`, ph = `keydown.dismiss${it}`, mh = `click${it}${oh}`, qo = "modal-open", gh = "fade", Uo = "show", Os = "modal-static", vh = ".modal.show", yh = ".modal-dialog", bh = ".modal-body", Eh = '[data-bs-toggle="modal"]', Sh = { backdrop: true, focus: true, keyboard: true }, Th = { backdrop: "(boolean|string)", focus: "boolean", keyboard: "boolean" };
  class ii extends ut {
    constructor(t, i) {
      super(t, i), this._dialog = ne.findOne(yh, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = false, this._isTransitioning = false, this._scrollBar = new fr(), this._addEventListeners();
    }
    static get Default() {
      return Sh;
    }
    static get DefaultType() {
      return Th;
    }
    static get NAME() {
      return sh;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      this._isShown || this._isTransitioning || q.trigger(this._element, Pl, { relatedTarget: t }).defaultPrevented || (this._isShown = true, this._isTransitioning = true, this._scrollBar.hide(), document.body.classList.add(qo), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
    }
    hide() {
      !this._isShown || this._isTransitioning || q.trigger(this._element, lh).defaultPrevented || (this._isShown = false, this._isTransitioning = true, this._focustrap.deactivate(), this._element.classList.remove(Uo), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
    }
    dispose() {
      q.off(window, it), q.off(this._dialog, it), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    handleUpdate() {
      this._adjustDialog();
    }
    _initializeBackDrop() {
      return new Ol({ isVisible: !!this._config.backdrop, isAnimated: this._isAnimated() });
    }
    _initializeFocusTrap() {
      return new Ml({ trapElement: this._element });
    }
    _showElement(t) {
      document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
      const i = ne.findOne(bh, this._dialog);
      i && (i.scrollTop = 0), en(this._element), this._element.classList.add(Uo);
      const n = () => {
        this._config.focus && this._focustrap.activate(), this._isTransitioning = false, q.trigger(this._element, uh, { relatedTarget: t });
      };
      this._queueCallback(n, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
      q.on(this._element, ph, (t) => {
        if (t.key === ah) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          this._triggerBackdropTransition();
        }
      }), q.on(window, dh, () => {
        this._isShown && !this._isTransitioning && this._adjustDialog();
      }), q.on(this._element, hh, (t) => {
        q.one(this._element, fh, (i) => {
          if (!(this._element !== t.target || this._element !== i.target)) {
            if (this._config.backdrop === "static") {
              this._triggerBackdropTransition();
              return;
            }
            this._config.backdrop && this.hide();
          }
        });
      });
    }
    _hideModal() {
      this._element.style.display = "none", this._element.setAttribute("aria-hidden", true), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = false, this._backdrop.hide(() => {
        document.body.classList.remove(qo), this._resetAdjustments(), this._scrollBar.reset(), q.trigger(this._element, Ll);
      });
    }
    _isAnimated() {
      return this._element.classList.contains(gh);
    }
    _triggerBackdropTransition() {
      if (q.trigger(this._element, ch).defaultPrevented) return;
      const i = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
      n === "hidden" || this._element.classList.contains(Os) || (i || (this._element.style.overflowY = "hidden"), this._element.classList.add(Os), this._queueCallback(() => {
        this._element.classList.remove(Os), this._queueCallback(() => {
          this._element.style.overflowY = n;
        }, this._dialog);
      }, this._dialog), this._element.focus());
    }
    _adjustDialog() {
      const t = this._element.scrollHeight > document.documentElement.clientHeight, i = this._scrollBar.getWidth(), n = i > 0;
      if (n && !t) {
        const r = tt() ? "paddingLeft" : "paddingRight";
        this._element.style[r] = `${i}px`;
      }
      if (!n && t) {
        const r = tt() ? "paddingRight" : "paddingLeft";
        this._element.style[r] = `${i}px`;
      }
    }
    _resetAdjustments() {
      this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
    }
    static jQueryInterface(t, i) {
      return this.each(function() {
        const n = ii.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof n[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          n[t](i);
        }
      });
    }
  }
  q.on(document, mh, Eh, function(e) {
    const t = ne.getElementFromSelector(this);
    ["A", "AREA"].includes(this.tagName) && e.preventDefault(), q.one(t, Pl, (r) => {
      r.defaultPrevented || q.one(t, Ll, () => {
        $i(this) && this.focus();
      });
    });
    const i = ne.findOne(vh);
    i && ii.getInstance(i).hide(), ii.getOrCreateInstance(t).toggle(this);
  });
  Yn(ii);
  nt(ii);
  const _h = "offcanvas", xh = "bs.offcanvas", Mt = `.${xh}`, Dl = ".data-api", Ch = `load${Mt}${Dl}`, wh = "Escape", Ko = "show", Zo = "showing", Qo = "hiding", Ah = "offcanvas-backdrop", zl = ".offcanvas.show", Ih = `show${Mt}`, Oh = `shown${Mt}`, Mh = `hide${Mt}`, Jo = `hidePrevented${Mt}`, $l = `hidden${Mt}`, Lh = `resize${Mt}`, Ph = `click${Mt}${Dl}`, Dh = `keydown.dismiss${Mt}`, zh = '[data-bs-toggle="offcanvas"]', $h = { backdrop: true, keyboard: true, scroll: false }, Nh = { backdrop: "(boolean|string)", keyboard: "boolean", scroll: "boolean" };
  class Ot extends ut {
    constructor(t, i) {
      super(t, i), this._isShown = false, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
    }
    static get Default() {
      return $h;
    }
    static get DefaultType() {
      return Nh;
    }
    static get NAME() {
      return _h;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      if (this._isShown || q.trigger(this._element, Ih, { relatedTarget: t }).defaultPrevented) return;
      this._isShown = true, this._backdrop.show(), this._config.scroll || new fr().hide(), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.classList.add(Zo);
      const n = () => {
        (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(Ko), this._element.classList.remove(Zo), q.trigger(this._element, Oh, { relatedTarget: t });
      };
      this._queueCallback(n, this._element, true);
    }
    hide() {
      if (!this._isShown || q.trigger(this._element, Mh).defaultPrevented) return;
      this._focustrap.deactivate(), this._element.blur(), this._isShown = false, this._element.classList.add(Qo), this._backdrop.hide();
      const i = () => {
        this._element.classList.remove(Ko, Qo), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new fr().reset(), q.trigger(this._element, $l);
      };
      this._queueCallback(i, this._element, true);
    }
    dispose() {
      this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    _initializeBackDrop() {
      const t = () => {
        if (this._config.backdrop === "static") {
          q.trigger(this._element, Jo);
          return;
        }
        this.hide();
      }, i = !!this._config.backdrop;
      return new Ol({ className: Ah, isVisible: i, isAnimated: true, rootElement: this._element.parentNode, clickCallback: i ? t : null });
    }
    _initializeFocusTrap() {
      return new Ml({ trapElement: this._element });
    }
    _addEventListeners() {
      q.on(this._element, Dh, (t) => {
        if (t.key === wh) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          q.trigger(this._element, Jo);
        }
      });
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Ot.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  q.on(document, Ph, zh, function(e) {
    const t = ne.getElementFromSelector(this);
    if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), Bt(this)) return;
    q.one(t, $l, () => {
      $i(this) && this.focus();
    });
    const i = ne.findOne(zl);
    i && i !== t && Ot.getInstance(i).hide(), Ot.getOrCreateInstance(t).toggle(this);
  });
  q.on(window, Ch, () => {
    for (const e of ne.find(zl)) Ot.getOrCreateInstance(e).show();
  });
  q.on(window, Lh, () => {
    for (const e of ne.find("[aria-modal][class*=show][class*=offcanvas-]")) getComputedStyle(e).position !== "fixed" && Ot.getOrCreateInstance(e).hide();
  });
  Yn(Ot);
  nt(Ot);
  const kh = /^aria-[\w-]*$/i, Nl = { "*": ["class", "dir", "id", "lang", "role", kh], a: ["target", "href", "title", "rel"], area: [], b: [], br: [], col: [], code: [], dd: [], div: [], dl: [], dt: [], em: [], hr: [], h1: [], h2: [], h3: [], h4: [], h5: [], h6: [], i: [], img: ["src", "srcset", "alt", "title", "width", "height"], li: [], ol: [], p: [], pre: [], s: [], small: [], span: [], sub: [], sup: [], strong: [], u: [], ul: [] }, Rh = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), Hh = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, Vh = (e, t) => {
    const i = e.nodeName.toLowerCase();
    return t.includes(i) ? Rh.has(i) ? !!Hh.test(e.nodeValue) : true : t.filter((n) => n instanceof RegExp).some((n) => n.test(i));
  };
  function Bh(e, t, i) {
    if (!e.length) return e;
    if (i && typeof i == "function") return i(e);
    const r = new window.DOMParser().parseFromString(e, "text/html"), o = [].concat(...r.body.querySelectorAll("*"));
    for (const c of o) {
      const u = c.nodeName.toLowerCase();
      if (!Object.keys(t).includes(u)) {
        c.remove();
        continue;
      }
      const l = [].concat(...c.attributes), m = [].concat(t["*"] || [], t[u] || []);
      for (const v of l) Vh(v, m) || c.removeAttribute(v.nodeName);
    }
    return r.body.innerHTML;
  }
  const Wh = "TemplateFactory", Fh = { allowList: Nl, content: {}, extraClass: "", html: false, sanitize: true, sanitizeFn: null, template: "<div></div>" }, Gh = { allowList: "object", content: "object", extraClass: "(string|function)", html: "boolean", sanitize: "boolean", sanitizeFn: "(null|function)", template: "string" }, jh = { entry: "(string|element|function|null)", selector: "(string|element)" };
  class Yh extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t);
    }
    static get Default() {
      return Fh;
    }
    static get DefaultType() {
      return Gh;
    }
    static get NAME() {
      return Wh;
    }
    getContent() {
      return Object.values(this._config.content).map((t) => this._resolvePossibleFunction(t)).filter(Boolean);
    }
    hasContent() {
      return this.getContent().length > 0;
    }
    changeContent(t) {
      return this._checkContent(t), this._config.content = Ae(Ae({}, this._config.content), t), this;
    }
    toHtml() {
      const t = document.createElement("div");
      t.innerHTML = this._maybeSanitize(this._config.template);
      for (const [r, o] of Object.entries(this._config.content)) this._setContent(t, o, r);
      const i = t.children[0], n = this._resolvePossibleFunction(this._config.extraClass);
      return n && i.classList.add(...n.split(" ")), i;
    }
    _typeCheckConfig(t) {
      super._typeCheckConfig(t), this._checkContent(t.content);
    }
    _checkContent(t) {
      for (const [i, n] of Object.entries(t)) super._typeCheckConfig({ selector: i, entry: n }, jh);
    }
    _setContent(t, i, n) {
      const r = ne.findOne(n, t);
      if (r) {
        if (i = this._resolvePossibleFunction(i), !i) {
          r.remove();
          return;
        }
        if (wt(i)) {
          this._putElementInTemplate(Vt(i), r);
          return;
        }
        if (this._config.html) {
          r.innerHTML = this._maybeSanitize(i);
          return;
        }
        r.textContent = i;
      }
    }
    _maybeSanitize(t) {
      return this._config.sanitize ? Bh(t, this._config.allowList, this._config.sanitizeFn) : t;
    }
    _resolvePossibleFunction(t) {
      return Fe(t, [void 0, this]);
    }
    _putElementInTemplate(t, i) {
      if (this._config.html) {
        i.innerHTML = "", i.append(t);
        return;
      }
      i.textContent = t.textContent;
    }
  }
  const Xh = "tooltip", qh = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), Ms = "fade", Uh = "modal", Cn = "show", Kh = ".tooltip-inner", ea = `.${Uh}`, ta = "hide.bs.modal", ji = "hover", Ls = "focus", Ps = "click", Zh = "manual", Qh = "hide", Jh = "hidden", ep = "show", tp = "shown", ip = "inserted", np = "click", sp = "focusin", rp = "focusout", op = "mouseenter", ap = "mouseleave", lp = { AUTO: "auto", TOP: "top", RIGHT: tt() ? "left" : "right", BOTTOM: "bottom", LEFT: tt() ? "right" : "left" }, cp = { allowList: Nl, animation: true, boundary: "clippingParents", container: false, customClass: "", delay: 0, fallbackPlacements: ["top", "right", "bottom", "left"], html: false, offset: [0, 6], placement: "top", popperConfig: null, sanitize: true, sanitizeFn: null, selector: false, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', title: "", trigger: "hover focus" }, up = { allowList: "object", animation: "boolean", boundary: "(string|element)", container: "(string|element|boolean)", customClass: "(string|function)", delay: "(number|object)", fallbackPlacements: "array", html: "boolean", offset: "(array|string|function)", placement: "(string|function)", popperConfig: "(null|object|function)", sanitize: "boolean", sanitizeFn: "(null|function)", selector: "(string|boolean)", template: "string", title: "(string|element|function)", trigger: "string" };
  class ri extends ut {
    constructor(t, i) {
      if (typeof cl == "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
      super(t, i), this._isEnabled = true, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
    }
    static get Default() {
      return cp;
    }
    static get DefaultType() {
      return up;
    }
    static get NAME() {
      return Xh;
    }
    enable() {
      this._isEnabled = true;
    }
    disable() {
      this._isEnabled = false;
    }
    toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }
    toggle() {
      if (this._isEnabled) {
        if (this._isShown()) {
          this._leave();
          return;
        }
        this._enter();
      }
    }
    dispose() {
      clearTimeout(this._timeout), q.off(this._element.closest(ea), ta, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
    }
    show() {
      if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
      if (!(this._isWithContent() && this._isEnabled)) return;
      const t = q.trigger(this._element, this.constructor.eventName(ep)), n = (fl(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
      if (t.defaultPrevented || !n) return;
      this._disposePopper();
      const r = this._getTipElement();
      this._element.setAttribute("aria-describedby", r.getAttribute("id"));
      const { container: o } = this._config;
      if (this._element.ownerDocument.documentElement.contains(this.tip) || (o.append(r), q.trigger(this._element, this.constructor.eventName(ip))), this._popper = this._createPopper(r), r.classList.add(Cn), "ontouchstart" in document.documentElement) for (const u of [].concat(...document.body.children)) q.on(u, "mouseover", zn);
      const c = () => {
        q.trigger(this._element, this.constructor.eventName(tp)), this._isHovered === false && this._leave(), this._isHovered = false;
      };
      this._queueCallback(c, this.tip, this._isAnimated());
    }
    hide() {
      if (!this._isShown() || q.trigger(this._element, this.constructor.eventName(Qh)).defaultPrevented) return;
      if (this._getTipElement().classList.remove(Cn), "ontouchstart" in document.documentElement) for (const r of [].concat(...document.body.children)) q.off(r, "mouseover", zn);
      this._activeTrigger[Ps] = false, this._activeTrigger[Ls] = false, this._activeTrigger[ji] = false, this._isHovered = null;
      const n = () => {
        this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), q.trigger(this._element, this.constructor.eventName(Jh)));
      };
      this._queueCallback(n, this.tip, this._isAnimated());
    }
    update() {
      this._popper && this._popper.update();
    }
    _isWithContent() {
      return !!this._getTitle();
    }
    _getTipElement() {
      return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
    }
    _createTipElement(t) {
      const i = this._getTemplateFactory(t).toHtml();
      if (!i) return null;
      i.classList.remove(Ms, Cn), i.classList.add(`bs-${this.constructor.NAME}-auto`);
      const n = Ku(this.constructor.NAME).toString();
      return i.setAttribute("id", n), this._isAnimated() && i.classList.add(Ms), i;
    }
    setContent(t) {
      this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
    }
    _getTemplateFactory(t) {
      return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new Yh(bi(Ae({}, this._config), { content: t, extraClass: this._resolvePossibleFunction(this._config.customClass) })), this._templateFactory;
    }
    _getContentForTemplate() {
      return { [Kh]: this._getTitle() };
    }
    _getTitle() {
      return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    _initializeOnDelegatedTarget(t) {
      return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
      return this._config.animation || this.tip && this.tip.classList.contains(Ms);
    }
    _isShown() {
      return this.tip && this.tip.classList.contains(Cn);
    }
    _createPopper(t) {
      const i = Fe(this._config.placement, [this, t, this._element]), n = lp[i.toUpperCase()];
      return xr(this._element, t, this._getPopperConfig(n));
    }
    _getOffset() {
      const { offset: t } = this._config;
      return typeof t == "string" ? t.split(",").map((i) => Number.parseInt(i, 10)) : typeof t == "function" ? (i) => t(i, this._element) : t;
    }
    _resolvePossibleFunction(t) {
      return Fe(t, [this._element, this._element]);
    }
    _getPopperConfig(t) {
      const i = { placement: t, modifiers: [{ name: "flip", options: { fallbackPlacements: this._config.fallbackPlacements } }, { name: "offset", options: { offset: this._getOffset() } }, { name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "arrow", options: { element: `.${this.constructor.NAME}-arrow` } }, { name: "preSetPlacement", enabled: true, phase: "beforeMain", fn: (n) => {
        this._getTipElement().setAttribute("data-popper-placement", n.state.placement);
      } }] };
      return Ae(Ae({}, i), Fe(this._config.popperConfig, [void 0, i]));
    }
    _setListeners() {
      const t = this._config.trigger.split(" ");
      for (const i of t) if (i === "click") q.on(this._element, this.constructor.eventName(np), this._config.selector, (n) => {
        const r = this._initializeOnDelegatedTarget(n);
        r._activeTrigger[Ps] = !(r._isShown() && r._activeTrigger[Ps]), r.toggle();
      });
      else if (i !== Zh) {
        const n = i === ji ? this.constructor.eventName(op) : this.constructor.eventName(sp), r = i === ji ? this.constructor.eventName(ap) : this.constructor.eventName(rp);
        q.on(this._element, n, this._config.selector, (o) => {
          const c = this._initializeOnDelegatedTarget(o);
          c._activeTrigger[o.type === "focusin" ? Ls : ji] = true, c._enter();
        }), q.on(this._element, r, this._config.selector, (o) => {
          const c = this._initializeOnDelegatedTarget(o);
          c._activeTrigger[o.type === "focusout" ? Ls : ji] = c._element.contains(o.relatedTarget), c._leave();
        });
      }
      this._hideModalHandler = () => {
        this._element && this.hide();
      }, q.on(this._element.closest(ea), ta, this._hideModalHandler);
    }
    _fixTitle() {
      const t = this._element.getAttribute("title");
      t && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
    }
    _enter() {
      if (this._isShown() || this._isHovered) {
        this._isHovered = true;
        return;
      }
      this._isHovered = true, this._setTimeout(() => {
        this._isHovered && this.show();
      }, this._config.delay.show);
    }
    _leave() {
      this._isWithActiveTrigger() || (this._isHovered = false, this._setTimeout(() => {
        this._isHovered || this.hide();
      }, this._config.delay.hide));
    }
    _setTimeout(t, i) {
      clearTimeout(this._timeout), this._timeout = setTimeout(t, i);
    }
    _isWithActiveTrigger() {
      return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(t) {
      const i = At.getDataAttributes(this._element);
      for (const n of Object.keys(i)) qh.has(n) && delete i[n];
      return t = Ae(Ae({}, i), typeof t == "object" && t ? t : {}), t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    _configAfterMerge(t) {
      return t.container = t.container === false ? document.body : Vt(t.container), typeof t.delay == "number" && (t.delay = { show: t.delay, hide: t.delay }), typeof t.title == "number" && (t.title = t.title.toString()), typeof t.content == "number" && (t.content = t.content.toString()), t;
    }
    _getDelegateConfig() {
      const t = {};
      for (const [i, n] of Object.entries(this._config)) this.constructor.Default[i] !== n && (t[i] = n);
      return t.selector = false, t.trigger = "manual", t;
    }
    _disposePopper() {
      this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = ri.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  nt(ri);
  const dp = "popover", fp = ".popover-header", hp = ".popover-body", pp = bi(Ae({}, ri.Default), { content: "", offset: [0, 8], placement: "right", template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>', trigger: "click" }), mp = bi(Ae({}, ri.DefaultType), { content: "(null|string|element|function)" });
  class Ir extends ri {
    static get Default() {
      return pp;
    }
    static get DefaultType() {
      return mp;
    }
    static get NAME() {
      return dp;
    }
    _isWithContent() {
      return this._getTitle() || this._getContent();
    }
    _getContentForTemplate() {
      return { [fp]: this._getTitle(), [hp]: this._getContent() };
    }
    _getContent() {
      return this._resolvePossibleFunction(this._config.content);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Ir.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  nt(Ir);
  const gp = "scrollspy", vp = "bs.scrollspy", Or = `.${vp}`, yp = ".data-api", bp = `activate${Or}`, ia = `click${Or}`, Ep = `load${Or}${yp}`, Sp = "dropdown-item", Si = "active", Tp = '[data-bs-spy="scroll"]', Ds = "[href]", _p = ".nav, .list-group", na = ".nav-link", xp = ".nav-item", Cp = ".list-group-item", wp = `${na}, ${xp} > ${na}, ${Cp}`, Ap = ".dropdown", Ip = ".dropdown-toggle", Op = { offset: null, rootMargin: "0px 0px -25%", smoothScroll: false, target: null, threshold: [0.1, 0.5, 1] }, Mp = { offset: "(number|null)", rootMargin: "string", smoothScroll: "boolean", target: "element", threshold: "array" };
  class Un extends ut {
    constructor(t, i) {
      super(t, i), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = { visibleEntryTop: 0, parentScrollTop: 0 }, this.refresh();
    }
    static get Default() {
      return Op;
    }
    static get DefaultType() {
      return Mp;
    }
    static get NAME() {
      return gp;
    }
    refresh() {
      this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
      for (const t of this._observableSections.values()) this._observer.observe(t);
    }
    dispose() {
      this._observer.disconnect(), super.dispose();
    }
    _configAfterMerge(t) {
      return t.target = Vt(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, typeof t.threshold == "string" && (t.threshold = t.threshold.split(",").map((i) => Number.parseFloat(i))), t;
    }
    _maybeEnableSmoothScroll() {
      this._config.smoothScroll && (q.off(this._config.target, ia), q.on(this._config.target, ia, Ds, (t) => {
        const i = this._observableSections.get(t.target.hash);
        if (i) {
          t.preventDefault();
          const n = this._rootElement || window, r = i.offsetTop - this._element.offsetTop;
          if (n.scrollTo) {
            n.scrollTo({ top: r, behavior: "smooth" });
            return;
          }
          n.scrollTop = r;
        }
      }));
    }
    _getNewObserver() {
      const t = { root: this._rootElement, threshold: this._config.threshold, rootMargin: this._config.rootMargin };
      return new IntersectionObserver((i) => this._observerCallback(i), t);
    }
    _observerCallback(t) {
      const i = (c) => this._targetLinks.get(`#${c.target.id}`), n = (c) => {
        this._previousScrollData.visibleEntryTop = c.target.offsetTop, this._process(i(c));
      }, r = (this._rootElement || document.documentElement).scrollTop, o = r >= this._previousScrollData.parentScrollTop;
      this._previousScrollData.parentScrollTop = r;
      for (const c of t) {
        if (!c.isIntersecting) {
          this._activeTarget = null, this._clearActiveClass(i(c));
          continue;
        }
        const u = c.target.offsetTop >= this._previousScrollData.visibleEntryTop;
        if (o && u) {
          if (n(c), !r) return;
          continue;
        }
        !o && !u && n(c);
      }
    }
    _initializeTargetsAndObservables() {
      this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
      const t = ne.find(Ds, this._config.target);
      for (const i of t) {
        if (!i.hash || Bt(i)) continue;
        const n = ne.findOne(decodeURI(i.hash), this._element);
        $i(n) && (this._targetLinks.set(decodeURI(i.hash), i), this._observableSections.set(i.hash, n));
      }
    }
    _process(t) {
      this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(Si), this._activateParents(t), q.trigger(this._element, bp, { relatedTarget: t }));
    }
    _activateParents(t) {
      if (t.classList.contains(Sp)) {
        ne.findOne(Ip, t.closest(Ap)).classList.add(Si);
        return;
      }
      for (const i of ne.parents(t, _p)) for (const n of ne.prev(i, wp)) n.classList.add(Si);
    }
    _clearActiveClass(t) {
      t.classList.remove(Si);
      const i = ne.find(`${Ds}.${Si}`, t);
      for (const n of i) n.classList.remove(Si);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Un.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(window, Ep, () => {
    for (const e of ne.find(Tp)) Un.getOrCreateInstance(e);
  });
  nt(Un);
  const Lp = "tab", Pp = "bs.tab", oi = `.${Pp}`, Dp = `hide${oi}`, zp = `hidden${oi}`, $p = `show${oi}`, Np = `shown${oi}`, kp = `click${oi}`, Rp = `keydown${oi}`, Hp = `load${oi}`, Vp = "ArrowLeft", sa = "ArrowRight", Bp = "ArrowUp", ra = "ArrowDown", zs = "Home", oa = "End", Kt = "active", aa = "fade", $s = "show", Wp = "dropdown", kl = ".dropdown-toggle", Fp = ".dropdown-menu", Ns = `:not(${kl})`, Gp = '.list-group, .nav, [role="tablist"]', jp = ".nav-item, .list-group-item", Yp = `.nav-link${Ns}, .list-group-item${Ns}, [role="tab"]${Ns}`, Rl = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', ks = `${Yp}, ${Rl}`, Xp = `.${Kt}[data-bs-toggle="tab"], .${Kt}[data-bs-toggle="pill"], .${Kt}[data-bs-toggle="list"]`;
  class ni extends ut {
    constructor(t) {
      super(t), this._parent = this._element.closest(Gp), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), q.on(this._element, Rp, (i) => this._keydown(i)));
    }
    static get NAME() {
      return Lp;
    }
    show() {
      const t = this._element;
      if (this._elemIsActive(t)) return;
      const i = this._getActiveElem(), n = i ? q.trigger(i, Dp, { relatedTarget: t }) : null;
      q.trigger(t, $p, { relatedTarget: i }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(i, t), this._activate(t, i));
    }
    _activate(t, i) {
      if (!t) return;
      t.classList.add(Kt), this._activate(ne.getElementFromSelector(t));
      const n = () => {
        if (t.getAttribute("role") !== "tab") {
          t.classList.add($s);
          return;
        }
        t.removeAttribute("tabindex"), t.setAttribute("aria-selected", true), this._toggleDropDown(t, true), q.trigger(t, Np, { relatedTarget: i });
      };
      this._queueCallback(n, t, t.classList.contains(aa));
    }
    _deactivate(t, i) {
      if (!t) return;
      t.classList.remove(Kt), t.blur(), this._deactivate(ne.getElementFromSelector(t));
      const n = () => {
        if (t.getAttribute("role") !== "tab") {
          t.classList.remove($s);
          return;
        }
        t.setAttribute("aria-selected", false), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, false), q.trigger(t, zp, { relatedTarget: i });
      };
      this._queueCallback(n, t, t.classList.contains(aa));
    }
    _keydown(t) {
      if (![Vp, sa, Bp, ra, zs, oa].includes(t.key)) return;
      t.stopPropagation(), t.preventDefault();
      const i = this._getChildren().filter((r) => !Bt(r));
      let n;
      if ([zs, oa].includes(t.key)) n = i[t.key === zs ? 0 : i.length - 1];
      else {
        const r = [sa, ra].includes(t.key);
        n = Cr(i, t.target, r, true);
      }
      n && (n.focus({ preventScroll: true }), ni.getOrCreateInstance(n).show());
    }
    _getChildren() {
      return ne.find(ks, this._parent);
    }
    _getActiveElem() {
      return this._getChildren().find((t) => this._elemIsActive(t)) || null;
    }
    _setInitialAttributes(t, i) {
      this._setAttributeIfNotExists(t, "role", "tablist");
      for (const n of i) this._setInitialAttributesOnChild(n);
    }
    _setInitialAttributesOnChild(t) {
      t = this._getInnerElement(t);
      const i = this._elemIsActive(t), n = this._getOuterElement(t);
      t.setAttribute("aria-selected", i), n !== t && this._setAttributeIfNotExists(n, "role", "presentation"), i || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
    }
    _setInitialAttributesOnTargetPanel(t) {
      const i = ne.getElementFromSelector(t);
      i && (this._setAttributeIfNotExists(i, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(i, "aria-labelledby", `${t.id}`));
    }
    _toggleDropDown(t, i) {
      const n = this._getOuterElement(t);
      if (!n.classList.contains(Wp)) return;
      const r = (o, c) => {
        const u = ne.findOne(o, n);
        u && u.classList.toggle(c, i);
      };
      r(kl, Kt), r(Fp, $s), n.setAttribute("aria-expanded", i);
    }
    _setAttributeIfNotExists(t, i, n) {
      t.hasAttribute(i) || t.setAttribute(i, n);
    }
    _elemIsActive(t) {
      return t.classList.contains(Kt);
    }
    _getInnerElement(t) {
      return t.matches(ks) ? t : ne.findOne(ks, t);
    }
    _getOuterElement(t) {
      return t.closest(jp) || t;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = ni.getOrCreateInstance(this);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(document, kp, Rl, function(e) {
    ["A", "AREA"].includes(this.tagName) && e.preventDefault(), !Bt(this) && ni.getOrCreateInstance(this).show();
  });
  q.on(window, Hp, () => {
    for (const e of ne.find(Xp)) ni.getOrCreateInstance(e);
  });
  nt(ni);
  const qp = "toast", Up = "bs.toast", Gt = `.${Up}`, Kp = `mouseover${Gt}`, Zp = `mouseout${Gt}`, Qp = `focusin${Gt}`, Jp = `focusout${Gt}`, em = `hide${Gt}`, tm = `hidden${Gt}`, im = `show${Gt}`, nm = `shown${Gt}`, sm = "fade", la = "hide", wn = "show", An = "showing", rm = { animation: "boolean", autohide: "boolean", delay: "number" }, om = { animation: true, autohide: true, delay: 5e3 };
  class Kn extends ut {
    constructor(t, i) {
      super(t, i), this._timeout = null, this._hasMouseInteraction = false, this._hasKeyboardInteraction = false, this._setListeners();
    }
    static get Default() {
      return om;
    }
    static get DefaultType() {
      return rm;
    }
    static get NAME() {
      return qp;
    }
    show() {
      if (q.trigger(this._element, im).defaultPrevented) return;
      this._clearTimeout(), this._config.animation && this._element.classList.add(sm);
      const i = () => {
        this._element.classList.remove(An), q.trigger(this._element, nm), this._maybeScheduleHide();
      };
      this._element.classList.remove(la), en(this._element), this._element.classList.add(wn, An), this._queueCallback(i, this._element, this._config.animation);
    }
    hide() {
      if (!this.isShown() || q.trigger(this._element, em).defaultPrevented) return;
      const i = () => {
        this._element.classList.add(la), this._element.classList.remove(An, wn), q.trigger(this._element, tm);
      };
      this._element.classList.add(An), this._queueCallback(i, this._element, this._config.animation);
    }
    dispose() {
      this._clearTimeout(), this.isShown() && this._element.classList.remove(wn), super.dispose();
    }
    isShown() {
      return this._element.classList.contains(wn);
    }
    _maybeScheduleHide() {
      this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
        this.hide();
      }, this._config.delay)));
    }
    _onInteraction(t, i) {
      switch (t.type) {
        case "mouseover":
        case "mouseout": {
          this._hasMouseInteraction = i;
          break;
        }
        case "focusin":
        case "focusout": {
          this._hasKeyboardInteraction = i;
          break;
        }
      }
      if (i) {
        this._clearTimeout();
        return;
      }
      const n = t.relatedTarget;
      this._element === n || this._element.contains(n) || this._maybeScheduleHide();
    }
    _setListeners() {
      q.on(this._element, Kp, (t) => this._onInteraction(t, true)), q.on(this._element, Zp, (t) => this._onInteraction(t, false)), q.on(this._element, Qp, (t) => this._onInteraction(t, true)), q.on(this._element, Jp, (t) => this._onInteraction(t, false));
    }
    _clearTimeout() {
      clearTimeout(this._timeout), this._timeout = null;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Kn.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  Yn(Kn);
  nt(Kn);
  window.bootstrap = { Tooltip: ri, Modal: ii, Offcanvas: Ot, Collapse: Li, Dropdown: lt, Tab: ni };
  function ca(e) {
    return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
  }
  function Mr(e = {}, t = {}) {
    const i = ["__proto__", "constructor", "prototype"];
    Object.keys(t).filter((n) => i.indexOf(n) < 0).forEach((n) => {
      typeof e[n] == "undefined" ? e[n] = t[n] : ca(t[n]) && ca(e[n]) && Object.keys(t[n]).length > 0 && Mr(e[n], t[n]);
    });
  }
  const Hl = { body: {}, addEventListener() {
  }, removeEventListener() {
  }, activeElement: { blur() {
  }, nodeName: "" }, querySelector() {
    return null;
  }, querySelectorAll() {
    return [];
  }, getElementById() {
    return null;
  }, createEvent() {
    return { initEvent() {
    } };
  }, createElement() {
    return { children: [], childNodes: [], style: {}, setAttribute() {
    }, getElementsByTagName() {
      return [];
    } };
  }, createElementNS() {
    return {};
  }, importNode() {
    return null;
  }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" } };
  function Le() {
    const e = typeof document != "undefined" ? document : {};
    return Mr(e, Hl), e;
  }
  const am = { document: Hl, navigator: { userAgent: "" }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }, history: { replaceState() {
  }, pushState() {
  }, go() {
  }, back() {
  } }, CustomEvent: function() {
    return this;
  }, addEventListener() {
  }, removeEventListener() {
  }, getComputedStyle() {
    return { getPropertyValue() {
      return "";
    } };
  }, Image() {
  }, Date() {
  }, screen: {}, setTimeout() {
  }, clearTimeout() {
  }, matchMedia() {
    return {};
  }, requestAnimationFrame(e) {
    return typeof setTimeout == "undefined" ? (e(), null) : setTimeout(e, 0);
  }, cancelAnimationFrame(e) {
    typeof setTimeout != "undefined" && clearTimeout(e);
  } };
  function ye() {
    const e = typeof window != "undefined" ? window : {};
    return Mr(e, am), e;
  }
  function kt(e = "") {
    return e.trim().split(" ").filter((t) => !!t.trim());
  }
  function lm(e) {
    const t = e;
    Object.keys(t).forEach((i) => {
      try {
        t[i] = null;
      } catch (n) {
      }
      try {
        delete t[i];
      } catch (n) {
      }
    });
  }
  function Pi(e, t = 0) {
    return setTimeout(e, t);
  }
  function Je() {
    return Date.now();
  }
  function cm(e) {
    const t = ye();
    let i;
    return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
  }
  function hr(e, t = "x") {
    const i = ye();
    let n, r, o;
    const c = cm(e);
    return i.WebKitCSSMatrix ? (r = c.transform || c.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((u) => u.replace(",", ".")).join(", ")), o = new i.WebKitCSSMatrix(r === "none" ? "" : r)) : (o = c.MozTransform || c.OTransform || c.MsTransform || c.msTransform || c.transform || c.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), t === "x" && (i.WebKitCSSMatrix ? r = o.m41 : n.length === 16 ? r = parseFloat(n[12]) : r = parseFloat(n[4])), t === "y" && (i.WebKitCSSMatrix ? r = o.m42 : n.length === 16 ? r = parseFloat(n[13]) : r = parseFloat(n[5])), r || 0;
  }
  function qi(e) {
    return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
  }
  function um(e) {
    return typeof window != "undefined" && typeof window.HTMLElement != "undefined" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
  }
  function Ye(...e) {
    const t = Object(e[0]);
    for (let i = 1; i < e.length; i += 1) {
      const n = e[i];
      if (n != null && !um(n)) {
        const r = Object.keys(Object(n)).filter((o) => o !== "__proto__" && o !== "constructor" && o !== "prototype");
        for (let o = 0, c = r.length; o < c; o += 1) {
          const u = r[o], l = Object.getOwnPropertyDescriptor(n, u);
          l !== void 0 && l.enumerable && (qi(t[u]) && qi(n[u]) ? n[u].__swiper__ ? t[u] = n[u] : Ye(t[u], n[u]) : !qi(t[u]) && qi(n[u]) ? (t[u] = {}, n[u].__swiper__ ? t[u] = n[u] : Ye(t[u], n[u])) : t[u] = n[u]);
        }
      }
    }
    return t;
  }
  function qt(e, t, i) {
    e.style.setProperty(t, i);
  }
  function Vl({ swiper: e, targetPosition: t, side: i }) {
    const n = ye(), r = -e.translate;
    let o = null, c;
    const u = e.params.speed;
    e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
    const l = t > r ? "next" : "prev", m = (y, E) => l === "next" && y >= E || l === "prev" && y <= E, v = () => {
      c = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = c);
      const y = Math.max(Math.min((c - o) / u, 1), 0), E = 0.5 - Math.cos(y * Math.PI) / 2;
      let h = r + E * (t - r);
      if (m(h, t) && (h = t), e.wrapperEl.scrollTo({ [i]: h }), m(h, t)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({ [i]: h });
        }), n.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = n.requestAnimationFrame(v);
    };
    v();
  }
  function ai(e) {
    return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
  }
  function Pe(e, t = "") {
    const i = ye(), n = [...e.children];
    return i.HTMLSlotElement && e instanceof HTMLSlotElement && n.push(...e.assignedElements()), t ? n.filter((r) => r.matches(t)) : n;
  }
  function dm(e, t) {
    const i = [t];
    for (; i.length > 0; ) {
      const n = i.shift();
      if (e === n) return true;
      i.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
    }
  }
  function fm(e, t) {
    const i = ye();
    let n = t.contains(e);
    return !n && i.HTMLSlotElement && t instanceof HTMLSlotElement && (n = [...t.assignedElements()].includes(e), n || (n = dm(e, t))), n;
  }
  function kn(e) {
    try {
      console.warn(e);
      return;
    } catch (t) {
    }
  }
  function Xe(e, t = []) {
    const i = document.createElement(e);
    return i.classList.add(...Array.isArray(t) ? t : kt(t)), i;
  }
  function Rn(e) {
    const t = ye(), i = Le(), n = e.getBoundingClientRect(), r = i.body, o = e.clientTop || r.clientTop || 0, c = e.clientLeft || r.clientLeft || 0, u = e === t ? t.scrollY : e.scrollTop, l = e === t ? t.scrollX : e.scrollLeft;
    return { top: n.top + u - o, left: n.left + l - c };
  }
  function hm(e, t) {
    const i = [];
    for (; e.previousElementSibling; ) {
      const n = e.previousElementSibling;
      t ? n.matches(t) && i.push(n) : i.push(n), e = n;
    }
    return i;
  }
  function pm(e, t) {
    const i = [];
    for (; e.nextElementSibling; ) {
      const n = e.nextElementSibling;
      t ? n.matches(t) && i.push(n) : i.push(n), e = n;
    }
    return i;
  }
  function Ht(e, t) {
    return ye().getComputedStyle(e, null).getPropertyValue(t);
  }
  function Qi(e) {
    let t = e, i;
    if (t) {
      for (i = 0; (t = t.previousSibling) !== null; ) t.nodeType === 1 && (i += 1);
      return i;
    }
  }
  function Qt(e, t) {
    const i = [];
    let n = e.parentElement;
    for (; n; ) t ? n.matches(t) && i.push(n) : i.push(n), n = n.parentElement;
    return i;
  }
  function Zi(e, t) {
    function i(n) {
      n.target === e && (t.call(e, n), e.removeEventListener("transitionend", i));
    }
    t && e.addEventListener("transitionend", i);
  }
  function pr(e, t, i) {
    const n = ye();
    return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
  }
  function ue(e) {
    return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
  }
  function Zn(e) {
    return (t) => Math.abs(t) > 0 && e.browser && e.browser.need3dFix && Math.abs(t) % 90 === 0 ? t + 1e-3 : t;
  }
  function bt(e, t = "") {
    typeof trustedTypes != "undefined" ? e.innerHTML = trustedTypes.createPolicy("html", { createHTML: (i) => i }).createHTML(t) : e.innerHTML = t;
  }
  let Rs;
  function mm() {
    const e = ye(), t = Le();
    return { smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style, touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch) };
  }
  function Bl() {
    return Rs || (Rs = mm()), Rs;
  }
  let Hs;
  function gm({ userAgent: e } = {}) {
    const t = Bl(), i = ye(), n = i.navigator.platform, r = e || i.navigator.userAgent, o = { ios: false, android: false }, c = i.screen.width, u = i.screen.height, l = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let m = r.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const v = r.match(/(iPod)(.*OS\s([\d_]+))?/), y = !m && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), E = n === "Win32";
    let h = n === "MacIntel";
    const g = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return !m && h && t.touch && g.indexOf(`${c}x${u}`) >= 0 && (m = r.match(/(Version)\/([\d.]+)/), m || (m = [0, 1, "13_0_0"]), h = false), l && !E && (o.os = "android", o.android = true), (m || y || v) && (o.os = "ios", o.ios = true), o;
  }
  function Wl(e = {}) {
    return Hs || (Hs = gm(e)), Hs;
  }
  let Vs;
  function vm() {
    const e = ye(), t = Wl();
    let i = false;
    function n() {
      const u = e.navigator.userAgent.toLowerCase();
      return u.indexOf("safari") >= 0 && u.indexOf("chrome") < 0 && u.indexOf("android") < 0;
    }
    if (n()) {
      const u = String(e.navigator.userAgent);
      if (u.includes("Version/")) {
        const [l, m] = u.split("Version/")[1].split(" ")[0].split(".").map((v) => Number(v));
        i = l < 16 || l === 16 && m < 2;
      }
    }
    const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), o = n(), c = o || r && t.ios;
    return { isSafari: i || o, needPerspectiveFix: i, need3dFix: c, isWebView: r };
  }
  function Fl() {
    return Vs || (Vs = vm()), Vs;
  }
  function ym({ swiper: e, on: t, emit: i }) {
    const n = ye();
    let r = null, o = null;
    const c = () => {
      !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
    }, u = () => {
      !e || e.destroyed || !e.initialized || (r = new ResizeObserver((v) => {
        o = n.requestAnimationFrame(() => {
          const { width: y, height: E } = e;
          let h = y, g = E;
          v.forEach(({ contentBoxSize: C, contentRect: _, target: p }) => {
            p && p !== e.el || (h = _ ? _.width : (C[0] || C).inlineSize, g = _ ? _.height : (C[0] || C).blockSize);
          }), (h !== y || g !== E) && c();
        });
      }), r.observe(e.el));
    }, l = () => {
      o && n.cancelAnimationFrame(o), r && r.unobserve && e.el && (r.unobserve(e.el), r = null);
    }, m = () => {
      !e || e.destroyed || !e.initialized || i("orientationchange");
    };
    t("init", () => {
      if (e.params.resizeObserver && typeof n.ResizeObserver != "undefined") {
        u();
        return;
      }
      n.addEventListener("resize", c), n.addEventListener("orientationchange", m);
    }), t("destroy", () => {
      l(), n.removeEventListener("resize", c), n.removeEventListener("orientationchange", m);
    });
  }
  function bm({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = [], o = ye(), c = (m, v = {}) => {
      const y = o.MutationObserver || o.WebkitMutationObserver, E = new y((h) => {
        if (e.__preventObserver__) return;
        if (h.length === 1) {
          n("observerUpdate", h[0]);
          return;
        }
        const g = function() {
          n("observerUpdate", h[0]);
        };
        o.requestAnimationFrame ? o.requestAnimationFrame(g) : o.setTimeout(g, 0);
      });
      E.observe(m, { attributes: typeof v.attributes == "undefined" ? true : v.attributes, childList: e.isElement || (typeof v.childList == "undefined" ? true : v).childList, characterData: typeof v.characterData == "undefined" ? true : v.characterData }), r.push(E);
    }, u = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const m = Qt(e.hostEl);
          for (let v = 0; v < m.length; v += 1) c(m[v]);
        }
        c(e.hostEl, { childList: e.params.observeSlideChildren }), c(e.wrapperEl, { attributes: false });
      }
    }, l = () => {
      r.forEach((m) => {
        m.disconnect();
      }), r.splice(0, r.length);
    };
    t({ observer: false, observeParents: false, observeSlideChildren: false }), i("init", u), i("destroy", l);
  }
  var Em = { on(e, t, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    const r = i ? "unshift" : "push";
    return e.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][r](t);
    }), n;
  }, once(e, t, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    function r(...o) {
      n.off(e, r), r.__emitterProxy && delete r.__emitterProxy, t.apply(n, o);
    }
    return r.__emitterProxy = t, n.on(e, r, i);
  }, onAny(e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const n = t ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e), i;
  }, offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const i = t.eventsAnyListeners.indexOf(e);
    return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
  }, off(e, t) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || e.split(" ").forEach((n) => {
      typeof t == "undefined" ? i.eventsListeners[n] = [] : i.eventsListeners[n] && i.eventsListeners[n].forEach((r, o) => {
        (r === t || r.__emitterProxy && r.__emitterProxy === t) && i.eventsListeners[n].splice(o, 1);
      });
    }), i;
  }, emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let i, n, r;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (i = e[0], n = e.slice(1, e.length), r = t) : (i = e[0].events, n = e[0].data, r = e[0].context || t), n.unshift(r), (Array.isArray(i) ? i : i.split(" ")).forEach((c) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((u) => {
        u.apply(r, [c, ...n]);
      }), t.eventsListeners && t.eventsListeners[c] && t.eventsListeners[c].forEach((u) => {
        u.apply(r, n);
      });
    }), t;
  } };
  function Sm() {
    const e = this;
    let t, i;
    const n = e.el;
    typeof e.params.width != "undefined" && e.params.width !== null ? t = e.params.width : t = n.clientWidth, typeof e.params.height != "undefined" && e.params.height !== null ? i = e.params.height : i = n.clientHeight, !(t === 0 && e.isHorizontal() || i === 0 && e.isVertical()) && (t = t - parseInt(Ht(n, "padding-left") || 0, 10) - parseInt(Ht(n, "padding-right") || 0, 10), i = i - parseInt(Ht(n, "padding-top") || 0, 10) - parseInt(Ht(n, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(i) && (i = 0), Object.assign(e, { width: t, height: i, size: e.isHorizontal() ? t : i }));
  }
  function Tm() {
    const e = this;
    function t(N, $) {
      return parseFloat(N.getPropertyValue(e.getDirectionLabel($)) || 0);
    }
    const i = e.params, { wrapperEl: n, slidesEl: r, rtlTranslate: o, wrongRTL: c } = e, u = e.virtual && i.virtual.enabled, l = u ? e.virtual.slides.length : e.slides.length, m = Pe(r, `.${e.params.slideClass}, swiper-slide`), v = u ? e.virtual.slides.length : m.length;
    let y = [];
    const E = [], h = [];
    let g = i.slidesOffsetBefore;
    typeof g == "function" && (g = i.slidesOffsetBefore.call(e));
    let C = i.slidesOffsetAfter;
    typeof C == "function" && (C = i.slidesOffsetAfter.call(e));
    const _ = e.snapGrid.length, p = e.slidesGrid.length, S = e.size - g - C;
    let w = i.spaceBetween, I = -g, L = 0, f = 0;
    if (typeof S == "undefined") return;
    typeof w == "string" && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * S : typeof w == "string" && (w = parseFloat(w)), e.virtualSize = -w - g - C, m.forEach((N) => {
      o ? N.style.marginLeft = "" : N.style.marginRight = "", N.style.marginBottom = "", N.style.marginTop = "";
    }), i.centeredSlides && i.cssMode && (qt(n, "--swiper-centered-offset-before", ""), qt(n, "--swiper-centered-offset-after", "")), i.cssMode && (qt(n, "--swiper-slides-offset-before", `${g}px`), qt(n, "--swiper-slides-offset-after", `${C}px`));
    const P = i.grid && i.grid.rows > 1 && e.grid;
    P ? e.grid.initSlides(m) : e.grid && e.grid.unsetSlides();
    let D;
    const R = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((N) => typeof i.breakpoints[N].slidesPerView != "undefined").length > 0;
    for (let N = 0; N < v; N += 1) {
      D = 0;
      const $ = m[N];
      if (!($ && (P && e.grid.updateSlide(N, $, m), Ht($, "display") === "none"))) {
        if (u && i.slidesPerView === "auto") i.virtual.slidesPerViewAutoSlideSize && (D = i.virtual.slidesPerViewAutoSlideSize), D && $ && (i.roundLengths && (D = Math.floor(D)), $.style[e.getDirectionLabel("width")] = `${D}px`);
        else if (i.slidesPerView === "auto") {
          R && ($.style[e.getDirectionLabel("width")] = "");
          const V = getComputedStyle($), B = $.style.transform, X = $.style.webkitTransform;
          if (B && ($.style.transform = "none"), X && ($.style.webkitTransform = "none"), i.roundLengths) D = e.isHorizontal() ? pr($, "width") : pr($, "height");
          else {
            const Z = t(V, "width"), F = t(V, "padding-left"), W = t(V, "padding-right"), Y = t(V, "margin-left"), J = t(V, "margin-right"), oe = V.getPropertyValue("box-sizing");
            if (oe && oe === "border-box") D = Z + Y + J;
            else {
              const { clientWidth: he, offsetWidth: _e } = $;
              D = Z + F + W + Y + J + (_e - he);
            }
          }
          B && ($.style.transform = B), X && ($.style.webkitTransform = X), i.roundLengths && (D = Math.floor(D));
        } else D = (S - (i.slidesPerView - 1) * w) / i.slidesPerView, i.roundLengths && (D = Math.floor(D)), $ && ($.style[e.getDirectionLabel("width")] = `${D}px`);
        $ && ($.swiperSlideSize = D), h.push(D), i.centeredSlides ? (I = I + D / 2 + L / 2 + w, L === 0 && N !== 0 && (I = I - S / 2 - w), N === 0 && (I = I - S / 2 - w), Math.abs(I) < 1 / 1e3 && (I = 0), i.roundLengths && (I = Math.floor(I)), f % i.slidesPerGroup === 0 && y.push(I), E.push(I)) : (i.roundLengths && (I = Math.floor(I)), (f - Math.min(e.params.slidesPerGroupSkip, f)) % e.params.slidesPerGroup === 0 && y.push(I), E.push(I), I = I + D + w), e.virtualSize += D + w, L = D, f += 1;
      }
    }
    if (e.virtualSize = Math.max(e.virtualSize, S) + C, o && c && (i.effect === "slide" || i.effect === "coverflow") && (n.style.width = `${e.virtualSize + w}px`), i.setWrapperSize && (n.style[e.getDirectionLabel("width")] = `${e.virtualSize + w}px`), P && e.grid.updateWrapperSize(D, y), !i.centeredSlides) {
      const N = i.slidesPerView !== "auto" && i.slidesPerView % 1 !== 0, $ = i.snapToSlideEdge && !i.loop && (i.slidesPerView === "auto" || N);
      let V = y.length;
      if ($) {
        let X;
        if (i.slidesPerView === "auto") {
          X = 1;
          let Z = 0;
          for (let F = h.length - 1; F >= 0 && (Z += h[F] + (F < h.length - 1 ? w : 0), Z <= S); F -= 1) X = h.length - F;
        } else X = Math.floor(i.slidesPerView);
        V = Math.max(v - X, 0);
      }
      const B = [];
      for (let X = 0; X < y.length; X += 1) {
        let Z = y[X];
        i.roundLengths && (Z = Math.floor(Z)), $ ? X <= V && B.push(Z) : y[X] <= e.virtualSize - S && B.push(Z);
      }
      y = B, Math.floor(e.virtualSize - S) - Math.floor(y[y.length - 1]) > 1 && ($ || y.push(e.virtualSize - S));
    }
    if (u && i.loop) {
      const N = h[0] + w;
      if (i.slidesPerGroup > 1) {
        const $ = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup), V = N * i.slidesPerGroup;
        for (let B = 0; B < $; B += 1) y.push(y[y.length - 1] + V);
      }
      for (let $ = 0; $ < e.virtual.slidesBefore + e.virtual.slidesAfter; $ += 1) i.slidesPerGroup === 1 && y.push(y[y.length - 1] + N), E.push(E[E.length - 1] + N), e.virtualSize += N;
    }
    if (y.length === 0 && (y = [0]), w !== 0) {
      const N = e.isHorizontal() && o ? "marginLeft" : e.getDirectionLabel("marginRight");
      m.filter(($, V) => !i.cssMode || i.loop ? true : V !== m.length - 1).forEach(($) => {
        $.style[N] = `${w}px`;
      });
    }
    if (i.centeredSlides && i.centeredSlidesBounds) {
      let N = 0;
      h.forEach((V) => {
        N += V + (w || 0);
      }), N -= w;
      const $ = N > S ? N - S : 0;
      y = y.map((V) => V <= 0 ? -g : V > $ ? $ + C : V);
    }
    if (i.centerInsufficientSlides) {
      let N = 0;
      if (h.forEach(($) => {
        N += $ + (w || 0);
      }), N -= w, N < S) {
        const $ = (S - N) / 2;
        y.forEach((V, B) => {
          y[B] = V - $;
        }), E.forEach((V, B) => {
          E[B] = V + $;
        });
      }
    }
    if (Object.assign(e, { slides: m, snapGrid: y, slidesGrid: E, slidesSizesGrid: h }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
      qt(n, "--swiper-centered-offset-before", `${-y[0]}px`), qt(n, "--swiper-centered-offset-after", `${e.size / 2 - h[h.length - 1] / 2}px`);
      const N = -e.snapGrid[0], $ = -e.slidesGrid[0];
      e.snapGrid = e.snapGrid.map((V) => V + N), e.slidesGrid = e.slidesGrid.map((V) => V + $);
    }
    if (v !== l && e.emit("slidesLengthChange"), y.length !== _ && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), E.length !== p && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !u && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
      const N = `${i.containerModifierClass}backface-hidden`, $ = e.el.classList.contains(N);
      v <= i.maxBackfaceHiddenSlides ? $ || e.el.classList.add(N) : $ && e.el.classList.remove(N);
    }
  }
  function _m(e) {
    const t = this, i = [], n = t.virtual && t.params.virtual.enabled;
    let r = 0, o;
    typeof e == "number" ? t.setTransition(e) : e === true && t.setTransition(t.params.speed);
    const c = (u) => n ? t.slides[t.getSlideIndexByData(u)] : t.slides[u];
    if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1) if (t.params.centeredSlides) (t.visibleSlides || []).forEach((u) => {
      i.push(u);
    });
    else for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
      const u = t.activeIndex + o;
      if (u > t.slides.length && !n) break;
      i.push(c(u));
    }
    else i.push(c(t.activeIndex));
    for (o = 0; o < i.length; o += 1) if (typeof i[o] != "undefined") {
      const u = i[o].offsetHeight;
      r = u > r ? u : r;
    }
    (r || r === 0) && (t.wrapperEl.style.height = `${r}px`);
  }
  function xm() {
    const e = this, t = e.slides, i = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = (e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop) - i - e.cssOverflowAdjustment();
  }
  const ua = (e, t, i) => {
    t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
  };
  function Cm(e = this && this.translate || 0) {
    const t = this, i = t.params, { slides: n, rtlTranslate: r, snapGrid: o } = t;
    if (n.length === 0) return;
    typeof n[0].swiperSlideOffset == "undefined" && t.updateSlidesOffset();
    let c = -e;
    r && (c = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    let u = i.spaceBetween;
    typeof u == "string" && u.indexOf("%") >= 0 ? u = parseFloat(u.replace("%", "")) / 100 * t.size : typeof u == "string" && (u = parseFloat(u));
    for (let l = 0; l < n.length; l += 1) {
      const m = n[l];
      let v = m.swiperSlideOffset;
      i.cssMode && i.centeredSlides && (v -= n[0].swiperSlideOffset);
      const y = (c + (i.centeredSlides ? t.minTranslate() : 0) - v) / (m.swiperSlideSize + u), E = (c - o[0] + (i.centeredSlides ? t.minTranslate() : 0) - v) / (m.swiperSlideSize + u), h = -(c - v), g = h + t.slidesSizesGrid[l], C = h >= 0 && h <= t.size - t.slidesSizesGrid[l], _ = h >= 0 && h < t.size - 1 || g > 1 && g <= t.size || h <= 0 && g >= t.size;
      _ && (t.visibleSlides.push(m), t.visibleSlidesIndexes.push(l)), ua(m, _, i.slideVisibleClass), ua(m, C, i.slideFullyVisibleClass), m.progress = r ? -y : y, m.originalProgress = r ? -E : E;
    }
  }
  function wm(e) {
    const t = this;
    if (typeof e == "undefined") {
      const v = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * v || 0;
    }
    const i = t.params, n = t.maxTranslate() - t.minTranslate();
    let { progress: r, isBeginning: o, isEnd: c, progressLoop: u } = t;
    const l = o, m = c;
    if (n === 0) r = 0, o = true, c = true;
    else {
      r = (e - t.minTranslate()) / n;
      const v = Math.abs(e - t.minTranslate()) < 1, y = Math.abs(e - t.maxTranslate()) < 1;
      o = v || r <= 0, c = y || r >= 1, v && (r = 0), y && (r = 1);
    }
    if (i.loop) {
      const v = t.getSlideIndexByData(0), y = t.getSlideIndexByData(t.slides.length - 1), E = t.slidesGrid[v], h = t.slidesGrid[y], g = t.slidesGrid[t.slidesGrid.length - 1], C = Math.abs(e);
      C >= E ? u = (C - E) / g : u = (C + g - h) / g, u > 1 && (u -= 1);
    }
    Object.assign(t, { progress: r, progressLoop: u, isBeginning: o, isEnd: c }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), o && !l && t.emit("reachBeginning toEdge"), c && !m && t.emit("reachEnd toEdge"), (l && !o || m && !c) && t.emit("fromEdge"), t.emit("progress", r);
  }
  const Bs = (e, t, i) => {
    t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
  };
  function Am() {
    const e = this, { slides: t, params: i, slidesEl: n, activeIndex: r } = e, o = e.virtual && i.virtual.enabled, c = e.grid && i.grid && i.grid.rows > 1, u = (y) => Pe(n, `.${i.slideClass}${y}, swiper-slide${y}`)[0];
    let l, m, v;
    if (o) if (i.loop) {
      let y = r - e.virtual.slidesBefore;
      y < 0 && (y = e.virtual.slides.length + y), y >= e.virtual.slides.length && (y -= e.virtual.slides.length), l = u(`[data-swiper-slide-index="${y}"]`);
    } else l = u(`[data-swiper-slide-index="${r}"]`);
    else c ? (l = t.find((y) => y.column === r), v = t.find((y) => y.column === r + 1), m = t.find((y) => y.column === r - 1)) : l = t[r];
    l && (c || (v = pm(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !v && (v = t[0]), m = hm(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !m === 0 && (m = t[t.length - 1]))), t.forEach((y) => {
      Bs(y, y === l, i.slideActiveClass), Bs(y, y === v, i.slideNextClass), Bs(y, y === m, i.slidePrevClass);
    }), e.emitSlidesClasses();
  }
  const Ln = (e, t) => {
    if (!e || e.destroyed || !e.params) return;
    const i = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, n = t.closest(i());
    if (n) {
      let r = n.querySelector(`.${e.params.lazyPreloaderClass}`);
      !r && e.isElement && (n.shadowRoot ? r = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        n.shadowRoot && (r = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), r && !r.lazyPreloaderManaged && r.remove());
      })), r && !r.lazyPreloaderManaged && r.remove();
    }
  }, Ws = (e, t) => {
    if (!e.slides[t]) return;
    const i = e.slides[t].querySelector('[loading="lazy"]');
    i && i.removeAttribute("loading");
  }, mr = (e) => {
    if (!e || e.destroyed || !e.params) return;
    let t = e.params.lazyPreloadPrevNext;
    const i = e.slides.length;
    if (!i || !t || t < 0) return;
    t = Math.min(t, i);
    const n = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), r = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      const c = r, u = [c - t];
      u.push(...Array.from({ length: t }).map((l, m) => c + n + m)), e.slides.forEach((l, m) => {
        u.includes(l.column) && Ws(e, m);
      });
      return;
    }
    const o = r + n - 1;
    if (e.params.rewind || e.params.loop) for (let c = r - t; c <= o + t; c += 1) {
      const u = (c % i + i) % i;
      (u < r || u > o) && Ws(e, u);
    }
    else for (let c = Math.max(r - t, 0); c <= Math.min(o + t, i - 1); c += 1) c !== r && (c > o || c < r) && Ws(e, c);
  };
  function Im(e) {
    const { slidesGrid: t, params: i } = e, n = e.rtlTranslate ? e.translate : -e.translate;
    let r;
    for (let o = 0; o < t.length; o += 1) typeof t[o + 1] != "undefined" ? n >= t[o] && n < t[o + 1] - (t[o + 1] - t[o]) / 2 ? r = o : n >= t[o] && n < t[o + 1] && (r = o + 1) : n >= t[o] && (r = o);
    return i.normalizeSlideIndex && (r < 0 || typeof r == "undefined") && (r = 0), r;
  }
  function Om(e) {
    const t = this, i = t.rtlTranslate ? t.translate : -t.translate, { snapGrid: n, params: r, activeIndex: o, realIndex: c, snapIndex: u } = t;
    let l = e, m;
    const v = (h) => {
      let g = h - t.virtual.slidesBefore;
      return g < 0 && (g = t.virtual.slides.length + g), g >= t.virtual.slides.length && (g -= t.virtual.slides.length), g;
    };
    if (typeof l == "undefined" && (l = Im(t)), n.indexOf(i) >= 0) m = n.indexOf(i);
    else {
      const h = Math.min(r.slidesPerGroupSkip, l);
      m = h + Math.floor((l - h) / r.slidesPerGroup);
    }
    if (m >= n.length && (m = n.length - 1), l === o && !t.params.loop) {
      m !== u && (t.snapIndex = m, t.emit("snapIndexChange"));
      return;
    }
    if (l === o && t.params.loop && t.virtual && t.params.virtual.enabled) {
      t.realIndex = v(l);
      return;
    }
    const y = t.grid && r.grid && r.grid.rows > 1;
    let E;
    if (t.virtual && r.virtual.enabled) r.loop ? E = v(l) : E = l;
    else if (y) {
      const h = t.slides.find((C) => C.column === l);
      let g = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
      Number.isNaN(g) && (g = Math.max(t.slides.indexOf(h), 0)), E = Math.floor(g / r.grid.rows);
    } else if (t.slides[l]) {
      const h = t.slides[l].getAttribute("data-swiper-slide-index");
      h ? E = parseInt(h, 10) : E = l;
    } else E = l;
    Object.assign(t, { previousSnapIndex: u, snapIndex: m, previousRealIndex: c, realIndex: E, previousIndex: o, activeIndex: l }), t.initialized && mr(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (c !== E && t.emit("realIndexChange"), t.emit("slideChange"));
  }
  function Mm(e, t) {
    const i = this, n = i.params;
    let r = e.closest(`.${n.slideClass}, swiper-slide`);
    !r && i.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((u) => {
      !r && u.matches && u.matches(`.${n.slideClass}, swiper-slide`) && (r = u);
    });
    let o = false, c;
    if (r) {
      for (let u = 0; u < i.slides.length; u += 1) if (i.slides[u] === r) {
        o = true, c = u;
        break;
      }
    }
    if (r && o) i.clickedSlide = r, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = c;
    else {
      i.clickedSlide = void 0, i.clickedIndex = void 0;
      return;
    }
    n.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
  }
  var Lm = { updateSize: Sm, updateSlides: Tm, updateAutoHeight: _m, updateSlidesOffset: xm, updateSlidesProgress: Cm, updateProgress: wm, updateSlidesClasses: Am, updateActiveIndex: Om, updateClickedSlide: Mm };
  function Pm(e = this.isHorizontal() ? "x" : "y") {
    const t = this, { params: i, rtlTranslate: n, translate: r, wrapperEl: o } = t;
    if (i.virtualTranslate) return n ? -r : r;
    if (i.cssMode) return r;
    let c = hr(o, e);
    return c += t.cssOverflowAdjustment(), n && (c = -c), c || 0;
  }
  function Dm(e, t) {
    const i = this, { rtlTranslate: n, params: r, wrapperEl: o, progress: c } = i;
    let u = 0, l = 0;
    const m = 0;
    i.isHorizontal() ? u = n ? -e : e : l = e, r.roundLengths && (u = Math.floor(u), l = Math.floor(l)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? u : l, r.cssMode ? o[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -u : -l : r.virtualTranslate || (i.isHorizontal() ? u -= i.cssOverflowAdjustment() : l -= i.cssOverflowAdjustment(), o.style.transform = `translate3d(${u}px, ${l}px, ${m}px)`);
    let v;
    const y = i.maxTranslate() - i.minTranslate();
    y === 0 ? v = 0 : v = (e - i.minTranslate()) / y, v !== c && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
  }
  function zm() {
    return -this.snapGrid[0];
  }
  function $m() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function Nm(e = 0, t = this.params.speed, i = true, n = true, r) {
    const o = this, { params: c, wrapperEl: u } = o;
    if (o.animating && c.preventInteractionOnTransition) return false;
    const l = o.minTranslate(), m = o.maxTranslate();
    let v;
    if (n && e > l ? v = l : n && e < m ? v = m : v = e, o.updateProgress(v), c.cssMode) {
      const y = o.isHorizontal();
      if (t === 0) u[y ? "scrollLeft" : "scrollTop"] = -v;
      else {
        if (!o.support.smoothScroll) return Vl({ swiper: o, targetPosition: -v, side: y ? "left" : "top" }), true;
        u.scrollTo({ [y ? "left" : "top"]: -v, behavior: "smooth" });
      }
      return true;
    }
    return t === 0 ? (o.setTransition(0), o.setTranslate(v), i && (o.emit("beforeTransitionStart", t, r), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(v), i && (o.emit("beforeTransitionStart", t, r), o.emit("transitionStart")), o.animating || (o.animating = true, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(E) {
      !o || o.destroyed || E.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = false, i && o.emit("transitionEnd"));
    }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), true;
  }
  var km = { getTranslate: Pm, setTranslate: Dm, minTranslate: zm, maxTranslate: $m, translateTo: Nm };
  function Rm(e, t) {
    const i = this;
    i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${e}ms`, i.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), i.emit("setTransition", e, t);
  }
  function Gl({ swiper: e, runCallbacks: t, direction: i, step: n }) {
    const { activeIndex: r, previousIndex: o } = e;
    let c = i;
    c || (r > o ? c = "next" : r < o ? c = "prev" : c = "reset"), e.emit(`transition${n}`), t && c === "reset" ? e.emit(`slideResetTransition${n}`) : t && r !== o && (e.emit(`slideChangeTransition${n}`), c === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`));
  }
  function Hm(e = true, t) {
    const i = this, { params: n } = i;
    n.cssMode || (n.autoHeight && i.updateAutoHeight(), Gl({ swiper: i, runCallbacks: e, direction: t, step: "Start" }));
  }
  function Vm(e = true, t) {
    const i = this, { params: n } = i;
    i.animating = false, !n.cssMode && (i.setTransition(0), Gl({ swiper: i, runCallbacks: e, direction: t, step: "End" }));
  }
  var Bm = { setTransition: Rm, transitionStart: Hm, transitionEnd: Vm };
  function Wm(e = 0, t, i = true, n, r) {
    typeof e == "string" && (e = parseInt(e, 10));
    const o = this;
    let c = e;
    c < 0 && (c = 0);
    const { params: u, snapGrid: l, slidesGrid: m, previousIndex: v, activeIndex: y, rtlTranslate: E, wrapperEl: h, enabled: g } = o;
    if (!g && !n && !r || o.destroyed || o.animating && u.preventInteractionOnTransition) return false;
    typeof t == "undefined" && (t = o.params.speed);
    const C = Math.min(o.params.slidesPerGroupSkip, c);
    let _ = C + Math.floor((c - C) / o.params.slidesPerGroup);
    _ >= l.length && (_ = l.length - 1);
    const p = -l[_];
    if (u.normalizeSlideIndex) for (let P = 0; P < m.length; P += 1) {
      const D = -Math.floor(p * 100), R = Math.floor(m[P] * 100), N = Math.floor(m[P + 1] * 100);
      typeof m[P + 1] != "undefined" ? D >= R && D < N - (N - R) / 2 ? c = P : D >= R && D < N && (c = P + 1) : D >= R && (c = P);
    }
    if (o.initialized && c !== y && (!o.allowSlideNext && (E ? p > o.translate && p > o.minTranslate() : p < o.translate && p < o.minTranslate()) || !o.allowSlidePrev && p > o.translate && p > o.maxTranslate() && (y || 0) !== c)) return false;
    c !== (v || 0) && i && o.emit("beforeSlideChangeStart"), o.updateProgress(p);
    let S;
    c > y ? S = "next" : c < y ? S = "prev" : S = "reset";
    const w = o.virtual && o.params.virtual.enabled;
    if (!(w && r) && (E && -p === o.translate || !E && p === o.translate)) return o.updateActiveIndex(c), u.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), u.effect !== "slide" && o.setTranslate(p), S !== "reset" && (o.transitionStart(i, S), o.transitionEnd(i, S)), false;
    if (u.cssMode) {
      const P = o.isHorizontal(), D = E ? p : -p;
      if (t === 0) w && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = true), w && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = true, requestAnimationFrame(() => {
        h[P ? "scrollLeft" : "scrollTop"] = D;
      })) : h[P ? "scrollLeft" : "scrollTop"] = D, w && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = false;
      });
      else {
        if (!o.support.smoothScroll) return Vl({ swiper: o, targetPosition: D, side: P ? "left" : "top" }), true;
        h.scrollTo({ [P ? "left" : "top"]: D, behavior: "smooth" });
      }
      return true;
    }
    const f = Fl().isSafari;
    return w && !r && f && o.isElement && o.virtual.update(false, false, c), o.setTransition(t), o.setTranslate(p), o.updateActiveIndex(c), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, n), o.transitionStart(i, S), t === 0 ? o.transitionEnd(i, S) : o.animating || (o.animating = true, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(D) {
      !o || o.destroyed || D.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(i, S));
    }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), true;
  }
  function Fm(e = 0, t, i = true, n) {
    typeof e == "string" && (e = parseInt(e, 10));
    const r = this;
    if (r.destroyed) return;
    typeof t == "undefined" && (t = r.params.speed);
    const o = r.grid && r.params.grid && r.params.grid.rows > 1;
    let c = e;
    if (r.params.loop) if (r.virtual && r.params.virtual.enabled) c = c + r.virtual.slidesBefore;
    else {
      let u;
      if (o) {
        const C = c * r.params.grid.rows;
        u = r.slides.find((_) => _.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else u = r.getSlideIndexByData(c);
      const l = o ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, { centeredSlides: m, slidesOffsetBefore: v, slidesOffsetAfter: y } = r.params, E = m || !!v || !!y;
      let h = r.params.slidesPerView;
      h === "auto" ? h = r.slidesPerViewDynamic() : (h = Math.ceil(parseFloat(r.params.slidesPerView, 10)), E && h % 2 === 0 && (h = h + 1));
      let g = l - u < h;
      if (E && (g = g || u < Math.ceil(h / 2)), n && E && r.params.slidesPerView !== "auto" && !o && (g = false), g) {
        const C = E ? u < r.activeIndex ? "prev" : "next" : u - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({ direction: C, slideTo: true, activeSlideIndex: C === "next" ? u + 1 : u - l + 1, slideRealIndex: C === "next" ? r.realIndex : void 0 });
      }
      if (o) {
        const C = c * r.params.grid.rows;
        c = r.slides.find((_) => _.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else c = r.getSlideIndexByData(c);
    }
    return requestAnimationFrame(() => {
      r.slideTo(c, t, i, n);
    }), r;
  }
  function Gm(e, t = true, i) {
    const n = this, { enabled: r, params: o, animating: c } = n;
    if (!r || n.destroyed) return n;
    typeof e == "undefined" && (e = n.params.speed);
    let u = o.slidesPerGroup;
    o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (u = Math.max(n.slidesPerViewDynamic("current", true), 1));
    const l = n.activeIndex < o.slidesPerGroupSkip ? 1 : u, m = n.virtual && o.virtual.enabled;
    if (o.loop) {
      if (c && !m && o.loopPreventsSliding) return false;
      if (n.loopFix({ direction: "next" }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && o.cssMode) return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + l, e, t, i);
      }), true;
    }
    return o.rewind && n.isEnd ? n.slideTo(0, e, t, i) : n.slideTo(n.activeIndex + l, e, t, i);
  }
  function jm(e, t = true, i) {
    const n = this, { params: r, snapGrid: o, slidesGrid: c, rtlTranslate: u, enabled: l, animating: m } = n;
    if (!l || n.destroyed) return n;
    typeof e == "undefined" && (e = n.params.speed);
    const v = n.virtual && r.virtual.enabled;
    if (r.loop) {
      if (m && !v && r.loopPreventsSliding) return false;
      n.loopFix({ direction: "prev" }), n._clientLeft = n.wrapperEl.clientLeft;
    }
    const y = u ? n.translate : -n.translate;
    function E(S) {
      return S < 0 ? -Math.floor(Math.abs(S)) : Math.floor(S);
    }
    const h = E(y), g = o.map((S) => E(S)), C = r.freeMode && r.freeMode.enabled;
    let _ = o[g.indexOf(h) - 1];
    if (typeof _ == "undefined" && (r.cssMode || C)) {
      let S;
      o.forEach((w, I) => {
        h >= w && (S = I);
      }), typeof S != "undefined" && (_ = C ? o[S] : o[S > 0 ? S - 1 : S]);
    }
    let p = 0;
    if (typeof _ != "undefined" && (p = c.indexOf(_), p < 0 && (p = n.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (p = p - n.slidesPerViewDynamic("previous", true) + 1, p = Math.max(p, 0))), r.rewind && n.isBeginning) {
      const S = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
      return n.slideTo(S, e, t, i);
    } else if (r.loop && n.activeIndex === 0 && r.cssMode) return requestAnimationFrame(() => {
      n.slideTo(p, e, t, i);
    }), true;
    return n.slideTo(p, e, t, i);
  }
  function Ym(e, t = true, i) {
    const n = this;
    if (!n.destroyed) return typeof e == "undefined" && (e = n.params.speed), n.slideTo(n.activeIndex, e, t, i);
  }
  function Xm(e, t = true, i, n = 0.5) {
    const r = this;
    if (r.destroyed) return;
    typeof e == "undefined" && (e = r.params.speed);
    let o = r.activeIndex;
    const c = Math.min(r.params.slidesPerGroupSkip, o), u = c + Math.floor((o - c) / r.params.slidesPerGroup), l = r.rtlTranslate ? r.translate : -r.translate;
    if (l >= r.snapGrid[u]) {
      const m = r.snapGrid[u], v = r.snapGrid[u + 1];
      l - m > (v - m) * n && (o += r.params.slidesPerGroup);
    } else {
      const m = r.snapGrid[u - 1], v = r.snapGrid[u];
      l - m <= (v - m) * n && (o -= r.params.slidesPerGroup);
    }
    return o = Math.max(o, 0), o = Math.min(o, r.slidesGrid.length - 1), r.slideTo(o, e, t, i);
  }
  function qm() {
    const e = this;
    if (e.destroyed) return;
    const { params: t, slidesEl: i } = e, n = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
    let r = e.getSlideIndexWhenGrid(e.clickedIndex), o;
    const c = e.isElement ? "swiper-slide" : `.${t.slideClass}`, u = e.grid && e.params.grid && e.params.grid.rows > 1;
    if (t.loop) {
      if (e.animating) return;
      o = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? e.slideToLoop(o) : r > (u ? (e.slides.length - n) / 2 - (e.params.grid.rows - 1) : e.slides.length - n) ? (e.loopFix(), r = e.getSlideIndex(Pe(i, `${c}[data-swiper-slide-index="${o}"]`)[0]), Pi(() => {
        e.slideTo(r);
      })) : e.slideTo(r);
    } else e.slideTo(r);
  }
  var Um = { slideTo: Wm, slideToLoop: Fm, slideNext: Gm, slidePrev: jm, slideReset: Ym, slideToClosest: Xm, slideToClickedSlide: qm };
  function Km(e, t) {
    const i = this, { params: n, slidesEl: r } = i;
    if (!n.loop || i.virtual && i.params.virtual.enabled) return;
    const o = () => {
      Pe(r, `.${n.slideClass}, swiper-slide`).forEach((g, C) => {
        g.setAttribute("data-swiper-slide-index", C);
      });
    }, c = () => {
      const h = Pe(r, `.${n.slideBlankClass}`);
      h.forEach((g) => {
        g.remove();
      }), h.length > 0 && (i.recalcSlides(), i.updateSlides());
    }, u = i.grid && n.grid && n.grid.rows > 1;
    n.loopAddBlankSlides && (n.slidesPerGroup > 1 || u) && c();
    const l = n.slidesPerGroup * (u ? n.grid.rows : 1), m = i.slides.length % l !== 0, v = u && i.slides.length % n.grid.rows !== 0, y = (h) => {
      for (let g = 0; g < h; g += 1) {
        const C = i.isElement ? Xe("swiper-slide", [n.slideBlankClass]) : Xe("div", [n.slideClass, n.slideBlankClass]);
        i.slidesEl.append(C);
      }
    };
    if (m) {
      if (n.loopAddBlankSlides) {
        const h = l - i.slides.length % l;
        y(h), i.recalcSlides(), i.updateSlides();
      } else kn("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else if (v) {
      if (n.loopAddBlankSlides) {
        const h = n.grid.rows - i.slides.length % n.grid.rows;
        y(h), i.recalcSlides(), i.updateSlides();
      } else kn("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else o();
    const E = n.centeredSlides || !!n.slidesOffsetBefore || !!n.slidesOffsetAfter;
    i.loopFix({ slideRealIndex: e, direction: E ? void 0 : "next", initial: t });
  }
  function Zm({ slideRealIndex: e, slideTo: t = true, direction: i, setTranslate: n, activeSlideIndex: r, initial: o, byController: c, byMousewheel: u } = {}) {
    const l = this;
    if (!l.params.loop) return;
    l.emit("beforeLoopFix");
    const { slides: m, allowSlidePrev: v, allowSlideNext: y, slidesEl: E, params: h } = l, { centeredSlides: g, slidesOffsetBefore: C, slidesOffsetAfter: _, initialSlide: p } = h, S = g || !!C || !!_;
    if (l.allowSlidePrev = true, l.allowSlideNext = true, l.virtual && h.virtual.enabled) {
      t && (!S && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, false, true) : S && l.snapIndex < h.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, false, true) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, false, true)), l.allowSlidePrev = v, l.allowSlideNext = y, l.emit("loopFix");
      return;
    }
    let w = h.slidesPerView;
    w === "auto" ? w = l.slidesPerViewDynamic() : (w = Math.ceil(parseFloat(h.slidesPerView, 10)), S && w % 2 === 0 && (w = w + 1));
    const I = h.slidesPerGroupAuto ? w : h.slidesPerGroup;
    let L = S ? Math.max(I, Math.ceil(w / 2)) : I;
    L % I !== 0 && (L += I - L % I), L += h.loopAdditionalSlides, l.loopedSlides = L;
    const f = l.grid && h.grid && h.grid.rows > 1;
    m.length < w + L || l.params.effect === "cards" && m.length < w + L * 2 ? kn("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : f && h.grid.fill === "row" && kn("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const P = [], D = [], R = f ? Math.ceil(m.length / h.grid.rows) : m.length, N = o && R - p < w && !S;
    let $ = N ? p : l.activeIndex;
    typeof r == "undefined" ? r = l.getSlideIndex(m.find((Y) => Y.classList.contains(h.slideActiveClass))) : $ = r;
    const V = i === "next" || !i, B = i === "prev" || !i;
    let X = 0, Z = 0;
    const W = (f ? m[r].column : r) + (S && typeof n == "undefined" ? -w / 2 + 0.5 : 0);
    if (W < L) {
      X = Math.max(L - W, I);
      for (let Y = 0; Y < L - W; Y += 1) {
        const J = Y - Math.floor(Y / R) * R;
        if (f) {
          const oe = R - J - 1;
          for (let he = m.length - 1; he >= 0; he -= 1) m[he].column === oe && P.push(he);
        } else P.push(R - J - 1);
      }
    } else if (W + w > R - L) {
      Z = Math.max(W - (R - L * 2), I), N && (Z = Math.max(Z, w - R + p + 1));
      for (let Y = 0; Y < Z; Y += 1) {
        const J = Y - Math.floor(Y / R) * R;
        f ? m.forEach((oe, he) => {
          oe.column === J && D.push(he);
        }) : D.push(J);
      }
    }
    if (l.__preventObserver__ = true, requestAnimationFrame(() => {
      l.__preventObserver__ = false;
    }), l.params.effect === "cards" && m.length < w + L * 2 && (D.includes(r) && D.splice(D.indexOf(r), 1), P.includes(r) && P.splice(P.indexOf(r), 1)), B && P.forEach((Y) => {
      m[Y].swiperLoopMoveDOM = true, E.prepend(m[Y]), m[Y].swiperLoopMoveDOM = false;
    }), V && D.forEach((Y) => {
      m[Y].swiperLoopMoveDOM = true, E.append(m[Y]), m[Y].swiperLoopMoveDOM = false;
    }), l.recalcSlides(), h.slidesPerView === "auto" ? l.updateSlides() : f && (P.length > 0 && B || D.length > 0 && V) && l.slides.forEach((Y, J) => {
      l.grid.updateSlide(J, Y, l.slides);
    }), h.watchSlidesProgress && l.updateSlidesOffset(), t) {
      if (P.length > 0 && B) {
        if (typeof e == "undefined") {
          const Y = l.slidesGrid[$], oe = l.slidesGrid[$ + X] - Y;
          u ? l.setTranslate(l.translate - oe) : (l.slideTo($ + Math.ceil(X), 0, false, true), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - oe, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - oe));
        } else if (n) {
          const Y = f ? P.length / h.grid.rows : P.length;
          l.slideTo(l.activeIndex + Y, 0, false, true), l.touchEventsData.currentTranslate = l.translate;
        }
      } else if (D.length > 0 && V) if (typeof e == "undefined") {
        const Y = l.slidesGrid[$], oe = l.slidesGrid[$ - Z] - Y;
        u ? l.setTranslate(l.translate - oe) : (l.slideTo($ - Z, 0, false, true), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - oe, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - oe));
      } else {
        const Y = f ? D.length / h.grid.rows : D.length;
        l.slideTo(l.activeIndex - Y, 0, false, true);
      }
    }
    if (l.allowSlidePrev = v, l.allowSlideNext = y, l.controller && l.controller.control && !c) {
      const Y = { slideRealIndex: e, direction: i, setTranslate: n, activeSlideIndex: r, byController: true };
      Array.isArray(l.controller.control) ? l.controller.control.forEach((J) => {
        !J.destroyed && J.params.loop && J.loopFix(bi(Ae({}, Y), { slideTo: J.params.slidesPerView === h.slidesPerView ? t : false }));
      }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix(bi(Ae({}, Y), { slideTo: l.controller.control.params.slidesPerView === h.slidesPerView ? t : false }));
    }
    l.emit("loopFix");
  }
  function Qm() {
    const e = this, { params: t, slidesEl: i } = e;
    if (!t.loop || !i || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    const n = [];
    e.slides.forEach((r) => {
      const o = typeof r.swiperSlideIndex == "undefined" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
      n[o] = r;
    }), e.slides.forEach((r) => {
      r.removeAttribute("data-swiper-slide-index");
    }), n.forEach((r) => {
      i.append(r);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
  }
  var Jm = { loopCreate: Km, loopFix: Zm, loopDestroy: Qm };
  function eg(e) {
    const t = this;
    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
    const i = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
    t.isElement && (t.__preventObserver__ = true), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
      t.__preventObserver__ = false;
    });
  }
  function tg() {
    const e = this;
    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = true), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
      e.__preventObserver__ = false;
    }));
  }
  var ig = { setGrabCursor: eg, unsetGrabCursor: tg };
  function ng(e, t = this) {
    function i(n) {
      if (!n || n === Le() || n === ye()) return null;
      n.assignedSlot && (n = n.assignedSlot);
      const r = n.closest(e);
      return !r && !n.getRootNode ? null : r || i(n.getRootNode().host);
    }
    return i(t);
  }
  function da(e, t, i) {
    const n = ye(), { params: r } = e, o = r.edgeSwipeDetection, c = r.edgeSwipeThreshold;
    return o && (i <= c || i >= n.innerWidth - c) ? o === "prevent" ? (t.preventDefault(), true) : false : true;
  }
  function sg(e) {
    const t = this, i = Le();
    let n = e;
    n.originalEvent && (n = n.originalEvent);
    const r = t.touchEventsData;
    if (n.type === "pointerdown") {
      if (r.pointerId !== null && r.pointerId !== n.pointerId) return;
      r.pointerId = n.pointerId;
    } else n.type === "touchstart" && n.targetTouches.length === 1 && (r.touchId = n.targetTouches[0].identifier);
    if (n.type === "touchstart") {
      da(t, n, n.targetTouches[0].pageX);
      return;
    }
    const { params: o, touches: c, enabled: u } = t;
    if (!u || !o.simulateTouch && n.pointerType === "mouse" || t.animating && o.preventInteractionOnTransition) return;
    !t.animating && o.cssMode && o.loop && t.loopFix();
    let l = n.target;
    if (o.touchEventsTarget === "wrapper" && !fm(l, t.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || r.isTouched && r.isMoved) return;
    const m = !!o.noSwipingClass && o.noSwipingClass !== "", v = n.composedPath ? n.composedPath() : n.path;
    m && n.target && n.target.shadowRoot && v && (l = v[0]);
    const y = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, E = !!(n.target && n.target.shadowRoot);
    if (o.noSwiping && (E ? ng(y, l) : l.closest(y))) {
      t.allowClick = true;
      return;
    }
    if (o.swipeHandler && !l.closest(o.swipeHandler)) return;
    c.currentX = n.pageX, c.currentY = n.pageY;
    const h = c.currentX, g = c.currentY;
    if (!da(t, n, h)) return;
    Object.assign(r, { isTouched: true, isMoved: false, allowTouchCallbacks: true, isScrolling: void 0, startMoving: void 0 }), c.startX = h, c.startY = g, r.touchStartTime = Je(), t.allowClick = true, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (r.allowThresholdMove = false);
    let C = true;
    l.matches(r.focusableElements) && (C = false, l.nodeName === "SELECT" && (r.isTouched = false)), i.activeElement && i.activeElement.matches(r.focusableElements) && i.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(r.focusableElements)) && i.activeElement.blur();
    const _ = C && t.allowTouchMove && o.touchStartPreventDefault;
    (o.touchStartForcePreventDefault || _) && !l.isContentEditable && n.preventDefault(), o.freeMode && o.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", n);
  }
  function rg(e) {
    const t = Le(), i = this, n = i.touchEventsData, { params: r, touches: o, rtlTranslate: c, enabled: u } = i;
    if (!u || !r.simulateTouch && e.pointerType === "mouse") return;
    let l = e;
    if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId)) return;
    let m;
    if (l.type === "touchmove") {
      if (m = [...l.changedTouches].find((L) => L.identifier === n.touchId), !m || m.identifier !== n.touchId) return;
    } else m = l;
    if (!n.isTouched) {
      n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", l);
      return;
    }
    const v = m.pageX, y = m.pageY;
    if (l.preventedByNestedSwiper) {
      o.startX = v, o.startY = y;
      return;
    }
    if (!i.allowTouchMove) {
      l.target.matches(n.focusableElements) || (i.allowClick = false), n.isTouched && (Object.assign(o, { startX: v, startY: y, currentX: v, currentY: y }), n.touchStartTime = Je());
      return;
    }
    if (r.touchReleaseOnEdges && !r.loop) if (i.isVertical()) {
      if (y < o.startY && i.translate <= i.maxTranslate() || y > o.startY && i.translate >= i.minTranslate()) {
        n.isTouched = false, n.isMoved = false;
        return;
      }
    } else {
      if (c && (v > o.startX && -i.translate <= i.maxTranslate() || v < o.startX && -i.translate >= i.minTranslate())) return;
      if (!c && (v < o.startX && i.translate <= i.maxTranslate() || v > o.startX && i.translate >= i.minTranslate())) return;
    }
    if (t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== l.target && l.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && l.target === t.activeElement && l.target.matches(n.focusableElements)) {
      n.isMoved = true, i.allowClick = false;
      return;
    }
    n.allowTouchCallbacks && i.emit("touchMove", l), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = v, o.currentY = y;
    const E = o.currentX - o.startX, h = o.currentY - o.startY;
    if (i.params.threshold && Math.sqrt(Me(E, 2) + Me(h, 2)) < i.params.threshold) return;
    if (typeof n.isScrolling == "undefined") {
      let L;
      i.isHorizontal() && o.currentY === o.startY || i.isVertical() && o.currentX === o.startX ? n.isScrolling = false : E * E + h * h >= 25 && (L = Math.atan2(Math.abs(h), Math.abs(E)) * 180 / Math.PI, n.isScrolling = i.isHorizontal() ? L > r.touchAngle : 90 - L > r.touchAngle);
    }
    if (n.isScrolling && i.emit("touchMoveOpposite", l), typeof n.startMoving == "undefined" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = true), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
      n.isTouched = false;
      return;
    }
    if (!n.startMoving) return;
    i.allowClick = false, !r.cssMode && l.cancelable && l.preventDefault(), r.touchMoveStopPropagation && !r.nested && l.stopPropagation();
    let g = i.isHorizontal() ? E : h, C = i.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
    r.oneWayMovement && (g = Math.abs(g) * (c ? 1 : -1), C = Math.abs(C) * (c ? 1 : -1)), o.diff = g, g *= r.touchRatio, c && (g = -g, C = -C);
    const _ = i.touchesDirection;
    i.swipeDirection = g > 0 ? "prev" : "next", i.touchesDirection = C > 0 ? "prev" : "next";
    const p = i.params.loop && !r.cssMode, S = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
    if (!n.isMoved) {
      if (p && S && i.loopFix({ direction: i.swipeDirection }), n.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
        const L = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true, detail: { bySwiperTouchMove: true } });
        i.wrapperEl.dispatchEvent(L);
      }
      n.allowMomentumBounce = false, r.grabCursor && (i.allowSlideNext === true || i.allowSlidePrev === true) && i.setGrabCursor(true), i.emit("sliderFirstMove", l);
    }
    if ((/* @__PURE__ */ new Date()).getTime(), r._loopSwapReset !== false && n.isMoved && n.allowThresholdMove && _ !== i.touchesDirection && p && S && Math.abs(g) >= 1) {
      Object.assign(o, { startX: v, startY: y, currentX: v, currentY: y, startTranslate: n.currentTranslate }), n.loopSwapReset = true, n.startTranslate = n.currentTranslate;
      return;
    }
    i.emit("sliderMove", l), n.isMoved = true, n.currentTranslate = g + n.startTranslate;
    let w = true, I = r.resistanceRatio;
    if (r.touchReleaseOnEdges && (I = 0), g > 0 ? (p && S && n.allowThresholdMove && n.currentTranslate > (r.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({ direction: "prev", setTranslate: true, activeSlideIndex: 0 }), n.currentTranslate > i.minTranslate() && (w = false, r.resistance && (n.currentTranslate = i.minTranslate() - 1 + Me(-i.minTranslate() + n.startTranslate + g, I)))) : g < 0 && (p && S && n.allowThresholdMove && n.currentTranslate < (r.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({ direction: "next", setTranslate: true, activeSlideIndex: i.slides.length - (r.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))) }), n.currentTranslate < i.maxTranslate() && (w = false, r.resistance && (n.currentTranslate = i.maxTranslate() + 1 - Me(i.maxTranslate() - n.startTranslate - g, I)))), w && (l.preventedByNestedSwiper = true), !i.allowSlideNext && i.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (n.currentTranslate = n.startTranslate), r.threshold > 0) if (Math.abs(g) > r.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = true, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = i.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
    !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && i.freeMode || r.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(n.currentTranslate), i.setTranslate(n.currentTranslate));
  }
  function og(e) {
    const t = this, i = t.touchEventsData;
    let n = e;
    n.originalEvent && (n = n.originalEvent);
    let r;
    if (n.type === "touchend" || n.type === "touchcancel") {
      if (r = [...n.changedTouches].find((L) => L.identifier === i.touchId), !r || r.identifier !== i.touchId) return;
    } else {
      if (i.touchId !== null || n.pointerId !== i.pointerId) return;
      r = n;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (t.browser.isSafari || t.browser.isWebView))) return;
    i.pointerId = null, i.touchId = null;
    const { params: c, touches: u, rtlTranslate: l, slidesGrid: m, enabled: v } = t;
    if (!v || !c.simulateTouch && n.pointerType === "mouse") return;
    if (i.allowTouchCallbacks && t.emit("touchEnd", n), i.allowTouchCallbacks = false, !i.isTouched) {
      i.isMoved && c.grabCursor && t.setGrabCursor(false), i.isMoved = false, i.startMoving = false;
      return;
    }
    c.grabCursor && i.isMoved && i.isTouched && (t.allowSlideNext === true || t.allowSlidePrev === true) && t.setGrabCursor(false);
    const y = Je(), E = y - i.touchStartTime;
    if (t.allowClick) {
      const L = n.path || n.composedPath && n.composedPath();
      t.updateClickedSlide(L && L[0] || n.target, L), t.emit("tap click", n), E < 300 && y - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", n);
    }
    if (i.lastClickTime = Je(), Pi(() => {
      t.destroyed || (t.allowClick = true);
    }), !i.isTouched || !i.isMoved || !t.swipeDirection || u.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
      i.isTouched = false, i.isMoved = false, i.startMoving = false;
      return;
    }
    i.isTouched = false, i.isMoved = false, i.startMoving = false;
    let h;
    if (c.followFinger ? h = l ? t.translate : -t.translate : h = -i.currentTranslate, c.cssMode) return;
    if (c.freeMode && c.freeMode.enabled) {
      t.freeMode.onTouchEnd({ currentPos: h });
      return;
    }
    const g = h >= -t.maxTranslate() && !t.params.loop;
    let C = 0, _ = t.slidesSizesGrid[0];
    for (let L = 0; L < m.length; L += L < c.slidesPerGroupSkip ? 1 : c.slidesPerGroup) {
      const f = L < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
      typeof m[L + f] != "undefined" ? (g || h >= m[L] && h < m[L + f]) && (C = L, _ = m[L + f] - m[L]) : (g || h >= m[L]) && (C = L, _ = m[m.length - 1] - m[m.length - 2]);
    }
    let p = null, S = null;
    c.rewind && (t.isBeginning ? S = c.virtual && c.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (p = 0));
    const w = (h - m[C]) / _, I = C < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
    if (E > c.longSwipesMs) {
      if (!c.longSwipes) {
        t.slideTo(t.activeIndex);
        return;
      }
      t.swipeDirection === "next" && (w >= c.longSwipesRatio ? t.slideTo(c.rewind && t.isEnd ? p : C + I) : t.slideTo(C)), t.swipeDirection === "prev" && (w > 1 - c.longSwipesRatio ? t.slideTo(C + I) : S !== null && w < 0 && Math.abs(w) > c.longSwipesRatio ? t.slideTo(S) : t.slideTo(C));
    } else {
      if (!c.shortSwipes) {
        t.slideTo(t.activeIndex);
        return;
      }
      t.navigation && (n.target === t.navigation.nextEl || n.target === t.navigation.prevEl) ? n.target === t.navigation.nextEl ? t.slideTo(C + I) : t.slideTo(C) : (t.swipeDirection === "next" && t.slideTo(p !== null ? p : C + I), t.swipeDirection === "prev" && t.slideTo(S !== null ? S : C));
    }
  }
  function fa() {
    const e = this, { params: t, el: i } = e;
    if (i && i.offsetWidth === 0) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: n, allowSlidePrev: r, snapGrid: o } = e, c = e.virtual && e.params.virtual.enabled;
    e.allowSlideNext = true, e.allowSlidePrev = true, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
    const u = c && t.loop;
    if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !u) {
      const l = c ? e.virtual.slides : e.slides;
      e.slideTo(l.length - 1, 0, false, true);
    } else e.params.loop && !c ? e.slideToLoop(e.realIndex, 0, false, true) : e.slideTo(e.activeIndex, 0, false, true);
    e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
      e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
    }, 500)), e.allowSlidePrev = r, e.allowSlideNext = n, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
  }
  function ag(e) {
    const t = this;
    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function lg() {
    const e = this, { wrapperEl: t, rtlTranslate: i, enabled: n } = e;
    if (!n) return;
    e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
    let r;
    const o = e.maxTranslate() - e.minTranslate();
    o === 0 ? r = 0 : r = (e.translate - e.minTranslate()) / o, r !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, false);
  }
  function cg(e) {
    const t = this;
    Ln(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
  }
  function ug() {
    const e = this;
    e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = true, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
  }
  const jl = (e, t) => {
    const i = Le(), { params: n, el: r, wrapperEl: o, device: c } = e, u = !!n.nested, l = t === "on" ? "addEventListener" : "removeEventListener", m = t;
    !r || typeof r == "string" || (i[l]("touchstart", e.onDocumentTouchStart, { passive: false, capture: u }), r[l]("touchstart", e.onTouchStart, { passive: false }), r[l]("pointerdown", e.onTouchStart, { passive: false }), i[l]("touchmove", e.onTouchMove, { passive: false, capture: u }), i[l]("pointermove", e.onTouchMove, { passive: false, capture: u }), i[l]("touchend", e.onTouchEnd, { passive: true }), i[l]("pointerup", e.onTouchEnd, { passive: true }), i[l]("pointercancel", e.onTouchEnd, { passive: true }), i[l]("touchcancel", e.onTouchEnd, { passive: true }), i[l]("pointerout", e.onTouchEnd, { passive: true }), i[l]("pointerleave", e.onTouchEnd, { passive: true }), i[l]("contextmenu", e.onTouchEnd, { passive: true }), (n.preventClicks || n.preventClicksPropagation) && r[l]("click", e.onClick, true), n.cssMode && o[l]("scroll", e.onScroll), n.updateOnWindowResize ? e[m](c.ios || c.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", fa, true) : e[m]("observerUpdate", fa, true), r[l]("load", e.onLoad, { capture: true }));
  };
  function dg() {
    const e = this, { params: t } = e;
    e.onTouchStart = sg.bind(e), e.onTouchMove = rg.bind(e), e.onTouchEnd = og.bind(e), e.onDocumentTouchStart = ug.bind(e), t.cssMode && (e.onScroll = lg.bind(e)), e.onClick = ag.bind(e), e.onLoad = cg.bind(e), jl(e, "on");
  }
  function fg() {
    jl(this, "off");
  }
  var hg = { attachEvents: dg, detachEvents: fg };
  const ha = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  function pg() {
    const e = this, { realIndex: t, initialized: i, params: n, el: r } = e, o = n.breakpoints;
    if (!o || o && Object.keys(o).length === 0) return;
    const c = Le(), u = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? e.el : c.querySelector(n.breakpointsBase), m = e.getBreakpoint(o, u, l);
    if (!m || e.currentBreakpoint === m) return;
    const y = (m in o ? o[m] : void 0) || e.originalParams, E = ha(e, n), h = ha(e, y), g = e.params.grabCursor, C = y.grabCursor, _ = n.enabled;
    E && !h ? (r.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !E && h && (r.classList.add(`${n.containerModifierClass}grid`), (y.grid.fill && y.grid.fill === "column" || !y.grid.fill && n.grid.fill === "column") && r.classList.add(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), g && !C ? e.unsetGrabCursor() : !g && C && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((f) => {
      if (typeof y[f] == "undefined") return;
      const P = n[f] && n[f].enabled, D = y[f] && y[f].enabled;
      P && !D && e[f].disable(), !P && D && e[f].enable();
    });
    const p = y.direction && y.direction !== n.direction, S = n.loop && (y.slidesPerView !== n.slidesPerView || p), w = n.loop;
    p && i && e.changeDirection(), Ye(e.params, y);
    const I = e.params.enabled, L = e.params.loop;
    Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }), _ && !I ? e.disable() : !_ && I && e.enable(), e.currentBreakpoint = m, e.emit("_beforeBreakpoint", y), i && (S ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !w && L ? (e.loopCreate(t), e.updateSlides()) : w && !L && e.loopDestroy()), e.emit("breakpoint", y);
  }
  function mg(e, t = "window", i) {
    if (!e || t === "container" && !i) return;
    let n = false;
    const r = ye(), o = t === "window" ? r.innerHeight : i.clientHeight, c = Object.keys(e).map((u) => {
      if (typeof u == "string" && u.indexOf("@") === 0) {
        const l = parseFloat(u.substr(1));
        return { value: o * l, point: u };
      }
      return { value: u, point: u };
    });
    c.sort((u, l) => parseInt(u.value, 10) - parseInt(l.value, 10));
    for (let u = 0; u < c.length; u += 1) {
      const { point: l, value: m } = c[u];
      t === "window" ? r.matchMedia(`(min-width: ${m}px)`).matches && (n = l) : m <= i.clientWidth && (n = l);
    }
    return n || "max";
  }
  var gg = { setBreakpoint: pg, getBreakpoint: mg };
  function vg(e, t) {
    const i = [];
    return e.forEach((n) => {
      typeof n == "object" ? Object.keys(n).forEach((r) => {
        n[r] && i.push(t + r);
      }) : typeof n == "string" && i.push(t + n);
    }), i;
  }
  function yg() {
    const e = this, { classNames: t, params: i, rtl: n, el: r, device: o } = e, c = vg(["initialized", i.direction, { "free-mode": e.params.freeMode && i.freeMode.enabled }, { autoheight: i.autoHeight }, { rtl: n }, { grid: i.grid && i.grid.rows > 1 }, { "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column" }, { android: o.android }, { ios: o.ios }, { "css-mode": i.cssMode }, { centered: i.cssMode && i.centeredSlides }, { "watch-progress": i.watchSlidesProgress }], i.containerModifierClass);
    t.push(...c), r.classList.add(...t), e.emitContainerClasses();
  }
  function bg() {
    const e = this, { el: t, classNames: i } = e;
    !t || typeof t == "string" || (t.classList.remove(...i), e.emitContainerClasses());
  }
  var Eg = { addClasses: yg, removeClasses: bg };
  function Sg() {
    const e = this, { isLocked: t, params: i } = e, { slidesOffsetBefore: n } = i;
    if (n) {
      const r = e.slides.length - 1, o = e.slidesGrid[r] + e.slidesSizesGrid[r] + n * 2;
      e.isLocked = e.size > o;
    } else e.isLocked = e.snapGrid.length === 1;
    i.allowSlideNext === true && (e.allowSlideNext = !e.isLocked), i.allowSlidePrev === true && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = false), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
  }
  var Tg = { checkOverflow: Sg }, pa = { init: true, direction: "horizontal", oneWayMovement: false, swiperElementNodeName: "SWIPER-CONTAINER", touchEventsTarget: "wrapper", initialSlide: 0, speed: 300, cssMode: false, updateOnWindowResize: true, resizeObserver: true, nested: false, createElements: false, eventsPrefix: "swiper", enabled: true, focusableElements: "input, select, option, textarea, button, video, label", width: null, height: null, preventInteractionOnTransition: false, userAgent: null, url: null, edgeSwipeDetection: false, edgeSwipeThreshold: 20, autoHeight: false, setWrapperSize: false, virtualTranslate: false, effect: "slide", breakpoints: void 0, breakpointsBase: "window", spaceBetween: 0, slidesPerView: 1, slidesPerGroup: 1, slidesPerGroupSkip: 0, slidesPerGroupAuto: false, centeredSlides: false, centeredSlidesBounds: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0, normalizeSlideIndex: true, centerInsufficientSlides: false, snapToSlideEdge: false, watchOverflow: true, roundLengths: false, touchRatio: 1, touchAngle: 45, simulateTouch: true, shortSwipes: true, longSwipes: true, longSwipesRatio: 0.5, longSwipesMs: 300, followFinger: true, allowTouchMove: true, threshold: 5, touchMoveStopPropagation: false, touchStartPreventDefault: true, touchStartForcePreventDefault: false, touchReleaseOnEdges: false, uniqueNavElements: true, resistance: true, resistanceRatio: 0.85, watchSlidesProgress: false, grabCursor: false, preventClicks: true, preventClicksPropagation: true, slideToClickedSlide: false, loop: false, loopAddBlankSlides: true, loopAdditionalSlides: 0, loopPreventsSliding: true, rewind: false, allowSlidePrev: true, allowSlideNext: true, swipeHandler: null, noSwiping: true, noSwipingClass: "swiper-no-swiping", noSwipingSelector: null, passiveListeners: true, maxBackfaceHiddenSlides: 10, containerModifierClass: "swiper-", slideClass: "swiper-slide", slideBlankClass: "swiper-slide-blank", slideActiveClass: "swiper-slide-active", slideVisibleClass: "swiper-slide-visible", slideFullyVisibleClass: "swiper-slide-fully-visible", slideNextClass: "swiper-slide-next", slidePrevClass: "swiper-slide-prev", wrapperClass: "swiper-wrapper", lazyPreloaderClass: "swiper-lazy-preloader", lazyPreloadPrevNext: 0, runCallbacksOnInit: true, _emitClasses: false };
  function _g(e, t) {
    return function(n = {}) {
      const r = Object.keys(n)[0], o = n[r];
      if (typeof o != "object" || o === null) {
        Ye(t, n);
        return;
      }
      if (e[r] === true && (e[r] = { enabled: true }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = true), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = true), !(r in e && "enabled" in o)) {
        Ye(t, n);
        return;
      }
      typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = true), e[r] || (e[r] = { enabled: false }), Ye(t, n);
    };
  }
  const Fs = { eventsEmitter: Em, update: Lm, translate: km, transition: Bm, slide: Um, loop: Jm, grabCursor: ig, events: hg, breakpoints: gg, checkOverflow: Tg, classes: Eg }, Gs = {};
  class Be {
    constructor(...t) {
      let i, n;
      t.length === 1 && t[0].constructor && Object.prototype.toString.call(t[0]).slice(8, -1) === "Object" ? n = t[0] : [i, n] = t, n || (n = {}), n = Ye({}, n), i && !n.el && (n.el = i);
      const r = Le();
      if (n.el && typeof n.el == "string" && r.querySelectorAll(n.el).length > 1) {
        const l = [];
        return r.querySelectorAll(n.el).forEach((m) => {
          const v = Ye({}, n, { el: m });
          l.push(new Be(v));
        }), l;
      }
      const o = this;
      o.__swiper__ = true, o.support = Bl(), o.device = Wl({ userAgent: n.userAgent }), o.browser = Fl(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && n.modules.forEach((l) => {
        typeof l == "function" && o.modules.indexOf(l) < 0 && o.modules.push(l);
      });
      const c = {};
      o.modules.forEach((l) => {
        l({ params: n, swiper: o, extendParams: _g(n, c), on: o.on.bind(o), once: o.once.bind(o), off: o.off.bind(o), emit: o.emit.bind(o) });
      });
      const u = Ye({}, pa, c);
      return o.params = Ye({}, u, Gs, n), o.originalParams = Ye({}, o.params), o.passedParams = Ye({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((l) => {
        o.on(l, o.params.on[l]);
      }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, { enabled: o.params.enabled, el: i, classNames: [], slides: [], slidesGrid: [], snapGrid: [], slidesSizesGrid: [], isHorizontal() {
        return o.params.direction === "horizontal";
      }, isVertical() {
        return o.params.direction === "vertical";
      }, activeIndex: 0, realIndex: 0, isBeginning: true, isEnd: false, translate: 0, previousTranslate: 0, progress: 0, velocity: 0, animating: false, cssOverflowAdjustment() {
        return Math.trunc(this.translate / Me(2, 23)) * Me(2, 23);
      }, allowSlideNext: o.params.allowSlideNext, allowSlidePrev: o.params.allowSlidePrev, touchEventsData: { isTouched: void 0, isMoved: void 0, allowTouchCallbacks: void 0, touchStartTime: void 0, isScrolling: void 0, currentTranslate: void 0, startTranslate: void 0, allowThresholdMove: void 0, focusableElements: o.params.focusableElements, lastClickTime: 0, clickTimeout: void 0, velocities: [], allowMomentumBounce: void 0, startMoving: void 0, pointerId: null, touchId: null }, allowClick: true, allowTouchMove: o.params.allowTouchMove, touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 }, imagesToLoad: [], imagesLoaded: 0 }), o.emit("_swiper"), o.params.init && o.init(), o;
    }
    getDirectionLabel(t) {
      return this.isHorizontal() ? t : { width: "height", "margin-top": "margin-left", "margin-bottom ": "margin-right", "margin-left": "margin-top", "margin-right": "margin-bottom", "padding-left": "padding-top", "padding-right": "padding-bottom", marginRight: "marginBottom" }[t];
    }
    getSlideIndex(t) {
      const { slidesEl: i, params: n } = this, r = Pe(i, `.${n.slideClass}, swiper-slide`), o = Qi(r[0]);
      return Qi(t) - o;
    }
    getSlideIndexByData(t) {
      return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === t));
    }
    getSlideIndexWhenGrid(t) {
      return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? t = Math.floor(t / this.params.grid.rows) : this.params.grid.fill === "row" && (t = t % Math.ceil(this.slides.length / this.params.grid.rows))), t;
    }
    recalcSlides() {
      const t = this, { slidesEl: i, params: n } = t;
      t.slides = Pe(i, `.${n.slideClass}, swiper-slide`);
    }
    enable() {
      const t = this;
      t.enabled || (t.enabled = true, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
    }
    disable() {
      const t = this;
      t.enabled && (t.enabled = false, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
    }
    setProgress(t, i) {
      const n = this;
      t = Math.min(Math.max(t, 0), 1);
      const r = n.minTranslate(), c = (n.maxTranslate() - r) * t + r;
      n.translateTo(c, typeof i == "undefined" ? 0 : i), n.updateActiveIndex(), n.updateSlidesClasses();
    }
    emitContainerClasses() {
      const t = this;
      if (!t.params._emitClasses || !t.el) return;
      const i = t.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(t.params.containerModifierClass) === 0);
      t.emit("_containerClasses", i.join(" "));
    }
    getSlideClasses(t) {
      const i = this;
      return i.destroyed ? "" : t.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(i.params.slideClass) === 0).join(" ");
    }
    emitSlidesClasses() {
      const t = this;
      if (!t.params._emitClasses || !t.el) return;
      const i = [];
      t.slides.forEach((n) => {
        const r = t.getSlideClasses(n);
        i.push({ slideEl: n, classNames: r }), t.emit("_slideClass", n, r);
      }), t.emit("_slideClasses", i);
    }
    slidesPerViewDynamic(t = "current", i = false) {
      const n = this, { params: r, slides: o, slidesGrid: c, slidesSizesGrid: u, size: l, activeIndex: m } = n;
      let v = 1;
      if (typeof r.slidesPerView == "number") return r.slidesPerView;
      if (r.centeredSlides) {
        let y = o[m] ? Math.ceil(o[m].swiperSlideSize) : 0, E;
        for (let h = m + 1; h < o.length; h += 1) o[h] && !E && (y += Math.ceil(o[h].swiperSlideSize), v += 1, y > l && (E = true));
        for (let h = m - 1; h >= 0; h -= 1) o[h] && !E && (y += o[h].swiperSlideSize, v += 1, y > l && (E = true));
      } else if (t === "current") for (let y = m + 1; y < o.length; y += 1) (i ? c[y] + u[y] - c[m] < l : c[y] - c[m] < l) && (v += 1);
      else for (let y = m - 1; y >= 0; y -= 1) c[m] - c[y] < l && (v += 1);
      return v;
    }
    update() {
      const t = this;
      if (!t || t.destroyed) return;
      const { snapGrid: i, params: n } = t;
      n.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((c) => {
        c.complete && Ln(t, c);
      }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
      function r() {
        const c = t.rtlTranslate ? t.translate * -1 : t.translate, u = Math.min(Math.max(c, t.maxTranslate()), t.minTranslate());
        t.setTranslate(u), t.updateActiveIndex(), t.updateSlidesClasses();
      }
      let o;
      if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && t.updateAutoHeight();
      else {
        if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && t.isEnd && !n.centeredSlides) {
          const c = t.virtual && n.virtual.enabled ? t.virtual.slides : t.slides;
          o = t.slideTo(c.length - 1, 0, false, true);
        } else o = t.slideTo(t.activeIndex, 0, false, true);
        o || r();
      }
      n.watchOverflow && i !== t.snapGrid && t.checkOverflow(), t.emit("update");
    }
    changeDirection(t, i = true) {
      const n = this, r = n.params.direction;
      return t || (t = r === "horizontal" ? "vertical" : "horizontal"), t === r || t !== "horizontal" && t !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${t}`), n.emitContainerClasses(), n.params.direction = t, n.slides.forEach((o) => {
        t === "vertical" ? o.style.width = "" : o.style.height = "";
      }), n.emit("changeDirection"), i && n.update()), n;
    }
    changeLanguageDirection(t) {
      const i = this;
      i.rtl && t === "rtl" || !i.rtl && t === "ltr" || (i.rtl = t === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
    }
    mount(t) {
      const i = this;
      if (i.mounted) return true;
      let n = t || i.params.el;
      if (typeof n == "string" && (n = document.querySelector(n)), !n) return false;
      n.swiper = i, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = true);
      const r = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let c = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : Pe(n, r())[0];
      return !c && i.params.createElements && (c = Xe("div", i.params.wrapperClass), n.append(c), Pe(n, `.${i.params.slideClass}`).forEach((u) => {
        c.append(u);
      })), Object.assign(i, { el: n, wrapperEl: c, slidesEl: i.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : c, hostEl: i.isElement ? n.parentNode.host : n, mounted: true, rtl: n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl", rtlTranslate: i.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl"), wrongRTL: Ht(c, "display") === "-webkit-box" }), true;
    }
    init(t) {
      const i = this;
      if (i.initialized || i.mount(t) === false) return i;
      i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, false, true) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, false, true), i.params.loop && i.loopCreate(void 0, true), i.attachEvents();
      const r = [...i.el.querySelectorAll('[loading="lazy"]')];
      return i.isElement && r.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((o) => {
        o.complete ? Ln(i, o) : o.addEventListener("load", (c) => {
          Ln(i, c.target);
        });
      }), mr(i), i.initialized = true, mr(i), i.emit("init"), i.emit("afterInit"), i;
    }
    destroy(t = true, i = true) {
      const n = this, { params: r, el: o, wrapperEl: c, slides: u } = n;
      return typeof n.params == "undefined" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = false, n.detachEvents(), r.loop && n.loopDestroy(), i && (n.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), c && c.removeAttribute("style"), u && u.length && u.forEach((l) => {
        l.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
      })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((l) => {
        n.off(l);
      }), t !== false && (n.el && typeof n.el != "string" && (n.el.swiper = null), lm(n)), n.destroyed = true), null;
    }
    static extendDefaults(t) {
      Ye(Gs, t);
    }
    static get extendedDefaults() {
      return Gs;
    }
    static get defaults() {
      return pa;
    }
    static installModule(t) {
      Be.prototype.__modules__ || (Be.prototype.__modules__ = []);
      const i = Be.prototype.__modules__;
      typeof t == "function" && i.indexOf(t) < 0 && i.push(t);
    }
    static use(t) {
      return Array.isArray(t) ? (t.forEach((i) => Be.installModule(i)), Be) : (Be.installModule(t), Be);
    }
  }
  Object.keys(Fs).forEach((e) => {
    Object.keys(Fs[e]).forEach((t) => {
      Be.prototype[t] = Fs[e][t];
    });
  });
  Be.use([ym, bm]);
  function xg({ swiper: e, extendParams: t, on: i, emit: n }) {
    t({ virtual: { enabled: false, slides: [], cache: true, slidesPerViewAutoSlideSize: 320, renderSlide: null, renderExternal: null, renderExternalUpdate: true, addSlidesBefore: 0, addSlidesAfter: 0 } });
    let r;
    const o = Le();
    e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
    const c = o.createElement("div");
    function u(h, g) {
      const C = e.params.virtual;
      if (C.cache && e.virtual.cache[g]) return e.virtual.cache[g];
      let _;
      return C.renderSlide ? (_ = C.renderSlide.call(e, h, g), typeof _ == "string" && (bt(c, _), _ = c.children[0])) : e.isElement ? _ = Xe("swiper-slide") : _ = Xe("div", e.params.slideClass), _.setAttribute("data-swiper-slide-index", g), C.renderSlide || bt(_, h), C.cache && (e.virtual.cache[g] = _), _;
    }
    function l(h, g, C) {
      const { slidesPerGroup: _, centeredSlides: p, slidesPerView: S, loop: w, initialSlide: I } = e.params;
      if (g && !w && I > 0) return;
      const { addSlidesBefore: L, addSlidesAfter: f, slidesPerViewAutoSlideSize: P } = e.params.virtual, { from: D, to: R, slides: N, slidesGrid: $, offset: V } = e.virtual;
      e.params.cssMode || e.updateActiveIndex();
      const B = typeof C == "undefined" ? e.activeIndex || 0 : C;
      let X;
      e.rtlTranslate ? X = "right" : X = e.isHorizontal() ? "left" : "top";
      let Z;
      if (S === "auto") if (P) {
        let K = e.size;
        K || (K = e.isHorizontal() ? e.el.getBoundingClientRect().width : e.el.getBoundingClientRect().height), Z = Math.max(1, Math.ceil(K / P));
      } else Z = 1;
      else Z = S;
      let F, W;
      p ? (F = Math.floor(Z / 2) + _ + f, W = Math.floor(Z / 2) + _ + L) : (F = Z + (_ - 1) + f, W = (w ? Z : _) + L);
      let Y = B - W, J = B + F;
      w || (Y = Math.max(Y, 0), J = Math.min(J, N.length - 1));
      let oe = (e.slidesGrid[Y] || 0) - (e.slidesGrid[0] || 0);
      w && B >= W ? (Y -= W, p || (oe += e.slidesGrid[0])) : w && B < W && (Y = -W, p && (oe += e.slidesGrid[0])), Object.assign(e.virtual, { from: Y, to: J, offset: oe, slidesGrid: e.slidesGrid, slidesBefore: W, slidesAfter: F });
      function he() {
        e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate");
      }
      if (D === Y && R === J && !h) {
        e.slidesGrid !== $ && oe !== V && e.slides.forEach((K) => {
          K.style[X] = `${oe - Math.abs(e.cssOverflowAdjustment())}px`;
        }), e.updateProgress(), n("virtualUpdate");
        return;
      }
      if (e.params.virtual.renderExternal) {
        e.params.virtual.renderExternal.call(e, { offset: oe, from: Y, to: J, slides: (function() {
          const se = [];
          for (let Se = Y; Se <= J; Se += 1) se.push(N[Se]);
          return se;
        })() }), e.params.virtual.renderExternalUpdate ? he() : n("virtualUpdate");
        return;
      }
      const _e = [], Ee = [], U = (K) => {
        let se = K;
        return K < 0 ? se = N.length + K : se >= N.length && (se = se - N.length), se;
      };
      if (h) e.slides.filter((K) => K.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((K) => {
        K.remove();
      });
      else for (let K = D; K <= R; K += 1) if (K < Y || K > J) {
        const se = U(K);
        e.slides.filter((Se) => Se.matches(`.${e.params.slideClass}[data-swiper-slide-index="${se}"], swiper-slide[data-swiper-slide-index="${se}"]`)).forEach((Se) => {
          Se.remove();
        });
      }
      const Q = w ? -N.length : 0, ee = w ? N.length * 2 : N.length;
      for (let K = Q; K < ee; K += 1) if (K >= Y && K <= J) {
        const se = U(K);
        typeof R == "undefined" || h ? Ee.push(se) : (K > R && Ee.push(se), K < D && _e.push(se));
      }
      if (Ee.forEach((K) => {
        e.slidesEl.append(u(N[K], K));
      }), w) for (let K = _e.length - 1; K >= 0; K -= 1) {
        const se = _e[K];
        e.slidesEl.prepend(u(N[se], se));
      }
      else _e.sort((K, se) => se - K), _e.forEach((K) => {
        e.slidesEl.prepend(u(N[K], K));
      });
      Pe(e.slidesEl, ".swiper-slide, swiper-slide").forEach((K) => {
        K.style[X] = `${oe - Math.abs(e.cssOverflowAdjustment())}px`;
      }), he();
    }
    function m(h) {
      if (typeof h == "object" && "length" in h) for (let g = 0; g < h.length; g += 1) h[g] && e.virtual.slides.push(h[g]);
      else e.virtual.slides.push(h);
      l(true);
    }
    function v(h) {
      const g = e.activeIndex;
      let C = g + 1, _ = 1;
      if (Array.isArray(h)) {
        for (let p = 0; p < h.length; p += 1) h[p] && e.virtual.slides.unshift(h[p]);
        C = g + h.length, _ = h.length;
      } else e.virtual.slides.unshift(h);
      if (e.params.virtual.cache) {
        const p = e.virtual.cache, S = {};
        Object.keys(p).forEach((w) => {
          const I = p[w], L = I.getAttribute("data-swiper-slide-index");
          L && I.setAttribute("data-swiper-slide-index", parseInt(L, 10) + _), S[parseInt(w, 10) + _] = I;
        }), e.virtual.cache = S;
      }
      l(true), e.slideTo(C, 0);
    }
    function y(h) {
      if (typeof h == "undefined" || h === null) return;
      let g = e.activeIndex;
      if (Array.isArray(h)) for (let C = h.length - 1; C >= 0; C -= 1) e.params.virtual.cache && (delete e.virtual.cache[h[C]], Object.keys(e.virtual.cache).forEach((_) => {
        _ > h && (e.virtual.cache[_ - 1] = e.virtual.cache[_], e.virtual.cache[_ - 1].setAttribute("data-swiper-slide-index", _ - 1), delete e.virtual.cache[_]);
      })), e.virtual.slides.splice(h[C], 1), h[C] < g && (g -= 1), g = Math.max(g, 0);
      else e.params.virtual.cache && (delete e.virtual.cache[h], Object.keys(e.virtual.cache).forEach((C) => {
        C > h && (e.virtual.cache[C - 1] = e.virtual.cache[C], e.virtual.cache[C - 1].setAttribute("data-swiper-slide-index", C - 1), delete e.virtual.cache[C]);
      })), e.virtual.slides.splice(h, 1), h < g && (g -= 1), g = Math.max(g, 0);
      l(true), e.slideTo(g, 0);
    }
    function E() {
      e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), l(true), e.slideTo(0, 0);
    }
    i("beforeInit", () => {
      if (!e.params.virtual.enabled) return;
      let h;
      if (typeof e.passedParams.virtual.slides == "undefined") {
        const g = [...e.slidesEl.children].filter((C) => C.matches(`.${e.params.slideClass}, swiper-slide`));
        g && g.length && (e.virtual.slides = [...g], h = true, g.forEach((C, _) => {
          C.setAttribute("data-swiper-slide-index", _), e.virtual.cache[_] = C, C.remove();
        }));
      }
      h || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = true, e.originalParams.watchSlidesProgress = true, l(false, true);
    }), i("setTranslate", () => {
      e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(r), r = setTimeout(() => {
        l();
      }, 100)) : l());
    }), i("init update resize", () => {
      e.params.virtual.enabled && e.params.cssMode && qt(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
    }), Object.assign(e.virtual, { appendSlide: m, prependSlide: v, removeSlide: y, removeAllSlides: E, update: l });
  }
  function Cg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = Le(), o = ye();
    e.keyboard = { enabled: false }, t({ keyboard: { enabled: false, onlyInViewport: true, pageUpDown: true, speed: void 0 } });
    function c(m) {
      if (!e.enabled) return;
      const { rtlTranslate: v } = e;
      let y = m;
      y.originalEvent && (y = y.originalEvent);
      const E = y.keyCode || y.charCode, h = e.params.keyboard.pageUpDown, g = h && E === 33, C = h && E === 34, _ = E === 37, p = E === 39, S = E === 38, w = E === 40;
      if (!e.allowSlideNext && (e.isHorizontal() && p || e.isVertical() && w || C) || !e.allowSlidePrev && (e.isHorizontal() && _ || e.isVertical() && S || g)) return false;
      if (y.shiftKey || y.altKey || y.ctrlKey || y.metaKey || r.activeElement && (r.activeElement.isContentEditable || r.activeElement.nodeName && (r.activeElement.nodeName.toLowerCase() === "input" || r.activeElement.nodeName.toLowerCase() === "textarea"))) return;
      if (e.params.keyboard.onlyInViewport && (g || C || _ || p || S || w)) {
        let L = false;
        if (Qt(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Qt(e.el, `.${e.params.slideActiveClass}`).length === 0) return;
        const f = e.el, P = f.clientWidth, D = f.clientHeight, R = o.innerWidth, N = o.innerHeight, $ = Rn(f);
        v && ($.left -= f.scrollLeft);
        const V = [[$.left, $.top], [$.left + P, $.top], [$.left, $.top + D], [$.left + P, $.top + D]];
        for (let B = 0; B < V.length; B += 1) {
          const X = V[B];
          if (X[0] >= 0 && X[0] <= R && X[1] >= 0 && X[1] <= N) {
            if (X[0] === 0 && X[1] === 0) continue;
            L = true;
          }
        }
        if (!L) return;
      }
      const I = e.params.keyboard.speed;
      e.isHorizontal() ? ((g || C || _ || p) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), ((C || p) && !v || (g || _) && v) && e.slideNext(I), ((g || _) && !v || (C || p) && v) && e.slidePrev(I)) : ((g || C || S || w) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), (C || w) && e.slideNext(I), (g || S) && e.slidePrev(I)), n("keyPress", E);
    }
    function u() {
      e.keyboard.enabled || (r.addEventListener("keydown", c), e.keyboard.enabled = true);
    }
    function l() {
      e.keyboard.enabled && (r.removeEventListener("keydown", c), e.keyboard.enabled = false);
    }
    i("init", () => {
      e.params.keyboard.enabled && u();
    }), i("destroy", () => {
      e.keyboard.enabled && l();
    }), Object.assign(e.keyboard, { enable: u, disable: l });
  }
  function wg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = ye();
    t({ mousewheel: { enabled: false, releaseOnEdges: false, invert: false, forceToAxis: false, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }), e.mousewheel = { enabled: false };
    let o, c = Je(), u;
    const l = [];
    function m(S) {
      let f = 0, P = 0, D = 0, R = 0;
      return "detail" in S && (P = S.detail), "wheelDelta" in S && (P = -S.wheelDelta / 120), "wheelDeltaY" in S && (P = -S.wheelDeltaY / 120), "wheelDeltaX" in S && (f = -S.wheelDeltaX / 120), "axis" in S && S.axis === S.HORIZONTAL_AXIS && (f = P, P = 0), D = f * 10, R = P * 10, "deltaY" in S && (R = S.deltaY), "deltaX" in S && (D = S.deltaX), S.shiftKey && !D && (D = R, R = 0), (D || R) && S.deltaMode && (S.deltaMode === 1 ? (D *= 40, R *= 40) : (D *= 800, R *= 800)), D && !f && (f = D < 1 ? -1 : 1), R && !P && (P = R < 1 ? -1 : 1), { spinX: f, spinY: P, pixelX: D, pixelY: R };
    }
    function v() {
      e.enabled && (e.mouseEntered = true);
    }
    function y() {
      e.enabled && (e.mouseEntered = false);
    }
    function E(S) {
      return e.params.mousewheel.thresholdDelta && S.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && Je() - c < e.params.mousewheel.thresholdTime ? false : S.delta >= 6 && Je() - c < 60 ? true : (S.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", S.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", S.raw)), c = new r.Date().getTime(), false);
    }
    function h(S) {
      const w = e.params.mousewheel;
      if (S.direction < 0) {
        if (e.isEnd && !e.params.loop && w.releaseOnEdges) return true;
      } else if (e.isBeginning && !e.params.loop && w.releaseOnEdges) return true;
      return false;
    }
    function g(S) {
      let w = S, I = true;
      if (!e.enabled || S.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
      const L = e.params.mousewheel;
      e.params.cssMode && w.preventDefault();
      let f = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (f = document.querySelector(e.params.mousewheel.eventsTarget));
      const P = f && f.contains(w.target);
      if (!e.mouseEntered && !P && !L.releaseOnEdges) return true;
      w.originalEvent && (w = w.originalEvent);
      let D = 0;
      const R = e.rtlTranslate ? -1 : 1, N = m(w);
      if (L.forceToAxis) if (e.isHorizontal()) if (Math.abs(N.pixelX) > Math.abs(N.pixelY)) D = -N.pixelX * R;
      else return true;
      else if (Math.abs(N.pixelY) > Math.abs(N.pixelX)) D = -N.pixelY;
      else return true;
      else D = Math.abs(N.pixelX) > Math.abs(N.pixelY) ? -N.pixelX * R : -N.pixelY;
      if (D === 0) return true;
      L.invert && (D = -D);
      let $ = e.getTranslate() + D * L.sensitivity;
      if ($ >= e.minTranslate() && ($ = e.minTranslate()), $ <= e.maxTranslate() && ($ = e.maxTranslate()), I = e.params.loop ? true : !($ === e.minTranslate() || $ === e.maxTranslate()), I && e.params.nested && w.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
        const V = { time: Je(), delta: Math.abs(D), direction: Math.sign(D), raw: S };
        l.length >= 2 && l.shift();
        const B = l.length ? l[l.length - 1] : void 0;
        if (l.push(V), B ? (V.direction !== B.direction || V.delta > B.delta || V.time > B.time + 150) && E(V) : E(V), h(V)) return true;
      } else {
        const V = { time: Je(), delta: Math.abs(D), direction: Math.sign(D) }, B = u && V.time < u.time + 500 && V.delta <= u.delta && V.direction === u.direction;
        if (!B) {
          u = void 0;
          let X = e.getTranslate() + D * L.sensitivity;
          const Z = e.isBeginning, F = e.isEnd;
          if (X >= e.minTranslate() && (X = e.minTranslate()), X <= e.maxTranslate() && (X = e.maxTranslate()), e.setTransition(0), e.setTranslate(X), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!Z && e.isBeginning || !F && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({ direction: V.direction < 0 ? "next" : "prev", byMousewheel: true }), e.params.freeMode.sticky) {
            clearTimeout(o), o = void 0, l.length >= 15 && l.shift();
            const W = l.length ? l[l.length - 1] : void 0, Y = l[0];
            if (l.push(V), W && (V.delta > W.delta || V.direction !== W.direction)) l.splice(0);
            else if (l.length >= 15 && V.time - Y.time < 500 && Y.delta - V.delta >= 1 && V.delta <= 6) {
              const J = D > 0 ? 0.8 : 0.2;
              u = V, l.splice(0), o = Pi(() => {
                e.destroyed || !e.params || e.slideToClosest(e.params.speed, true, void 0, J);
              }, 0);
            }
            o || (o = Pi(() => {
              if (e.destroyed || !e.params) return;
              const J = 0.5;
              u = V, l.splice(0), e.slideToClosest(e.params.speed, true, void 0, J);
            }, 500));
          }
          if (B || n("scroll", w), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), L.releaseOnEdges && (X === e.minTranslate() || X === e.maxTranslate())) return true;
        }
      }
      return w.preventDefault ? w.preventDefault() : w.returnValue = false, false;
    }
    function C(S) {
      let w = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (w = document.querySelector(e.params.mousewheel.eventsTarget)), w[S]("mouseenter", v), w[S]("mouseleave", y), w[S]("wheel", g);
    }
    function _() {
      return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", g), true) : e.mousewheel.enabled ? false : (C("addEventListener"), e.mousewheel.enabled = true, true);
    }
    function p() {
      return e.params.cssMode ? (e.wrapperEl.addEventListener(event, g), true) : e.mousewheel.enabled ? (C("removeEventListener"), e.mousewheel.enabled = false, true) : false;
    }
    i("init", () => {
      !e.params.mousewheel.enabled && e.params.cssMode && p(), e.params.mousewheel.enabled && _();
    }), i("destroy", () => {
      e.params.cssMode && _(), e.mousewheel.enabled && p();
    }), Object.assign(e.mousewheel, { enable: _, disable: p });
  }
  function Lr(e, t, i, n) {
    return e.params.createElements && Object.keys(n).forEach((r) => {
      if (!i[r] && i.auto === true) {
        let o = Pe(e.el, `.${n[r]}`)[0];
        o || (o = Xe("div", n[r]), o.className = n[r], e.el.append(o)), i[r] = o, t[r] = o;
      }
    }), i;
  }
  const ma = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
  function Ag({ swiper: e, extendParams: t, on: i, emit: n }) {
    t({ navigation: { nextEl: null, prevEl: null, addIcons: true, hideOnClick: false, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" } }), e.navigation = { nextEl: null, prevEl: null, arrowSvg: ma };
    function r(h) {
      let g;
      return h && typeof h == "string" && e.isElement && (g = e.el.querySelector(h) || e.hostEl.querySelector(h), g) ? g : (h && (typeof h == "string" && (g = [...document.querySelectorAll(h)]), e.params.uniqueNavElements && typeof h == "string" && g && g.length > 1 && e.el.querySelectorAll(h).length === 1 ? g = e.el.querySelector(h) : g && g.length === 1 && (g = g[0])), h && !g ? h : g);
    }
    function o(h, g) {
      const C = e.params.navigation;
      h = ue(h), h.forEach((_) => {
        _ && (_.classList[g ? "add" : "remove"](...C.disabledClass.split(" ")), _.tagName === "BUTTON" && (_.disabled = g), e.params.watchOverflow && e.enabled && _.classList[e.isLocked ? "add" : "remove"](C.lockClass));
      });
    }
    function c() {
      const { nextEl: h, prevEl: g } = e.navigation;
      if (e.params.loop) {
        o(g, false), o(h, false);
        return;
      }
      o(g, e.isBeginning && !e.params.rewind), o(h, e.isEnd && !e.params.rewind);
    }
    function u(h) {
      h.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
    }
    function l(h) {
      h.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
    }
    function m() {
      const h = e.params.navigation;
      if (e.params.navigation = Lr(e, e.originalParams.navigation, e.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }), !(h.nextEl || h.prevEl)) return;
      let g = r(h.nextEl), C = r(h.prevEl);
      Object.assign(e.navigation, { nextEl: g, prevEl: C }), g = ue(g), C = ue(C);
      const _ = (p, S) => {
        if (p) {
          if (h.addIcons && p.matches(".swiper-button-next,.swiper-button-prev") && !p.querySelector("svg")) {
            const w = document.createElement("div");
            bt(w, ma), p.appendChild(w.querySelector("svg")), w.remove();
          }
          p.addEventListener("click", S === "next" ? l : u);
        }
        !e.enabled && p && p.classList.add(...h.lockClass.split(" "));
      };
      g.forEach((p) => _(p, "next")), C.forEach((p) => _(p, "prev"));
    }
    function v() {
      let { nextEl: h, prevEl: g } = e.navigation;
      h = ue(h), g = ue(g);
      const C = (_, p) => {
        _.removeEventListener("click", p === "next" ? l : u), _.classList.remove(...e.params.navigation.disabledClass.split(" "));
      };
      h.forEach((_) => C(_, "next")), g.forEach((_) => C(_, "prev"));
    }
    i("init", () => {
      e.params.navigation.enabled === false ? E() : (m(), c());
    }), i("toEdge fromEdge lock unlock", () => {
      c();
    }), i("destroy", () => {
      v();
    }), i("enable disable", () => {
      let { nextEl: h, prevEl: g } = e.navigation;
      if (h = ue(h), g = ue(g), e.enabled) {
        c();
        return;
      }
      [...h, ...g].filter((C) => !!C).forEach((C) => C.classList.add(e.params.navigation.lockClass));
    }), i("click", (h, g) => {
      let { nextEl: C, prevEl: _ } = e.navigation;
      C = ue(C), _ = ue(_);
      const p = g.target;
      let S = _.includes(p) || C.includes(p);
      if (e.isElement && !S) {
        const w = g.path || g.composedPath && g.composedPath();
        w && (S = w.find((I) => C.includes(I) || _.includes(I)));
      }
      if (e.params.navigation.hideOnClick && !S) {
        if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === p || e.pagination.el.contains(p))) return;
        let w;
        C.length ? w = C[0].classList.contains(e.params.navigation.hiddenClass) : _.length && (w = _[0].classList.contains(e.params.navigation.hiddenClass)), n(w === true ? "navigationShow" : "navigationHide"), [...C, ..._].filter((I) => !!I).forEach((I) => I.classList.toggle(e.params.navigation.hiddenClass));
      }
    });
    const y = () => {
      e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), m(), c();
    }, E = () => {
      e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), v();
    };
    Object.assign(e.navigation, { enable: y, disable: E, update: c, init: m, destroy: v });
  }
  function Ct(e = "") {
    return `.${e.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1").replace(/ /g, ".")}`;
  }
  function Ig({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = "swiper-pagination";
    t({ pagination: { el: null, bulletElement: "span", clickable: false, hideOnClick: false, renderBullet: null, renderProgressbar: null, renderFraction: null, renderCustom: null, progressbarOpposite: false, type: "bullets", dynamicBullets: false, dynamicMainBullets: 1, formatFractionCurrent: (p) => p, formatFractionTotal: (p) => p, bulletClass: `${r}-bullet`, bulletActiveClass: `${r}-bullet-active`, modifierClass: `${r}-`, currentClass: `${r}-current`, totalClass: `${r}-total`, hiddenClass: `${r}-hidden`, progressbarFillClass: `${r}-progressbar-fill`, progressbarOppositeClass: `${r}-progressbar-opposite`, clickableClass: `${r}-clickable`, lockClass: `${r}-lock`, horizontalClass: `${r}-horizontal`, verticalClass: `${r}-vertical`, paginationDisabledClass: `${r}-disabled` } }), e.pagination = { el: null, bullets: [] };
    let o, c = 0;
    function u() {
      return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
    }
    function l(p, S) {
      const { bulletActiveClass: w } = e.params.pagination;
      p && (p = p[`${S === "prev" ? "previous" : "next"}ElementSibling`], p && (p.classList.add(`${w}-${S}`), p = p[`${S === "prev" ? "previous" : "next"}ElementSibling`], p && p.classList.add(`${w}-${S}-${S}`)));
    }
    function m(p, S, w) {
      if (p = p % w, S = S % w, S === p + 1) return "next";
      if (S === p - 1) return "previous";
    }
    function v(p) {
      const S = p.target.closest(Ct(e.params.pagination.bulletClass));
      if (!S) return;
      p.preventDefault();
      const w = Qi(S) * e.params.slidesPerGroup;
      if (e.params.loop) {
        if (e.realIndex === w) return;
        const I = m(e.realIndex, w, e.slides.length);
        I === "next" ? e.slideNext() : I === "previous" ? e.slidePrev() : e.slideToLoop(w);
      } else e.slideTo(w);
    }
    function y() {
      const p = e.rtl, S = e.params.pagination;
      if (u()) return;
      let w = e.pagination.el;
      w = ue(w);
      let I, L;
      const f = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, P = e.params.loop ? Math.ceil(f / e.params.slidesPerGroup) : e.snapGrid.length;
      if (e.params.loop ? (L = e.previousRealIndex || 0, I = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex != "undefined" ? (I = e.snapIndex, L = e.previousSnapIndex) : (L = e.previousIndex || 0, I = e.activeIndex || 0), S.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
        const D = e.pagination.bullets;
        let R, N, $;
        if (S.dynamicBullets && (o = pr(D[0], e.isHorizontal() ? "width" : "height"), w.forEach((V) => {
          V.style[e.isHorizontal() ? "width" : "height"] = `${o * (S.dynamicMainBullets + 4)}px`;
        }), S.dynamicMainBullets > 1 && L !== void 0 && (c += I - (L || 0), c > S.dynamicMainBullets - 1 ? c = S.dynamicMainBullets - 1 : c < 0 && (c = 0)), R = Math.max(I - c, 0), N = R + (Math.min(D.length, S.dynamicMainBullets) - 1), $ = (N + R) / 2), D.forEach((V) => {
          const B = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((X) => `${S.bulletActiveClass}${X}`)].map((X) => typeof X == "string" && X.includes(" ") ? X.split(" ") : X).flat();
          V.classList.remove(...B);
        }), w.length > 1) D.forEach((V) => {
          const B = Qi(V);
          B === I ? V.classList.add(...S.bulletActiveClass.split(" ")) : e.isElement && V.setAttribute("part", "bullet"), S.dynamicBullets && (B >= R && B <= N && V.classList.add(...`${S.bulletActiveClass}-main`.split(" ")), B === R && l(V, "prev"), B === N && l(V, "next"));
        });
        else {
          const V = D[I];
          if (V && V.classList.add(...S.bulletActiveClass.split(" ")), e.isElement && D.forEach((B, X) => {
            B.setAttribute("part", X === I ? "bullet-active" : "bullet");
          }), S.dynamicBullets) {
            const B = D[R], X = D[N];
            for (let Z = R; Z <= N; Z += 1) D[Z] && D[Z].classList.add(...`${S.bulletActiveClass}-main`.split(" "));
            l(B, "prev"), l(X, "next");
          }
        }
        if (S.dynamicBullets) {
          const V = Math.min(D.length, S.dynamicMainBullets + 4), B = (o * V - o) / 2 - $ * o, X = p ? "right" : "left";
          D.forEach((Z) => {
            Z.style[e.isHorizontal() ? X : "top"] = `${B}px`;
          });
        }
      }
      w.forEach((D, R) => {
        if (S.type === "fraction" && (D.querySelectorAll(Ct(S.currentClass)).forEach((N) => {
          N.textContent = S.formatFractionCurrent(I + 1);
        }), D.querySelectorAll(Ct(S.totalClass)).forEach((N) => {
          N.textContent = S.formatFractionTotal(P);
        })), S.type === "progressbar") {
          let N;
          S.progressbarOpposite ? N = e.isHorizontal() ? "vertical" : "horizontal" : N = e.isHorizontal() ? "horizontal" : "vertical";
          const $ = (I + 1) / P;
          let V = 1, B = 1;
          N === "horizontal" ? V = $ : B = $, D.querySelectorAll(Ct(S.progressbarFillClass)).forEach((X) => {
            X.style.transform = `translate3d(0,0,0) scaleX(${V}) scaleY(${B})`, X.style.transitionDuration = `${e.params.speed}ms`;
          });
        }
        S.type === "custom" && S.renderCustom ? (bt(D, S.renderCustom(e, I + 1, P)), R === 0 && n("paginationRender", D)) : (R === 0 && n("paginationRender", D), n("paginationUpdate", D)), e.params.watchOverflow && e.enabled && D.classList[e.isLocked ? "add" : "remove"](S.lockClass);
      });
    }
    function E() {
      const p = e.params.pagination;
      if (u()) return;
      const S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
      let w = e.pagination.el;
      w = ue(w);
      let I = "";
      if (p.type === "bullets") {
        let L = e.params.loop ? Math.ceil(S / e.params.slidesPerGroup) : e.snapGrid.length;
        e.params.freeMode && e.params.freeMode.enabled && L > S && (L = S);
        for (let f = 0; f < L; f += 1) p.renderBullet ? I += p.renderBullet.call(e, f, p.bulletClass) : I += `<${p.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${p.bulletClass}"></${p.bulletElement}>`;
      }
      p.type === "fraction" && (p.renderFraction ? I = p.renderFraction.call(e, p.currentClass, p.totalClass) : I = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`), p.type === "progressbar" && (p.renderProgressbar ? I = p.renderProgressbar.call(e, p.progressbarFillClass) : I = `<span class="${p.progressbarFillClass}"></span>`), e.pagination.bullets = [], w.forEach((L) => {
        p.type !== "custom" && bt(L, I || ""), p.type === "bullets" && e.pagination.bullets.push(...L.querySelectorAll(Ct(p.bulletClass)));
      }), p.type !== "custom" && n("paginationRender", w[0]);
    }
    function h() {
      e.params.pagination = Lr(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
      const p = e.params.pagination;
      if (!p.el) return;
      let S;
      typeof p.el == "string" && e.isElement && (S = e.el.querySelector(p.el)), !S && typeof p.el == "string" && (S = [...document.querySelectorAll(p.el)]), S || (S = p.el), !(!S || S.length === 0) && (e.params.uniqueNavElements && typeof p.el == "string" && Array.isArray(S) && S.length > 1 && (S = [...e.el.querySelectorAll(p.el)], S.length > 1 && (S = S.find((w) => Qt(w, ".swiper")[0] === e.el))), Array.isArray(S) && S.length === 1 && (S = S[0]), Object.assign(e.pagination, { el: S }), S = ue(S), S.forEach((w) => {
        p.type === "bullets" && p.clickable && w.classList.add(...(p.clickableClass || "").split(" ")), w.classList.add(p.modifierClass + p.type), w.classList.add(e.isHorizontal() ? p.horizontalClass : p.verticalClass), p.type === "bullets" && p.dynamicBullets && (w.classList.add(`${p.modifierClass}${p.type}-dynamic`), c = 0, p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)), p.type === "progressbar" && p.progressbarOpposite && w.classList.add(p.progressbarOppositeClass), p.clickable && w.addEventListener("click", v), e.enabled || w.classList.add(p.lockClass);
      }));
    }
    function g() {
      const p = e.params.pagination;
      if (u()) return;
      let S = e.pagination.el;
      S && (S = ue(S), S.forEach((w) => {
        w.classList.remove(p.hiddenClass), w.classList.remove(p.modifierClass + p.type), w.classList.remove(e.isHorizontal() ? p.horizontalClass : p.verticalClass), p.clickable && (w.classList.remove(...(p.clickableClass || "").split(" ")), w.removeEventListener("click", v));
      })), e.pagination.bullets && e.pagination.bullets.forEach((w) => w.classList.remove(...p.bulletActiveClass.split(" ")));
    }
    i("changeDirection", () => {
      if (!e.pagination || !e.pagination.el) return;
      const p = e.params.pagination;
      let { el: S } = e.pagination;
      S = ue(S), S.forEach((w) => {
        w.classList.remove(p.horizontalClass, p.verticalClass), w.classList.add(e.isHorizontal() ? p.horizontalClass : p.verticalClass);
      });
    }), i("init", () => {
      e.params.pagination.enabled === false ? _() : (h(), E(), y());
    }), i("activeIndexChange", () => {
      typeof e.snapIndex == "undefined" && y();
    }), i("snapIndexChange", () => {
      y();
    }), i("snapGridLengthChange", () => {
      E(), y();
    }), i("destroy", () => {
      g();
    }), i("enable disable", () => {
      let { el: p } = e.pagination;
      p && (p = ue(p), p.forEach((S) => S.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
    }), i("lock unlock", () => {
      y();
    }), i("click", (p, S) => {
      const w = S.target, I = ue(e.pagination.el);
      if (e.params.pagination.el && e.params.pagination.hideOnClick && I && I.length > 0 && !w.classList.contains(e.params.pagination.bulletClass)) {
        if (e.navigation && (e.navigation.nextEl && w === e.navigation.nextEl || e.navigation.prevEl && w === e.navigation.prevEl)) return;
        const L = I[0].classList.contains(e.params.pagination.hiddenClass);
        n(L === true ? "paginationShow" : "paginationHide"), I.forEach((f) => f.classList.toggle(e.params.pagination.hiddenClass));
      }
    });
    const C = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let { el: p } = e.pagination;
      p && (p = ue(p), p.forEach((S) => S.classList.remove(e.params.pagination.paginationDisabledClass))), h(), E(), y();
    }, _ = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let { el: p } = e.pagination;
      p && (p = ue(p), p.forEach((S) => S.classList.add(e.params.pagination.paginationDisabledClass))), g();
    };
    Object.assign(e.pagination, { enable: C, disable: _, render: E, update: y, init: h, destroy: g });
  }
  function Og({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = Le();
    let o = false, c = null, u = null, l, m, v, y;
    t({ scrollbar: { el: null, dragSize: "auto", hide: false, draggable: false, snapOnRelease: true, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag", scrollbarDisabledClass: "swiper-scrollbar-disabled", horizontalClass: "swiper-scrollbar-horizontal", verticalClass: "swiper-scrollbar-vertical" } }), e.scrollbar = { el: null, dragEl: null };
    function E() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      const { scrollbar: $, rtlTranslate: V } = e, { dragEl: B, el: X } = $, Z = e.params.scrollbar, F = e.params.loop ? e.progressLoop : e.progress;
      let W = m, Y = (v - m) * F;
      V ? (Y = -Y, Y > 0 ? (W = m - Y, Y = 0) : -Y + m > v && (W = v + Y)) : Y < 0 ? (W = m + Y, Y = 0) : Y + m > v && (W = v - Y), e.isHorizontal() ? (B.style.transform = `translate3d(${Y}px, 0, 0)`, B.style.width = `${W}px`) : (B.style.transform = `translate3d(0px, ${Y}px, 0)`, B.style.height = `${W}px`), Z.hide && (clearTimeout(c), X.style.opacity = 1, c = setTimeout(() => {
        X.style.opacity = 0, X.style.transitionDuration = "400ms";
      }, 1e3));
    }
    function h($) {
      !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${$}ms`);
    }
    function g() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      const { scrollbar: $ } = e, { dragEl: V, el: B } = $;
      V.style.width = "", V.style.height = "", v = e.isHorizontal() ? B.offsetWidth : B.offsetHeight, y = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? m = v * y : m = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? V.style.width = `${m}px` : V.style.height = `${m}px`, y >= 1 ? B.style.display = "none" : B.style.display = "", e.params.scrollbar.hide && (B.style.opacity = 0), e.params.watchOverflow && e.enabled && $.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
    }
    function C($) {
      return e.isHorizontal() ? $.clientX : $.clientY;
    }
    function _($) {
      const { scrollbar: V, rtlTranslate: B } = e, { el: X } = V;
      let Z;
      Z = (C($) - Rn(X)[e.isHorizontal() ? "left" : "top"] - (l !== null ? l : m / 2)) / (v - m), Z = Math.max(Math.min(Z, 1), 0), B && (Z = 1 - Z);
      const F = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * Z;
      e.updateProgress(F), e.setTranslate(F), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    function p($) {
      const V = e.params.scrollbar, { scrollbar: B, wrapperEl: X } = e, { el: Z, dragEl: F } = B;
      o = true, l = $.target === F ? C($) - $.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, $.preventDefault(), $.stopPropagation(), X.style.transitionDuration = "100ms", F.style.transitionDuration = "100ms", _($), clearTimeout(u), Z.style.transitionDuration = "0ms", V.hide && (Z.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", $);
    }
    function S($) {
      const { scrollbar: V, wrapperEl: B } = e, { el: X, dragEl: Z } = V;
      o && ($.preventDefault && $.cancelable ? $.preventDefault() : $.returnValue = false, _($), B.style.transitionDuration = "0ms", X.style.transitionDuration = "0ms", Z.style.transitionDuration = "0ms", n("scrollbarDragMove", $));
    }
    function w($) {
      const V = e.params.scrollbar, { scrollbar: B, wrapperEl: X } = e, { el: Z } = B;
      o && (o = false, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", X.style.transitionDuration = ""), V.hide && (clearTimeout(u), u = Pi(() => {
        Z.style.opacity = 0, Z.style.transitionDuration = "400ms";
      }, 1e3)), n("scrollbarDragEnd", $), V.snapOnRelease && e.slideToClosest());
    }
    function I($) {
      const { scrollbar: V, params: B } = e, X = V.el;
      if (!X) return;
      const Z = X, F = B.passiveListeners ? { passive: false, capture: false } : false, W = B.passiveListeners ? { passive: true, capture: false } : false;
      if (!Z) return;
      const Y = $ === "on" ? "addEventListener" : "removeEventListener";
      Z[Y]("pointerdown", p, F), r[Y]("pointermove", S, F), r[Y]("pointerup", w, W);
    }
    function L() {
      !e.params.scrollbar.el || !e.scrollbar.el || I("on");
    }
    function f() {
      !e.params.scrollbar.el || !e.scrollbar.el || I("off");
    }
    function P() {
      const { scrollbar: $, el: V } = e;
      e.params.scrollbar = Lr(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
      const B = e.params.scrollbar;
      if (!B.el) return;
      let X;
      if (typeof B.el == "string" && e.isElement && (X = e.el.querySelector(B.el)), !X && typeof B.el == "string") {
        if (X = r.querySelectorAll(B.el), !X.length) return;
      } else X || (X = B.el);
      e.params.uniqueNavElements && typeof B.el == "string" && X.length > 1 && V.querySelectorAll(B.el).length === 1 && (X = V.querySelector(B.el)), X.length > 0 && (X = X[0]), X.classList.add(e.isHorizontal() ? B.horizontalClass : B.verticalClass);
      let Z;
      X && (Z = X.querySelector(Ct(e.params.scrollbar.dragClass)), Z || (Z = Xe("div", e.params.scrollbar.dragClass), X.append(Z))), Object.assign($, { el: X, dragEl: Z }), B.draggable && L(), X && X.classList[e.enabled ? "remove" : "add"](...kt(e.params.scrollbar.lockClass));
    }
    function D() {
      const $ = e.params.scrollbar, V = e.scrollbar.el;
      V && V.classList.remove(...kt(e.isHorizontal() ? $.horizontalClass : $.verticalClass)), f();
    }
    i("changeDirection", () => {
      if (!e.scrollbar || !e.scrollbar.el) return;
      const $ = e.params.scrollbar;
      let { el: V } = e.scrollbar;
      V = ue(V), V.forEach((B) => {
        B.classList.remove($.horizontalClass, $.verticalClass), B.classList.add(e.isHorizontal() ? $.horizontalClass : $.verticalClass);
      });
    }), i("init", () => {
      e.params.scrollbar.enabled === false ? N() : (P(), g(), E());
    }), i("update resize observerUpdate lock unlock changeDirection", () => {
      g();
    }), i("setTranslate", () => {
      E();
    }), i("setTransition", ($, V) => {
      h(V);
    }), i("enable disable", () => {
      const { el: $ } = e.scrollbar;
      $ && $.classList[e.enabled ? "remove" : "add"](...kt(e.params.scrollbar.lockClass));
    }), i("destroy", () => {
      D();
    });
    const R = () => {
      e.el.classList.remove(...kt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...kt(e.params.scrollbar.scrollbarDisabledClass)), P(), g(), E();
    }, N = () => {
      e.el.classList.add(...kt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...kt(e.params.scrollbar.scrollbarDisabledClass)), D();
    };
    Object.assign(e.scrollbar, { enable: R, disable: N, updateSize: g, setTranslate: E, init: P, destroy: D });
  }
  function Mg({ swiper: e, extendParams: t, on: i }) {
    t({ parallax: { enabled: false } });
    const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", r = (u, l) => {
      const { rtl: m } = e, v = m ? -1 : 1, y = u.getAttribute("data-swiper-parallax") || "0";
      let E = u.getAttribute("data-swiper-parallax-x"), h = u.getAttribute("data-swiper-parallax-y");
      const g = u.getAttribute("data-swiper-parallax-scale"), C = u.getAttribute("data-swiper-parallax-opacity"), _ = u.getAttribute("data-swiper-parallax-rotate");
      if (E || h ? (E = E || "0", h = h || "0") : e.isHorizontal() ? (E = y, h = "0") : (h = y, E = "0"), E.indexOf("%") >= 0 ? E = `${parseInt(E, 10) * l * v}%` : E = `${E * l * v}px`, h.indexOf("%") >= 0 ? h = `${parseInt(h, 10) * l}%` : h = `${h * l}px`, typeof C != "undefined" && C !== null) {
        const S = C - (C - 1) * (1 - Math.abs(l));
        u.style.opacity = S;
      }
      let p = `translate3d(${E}, ${h}, 0px)`;
      if (typeof g != "undefined" && g !== null) {
        const S = g - (g - 1) * (1 - Math.abs(l));
        p += ` scale(${S})`;
      }
      if (_ && typeof _ != "undefined" && _ !== null) {
        const S = _ * l * -1;
        p += ` rotate(${S}deg)`;
      }
      u.style.transform = p;
    }, o = () => {
      const { el: u, slides: l, progress: m, snapGrid: v, isElement: y } = e, E = Pe(u, n);
      e.isElement && E.push(...Pe(e.hostEl, n)), E.forEach((h) => {
        r(h, m);
      }), l.forEach((h, g) => {
        let C = h.progress;
        e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (C += Math.ceil(g / 2) - m * (v.length - 1)), C = Math.min(Math.max(C, -1), 1), h.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((_) => {
          r(_, C);
        });
      });
    }, c = (u = e.params.speed) => {
      const { el: l, hostEl: m } = e, v = [...l.querySelectorAll(n)];
      e.isElement && v.push(...m.querySelectorAll(n)), v.forEach((y) => {
        let E = parseInt(y.getAttribute("data-swiper-parallax-duration"), 10) || u;
        u === 0 && (E = 0), y.style.transitionDuration = `${E}ms`;
      });
    };
    i("beforeInit", () => {
      e.params.parallax.enabled && (e.params.watchSlidesProgress = true, e.originalParams.watchSlidesProgress = true);
    }), i("init", () => {
      e.params.parallax.enabled && o();
    }), i("setTranslate", () => {
      e.params.parallax.enabled && o();
    }), i("setTransition", (u, l) => {
      e.params.parallax.enabled && c(l);
    });
  }
  function Lg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = ye();
    t({ zoom: { enabled: false, limitToOriginalSize: false, maxRatio: 3, minRatio: 1, panOnMouseMove: false, toggle: true, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), e.zoom = { enabled: false };
    let o = 1, c = false, u = false, l = { x: 0, y: 0 };
    const m = -3;
    let v, y;
    const E = [], h = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 }, g = { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, C = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
    let _ = 1;
    Object.defineProperty(e.zoom, "scale", { get() {
      return _;
    }, set(U) {
      if (_ !== U) {
        const Q = h.imageEl, ee = h.slideEl;
        n("zoomChange", U, Q, ee);
      }
      _ = U;
    } });
    function p() {
      if (E.length < 2) return 1;
      const U = E[0].pageX, Q = E[0].pageY, ee = E[1].pageX, K = E[1].pageY;
      return Math.sqrt(Me(ee - U, 2) + Me(K - Q, 2));
    }
    function S() {
      const U = e.params.zoom, Q = h.imageWrapEl.getAttribute("data-swiper-zoom") || U.maxRatio;
      if (U.limitToOriginalSize && h.imageEl && h.imageEl.naturalWidth) {
        const ee = h.imageEl.naturalWidth / h.imageEl.offsetWidth;
        return Math.min(ee, Q);
      }
      return Q;
    }
    function w() {
      if (E.length < 2) return { x: null, y: null };
      const U = h.imageEl.getBoundingClientRect();
      return [(E[0].pageX + (E[1].pageX - E[0].pageX) / 2 - U.x - r.scrollX) / o, (E[0].pageY + (E[1].pageY - E[0].pageY) / 2 - U.y - r.scrollY) / o];
    }
    function I() {
      return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
    }
    function L(U) {
      const Q = I();
      return !!(U.target.matches(Q) || e.slides.filter((ee) => ee.contains(U.target)).length > 0);
    }
    function f(U) {
      const Q = `.${e.params.zoom.containerClass}`;
      return !!(U.target.matches(Q) || [...e.hostEl.querySelectorAll(Q)].filter((ee) => ee.contains(U.target)).length > 0);
    }
    function P(U) {
      if (U.pointerType === "mouse" && E.splice(0, E.length), !L(U)) return;
      const Q = e.params.zoom;
      if (v = false, y = false, E.push(U), !(E.length < 2)) {
        if (v = true, h.scaleStart = p(), !h.slideEl) {
          h.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`), h.slideEl || (h.slideEl = e.slides[e.activeIndex]);
          let ee = h.slideEl.querySelector(`.${Q.containerClass}`);
          if (ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h.imageEl = ee, ee ? h.imageWrapEl = Qt(h.imageEl, `.${Q.containerClass}`)[0] : h.imageWrapEl = void 0, !h.imageWrapEl) {
            h.imageEl = void 0;
            return;
          }
          h.maxRatio = S();
        }
        if (h.imageEl) {
          const [ee, K] = w();
          h.originX = ee, h.originY = K, h.imageEl.style.transitionDuration = "0ms";
        }
        c = true;
      }
    }
    function D(U) {
      if (!L(U)) return;
      const Q = e.params.zoom, ee = e.zoom, K = E.findIndex((se) => se.pointerId === U.pointerId);
      K >= 0 && (E[K] = U), !(E.length < 2) && (y = true, h.scaleMove = p(), h.imageEl && (ee.scale = h.scaleMove / h.scaleStart * o, ee.scale > h.maxRatio && (ee.scale = h.maxRatio - 1 + Me(ee.scale - h.maxRatio + 1, 0.5)), ee.scale < Q.minRatio && (ee.scale = Q.minRatio + 1 - Me(Q.minRatio - ee.scale + 1, 0.5)), h.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`));
    }
    function R(U) {
      if (!L(U) || U.pointerType === "mouse" && U.type === "pointerout") return;
      const Q = e.params.zoom, ee = e.zoom, K = E.findIndex((se) => se.pointerId === U.pointerId);
      K >= 0 && E.splice(K, 1), !(!v || !y) && (v = false, y = false, h.imageEl && (ee.scale = Math.max(Math.min(ee.scale, h.maxRatio), Q.minRatio), h.imageEl.style.transitionDuration = `${e.params.speed}ms`, h.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`, o = ee.scale, c = false, ee.scale > 1 && h.slideEl ? h.slideEl.classList.add(`${Q.zoomedSlideClass}`) : ee.scale <= 1 && h.slideEl && h.slideEl.classList.remove(`${Q.zoomedSlideClass}`), ee.scale === 1 && (h.originX = 0, h.originY = 0, h.slideEl = void 0)));
    }
    let N;
    function $() {
      e.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function V() {
      clearTimeout(N), e.touchEventsData.preventTouchMoveFromPointerMove = true, N = setTimeout(() => {
        e.destroyed || $();
      });
    }
    function B(U) {
      const Q = e.device;
      if (!h.imageEl || g.isTouched) return;
      Q.android && U.cancelable && U.preventDefault(), g.isTouched = true;
      const ee = E.length > 0 ? E[0] : U;
      g.touchesStart.x = ee.pageX, g.touchesStart.y = ee.pageY;
    }
    function X(U) {
      const ee = U.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
      if (!L(U) || !f(U)) return;
      const K = e.zoom;
      if (!h.imageEl) return;
      if (!g.isTouched || !h.slideEl) {
        ee && W(U);
        return;
      }
      if (ee) {
        W(U);
        return;
      }
      g.isMoved || (g.width = h.imageEl.offsetWidth || h.imageEl.clientWidth, g.height = h.imageEl.offsetHeight || h.imageEl.clientHeight, g.startX = hr(h.imageWrapEl, "x") || 0, g.startY = hr(h.imageWrapEl, "y") || 0, h.slideWidth = h.slideEl.offsetWidth, h.slideHeight = h.slideEl.offsetHeight, h.imageWrapEl.style.transitionDuration = "0ms");
      const se = g.width * K.scale, Se = g.height * K.scale;
      if (g.minX = Math.min(h.slideWidth / 2 - se / 2, 0), g.maxX = -g.minX, g.minY = Math.min(h.slideHeight / 2 - Se / 2, 0), g.maxY = -g.minY, g.touchesCurrent.x = E.length > 0 ? E[0].pageX : U.pageX, g.touchesCurrent.y = E.length > 0 ? E[0].pageY : U.pageY, Math.max(Math.abs(g.touchesCurrent.x - g.touchesStart.x), Math.abs(g.touchesCurrent.y - g.touchesStart.y)) > 5 && (e.allowClick = false), !g.isMoved && !c) {
        if (e.isHorizontal() && (Math.floor(g.minX) === Math.floor(g.startX) && g.touchesCurrent.x < g.touchesStart.x || Math.floor(g.maxX) === Math.floor(g.startX) && g.touchesCurrent.x > g.touchesStart.x)) {
          g.isTouched = false, $();
          return;
        }
        if (!e.isHorizontal() && (Math.floor(g.minY) === Math.floor(g.startY) && g.touchesCurrent.y < g.touchesStart.y || Math.floor(g.maxY) === Math.floor(g.startY) && g.touchesCurrent.y > g.touchesStart.y)) {
          g.isTouched = false, $();
          return;
        }
      }
      U.cancelable && U.preventDefault(), U.stopPropagation(), V(), g.isMoved = true;
      const Ce = (K.scale - o) / (h.maxRatio - e.params.zoom.minRatio), { originX: Ze, originY: ge } = h;
      g.currentX = g.touchesCurrent.x - g.touchesStart.x + g.startX + Ce * (g.width - Ze * 2), g.currentY = g.touchesCurrent.y - g.touchesStart.y + g.startY + Ce * (g.height - ge * 2), g.currentX < g.minX && (g.currentX = g.minX + 1 - Me(g.minX - g.currentX + 1, 0.8)), g.currentX > g.maxX && (g.currentX = g.maxX - 1 + Me(g.currentX - g.maxX + 1, 0.8)), g.currentY < g.minY && (g.currentY = g.minY + 1 - Me(g.minY - g.currentY + 1, 0.8)), g.currentY > g.maxY && (g.currentY = g.maxY - 1 + Me(g.currentY - g.maxY + 1, 0.8)), C.prevPositionX || (C.prevPositionX = g.touchesCurrent.x), C.prevPositionY || (C.prevPositionY = g.touchesCurrent.y), C.prevTime || (C.prevTime = Date.now()), C.x = (g.touchesCurrent.x - C.prevPositionX) / (Date.now() - C.prevTime) / 2, C.y = (g.touchesCurrent.y - C.prevPositionY) / (Date.now() - C.prevTime) / 2, Math.abs(g.touchesCurrent.x - C.prevPositionX) < 2 && (C.x = 0), Math.abs(g.touchesCurrent.y - C.prevPositionY) < 2 && (C.y = 0), C.prevPositionX = g.touchesCurrent.x, C.prevPositionY = g.touchesCurrent.y, C.prevTime = Date.now(), h.imageWrapEl.style.transform = `translate3d(${g.currentX}px, ${g.currentY}px,0)`;
    }
    function Z() {
      const U = e.zoom;
      if (E.length = 0, !h.imageEl) return;
      if (!g.isTouched || !g.isMoved) {
        g.isTouched = false, g.isMoved = false;
        return;
      }
      g.isTouched = false, g.isMoved = false;
      let Q = 300, ee = 300;
      const K = C.x * Q, se = g.currentX + K, Se = C.y * ee, Ge = g.currentY + Se;
      C.x !== 0 && (Q = Math.abs((se - g.currentX) / C.x)), C.y !== 0 && (ee = Math.abs((Ge - g.currentY) / C.y));
      const Ce = Math.max(Q, ee);
      g.currentX = se, g.currentY = Ge;
      const Ze = g.width * U.scale, ge = g.height * U.scale;
      g.minX = Math.min(h.slideWidth / 2 - Ze / 2, 0), g.maxX = -g.minX, g.minY = Math.min(h.slideHeight / 2 - ge / 2, 0), g.maxY = -g.minY, g.currentX = Math.max(Math.min(g.currentX, g.maxX), g.minX), g.currentY = Math.max(Math.min(g.currentY, g.maxY), g.minY), h.imageWrapEl.style.transitionDuration = `${Ce}ms`, h.imageWrapEl.style.transform = `translate3d(${g.currentX}px, ${g.currentY}px,0)`;
    }
    function F() {
      const U = e.zoom;
      h.slideEl && e.activeIndex !== e.slides.indexOf(h.slideEl) && (h.imageEl && (h.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), h.imageWrapEl && (h.imageWrapEl.style.transform = "translate3d(0,0,0)"), h.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), U.scale = 1, o = 1, h.slideEl = void 0, h.imageEl = void 0, h.imageWrapEl = void 0, h.originX = 0, h.originY = 0);
    }
    function W(U) {
      if (o <= 1 || !h.imageWrapEl || !L(U) || !f(U)) return;
      const Q = r.getComputedStyle(h.imageWrapEl).transform, ee = new r.DOMMatrix(Q);
      if (!u) {
        u = true, l.x = U.clientX, l.y = U.clientY, g.startX = ee.e, g.startY = ee.f, g.width = h.imageEl.offsetWidth || h.imageEl.clientWidth, g.height = h.imageEl.offsetHeight || h.imageEl.clientHeight, h.slideWidth = h.slideEl.offsetWidth, h.slideHeight = h.slideEl.offsetHeight;
        return;
      }
      const K = (U.clientX - l.x) * m, se = (U.clientY - l.y) * m, Se = g.width * o, Ge = g.height * o, Ce = h.slideWidth, Ze = h.slideHeight, ge = Math.min(Ce / 2 - Se / 2, 0), be = -ge, Oe = Math.min(Ze / 2 - Ge / 2, 0), Et = -Oe, st = Math.max(Math.min(g.startX + K, be), ge), dt = Math.max(Math.min(g.startY + se, Et), Oe);
      h.imageWrapEl.style.transitionDuration = "0ms", h.imageWrapEl.style.transform = `translate3d(${st}px, ${dt}px, 0)`, l.x = U.clientX, l.y = U.clientY, g.startX = st, g.startY = dt, g.currentX = st, g.currentY = dt;
    }
    function Y(U) {
      const Q = e.zoom, ee = e.params.zoom;
      if (!h.slideEl) {
        U && U.target && (h.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`)), h.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? h.slideEl = Pe(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : h.slideEl = e.slides[e.activeIndex]);
        let ht = h.slideEl.querySelector(`.${ee.containerClass}`);
        ht && (ht = ht.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h.imageEl = ht, ht ? h.imageWrapEl = Qt(h.imageEl, `.${ee.containerClass}`)[0] : h.imageWrapEl = void 0;
      }
      if (!h.imageEl || !h.imageWrapEl) return;
      h.maxRatio = S(), e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), h.slideEl.classList.add(`${ee.zoomedSlideClass}`);
      let K, se, Se, Ge, Ce, Ze, ge, be, Oe, Et, st, dt, Lt, De, ft, je, rt, Te;
      typeof g.touchesStart.x == "undefined" && U ? (K = U.pageX, se = U.pageY) : (K = g.touchesStart.x, se = g.touchesStart.y);
      const St = o, we = typeof U == "number" ? U : null;
      o === 1 && we && (K = void 0, se = void 0, g.touchesStart.x = void 0, g.touchesStart.y = void 0);
      const $e = S();
      Q.scale = we || $e, o = we || $e, U && !(o === 1 && we) ? (rt = h.slideEl.offsetWidth, Te = h.slideEl.offsetHeight, Se = Rn(h.slideEl).left + r.scrollX, Ge = Rn(h.slideEl).top + r.scrollY, Ce = Se + rt / 2 - K, Ze = Ge + Te / 2 - se, Oe = h.imageEl.offsetWidth || h.imageEl.clientWidth, Et = h.imageEl.offsetHeight || h.imageEl.clientHeight, st = Oe * Q.scale, dt = Et * Q.scale, Lt = Math.min(rt / 2 - st / 2, 0), De = Math.min(Te / 2 - dt / 2, 0), ft = -Lt, je = -De, St > 0 && we && typeof g.currentX == "number" && typeof g.currentY == "number" ? (ge = g.currentX * Q.scale / St, be = g.currentY * Q.scale / St) : (ge = Ce * Q.scale, be = Ze * Q.scale), ge < Lt && (ge = Lt), ge > ft && (ge = ft), be < De && (be = De), be > je && (be = je)) : (ge = 0, be = 0), we && Q.scale === 1 && (h.originX = 0, h.originY = 0), g.currentX = ge, g.currentY = be, h.imageWrapEl.style.transitionDuration = "300ms", h.imageWrapEl.style.transform = `translate3d(${ge}px, ${be}px,0)`, h.imageEl.style.transitionDuration = "300ms", h.imageEl.style.transform = `translate3d(0,0,0) scale(${Q.scale})`;
    }
    function J() {
      const U = e.zoom, Q = e.params.zoom;
      if (!h.slideEl) {
        e.params.virtual && e.params.virtual.enabled && e.virtual ? h.slideEl = Pe(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : h.slideEl = e.slides[e.activeIndex];
        let ee = h.slideEl.querySelector(`.${Q.containerClass}`);
        ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h.imageEl = ee, ee ? h.imageWrapEl = Qt(h.imageEl, `.${Q.containerClass}`)[0] : h.imageWrapEl = void 0;
      }
      !h.imageEl || !h.imageWrapEl || (h.maxRatio = S(), e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), U.scale = 1, o = 1, g.currentX = void 0, g.currentY = void 0, g.touchesStart.x = void 0, g.touchesStart.y = void 0, h.imageWrapEl.style.transitionDuration = "300ms", h.imageWrapEl.style.transform = "translate3d(0,0,0)", h.imageEl.style.transitionDuration = "300ms", h.imageEl.style.transform = "translate3d(0,0,0) scale(1)", h.slideEl.classList.remove(`${Q.zoomedSlideClass}`), h.slideEl = void 0, h.originX = 0, h.originY = 0, e.params.zoom.panOnMouseMove && (l = { x: 0, y: 0 }, u && (u = false, g.startX = 0, g.startY = 0)));
    }
    function oe(U) {
      const Q = e.zoom;
      Q.scale && Q.scale !== 1 ? J() : Y(U);
    }
    function he() {
      const U = e.params.passiveListeners ? { passive: true, capture: false } : false, Q = e.params.passiveListeners ? { passive: false, capture: true } : true;
      return { passiveListener: U, activeListenerWithCapture: Q };
    }
    function _e() {
      const U = e.zoom;
      if (U.enabled) return;
      U.enabled = true;
      const { passiveListener: Q, activeListenerWithCapture: ee } = he();
      e.wrapperEl.addEventListener("pointerdown", P, Q), e.wrapperEl.addEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        e.wrapperEl.addEventListener(K, R, Q);
      }), e.wrapperEl.addEventListener("pointermove", X, ee);
    }
    function Ee() {
      const U = e.zoom;
      if (!U.enabled) return;
      U.enabled = false;
      const { passiveListener: Q, activeListenerWithCapture: ee } = he();
      e.wrapperEl.removeEventListener("pointerdown", P, Q), e.wrapperEl.removeEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        e.wrapperEl.removeEventListener(K, R, Q);
      }), e.wrapperEl.removeEventListener("pointermove", X, ee);
    }
    i("init", () => {
      e.params.zoom.enabled && _e();
    }), i("destroy", () => {
      Ee();
    }), i("touchStart", (U, Q) => {
      e.zoom.enabled && B(Q);
    }), i("touchEnd", (U, Q) => {
      e.zoom.enabled && Z();
    }), i("doubleTap", (U, Q) => {
      !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && oe(Q);
    }), i("transitionEnd", () => {
      e.zoom.enabled && e.params.zoom.enabled && F();
    }), i("slideChange", () => {
      e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && F();
    }), Object.assign(e.zoom, { enable: _e, disable: Ee, in: Y, out: J, toggle: oe });
  }
  function Pg({ swiper: e, extendParams: t, on: i }) {
    t({ controller: { control: void 0, inverse: false, by: "slide" } }), e.controller = { control: void 0 };
    function n(l, m) {
      const v = /* @__PURE__ */ (function() {
        let g, C, _;
        return (p, S) => {
          for (C = -1, g = p.length; g - C > 1; ) _ = g + C >> 1, p[_] <= S ? C = _ : g = _;
          return g;
        };
      })();
      this.x = l, this.y = m, this.lastIndex = l.length - 1;
      let y, E;
      return this.interpolate = function(g) {
        return g ? (E = v(this.x, g), y = E - 1, (g - this.x[y]) * (this.y[E] - this.y[y]) / (this.x[E] - this.x[y]) + this.y[y]) : 0;
      }, this;
    }
    function r(l) {
      e.controller.spline = e.params.loop ? new n(e.slidesGrid, l.slidesGrid) : new n(e.snapGrid, l.snapGrid);
    }
    function o(l, m) {
      const v = e.controller.control;
      let y, E;
      const h = e.constructor;
      function g(C) {
        if (C.destroyed) return;
        const _ = e.rtlTranslate ? -e.translate : e.translate;
        e.params.controller.by === "slide" && (r(C), E = -e.controller.spline.interpolate(-_)), (!E || e.params.controller.by === "container") && (y = (C.maxTranslate() - C.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(y) || !Number.isFinite(y)) && (y = 1), E = (_ - e.minTranslate()) * y + C.minTranslate()), e.params.controller.inverse && (E = C.maxTranslate() - E), C.updateProgress(E), C.setTranslate(E, e), C.updateActiveIndex(), C.updateSlidesClasses();
      }
      if (Array.isArray(v)) for (let C = 0; C < v.length; C += 1) v[C] !== m && v[C] instanceof h && g(v[C]);
      else v instanceof h && m !== v && g(v);
    }
    function c(l, m) {
      const v = e.constructor, y = e.controller.control;
      let E;
      function h(g) {
        g.destroyed || (g.setTransition(l, e), l !== 0 && (g.transitionStart(), g.params.autoHeight && Pi(() => {
          g.updateAutoHeight();
        }), Zi(g.wrapperEl, () => {
          y && g.transitionEnd();
        })));
      }
      if (Array.isArray(y)) for (E = 0; E < y.length; E += 1) y[E] !== m && y[E] instanceof v && h(y[E]);
      else y instanceof v && m !== y && h(y);
    }
    function u() {
      e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
    }
    i("beforeInit", () => {
      if (typeof window != "undefined" && (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
        (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((m) => {
          if (e.controller.control || (e.controller.control = []), m && m.swiper) e.controller.control.push(m.swiper);
          else if (m) {
            const v = `${e.params.eventsPrefix}init`, y = (E) => {
              e.controller.control.push(E.detail[0]), e.update(), m.removeEventListener(v, y);
            };
            m.addEventListener(v, y);
          }
        });
        return;
      }
      e.controller.control = e.params.controller.control;
    }), i("update", () => {
      u();
    }), i("resize", () => {
      u();
    }), i("observerUpdate", () => {
      u();
    }), i("setTranslate", (l, m, v) => {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(m, v);
    }), i("setTransition", (l, m, v) => {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(m, v);
    }), Object.assign(e.controller, { setTranslate: o, setTransition: c });
  }
  function Dg({ swiper: e, extendParams: t, on: i }) {
    t({ a11y: { enabled: true, notificationClass: "swiper-notification", prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", slideLabelMessage: "{{index}} / {{slidesLength}}", containerMessage: null, containerRoleDescriptionMessage: null, containerRole: null, itemRoleDescriptionMessage: null, slideRole: "group", id: null, scrollOnFocus: true, wrapperLiveRegion: true } }), e.a11y = { clicked: false };
    let n = null, r, o, c = (/* @__PURE__ */ new Date()).getTime();
    function u(F) {
      const W = n;
      W.length !== 0 && bt(W, F);
    }
    function l(F = 16) {
      const W = () => Math.round(16 * Math.random()).toString(16);
      return "x".repeat(F).replace(/x/g, W);
    }
    function m(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "0");
      });
    }
    function v(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "-1");
      });
    }
    function y(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("role", W);
      });
    }
    function E(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-roledescription", W);
      });
    }
    function h(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-controls", W);
      });
    }
    function g(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-label", W);
      });
    }
    function C(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("id", W);
      });
    }
    function _(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-live", W);
      });
    }
    function p(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", true);
      });
    }
    function S(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", false);
      });
    }
    function w(F) {
      if (F.keyCode !== 13 && F.keyCode !== 32) return;
      const W = e.params.a11y, Y = F.target;
      if (!(e.pagination && e.pagination.el && (Y === e.pagination.el || e.pagination.el.contains(F.target)) && !F.target.matches(Ct(e.params.pagination.bulletClass)))) {
        if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
          const J = ue(e.navigation.prevEl);
          ue(e.navigation.nextEl).includes(Y) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? u(W.lastSlideMessage) : u(W.nextSlideMessage)), J.includes(Y) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? u(W.firstSlideMessage) : u(W.prevSlideMessage));
        }
        e.pagination && Y.matches(Ct(e.params.pagination.bulletClass)) && Y.click();
      }
    }
    function I() {
      if (e.params.loop || e.params.rewind || !e.navigation) return;
      const { nextEl: F, prevEl: W } = e.navigation;
      W && (e.isBeginning ? (p(W), v(W)) : (S(W), m(W))), F && (e.isEnd ? (p(F), v(F)) : (S(F), m(F)));
    }
    function L() {
      return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
    }
    function f() {
      return L() && e.params.pagination.clickable;
    }
    function P() {
      const F = e.params.a11y;
      L() && e.pagination.bullets.forEach((W) => {
        e.params.pagination.clickable && (m(W), e.params.pagination.renderBullet || (y(W, "button"), g(W, F.paginationBulletMessage.replace(/\{\{index\}\}/, Qi(W) + 1)))), W.matches(Ct(e.params.pagination.bulletActiveClass)) ? W.setAttribute("aria-current", "true") : W.removeAttribute("aria-current");
      });
    }
    const D = (F, W, Y) => {
      m(F), F.tagName !== "BUTTON" && (y(F, "button"), F.addEventListener("keydown", w)), g(F, Y), h(F, W);
    }, R = (F) => {
      o && o !== F.target && !o.contains(F.target) && (r = true), e.a11y.clicked = true;
    }, N = () => {
      r = false, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          e.destroyed || (e.a11y.clicked = false);
        });
      });
    }, $ = (F) => {
      c = (/* @__PURE__ */ new Date()).getTime();
    }, V = (F) => {
      if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - c < 100) return;
      const W = F.target.closest(`.${e.params.slideClass}, swiper-slide`);
      if (!W || !e.slides.includes(W)) return;
      o = W;
      const Y = e.virtual && e.params.virtual.enabled, J = (Y ? parseInt(W.getAttribute("data-swiper-slide-index"), 10) : e.slides.indexOf(W)) === e.activeIndex, oe = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(W);
      J || oe || F.sourceCapabilities && F.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
        r || (e.params.loop ? e.slideToLoop(e.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"))), 0) : Y ? e.slideTo(e.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"), 10)), 0) : e.slideTo(e.getSlideIndexWhenGrid(e.slides.indexOf(W)), 0), r = false);
      }));
    }, B = () => {
      const F = e.params.a11y;
      F.itemRoleDescriptionMessage && E(e.slides, F.itemRoleDescriptionMessage), F.slideRole && y(e.slides, F.slideRole);
      const W = e.slides.length;
      F.slideLabelMessage && e.slides.forEach((Y, J) => {
        const oe = e.params.loop ? parseInt(Y.getAttribute("data-swiper-slide-index"), 10) : J, he = F.slideLabelMessage.replace(/\{\{index\}\}/, oe + 1).replace(/\{\{slidesLength\}\}/, W);
        g(Y, he);
      });
    }, X = () => {
      const F = e.params.a11y;
      e.el.append(n);
      const W = e.el;
      F.containerRoleDescriptionMessage && E(W, F.containerRoleDescriptionMessage), F.containerMessage && g(W, F.containerMessage), F.containerRole && y(W, F.containerRole);
      const Y = e.wrapperEl, J = F.id || Y.getAttribute("id") || `swiper-wrapper-${l(16)}`;
      if (C(Y, J), F.wrapperLiveRegion) {
        const Ee = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
        _(Y, Ee);
      }
      B();
      let { nextEl: oe, prevEl: he } = e.navigation ? e.navigation : {};
      oe = ue(oe), he = ue(he), oe && oe.forEach((Ee) => D(Ee, J, F.nextSlideMessage)), he && he.forEach((Ee) => D(Ee, J, F.prevSlideMessage)), f() && ue(e.pagination.el).forEach((U) => {
        U.addEventListener("keydown", w);
      }), Le().addEventListener("visibilitychange", $), e.el.addEventListener("focus", V, true), e.el.addEventListener("pointerdown", R, true), e.el.addEventListener("pointerup", N, true);
    };
    function Z() {
      n && n.remove();
      let { nextEl: F, prevEl: W } = e.navigation ? e.navigation : {};
      F = ue(F), W = ue(W), F && F.forEach((J) => J.removeEventListener("keydown", w)), W && W.forEach((J) => J.removeEventListener("keydown", w)), f() && ue(e.pagination.el).forEach((oe) => {
        oe.removeEventListener("keydown", w);
      }), Le().removeEventListener("visibilitychange", $), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", V, true), e.el.removeEventListener("pointerdown", R, true), e.el.removeEventListener("pointerup", N, true));
    }
    i("beforeInit", () => {
      n = Xe("span", e.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
    }), i("afterInit", () => {
      e.params.a11y.enabled && X();
    }), i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
      e.params.a11y.enabled && B();
    }), i("fromEdge toEdge afterInit lock unlock", () => {
      e.params.a11y.enabled && I();
    }), i("paginationUpdate", () => {
      e.params.a11y.enabled && P();
    }), i("destroy", () => {
      e.params.a11y.enabled && Z();
    });
  }
  function zg({ swiper: e, extendParams: t, on: i }) {
    t({ history: { enabled: false, root: "", replaceState: false, key: "slides", keepQuery: false } });
    let n = false, r = {};
    const o = (E) => E.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), c = (E) => {
      const h = ye();
      let g;
      E ? g = new URL(E) : g = h.location;
      const C = g.pathname.slice(1).split("/").filter((w) => w !== ""), _ = C.length, p = C[_ - 2], S = C[_ - 1];
      return { key: p, value: S };
    }, u = (E, h) => {
      const g = ye();
      if (!n || !e.params.history.enabled) return;
      let C;
      e.params.url ? C = new URL(e.params.url) : C = g.location;
      const _ = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${h}"]`) : e.slides[h];
      let p = o(_.getAttribute("data-history"));
      if (e.params.history.root.length > 0) {
        let w = e.params.history.root;
        w[w.length - 1] === "/" && (w = w.slice(0, w.length - 1)), p = `${w}/${E ? `${E}/` : ""}${p}`;
      } else C.pathname.includes(E) || (p = `${E ? `${E}/` : ""}${p}`);
      e.params.history.keepQuery && (p += C.search);
      const S = g.history.state;
      S && S.value === p || (e.params.history.replaceState ? g.history.replaceState({ value: p }, null, p) : g.history.pushState({ value: p }, null, p));
    }, l = (E, h, g) => {
      if (h) for (let C = 0, _ = e.slides.length; C < _; C += 1) {
        const p = e.slides[C];
        if (o(p.getAttribute("data-history")) === h) {
          const w = e.getSlideIndex(p);
          e.slideTo(w, E, g);
        }
      }
      else e.slideTo(0, E, g);
    }, m = () => {
      r = c(e.params.url), l(e.params.speed, r.value, false);
    }, v = () => {
      const E = ye();
      if (e.params.history) {
        if (!E.history || !E.history.pushState) {
          e.params.history.enabled = false, e.params.hashNavigation.enabled = true;
          return;
        }
        if (n = true, r = c(e.params.url), !r.key && !r.value) {
          e.params.history.replaceState || E.addEventListener("popstate", m);
          return;
        }
        l(0, r.value, e.params.runCallbacksOnInit), e.params.history.replaceState || E.addEventListener("popstate", m);
      }
    }, y = () => {
      const E = ye();
      e.params.history.replaceState || E.removeEventListener("popstate", m);
    };
    i("init", () => {
      e.params.history.enabled && v();
    }), i("destroy", () => {
      e.params.history.enabled && y();
    }), i("transitionEnd _freeModeNoMomentumRelease", () => {
      n && u(e.params.history.key, e.activeIndex);
    }), i("slideChange", () => {
      n && e.params.cssMode && u(e.params.history.key, e.activeIndex);
    });
  }
  function $g({ swiper: e, extendParams: t, emit: i, on: n }) {
    let r = false;
    const o = Le(), c = ye();
    t({ hashNavigation: { enabled: false, replaceState: false, watchState: false, getSlideIndex(y, E) {
      if (e.virtual && e.params.virtual.enabled) {
        const h = e.slides.find((C) => C.getAttribute("data-hash") === E);
        return h ? parseInt(h.getAttribute("data-swiper-slide-index"), 10) : 0;
      }
      return e.getSlideIndex(Pe(e.slidesEl, `.${e.params.slideClass}[data-hash="${E}"], swiper-slide[data-hash="${E}"]`)[0]);
    } } });
    const u = () => {
      i("hashChange");
      const y = o.location.hash.replace("#", ""), E = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], h = E ? E.getAttribute("data-hash") : "";
      if (y !== h) {
        const g = e.params.hashNavigation.getSlideIndex(e, y);
        if (typeof g == "undefined" || Number.isNaN(g)) return;
        e.slideTo(g);
      }
    }, l = () => {
      if (!r || !e.params.hashNavigation.enabled) return;
      const y = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], E = y ? y.getAttribute("data-hash") || y.getAttribute("data-history") : "";
      e.params.hashNavigation.replaceState && c.history && c.history.replaceState ? (c.history.replaceState(null, null, `#${E}` || ""), i("hashSet")) : (o.location.hash = E || "", i("hashSet"));
    }, m = () => {
      if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
      r = true;
      const y = o.location.hash.replace("#", "");
      if (y) {
        const h = e.params.hashNavigation.getSlideIndex(e, y);
        e.slideTo(h || 0, 0, e.params.runCallbacksOnInit, true);
      }
      e.params.hashNavigation.watchState && c.addEventListener("hashchange", u);
    }, v = () => {
      e.params.hashNavigation.watchState && c.removeEventListener("hashchange", u);
    };
    n("init", () => {
      e.params.hashNavigation.enabled && m();
    }), n("destroy", () => {
      e.params.hashNavigation.enabled && v();
    }), n("transitionEnd _freeModeNoMomentumRelease", () => {
      r && l();
    }), n("slideChange", () => {
      r && e.params.cssMode && l();
    });
  }
  function Ng({ swiper: e, extendParams: t, on: i, emit: n, params: r }) {
    e.autoplay = { running: false, paused: false, timeLeft: 0 }, t({ autoplay: { enabled: false, delay: 3e3, waitForTransition: true, disableOnInteraction: false, stopOnLastSlide: false, reverseDirection: false, pauseOnMouseEnter: false } });
    let o, c, u = r && r.autoplay ? r.autoplay.delay : 3e3, l = r && r.autoplay ? r.autoplay.delay : 3e3, m, v = (/* @__PURE__ */ new Date()).getTime(), y, E, h, g, C, _;
    function p(W) {
      !e || e.destroyed || !e.wrapperEl || W.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", p), !(_ || W.detail && W.detail.bySwiperTouchMove) && R());
    }
    const S = () => {
      if (e.destroyed || !e.autoplay.running) return;
      e.autoplay.paused ? y = true : y && (l = m, y = false);
      const W = e.autoplay.paused ? m : v + l - (/* @__PURE__ */ new Date()).getTime();
      e.autoplay.timeLeft = W, n("autoplayTimeLeft", W, W / u), c = requestAnimationFrame(() => {
        S();
      });
    }, w = () => {
      let W;
      return e.virtual && e.params.virtual.enabled ? W = e.slides.find((J) => J.classList.contains("swiper-slide-active")) : W = e.slides[e.activeIndex], W ? parseInt(W.getAttribute("data-swiper-autoplay"), 10) : void 0;
    }, I = () => {
      let W = e.params.autoplay.delay;
      const Y = w();
      return !Number.isNaN(Y) && Y > 0 && (W = Y), W;
    }, L = (W) => {
      if (e.destroyed || !e.autoplay.running) return;
      cancelAnimationFrame(c), S();
      let Y = W;
      typeof Y == "undefined" && (Y = I(), u = Y, l = Y), m = Y;
      const J = e.params.speed, oe = () => {
        !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(J, true, true), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, J, true, true), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(J, true, true), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, J, true, true), n("autoplay")), e.params.cssMode && (v = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
          L();
        })));
      };
      return Y > 0 ? (clearTimeout(o), o = setTimeout(() => {
        oe();
      }, Y)) : requestAnimationFrame(() => {
        oe();
      }), Y;
    }, f = () => {
      v = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = true, L(), n("autoplayStart");
    }, P = () => {
      e.autoplay.running = false, clearTimeout(o), cancelAnimationFrame(c), n("autoplayStop");
    }, D = (W, Y) => {
      if (e.destroyed || !e.autoplay.running) return;
      clearTimeout(o), W || (C = true);
      const J = () => {
        n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", p) : R();
      };
      if (e.autoplay.paused = true, Y) {
        J();
        return;
      }
      m = (m || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - v), !(e.isEnd && m < 0 && !e.params.loop) && (m < 0 && (m = 0), J());
    }, R = () => {
      e.isEnd && m < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (v = (/* @__PURE__ */ new Date()).getTime(), C ? (C = false, L(m)) : L(), e.autoplay.paused = false, n("autoplayResume"));
    }, N = () => {
      if (e.destroyed || !e.autoplay.running) return;
      const W = Le();
      W.visibilityState === "hidden" && (C = true, D(true)), W.visibilityState === "visible" && R();
    }, $ = (W) => {
      W.pointerType === "mouse" && (C = true, _ = true, !(e.animating || e.autoplay.paused) && D(true));
    }, V = (W) => {
      W.pointerType === "mouse" && (_ = false, e.autoplay.paused && R());
    }, B = () => {
      e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", $), e.el.addEventListener("pointerleave", V));
    }, X = () => {
      e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", $), e.el.removeEventListener("pointerleave", V));
    }, Z = () => {
      Le().addEventListener("visibilitychange", N);
    }, F = () => {
      Le().removeEventListener("visibilitychange", N);
    };
    i("init", () => {
      e.params.autoplay.enabled && (B(), Z(), f());
    }), i("destroy", () => {
      X(), F(), e.autoplay.running && P();
    }), i("_freeModeStaticRelease", () => {
      (h || C) && R();
    }), i("_freeModeNoMomentumRelease", () => {
      e.params.autoplay.disableOnInteraction ? P() : D(true, true);
    }), i("beforeTransitionStart", (W, Y, J) => {
      e.destroyed || !e.autoplay.running || (J || !e.params.autoplay.disableOnInteraction ? D(true, true) : P());
    }), i("sliderFirstMove", () => {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          P();
          return;
        }
        E = true, h = false, C = false, g = setTimeout(() => {
          C = true, h = true, D(true);
        }, 200);
      }
    }), i("touchEnd", () => {
      if (!(e.destroyed || !e.autoplay.running || !E)) {
        if (clearTimeout(g), clearTimeout(o), e.params.autoplay.disableOnInteraction) {
          h = false, E = false;
          return;
        }
        h && e.params.cssMode && R(), h = false, E = false;
      }
    }), i("slideChange", () => {
      e.destroyed || !e.autoplay.running || e.autoplay.paused && (m = I(), u = I());
    }), Object.assign(e.autoplay, { start: f, stop: P, pause: D, resume: R });
  }
  function kg({ swiper: e, extendParams: t, on: i }) {
    t({ thumbs: { swiper: null, multipleActiveThumbs: true, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
    let n = false, r = false;
    e.thumbs = { swiper: null };
    function o() {
      const v = e.thumbs.swiper;
      return !v || v.destroyed ? false : v.params.virtual && v.params.virtual.enabled;
    }
    function c() {
      const v = e.thumbs.swiper;
      if (!v || v.destroyed) return;
      const y = v.clickedIndex, E = v.clickedSlide;
      if (E && E.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof y == "undefined" || y === null) return;
      let h;
      v.params.loop ? h = parseInt(v.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : h = y, e.params.loop ? e.slideToLoop(h) : e.slideTo(h);
    }
    function u() {
      const { thumbs: v } = e.params;
      if (n) return false;
      n = true;
      const y = e.constructor;
      if (v.swiper instanceof y) {
        if (v.swiper.destroyed) return n = false, false;
        e.thumbs.swiper = v.swiper, Object.assign(e.thumbs.swiper.originalParams, { watchSlidesProgress: true, slideToClickedSlide: false }), Object.assign(e.thumbs.swiper.params, { watchSlidesProgress: true, slideToClickedSlide: false }), e.thumbs.swiper.update();
      } else if (qi(v.swiper)) {
        const E = Object.assign({}, v.swiper);
        Object.assign(E, { watchSlidesProgress: true, slideToClickedSlide: false }), e.thumbs.swiper = new y(E), r = true;
      }
      return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", c), o() && e.thumbs.swiper.on("virtualUpdate", () => {
        l(false, { autoScroll: false });
      }), true;
    }
    function l(v, y) {
      var C;
      const E = e.thumbs.swiper;
      if (!E || E.destroyed) return;
      let h = 1;
      const g = e.params.thumbs.slideThumbActiveClass;
      if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (h = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (h = 1), h = Math.floor(h), E.slides.forEach((_) => _.classList.remove(g)), E.params.loop || o()) for (let _ = 0; _ < h; _ += 1) Pe(E.slidesEl, `[data-swiper-slide-index="${e.realIndex + _}"]`).forEach((p) => {
        p.classList.add(g);
      });
      else for (let _ = 0; _ < h; _ += 1) E.slides[e.realIndex + _] && E.slides[e.realIndex + _].classList.add(g);
      ((C = y == null ? void 0 : y.autoScroll) == null || C) && m(v ? 0 : void 0);
    }
    function m(v) {
      const y = e.thumbs.swiper;
      if (!y || y.destroyed) return;
      const E = y.params.slidesPerView === "auto" ? y.slidesPerViewDynamic() : y.params.slidesPerView, h = e.params.thumbs.autoScrollOffset, g = h && !y.params.loop;
      if (e.realIndex !== y.realIndex || g) {
        const C = y.activeIndex;
        let _, p;
        if (y.params.loop) {
          const S = y.slides.find((w) => w.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
          _ = y.slides.indexOf(S), p = e.activeIndex > e.previousIndex ? "next" : "prev";
        } else _ = e.realIndex, p = _ > e.previousIndex ? "next" : "prev";
        g && (_ += p === "next" ? h : -1 * h), y.visibleSlidesIndexes && y.visibleSlidesIndexes.indexOf(_) < 0 && (y.params.centeredSlides ? _ > C ? _ = _ - Math.floor(E / 2) + 1 : _ = _ + Math.floor(E / 2) - 1 : _ > C && y.params.slidesPerGroup, y.slideTo(_, v));
      }
    }
    i("beforeInit", () => {
      const { thumbs: v } = e.params;
      if (!(!v || !v.swiper)) if (typeof v.swiper == "string" || v.swiper instanceof HTMLElement) {
        const y = Le(), E = () => {
          const g = typeof v.swiper == "string" ? y.querySelector(v.swiper) : v.swiper;
          if (g && g.swiper) v.swiper = g.swiper, u(), l(true);
          else if (g) {
            const C = `${e.params.eventsPrefix}init`, _ = (p) => {
              v.swiper = p.detail[0], g.removeEventListener(C, _), u(), l(true), v.swiper.update(), e.update();
            };
            g.addEventListener(C, _);
          }
          return g;
        }, h = () => {
          if (e.destroyed) return;
          E() || requestAnimationFrame(h);
        };
        requestAnimationFrame(h);
      } else u(), l(true);
    }), i("slideChange update resize observerUpdate", () => {
      l();
    }), i("setTransition", (v, y) => {
      const E = e.thumbs.swiper;
      !E || E.destroyed || E.setTransition(y);
    }), i("beforeDestroy", () => {
      const v = e.thumbs.swiper;
      !v || v.destroyed || r && v.destroy();
    }), Object.assign(e.thumbs, { init: u, update: l });
  }
  function Rg({ swiper: e, extendParams: t, emit: i, once: n }) {
    t({ freeMode: { enabled: false, momentum: true, momentumRatio: 1, momentumBounce: true, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: false, minimumVelocity: 0.02 } });
    function r() {
      if (e.params.cssMode) return;
      const u = e.getTranslate();
      e.setTranslate(u), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({ currentPos: e.rtl ? e.translate : -e.translate });
    }
    function o() {
      if (e.params.cssMode) return;
      const { touchEventsData: u, touches: l } = e;
      u.velocities.length === 0 && u.velocities.push({ position: l[e.isHorizontal() ? "startX" : "startY"], time: u.touchStartTime }), u.velocities.push({ position: l[e.isHorizontal() ? "currentX" : "currentY"], time: Je() });
    }
    function c({ currentPos: u }) {
      if (e.params.cssMode) return;
      const { params: l, wrapperEl: m, rtlTranslate: v, snapGrid: y, touchEventsData: E } = e, g = Je() - E.touchStartTime;
      if (u < -e.minTranslate()) {
        e.slideTo(e.activeIndex);
        return;
      }
      if (u > -e.maxTranslate()) {
        e.slides.length < y.length ? e.slideTo(y.length - 1) : e.slideTo(e.slides.length - 1);
        return;
      }
      if (l.freeMode.momentum) {
        if (E.velocities.length > 1) {
          const f = E.velocities.pop(), P = E.velocities.pop(), D = f.position - P.position, R = f.time - P.time;
          e.velocity = D / R, e.velocity /= 2, Math.abs(e.velocity) < l.freeMode.minimumVelocity && (e.velocity = 0), (R > 150 || Je() - f.time > 300) && (e.velocity = 0);
        } else e.velocity = 0;
        e.velocity *= l.freeMode.momentumVelocityRatio, E.velocities.length = 0;
        let C = 1e3 * l.freeMode.momentumRatio;
        const _ = e.velocity * C;
        let p = e.translate + _;
        v && (p = -p);
        let S = false, w;
        const I = Math.abs(e.velocity) * 20 * l.freeMode.momentumBounceRatio;
        let L;
        if (p < e.maxTranslate()) l.freeMode.momentumBounce ? (p + e.maxTranslate() < -I && (p = e.maxTranslate() - I), w = e.maxTranslate(), S = true, E.allowMomentumBounce = true) : p = e.maxTranslate(), l.loop && l.centeredSlides && (L = true);
        else if (p > e.minTranslate()) l.freeMode.momentumBounce ? (p - e.minTranslate() > I && (p = e.minTranslate() + I), w = e.minTranslate(), S = true, E.allowMomentumBounce = true) : p = e.minTranslate(), l.loop && l.centeredSlides && (L = true);
        else if (l.freeMode.sticky) {
          let f;
          for (let P = 0; P < y.length; P += 1) if (y[P] > -p) {
            f = P;
            break;
          }
          Math.abs(y[f] - p) < Math.abs(y[f - 1] - p) || e.swipeDirection === "next" ? p = y[f] : p = y[f - 1], p = -p;
        }
        if (L && n("transitionEnd", () => {
          e.loopFix();
        }), e.velocity !== 0) {
          if (v ? C = Math.abs((-p - e.translate) / e.velocity) : C = Math.abs((p - e.translate) / e.velocity), l.freeMode.sticky) {
            const f = Math.abs((v ? -p : p) - e.translate), P = e.slidesSizesGrid[e.activeIndex];
            f < P ? C = l.speed : f < 2 * P ? C = l.speed * 1.5 : C = l.speed * 2.5;
          }
        } else if (l.freeMode.sticky) {
          e.slideToClosest();
          return;
        }
        l.freeMode.momentumBounce && S ? (e.updateProgress(w), e.setTransition(C), e.setTranslate(p), e.transitionStart(true, e.swipeDirection), e.animating = true, Zi(m, () => {
          !e || e.destroyed || !E.allowMomentumBounce || (i("momentumBounce"), e.setTransition(l.speed), setTimeout(() => {
            e.setTranslate(w), Zi(m, () => {
              !e || e.destroyed || e.transitionEnd();
            });
          }, 0));
        })) : e.velocity ? (i("_freeModeNoMomentumRelease"), e.updateProgress(p), e.setTransition(C), e.setTranslate(p), e.transitionStart(true, e.swipeDirection), e.animating || (e.animating = true, Zi(m, () => {
          !e || e.destroyed || e.transitionEnd();
        }))) : e.updateProgress(p), e.updateActiveIndex(), e.updateSlidesClasses();
      } else if (l.freeMode.sticky) {
        e.slideToClosest();
        return;
      } else l.freeMode && i("_freeModeNoMomentumRelease");
      (!l.freeMode.momentum || g >= l.longSwipesMs) && (i("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
    }
    Object.assign(e, { freeMode: { onTouchStart: r, onTouchMove: o, onTouchEnd: c } });
  }
  function Hg({ swiper: e, extendParams: t, on: i }) {
    t({ grid: { rows: 1, fill: "column" } });
    let n, r, o, c;
    const u = () => {
      let g = e.params.spaceBetween;
      return typeof g == "string" && g.indexOf("%") >= 0 ? g = parseFloat(g.replace("%", "")) / 100 * e.size : typeof g == "string" && (g = parseFloat(g)), g;
    }, l = (g) => {
      const { slidesPerView: C } = e.params, { rows: _, fill: p } = e.params.grid, S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : g.length;
      o = Math.floor(S / _), Math.floor(S / _) === S / _ ? n = S : n = Math.ceil(S / _) * _, C !== "auto" && p === "row" && (n = Math.max(n, Math.floor(C) * _)), r = n / _;
    }, m = () => {
      e.slides && e.slides.forEach((g) => {
        g.swiperSlideGridSet && (g.style.height = "", g.style[e.getDirectionLabel("margin-top")] = "");
      });
    }, v = (g, C, _) => {
      const { slidesPerGroup: p } = e.params, S = u(), { rows: w, fill: I } = e.params.grid, L = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : _.length;
      let f, P, D;
      if (I === "row" && p > 1) {
        const R = Math.floor(g / (p * w)), N = g - w * p * R, $ = R === 0 ? p : Math.min(Math.ceil((L - R * w * p) / w), p);
        D = Math.floor(N / $), P = N - D * $ + R * p, f = P + D * n / w, C.style.order = f;
      } else I === "column" ? (P = Math.floor(g / w), D = g - P * w, (P > o || P === o && D === w - 1) && (D += 1, D >= w && (D = 0, P += 1))) : (D = Math.floor(g / r), P = g - D * r);
      C.row = D, C.column = P, C.style.height = `calc((100% - ${(w - 1) * S}px) / ${w})`, C.style[e.getDirectionLabel("margin-top")] = D !== 0 ? S && `${S}px` : "", C.swiperSlideGridSet = true;
    }, y = (g, C) => {
      const { centeredSlides: _, roundLengths: p } = e.params, S = u(), { rows: w } = e.params.grid;
      if (e.virtualSize = (g + S) * n, e.virtualSize = Math.ceil(e.virtualSize / w) - S, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + S}px`), _) {
        const I = [];
        for (let L = 0; L < C.length; L += 1) {
          let f = C[L];
          p && (f = Math.floor(f)), C[L] < e.virtualSize + C[0] && I.push(f);
        }
        C.splice(0, C.length), C.push(...I);
      }
    }, E = () => {
      c = e.params.grid && e.params.grid.rows > 1;
    }, h = () => {
      const { params: g, el: C } = e, _ = g.grid && g.grid.rows > 1;
      c && !_ ? (C.classList.remove(`${g.containerModifierClass}grid`, `${g.containerModifierClass}grid-column`), o = 1, e.emitContainerClasses()) : !c && _ && (C.classList.add(`${g.containerModifierClass}grid`), g.grid.fill === "column" && C.classList.add(`${g.containerModifierClass}grid-column`), e.emitContainerClasses()), c = _;
    };
    i("init", E), i("update", h), e.grid = { initSlides: l, unsetSlides: m, updateSlide: v, updateWrapperSize: y };
  }
  function Vg(e) {
    const t = this, { params: i, slidesEl: n } = t;
    i.loop && t.loopDestroy();
    const r = (o) => {
      if (typeof o == "string") {
        const c = document.createElement("div");
        bt(c, o), n.append(c.children[0]), bt(c, "");
      } else n.append(o);
    };
    if (typeof e == "object" && "length" in e) for (let o = 0; o < e.length; o += 1) e[o] && r(e[o]);
    else r(e);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update();
  }
  function Bg(e) {
    const t = this, { params: i, activeIndex: n, slidesEl: r } = t;
    i.loop && t.loopDestroy();
    let o = n + 1;
    const c = (u) => {
      if (typeof u == "string") {
        const l = document.createElement("div");
        bt(l, u), r.prepend(l.children[0]), bt(l, "");
      } else r.prepend(u);
    };
    if (typeof e == "object" && "length" in e) {
      for (let u = 0; u < e.length; u += 1) e[u] && c(e[u]);
      o = n + e.length;
    } else c(e);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update(), t.slideTo(o, 0, false);
  }
  function Wg(e, t) {
    const i = this, { params: n, activeIndex: r, slidesEl: o } = i;
    let c = r;
    n.loop && (c -= i.loopedSlides, i.loopDestroy(), i.recalcSlides());
    const u = i.slides.length;
    if (e <= 0) {
      i.prependSlide(t);
      return;
    }
    if (e >= u) {
      i.appendSlide(t);
      return;
    }
    let l = c > e ? c + 1 : c;
    const m = [];
    for (let v = u - 1; v >= e; v -= 1) {
      const y = i.slides[v];
      y.remove(), m.unshift(y);
    }
    if (typeof t == "object" && "length" in t) {
      for (let v = 0; v < t.length; v += 1) t[v] && o.append(t[v]);
      l = c > e ? c + t.length : c;
    } else o.append(t);
    for (let v = 0; v < m.length; v += 1) o.append(m[v]);
    i.recalcSlides(), n.loop && i.loopCreate(), (!n.observer || i.isElement) && i.update(), n.loop ? i.slideTo(l + i.loopedSlides, 0, false) : i.slideTo(l, 0, false);
  }
  function Fg(e) {
    const t = this, { params: i, activeIndex: n } = t;
    let r = n;
    i.loop && (r -= t.loopedSlides, t.loopDestroy());
    let o = r, c;
    if (typeof e == "object" && "length" in e) {
      for (let u = 0; u < e.length; u += 1) c = e[u], t.slides[c] && t.slides[c].remove(), c < o && (o -= 1);
      o = Math.max(o, 0);
    } else c = e, t.slides[c] && t.slides[c].remove(), c < o && (o -= 1), o = Math.max(o, 0);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update(), i.loop ? t.slideTo(o + t.loopedSlides, 0, false) : t.slideTo(o, 0, false);
  }
  function Gg() {
    const e = this, t = [];
    for (let i = 0; i < e.slides.length; i += 1) t.push(i);
    e.removeSlide(t);
  }
  function jg({ swiper: e }) {
    Object.assign(e, { appendSlide: Vg.bind(e), prependSlide: Bg.bind(e), addSlide: Wg.bind(e), removeSlide: Fg.bind(e), removeAllSlides: Gg.bind(e) });
  }
  function ki(e) {
    const { effect: t, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: c, perspective: u, recreateShadows: l, getEffectParams: m } = e;
    n("beforeInit", () => {
      if (i.params.effect !== t) return;
      i.classNames.push(`${i.params.containerModifierClass}${t}`), u && u() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = c ? c() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === t && r();
    }), n("setTransition", (y, E) => {
      i.params.effect === t && o(E);
    }), n("transitionEnd", () => {
      if (i.params.effect === t && l) {
        if (!m || !m().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((E) => E.remove());
        }), l();
      }
    });
    let v;
    n("virtualUpdate", () => {
      i.params.effect === t && (i.slides.length || (v = true), requestAnimationFrame(() => {
        v && i.slides && i.slides.length && (r(), v = false);
      }));
    });
  }
  function rn(e, t) {
    const i = ai(t);
    return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
  }
  function Qn({ swiper: e, duration: t, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = e, o = (c) => c.parentElement ? c.parentElement : e.slides.find((l) => l.shadowRoot && l.shadowRoot === c.parentNode);
    if (e.params.virtualTranslate && t !== 0) {
      let c = false, u;
      n ? u = i : u = i.filter((l) => {
        const m = l.classList.contains("swiper-slide-transform") ? o(l) : l;
        return e.getSlideIndex(m) === r;
      }), u.forEach((l) => {
        Zi(l, () => {
          if (c || !e || e.destroyed) return;
          c = true, e.animating = false;
          const m = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          e.wrapperEl.dispatchEvent(m);
        });
      });
    }
  }
  function Yg({ swiper: e, extendParams: t, on: i }) {
    t({ fadeEffect: { crossFade: false } }), ki({ effect: "fade", swiper: e, on: i, setTranslate: () => {
      const { slides: o } = e, c = e.params.fadeEffect;
      for (let u = 0; u < o.length; u += 1) {
        const l = e.slides[u];
        let v = -l.swiperSlideOffset;
        e.params.virtualTranslate || (v -= e.translate);
        let y = 0;
        e.isHorizontal() || (y = v, v = 0);
        const E = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(l.progress), 0) : 1 + Math.min(Math.max(l.progress, -1), 0), h = rn(c, l);
        h.style.opacity = E, h.style.transform = `translate3d(${v}px, ${y}px, 0px)`;
      }
    }, setTransition: (o) => {
      const c = e.slides.map((u) => ai(u));
      c.forEach((u) => {
        u.style.transitionDuration = `${o}ms`;
      }), Qn({ swiper: e, duration: o, transformElements: c, allSlides: true });
    }, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !e.params.cssMode }) });
  }
  function Xg({ swiper: e, extendParams: t, on: i }) {
    t({ cubeEffect: { slideShadows: true, shadow: true, shadowOffset: 20, shadowScale: 0.94 } });
    const n = (u, l, m) => {
      let v = m ? u.querySelector(".swiper-slide-shadow-left") : u.querySelector(".swiper-slide-shadow-top"), y = m ? u.querySelector(".swiper-slide-shadow-right") : u.querySelector(".swiper-slide-shadow-bottom");
      v || (v = Xe("div", `swiper-slide-shadow-cube swiper-slide-shadow-${m ? "left" : "top"}`.split(" ")), u.append(v)), y || (y = Xe("div", `swiper-slide-shadow-cube swiper-slide-shadow-${m ? "right" : "bottom"}`.split(" ")), u.append(y)), v && (v.style.opacity = Math.max(-l, 0)), y && (y.style.opacity = Math.max(l, 0));
    };
    ki({ effect: "cube", swiper: e, on: i, setTranslate: () => {
      const { el: u, wrapperEl: l, slides: m, width: v, height: y, rtlTranslate: E, size: h, browser: g } = e, C = Zn(e), _ = e.params.cubeEffect, p = e.isHorizontal(), S = e.virtual && e.params.virtual.enabled;
      let w = 0, I;
      _.shadow && (p ? (I = e.wrapperEl.querySelector(".swiper-cube-shadow"), I || (I = Xe("div", "swiper-cube-shadow"), e.wrapperEl.append(I)), I.style.height = `${v}px`) : (I = u.querySelector(".swiper-cube-shadow"), I || (I = Xe("div", "swiper-cube-shadow"), u.append(I))));
      for (let f = 0; f < m.length; f += 1) {
        const P = m[f];
        let D = f;
        S && (D = parseInt(P.getAttribute("data-swiper-slide-index"), 10));
        let R = D * 90, N = Math.floor(R / 360);
        E && (R = -R, N = Math.floor(-R / 360));
        const $ = Math.max(Math.min(P.progress, 1), -1);
        let V = 0, B = 0, X = 0;
        D % 4 === 0 ? (V = -N * 4 * h, X = 0) : (D - 1) % 4 === 0 ? (V = 0, X = -N * 4 * h) : (D - 2) % 4 === 0 ? (V = h + N * 4 * h, X = h) : (D - 3) % 4 === 0 && (V = -h, X = 3 * h + h * 4 * N), E && (V = -V), p || (B = V, V = 0);
        const Z = `rotateX(${C(p ? 0 : -R)}deg) rotateY(${C(p ? R : 0)}deg) translate3d(${V}px, ${B}px, ${X}px)`;
        $ <= 1 && $ > -1 && (w = D * 90 + $ * 90, E && (w = -D * 90 - $ * 90)), P.style.transform = Z, _.slideShadows && n(P, $, p);
      }
      if (l.style.transformOrigin = `50% 50% -${h / 2}px`, l.style["-webkit-transform-origin"] = `50% 50% -${h / 2}px`, _.shadow) if (p) I.style.transform = `translate3d(0px, ${v / 2 + _.shadowOffset}px, ${-v / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${_.shadowScale})`;
      else {
        const f = Math.abs(w) - Math.floor(Math.abs(w) / 90) * 90, P = 1.5 - (Math.sin(f * 2 * Math.PI / 360) / 2 + Math.cos(f * 2 * Math.PI / 360) / 2), D = _.shadowScale, R = _.shadowScale / P, N = _.shadowOffset;
        I.style.transform = `scale3d(${D}, 1, ${R}) translate3d(0px, ${y / 2 + N}px, ${-y / 2 / R}px) rotateX(-89.99deg)`;
      }
      const L = (g.isSafari || g.isWebView) && g.needPerspectiveFix ? -h / 2 : 0;
      l.style.transform = `translate3d(0px,0,${L}px) rotateX(${C(e.isHorizontal() ? 0 : w)}deg) rotateY(${C(e.isHorizontal() ? -w : 0)}deg)`, l.style.setProperty("--swiper-cube-translate-z", `${L}px`);
    }, setTransition: (u) => {
      const { el: l, slides: m } = e;
      if (m.forEach((v) => {
        v.style.transitionDuration = `${u}ms`, v.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((y) => {
          y.style.transitionDuration = `${u}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const v = l.querySelector(".swiper-cube-shadow");
        v && (v.style.transitionDuration = `${u}ms`);
      }
    }, recreateShadows: () => {
      const u = e.isHorizontal();
      e.slides.forEach((l) => {
        const m = Math.max(Math.min(l.progress, 1), -1);
        n(l, m, u);
      });
    }, getEffectParams: () => e.params.cubeEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, resistanceRatio: 0, spaceBetween: 0, centeredSlides: false, virtualTranslate: true }) });
  }
  function Di(e, t, i) {
    const n = `swiper-slide-shadow${i ? `-${i}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`, r = ai(t);
    let o = r.querySelector(`.${n.split(" ").join(".")}`);
    return o || (o = Xe("div", n.split(" ")), r.append(o)), o;
  }
  function qg({ swiper: e, extendParams: t, on: i }) {
    t({ flipEffect: { slideShadows: true, limitRotation: true } });
    const n = (u, l) => {
      let m = e.isHorizontal() ? u.querySelector(".swiper-slide-shadow-left") : u.querySelector(".swiper-slide-shadow-top"), v = e.isHorizontal() ? u.querySelector(".swiper-slide-shadow-right") : u.querySelector(".swiper-slide-shadow-bottom");
      m || (m = Di("flip", u, e.isHorizontal() ? "left" : "top")), v || (v = Di("flip", u, e.isHorizontal() ? "right" : "bottom")), m && (m.style.opacity = Math.max(-l, 0)), v && (v.style.opacity = Math.max(l, 0));
    };
    ki({ effect: "flip", swiper: e, on: i, setTranslate: () => {
      const { slides: u, rtlTranslate: l } = e, m = e.params.flipEffect, v = Zn(e);
      for (let y = 0; y < u.length; y += 1) {
        const E = u[y];
        let h = E.progress;
        e.params.flipEffect.limitRotation && (h = Math.max(Math.min(E.progress, 1), -1));
        const g = E.swiperSlideOffset;
        let _ = -180 * h, p = 0, S = e.params.cssMode ? -g - e.translate : -g, w = 0;
        e.isHorizontal() ? l && (_ = -_) : (w = S, S = 0, p = -_, _ = 0), E.style.zIndex = -Math.abs(Math.round(h)) + u.length, m.slideShadows && n(E, h);
        const I = `translate3d(${S}px, ${w}px, 0px) rotateX(${v(p)}deg) rotateY(${v(_)}deg)`, L = rn(m, E);
        L.style.transform = I;
      }
    }, setTransition: (u) => {
      const l = e.slides.map((m) => ai(m));
      l.forEach((m) => {
        m.style.transitionDuration = `${u}ms`, m.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((v) => {
          v.style.transitionDuration = `${u}ms`;
        });
      }), Qn({ swiper: e, duration: u, transformElements: l });
    }, recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((u) => {
        let l = u.progress;
        e.params.flipEffect.limitRotation && (l = Math.max(Math.min(u.progress, 1), -1)), n(u, l);
      });
    }, getEffectParams: () => e.params.flipEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !e.params.cssMode }) });
  }
  function Ug({ swiper: e, extendParams: t, on: i }) {
    t({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: true } }), ki({ effect: "coverflow", swiper: e, on: i, setTranslate: () => {
      const { width: o, height: c, slides: u, slidesSizesGrid: l } = e, m = e.params.coverflowEffect, v = e.isHorizontal(), y = e.translate, E = v ? -y + o / 2 : -y + c / 2, h = v ? m.rotate : -m.rotate, g = m.depth, C = Zn(e);
      for (let _ = 0, p = u.length; _ < p; _ += 1) {
        const S = u[_], w = l[_], I = S.swiperSlideOffset, L = (E - I - w / 2) / w, f = typeof m.modifier == "function" ? m.modifier(L) : L * m.modifier;
        let P = v ? h * f : 0, D = v ? 0 : h * f, R = -g * Math.abs(f), N = m.stretch;
        typeof N == "string" && N.indexOf("%") !== -1 && (N = parseFloat(m.stretch) / 100 * w);
        let $ = v ? 0 : N * f, V = v ? N * f : 0, B = 1 - (1 - m.scale) * Math.abs(f);
        Math.abs(V) < 1e-3 && (V = 0), Math.abs($) < 1e-3 && ($ = 0), Math.abs(R) < 1e-3 && (R = 0), Math.abs(P) < 1e-3 && (P = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(B) < 1e-3 && (B = 0);
        const X = `translate3d(${V}px,${$}px,${R}px)  rotateX(${C(D)}deg) rotateY(${C(P)}deg) scale(${B})`, Z = rn(m, S);
        if (Z.style.transform = X, S.style.zIndex = -Math.abs(Math.round(f)) + 1, m.slideShadows) {
          let F = v ? S.querySelector(".swiper-slide-shadow-left") : S.querySelector(".swiper-slide-shadow-top"), W = v ? S.querySelector(".swiper-slide-shadow-right") : S.querySelector(".swiper-slide-shadow-bottom");
          F || (F = Di("coverflow", S, v ? "left" : "top")), W || (W = Di("coverflow", S, v ? "right" : "bottom")), F && (F.style.opacity = f > 0 ? f : 0), W && (W.style.opacity = -f > 0 ? -f : 0);
        }
      }
    }, setTransition: (o) => {
      e.slides.map((u) => ai(u)).forEach((u) => {
        u.style.transitionDuration = `${o}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((l) => {
          l.style.transitionDuration = `${o}ms`;
        });
      });
    }, perspective: () => true, overwriteParams: () => ({ watchSlidesProgress: true }) });
  }
  function Kg({ swiper: e, extendParams: t, on: i }) {
    t({ creativeEffect: { limitProgress: 1, shadowPerProgress: false, progressMultiplier: 1, perspective: true, prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 }, next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 } } });
    const n = (c) => typeof c == "string" ? c : `${c}px`;
    ki({ effect: "creative", swiper: e, on: i, setTranslate: () => {
      const { slides: c, wrapperEl: u, slidesSizesGrid: l } = e, m = e.params.creativeEffect, { progressMultiplier: v } = m, y = e.params.centeredSlides, E = Zn(e);
      if (y) {
        const h = l[0] / 2 - e.params.slidesOffsetBefore || 0;
        u.style.transform = `translateX(calc(50% - ${h}px))`;
      }
      for (let h = 0; h < c.length; h += 1) {
        const g = c[h], C = g.progress, _ = Math.min(Math.max(g.progress, -m.limitProgress), m.limitProgress);
        let p = _;
        y || (p = Math.min(Math.max(g.originalProgress, -m.limitProgress), m.limitProgress));
        const S = g.swiperSlideOffset, w = [e.params.cssMode ? -S - e.translate : -S, 0, 0], I = [0, 0, 0];
        let L = false;
        e.isHorizontal() || (w[1] = w[0], w[0] = 0);
        let f = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
        _ < 0 ? (f = m.next, L = true) : _ > 0 && (f = m.prev, L = true), w.forEach((B, X) => {
          w[X] = `calc(${B}px + (${n(f.translate[X])} * ${Math.abs(_ * v)}))`;
        }), I.forEach((B, X) => {
          let Z = f.rotate[X] * Math.abs(_ * v);
          I[X] = Z;
        }), g.style.zIndex = -Math.abs(Math.round(C)) + c.length;
        const P = w.join(", "), D = `rotateX(${E(I[0])}deg) rotateY(${E(I[1])}deg) rotateZ(${E(I[2])}deg)`, R = p < 0 ? `scale(${1 + (1 - f.scale) * p * v})` : `scale(${1 - (1 - f.scale) * p * v})`, N = p < 0 ? 1 + (1 - f.opacity) * p * v : 1 - (1 - f.opacity) * p * v, $ = `translate3d(${P}) ${D} ${R}`;
        if (L && f.shadow || !L) {
          let B = g.querySelector(".swiper-slide-shadow");
          if (!B && f.shadow && (B = Di("creative", g)), B) {
            const X = m.shadowPerProgress ? _ * (1 / m.limitProgress) : _;
            B.style.opacity = Math.min(Math.max(Math.abs(X), 0), 1);
          }
        }
        const V = rn(m, g);
        V.style.transform = $, V.style.opacity = N, f.origin && (V.style.transformOrigin = f.origin);
      }
    }, setTransition: (c) => {
      const u = e.slides.map((l) => ai(l));
      u.forEach((l) => {
        l.style.transitionDuration = `${c}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((m) => {
          m.style.transitionDuration = `${c}ms`;
        });
      }), Qn({ swiper: e, duration: c, transformElements: u, allSlides: true });
    }, perspective: () => e.params.creativeEffect.perspective, overwriteParams: () => ({ watchSlidesProgress: true, virtualTranslate: !e.params.cssMode }) });
  }
  function Zg({ swiper: e, extendParams: t, on: i }) {
    t({ cardsEffect: { slideShadows: true, rotate: true, perSlideRotate: 2, perSlideOffset: 8 } }), ki({ effect: "cards", swiper: e, on: i, setTranslate: () => {
      const { slides: o, activeIndex: c, rtlTranslate: u } = e, l = e.params.cardsEffect, { startTranslate: m, isTouched: v } = e.touchEventsData, y = u ? -e.translate : e.translate;
      for (let E = 0; E < o.length; E += 1) {
        const h = o[E], g = h.progress, C = Math.min(Math.max(g, -4), 4);
        let _ = h.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (_ -= o[0].swiperSlideOffset);
        let p = e.params.cssMode ? -_ - e.translate : -_, S = 0;
        const w = -100 * Math.abs(C);
        let I = 1, L = -l.perSlideRotate * C, f = l.perSlideOffset - Math.abs(C) * 0.75;
        const P = e.virtual && e.params.virtual.enabled ? e.virtual.from + E : E, D = (P === c || P === c - 1) && C > 0 && C < 1 && (v || e.params.cssMode) && y < m, R = (P === c || P === c + 1) && C < 0 && C > -1 && (v || e.params.cssMode) && y > m;
        if (D || R) {
          const B = Me(1 - Math.abs((Math.abs(C) - 0.5) / 0.5), 0.5);
          L += -28 * C * B, I += -0.5 * B, f += 96 * B, S = `${(l.rotate || e.isHorizontal() ? -25 : 0) * B * Math.abs(C)}%`;
        }
        if (C < 0 ? p = `calc(${p}px ${u ? "-" : "+"} (${f * Math.abs(C)}%))` : C > 0 ? p = `calc(${p}px ${u ? "-" : "+"} (-${f * Math.abs(C)}%))` : p = `${p}px`, !e.isHorizontal()) {
          const B = S;
          S = p, p = B;
        }
        const N = C < 0 ? `${1 + (1 - I) * C}` : `${1 - (1 - I) * C}`, $ = `
        translate3d(${p}, ${S}, ${w}px)
        rotateZ(${l.rotate ? u ? -L : L : 0}deg)
        scale(${N})
      `;
        if (l.slideShadows) {
          let B = h.querySelector(".swiper-slide-shadow");
          B || (B = Di("cards", h)), B && (B.style.opacity = Math.min(Math.max((Math.abs(C) - 0.5) / 0.5, 0), 1));
        }
        h.style.zIndex = -Math.abs(Math.round(g)) + o.length;
        const V = rn(l, h);
        V.style.transform = $;
      }
    }, setTransition: (o) => {
      const c = e.slides.map((u) => ai(u));
      c.forEach((u) => {
        u.style.transitionDuration = `${o}ms`, u.querySelectorAll(".swiper-slide-shadow").forEach((l) => {
          l.style.transitionDuration = `${o}ms`;
        });
      }), Qn({ swiper: e, duration: o, transformElements: c });
    }, perspective: () => true, overwriteParams: () => ({ _loopSwapReset: false, watchSlidesProgress: true, loopAdditionalSlides: e.params.cardsEffect.rotate ? 3 : 2, centeredSlides: true, virtualTranslate: !e.params.cssMode }) });
  }
  const Qg = [xg, Cg, wg, Ag, Ig, Og, Mg, Lg, Pg, Dg, zg, $g, Ng, kg, Rg, Hg, jg, Yg, Xg, qg, Ug, Kg, Zg];
  Be.use(Qg);
  function Jg(e) {
    const { effect: t, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: c, perspective: u, recreateShadows: l, getEffectParams: m } = e;
    n("beforeInit", () => {
      if (i.params.effect !== t) return;
      i.classNames.push(`${i.params.containerModifierClass}${t}`), u && u() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = c ? c() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === t && r();
    }), n("setTransition", (y, E) => {
      i.params.effect === t && o(E);
    }), n("transitionEnd", () => {
      if (i.params.effect === t && l) {
        if (!m || !m().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((E) => E.remove());
        }), l();
      }
    });
    let v;
    n("virtualUpdate", () => {
      i.params.effect === t && (i.slides.length || (v = true), requestAnimationFrame(() => {
        v && i.slides && i.slides.length && (r(), v = false);
      }));
    });
  }
  function ev(e) {
    return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
  }
  function tv(e, t) {
    function i(n) {
      n.target === e && (t.call(e, n), e.removeEventListener("transitionend", i));
    }
    t && e.addEventListener("transitionend", i);
  }
  function iv({ swiper: e, duration: t, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = e;
    if (e.params.virtualTranslate && t !== 0) {
      let o = false, c;
      c = i, c.forEach((u) => {
        tv(u, () => {
          if (o || !e || e.destroyed) return;
          o = true, e.animating = false;
          const l = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          e.wrapperEl.dispatchEvent(l);
        });
      });
    }
  }
  function nv({ swiper: e, extendParams: t, on: i }) {
    t({ stackLiftEffect: {} });
    const n = () => {
      const { slides: u } = e, l = Math.round(u.length > 0 ? u[0].progress : 0), m = u.length;
      for (let v = 0; v < m; v += 1) {
        const y = u[v];
        let h = -y.swiperSlideOffset;
        e.params.virtualTranslate || (h -= e.translate);
        let g = v - l;
        g < 0 && (g += m);
        let C = o(g), _ = r(y, g);
        y.style.setProperty("--swiper-stack-lift-translate-x", `${h}px`), y.style.setProperty("--swiper-stack-lift-translate-y", `${C}px`), y.style.setProperty("--swiper-stack-lift-scale", _), y.style.setProperty("--swiper-stack-lift-z-index", m - g), g === 0 ? y.style.setProperty("--swiper-stack-lift-opacity", 0) : y.style.setProperty("--swiper-stack-lift-opacity", 1), y.dataset.sliderIndex = g;
      }
    };
    function r(u, l) {
      return (u.offsetWidth - 64 * l) / (u.offsetWidth * 1);
    }
    function o(u) {
      return u === 0 ? 0 : u === 1 ? 15 : 15 + (u - 1) * 12;
    }
    Jg({ effect: "stack-lift", swiper: e, on: i, setTranslate: n, setTransition: (u) => {
      const l = e.slides.map((m) => ev(m));
      l.forEach((m) => {
        m.style.transitionDuration = `${u}ms`;
      }), iv({ swiper: e, duration: u, transformElements: l, allSlides: true });
    }, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, watchSlidesProgress: true, centeredSlides: false, speed: 700, virtualTranslate: !e.params.cssMode }) });
  }
  Be.use([nv]);
  window.GSP = window.GSP || {};
  window.GSP.Swiper = { Swiper: Be };
  function sv(e, t, i) {
    if (e == null) return [];
    if (e instanceof EventTarget) return [e];
    if (typeof e == "string") {
      const r = document.querySelectorAll(e);
      return r ? Array.from(r) : [];
    }
    return Array.from(e).filter((n) => n != null);
  }
  const rv = { some: 0, all: 1 };
  function ov(e, t, { root: i, margin: n, amount: r = "some" } = {}) {
    const o = sv(e), c = /* @__PURE__ */ new WeakMap(), u = (m) => {
      m.forEach((v) => {
        const y = c.get(v.target);
        if (v.isIntersecting !== !!y) if (v.isIntersecting) {
          const E = t(v.target, v);
          typeof E == "function" ? c.set(v.target, E) : l.unobserve(v.target);
        } else typeof y == "function" && (y(v), c.delete(v.target));
      });
    }, l = new IntersectionObserver(u, { root: i, rootMargin: n, threshold: typeof r == "number" ? r : rv[r] });
    return o.forEach((m) => l.observe(m)), () => l.disconnect();
  }
  window.GSP = window.GSP || {};
  window.GSP.Motion = { inView: ov };
  var Hn = function() {
    return Hn = Object.assign || function(e) {
      for (var t, i = 1, n = arguments.length; i < n; i++) for (var r in t = arguments[i]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      return e;
    }, Hn.apply(this, arguments);
  }, av = (function() {
    function e(t, i, n) {
      var r = this;
      this.endVal = i, this.options = n, this.version = "2.10.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: true, useGrouping: true, useIndianSeparators: false, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", autoAnimate: false, autoAnimateDelay: 200, autoAnimateOnce: false }, this.finalEndVal = null, this.useEasing = true, this.countDown = false, this.error = "", this.startVal = 0, this.paused = true, this.once = false, this.count = function(o) {
        r.startTime || (r.startTime = o);
        var c = o - r.startTime;
        r.remaining = r.duration - c, r.useEasing ? r.countDown ? r.frameVal = r.startVal - r.easingFn(c, 0, r.startVal - r.endVal, r.duration) : r.frameVal = r.easingFn(c, r.startVal, r.endVal - r.startVal, r.duration) : r.frameVal = r.startVal + (r.endVal - r.startVal) * (c / r.duration);
        var u = r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal;
        r.frameVal = u ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), c < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal !== null ? r.update(r.finalEndVal) : r.options.onCompleteCallback && r.options.onCompleteCallback();
      }, this.formatNumber = function(o) {
        var c, u, l, m, v = o < 0 ? "-" : "";
        c = Math.abs(o).toFixed(r.options.decimalPlaces);
        var y = (c += "").split(".");
        if (u = y[0], l = y.length > 1 ? r.options.decimal + y[1] : "", r.options.useGrouping) {
          m = "";
          for (var E = 3, h = 0, g = 0, C = u.length; g < C; ++g) r.options.useIndianSeparators && g === 4 && (E = 2, h = 1), g !== 0 && h % E == 0 && (m = r.options.separator + m), h++, m = u[C - g - 1] + m;
          u = m;
        }
        return r.options.numerals && r.options.numerals.length && (u = u.replace(/[0-9]/g, (function(_) {
          return r.options.numerals[+_];
        })), l = l.replace(/[0-9]/g, (function(_) {
          return r.options.numerals[+_];
        }))), v + r.options.prefix + u + l + r.options.suffix;
      }, this.easeOutExpo = function(o, c, u, l) {
        return u * (1 - Math.pow(2, -10 * o / l)) * 1024 / 1023 + c;
      }, this.options = Hn(Hn({}, this.defaults), n), this.options.enableScrollSpy && (this.options.autoAnimate = true), this.options.scrollSpyDelay !== void 0 && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = true), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = typeof t == "string" ? document.getElementById(t) : t, i = i == null ? this.parse(this.el.innerHTML) : i, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = false), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window != "undefined" && this.options.autoAnimate && (this.error || typeof IntersectionObserver == "undefined" ? this.error ? console.error(this.error, t) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return e.prototype.setupObserver = function() {
      var t = this, i = e.observedElements.get(this.el);
      i && i.unobserve(), e.observedElements.set(this.el, this), this.observer = new IntersectionObserver((function(n) {
        for (var r = 0, o = n; r < o.length; r++) {
          var c = o[r];
          c.isIntersecting && t.paused && !t.once ? (t.paused = false, t.autoAnimateTimeout = setTimeout((function() {
            return t.start();
          }), t.options.autoAnimateDelay), t.options.autoAnimateOnce && (t.once = true, t.observer.disconnect())) : c.isIntersecting || t.paused || (clearTimeout(t.autoAnimateTimeout), t.reset());
        }
      }), { threshold: 0 }), this.observer.observe(this.el);
    }, e.prototype.unobserve = function() {
      var t;
      clearTimeout(this.autoAnimateTimeout), (t = this.observer) === null || t === void 0 || t.disconnect(), e.observedElements.delete(this.el);
    }, e.prototype.onDestroy = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, e.prototype.determineDirectionAndSmartEasing = function() {
      var t = this.finalEndVal ? this.finalEndVal : this.endVal;
      this.countDown = this.startVal > t;
      var i = t - this.startVal;
      if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
        this.finalEndVal = t;
        var n = this.countDown ? 1 : -1;
        this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
      } else this.endVal = t, this.finalEndVal = null;
      this.finalEndVal !== null ? this.useEasing = false : this.useEasing = this.options.useEasing;
    }, e.prototype.start = function(t) {
      this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = false, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, e.prototype.pauseResume = function() {
      this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, e.prototype.reset = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.once = false, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, e.prototype.update = function(t) {
      cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, e.prototype.printValue = function(t) {
      var i;
      if (this.el) {
        var n = this.formattingFn(t);
        !((i = this.options.plugin) === null || i === void 0) && i.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
      }
    }, e.prototype.ensureNumber = function(t) {
      return typeof t == "number" && !isNaN(t);
    }, e.prototype.validateValue = function(t) {
      var i = Number(t);
      return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, e.prototype.resetDuration = function() {
      this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, e.prototype.parse = function(t) {
      var i = function(c) {
        return c.replace(/([.,'  ])/g, "\\$1");
      }, n = i(this.options.separator), r = i(this.options.decimal), o = t.replace(new RegExp(n, "g"), "").replace(new RegExp(r, "g"), ".");
      return parseFloat(o);
    }, e.observedElements = /* @__PURE__ */ new WeakMap(), e;
  })();
  window.CountUp = av;
  function Yl(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  var js = { exports: {} }, Ys = { exports: {} }, Pn = { exports: {} }, lv = Pn.exports, ga;
  function Xl() {
    return ga || (ga = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.EvEmitter = i();
      })(typeof window != "undefined" ? window : lv, function() {
        function t() {
        }
        var i = t.prototype;
        return i.on = function(n, r) {
          if (!(!n || !r)) {
            var o = this._events = this._events || {}, c = o[n] = o[n] || [];
            return c.indexOf(r) == -1 && c.push(r), this;
          }
        }, i.once = function(n, r) {
          if (!(!n || !r)) {
            this.on(n, r);
            var o = this._onceEvents = this._onceEvents || {}, c = o[n] = o[n] || {};
            return c[r] = true, this;
          }
        }, i.off = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            var c = o.indexOf(r);
            return c != -1 && o.splice(c, 1), this;
          }
        }, i.emitEvent = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            o = o.slice(0), r = r || [];
            for (var c = this._onceEvents && this._onceEvents[n], u = 0; u < o.length; u++) {
              var l = o[u], m = c && c[l];
              m && (this.off(n, l), delete c[l]), l.apply(this, r);
            }
            return this;
          }
        }, i.allOff = function() {
          delete this._events, delete this._onceEvents;
        }, t;
      });
    })(Pn)), Pn.exports;
  }
  var Xs = { exports: {} };
  var va;
  function on() {
    return va || (va = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.getSize = i();
      })(window, function() {
        function i(h) {
          var g = parseFloat(h), C = h.indexOf("%") == -1 && !isNaN(g);
          return C && g;
        }
        function n() {
        }
        var r = typeof console == "undefined" ? n : function(h) {
          console.error(h);
        }, o = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], c = o.length;
        function u() {
          for (var h = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, g = 0; g < c; g++) {
            var C = o[g];
            h[C] = 0;
          }
          return h;
        }
        function l(h) {
          var g = getComputedStyle(h);
          return g || r("Style returned " + g + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), g;
        }
        var m = false, v;
        function y() {
          if (!m) {
            m = true;
            var h = document.createElement("div");
            h.style.width = "200px", h.style.padding = "1px 2px 3px 4px", h.style.borderStyle = "solid", h.style.borderWidth = "1px 2px 3px 4px", h.style.boxSizing = "border-box";
            var g = document.body || document.documentElement;
            g.appendChild(h);
            var C = l(h);
            v = Math.round(i(C.width)) == 200, E.isBoxSizeOuter = v, g.removeChild(h);
          }
        }
        function E(h) {
          if (y(), typeof h == "string" && (h = document.querySelector(h)), !(!h || typeof h != "object" || !h.nodeType)) {
            var g = l(h);
            if (g.display == "none") return u();
            var C = {};
            C.width = h.offsetWidth, C.height = h.offsetHeight;
            for (var _ = C.isBorderBox = g.boxSizing == "border-box", p = 0; p < c; p++) {
              var S = o[p], w = g[S], I = parseFloat(w);
              C[S] = isNaN(I) ? 0 : I;
            }
            var L = C.paddingLeft + C.paddingRight, f = C.paddingTop + C.paddingBottom, P = C.marginLeft + C.marginRight, D = C.marginTop + C.marginBottom, R = C.borderLeftWidth + C.borderRightWidth, N = C.borderTopWidth + C.borderBottomWidth, $ = _ && v, V = i(g.width);
            V !== false && (C.width = V + ($ ? 0 : L + R));
            var B = i(g.height);
            return B !== false && (C.height = B + ($ ? 0 : f + N)), C.innerWidth = C.width - (L + R), C.innerHeight = C.height - (f + N), C.outerWidth = C.width + P, C.outerHeight = C.height + D, C;
          }
        }
        return E;
      });
    })(Xs)), Xs.exports;
  }
  var qs = { exports: {} }, Us = { exports: {} }, ya;
  function ql() {
    return ya || (ya = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.matchesSelector = i();
      })(window, function() {
        var i = (function() {
          var n = window.Element.prototype;
          if (n.matches) return "matches";
          if (n.matchesSelector) return "matchesSelector";
          for (var r = ["webkit", "moz", "ms", "o"], o = 0; o < r.length; o++) {
            var c = r[o], u = c + "MatchesSelector";
            if (n[u]) return u;
          }
        })();
        return function(r, o) {
          return r[i](o);
        };
      });
    })(Us)), Us.exports;
  }
  var ba;
  function Ul() {
    return ba || (ba = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, ql()) : t.fizzyUIUtils = i(t, t.matchesSelector);
      })(window, function(i, n) {
        var r = {};
        r.extend = function(u, l) {
          for (var m in l) u[m] = l[m];
          return u;
        }, r.modulo = function(u, l) {
          return (u % l + l) % l;
        };
        var o = Array.prototype.slice;
        r.makeArray = function(u) {
          if (Array.isArray(u)) return u;
          if (u == null) return [];
          var l = typeof u == "object" && typeof u.length == "number";
          return l ? o.call(u) : [u];
        }, r.removeFrom = function(u, l) {
          var m = u.indexOf(l);
          m != -1 && u.splice(m, 1);
        }, r.getParent = function(u, l) {
          for (; u.parentNode && u != document.body; ) if (u = u.parentNode, n(u, l)) return u;
        }, r.getQueryElement = function(u) {
          return typeof u == "string" ? document.querySelector(u) : u;
        }, r.handleEvent = function(u) {
          var l = "on" + u.type;
          this[l] && this[l](u);
        }, r.filterFindElements = function(u, l) {
          u = r.makeArray(u);
          var m = [];
          return u.forEach(function(v) {
            if (v instanceof HTMLElement) {
              if (!l) {
                m.push(v);
                return;
              }
              n(v, l) && m.push(v);
              for (var y = v.querySelectorAll(l), E = 0; E < y.length; E++) m.push(y[E]);
            }
          }), m;
        }, r.debounceMethod = function(u, l, m) {
          m = m || 100;
          var v = u.prototype[l], y = l + "Timeout";
          u.prototype[l] = function() {
            var E = this[y];
            clearTimeout(E);
            var h = arguments, g = this;
            this[y] = setTimeout(function() {
              v.apply(g, h), delete g[y];
            }, m);
          };
        }, r.docReady = function(u) {
          var l = document.readyState;
          l == "complete" || l == "interactive" ? setTimeout(u) : document.addEventListener("DOMContentLoaded", u);
        }, r.toDashed = function(u) {
          return u.replace(/(.)([A-Z])/g, function(l, m, v) {
            return m + "-" + v;
          }).toLowerCase();
        };
        var c = i.console;
        return r.htmlInit = function(u, l) {
          r.docReady(function() {
            var m = r.toDashed(l), v = "data-" + m, y = document.querySelectorAll("[" + v + "]"), E = document.querySelectorAll(".js-" + m), h = r.makeArray(y).concat(r.makeArray(E)), g = v + "-options", C = i.jQuery;
            h.forEach(function(_) {
              var p = _.getAttribute(v) || _.getAttribute(g), S;
              try {
                S = p && JSON.parse(p);
              } catch (I) {
                c && c.error("Error parsing " + v + " on " + _.className + ": " + I);
                return;
              }
              var w = new u(_, S);
              C && C.data(_, l, w);
            });
          });
        }, r;
      });
    })(qs)), qs.exports;
  }
  var Ks = { exports: {} }, Ea;
  function cv() {
    return Ea || (Ea = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Xl(), on()) : (t.Outlayer = {}, t.Outlayer.Item = i(t.EvEmitter, t.getSize));
      })(window, function(i, n) {
        function r(_) {
          for (var p in _) return false;
          return p = null, true;
        }
        var o = document.documentElement.style, c = typeof o.transition == "string" ? "transition" : "WebkitTransition", u = typeof o.transform == "string" ? "transform" : "WebkitTransform", l = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[c], m = { transform: u, transition: c, transitionDuration: c + "Duration", transitionProperty: c + "Property", transitionDelay: c + "Delay" };
        function v(_, p) {
          _ && (this.element = _, this.layout = p, this.position = { x: 0, y: 0 }, this._create());
        }
        var y = v.prototype = Object.create(i.prototype);
        y.constructor = v, y._create = function() {
          this._transn = { ingProperties: {}, clean: {}, onEnd: {} }, this.css({ position: "absolute" });
        }, y.handleEvent = function(_) {
          var p = "on" + _.type;
          this[p] && this[p](_);
        }, y.getSize = function() {
          this.size = n(this.element);
        }, y.css = function(_) {
          var p = this.element.style;
          for (var S in _) {
            var w = m[S] || S;
            p[w] = _[S];
          }
        }, y.getPosition = function() {
          var _ = getComputedStyle(this.element), p = this.layout._getOption("originLeft"), S = this.layout._getOption("originTop"), w = _[p ? "left" : "right"], I = _[S ? "top" : "bottom"], L = parseFloat(w), f = parseFloat(I), P = this.layout.size;
          w.indexOf("%") != -1 && (L = L / 100 * P.width), I.indexOf("%") != -1 && (f = f / 100 * P.height), L = isNaN(L) ? 0 : L, f = isNaN(f) ? 0 : f, L -= p ? P.paddingLeft : P.paddingRight, f -= S ? P.paddingTop : P.paddingBottom, this.position.x = L, this.position.y = f;
        }, y.layoutPosition = function() {
          var _ = this.layout.size, p = {}, S = this.layout._getOption("originLeft"), w = this.layout._getOption("originTop"), I = S ? "paddingLeft" : "paddingRight", L = S ? "left" : "right", f = S ? "right" : "left", P = this.position.x + _[I];
          p[L] = this.getXValue(P), p[f] = "";
          var D = w ? "paddingTop" : "paddingBottom", R = w ? "top" : "bottom", N = w ? "bottom" : "top", $ = this.position.y + _[D];
          p[R] = this.getYValue($), p[N] = "", this.css(p), this.emitEvent("layout", [this]);
        }, y.getXValue = function(_) {
          var p = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !p ? _ / this.layout.size.width * 100 + "%" : _ + "px";
        }, y.getYValue = function(_) {
          var p = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && p ? _ / this.layout.size.height * 100 + "%" : _ + "px";
        }, y._transitionTo = function(_, p) {
          this.getPosition();
          var S = this.position.x, w = this.position.y, I = _ == this.position.x && p == this.position.y;
          if (this.setPosition(_, p), I && !this.isTransitioning) {
            this.layoutPosition();
            return;
          }
          var L = _ - S, f = p - w, P = {};
          P.transform = this.getTranslate(L, f), this.transition({ to: P, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: true });
        }, y.getTranslate = function(_, p) {
          var S = this.layout._getOption("originLeft"), w = this.layout._getOption("originTop");
          return _ = S ? _ : -_, p = w ? p : -p, "translate3d(" + _ + "px, " + p + "px, 0)";
        }, y.goTo = function(_, p) {
          this.setPosition(_, p), this.layoutPosition();
        }, y.moveTo = y._transitionTo, y.setPosition = function(_, p) {
          this.position.x = parseFloat(_), this.position.y = parseFloat(p);
        }, y._nonTransition = function(_) {
          this.css(_.to), _.isCleaning && this._removeStyles(_.to);
          for (var p in _.onTransitionEnd) _.onTransitionEnd[p].call(this);
        }, y.transition = function(_) {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(_);
            return;
          }
          var p = this._transn;
          for (var S in _.onTransitionEnd) p.onEnd[S] = _.onTransitionEnd[S];
          for (S in _.to) p.ingProperties[S] = true, _.isCleaning && (p.clean[S] = true);
          _.from && (this.css(_.from), this.element.offsetHeight), this.enableTransition(_.to), this.css(_.to), this.isTransitioning = true;
        };
        function E(_) {
          return _.replace(/([A-Z])/g, function(p) {
            return "-" + p.toLowerCase();
          });
        }
        var h = "opacity," + E(u);
        y.enableTransition = function() {
          if (!this.isTransitioning) {
            var _ = this.layout.options.transitionDuration;
            _ = typeof _ == "number" ? _ + "ms" : _, this.css({ transitionProperty: h, transitionDuration: _, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(l, this, false);
          }
        }, y.onwebkitTransitionEnd = function(_) {
          this.ontransitionend(_);
        }, y.onotransitionend = function(_) {
          this.ontransitionend(_);
        };
        var g = { "-webkit-transform": "transform" };
        y.ontransitionend = function(_) {
          if (_.target === this.element) {
            var p = this._transn, S = g[_.propertyName] || _.propertyName;
            if (delete p.ingProperties[S], r(p.ingProperties) && this.disableTransition(), S in p.clean && (this.element.style[_.propertyName] = "", delete p.clean[S]), S in p.onEnd) {
              var w = p.onEnd[S];
              w.call(this), delete p.onEnd[S];
            }
            this.emitEvent("transitionEnd", [this]);
          }
        }, y.disableTransition = function() {
          this.removeTransitionStyles(), this.element.removeEventListener(l, this, false), this.isTransitioning = false;
        }, y._removeStyles = function(_) {
          var p = {};
          for (var S in _) p[S] = "";
          this.css(p);
        };
        var C = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
        return y.removeTransitionStyles = function() {
          this.css(C);
        }, y.stagger = function(_) {
          _ = isNaN(_) ? 0 : _, this.staggerDelay = _ + "ms";
        }, y.removeElem = function() {
          this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
        }, y.remove = function() {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
          }
          this.once("transitionEnd", function() {
            this.removeElem();
          }), this.hide();
        }, y.reveal = function() {
          delete this.isHidden, this.css({ display: "" });
          var _ = this.layout.options, p = {}, S = this.getHideRevealTransitionEndProperty("visibleStyle");
          p[S] = this.onRevealTransitionEnd, this.transition({ from: _.hiddenStyle, to: _.visibleStyle, isCleaning: true, onTransitionEnd: p });
        }, y.onRevealTransitionEnd = function() {
          this.isHidden || this.emitEvent("reveal");
        }, y.getHideRevealTransitionEndProperty = function(_) {
          var p = this.layout.options[_];
          if (p.opacity) return "opacity";
          for (var S in p) return S;
        }, y.hide = function() {
          this.isHidden = true, this.css({ display: "" });
          var _ = this.layout.options, p = {}, S = this.getHideRevealTransitionEndProperty("hiddenStyle");
          p[S] = this.onHideTransitionEnd, this.transition({ from: _.visibleStyle, to: _.hiddenStyle, isCleaning: true, onTransitionEnd: p });
        }, y.onHideTransitionEnd = function() {
          this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
        }, y.destroy = function() {
          this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
        }, v;
      });
    })(Ks)), Ks.exports;
  }
  var Sa;
  function Jn() {
    return Sa || (Sa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, Xl(), on(), Ul(), cv()) : t.Outlayer = i(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
      })(window, function(i, n, r, o, c) {
        var u = i.console, l = i.jQuery, m = function() {
        }, v = 0, y = {};
        function E(p, S) {
          var w = o.getQueryElement(p);
          if (!w) {
            u && u.error("Bad element for " + this.constructor.namespace + ": " + (w || p));
            return;
          }
          this.element = w, l && (this.$element = l(this.element)), this.options = o.extend({}, this.constructor.defaults), this.option(S);
          var I = ++v;
          this.element.outlayerGUID = I, y[I] = this, this._create();
          var L = this._getOption("initLayout");
          L && this.layout();
        }
        E.namespace = "outlayer", E.Item = c, E.defaults = { containerStyle: { position: "relative" }, initLayout: true, originLeft: true, originTop: true, resize: true, resizeContainer: true, transitionDuration: "0.4s", hiddenStyle: { opacity: 0, transform: "scale(0.001)" }, visibleStyle: { opacity: 1, transform: "scale(1)" } };
        var h = E.prototype;
        o.extend(h, n.prototype), h.option = function(p) {
          o.extend(this.options, p);
        }, h._getOption = function(p) {
          var S = this.constructor.compatOptions[p];
          return S && this.options[S] !== void 0 ? this.options[S] : this.options[p];
        }, E.compatOptions = { initLayout: "isInitLayout", horizontal: "isHorizontal", layoutInstant: "isLayoutInstant", originLeft: "isOriginLeft", originTop: "isOriginTop", resize: "isResizeBound", resizeContainer: "isResizingContainer" }, h._create = function() {
          this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), o.extend(this.element.style, this.options.containerStyle);
          var p = this._getOption("resize");
          p && this.bindResize();
        }, h.reloadItems = function() {
          this.items = this._itemize(this.element.children);
        }, h._itemize = function(p) {
          for (var S = this._filterFindItemElements(p), w = this.constructor.Item, I = [], L = 0; L < S.length; L++) {
            var f = S[L], P = new w(f, this);
            I.push(P);
          }
          return I;
        }, h._filterFindItemElements = function(p) {
          return o.filterFindElements(p, this.options.itemSelector);
        }, h.getItemElements = function() {
          return this.items.map(function(p) {
            return p.element;
          });
        }, h.layout = function() {
          this._resetLayout(), this._manageStamps();
          var p = this._getOption("layoutInstant"), S = p !== void 0 ? p : !this._isLayoutInited;
          this.layoutItems(this.items, S), this._isLayoutInited = true;
        }, h._init = h.layout, h._resetLayout = function() {
          this.getSize();
        }, h.getSize = function() {
          this.size = r(this.element);
        }, h._getMeasurement = function(p, S) {
          var w = this.options[p], I;
          w ? (typeof w == "string" ? I = this.element.querySelector(w) : w instanceof HTMLElement && (I = w), this[p] = I ? r(I)[S] : w) : this[p] = 0;
        }, h.layoutItems = function(p, S) {
          p = this._getItemsForLayout(p), this._layoutItems(p, S), this._postLayout();
        }, h._getItemsForLayout = function(p) {
          return p.filter(function(S) {
            return !S.isIgnored;
          });
        }, h._layoutItems = function(p, S) {
          if (this._emitCompleteOnItems("layout", p), !(!p || !p.length)) {
            var w = [];
            p.forEach(function(I) {
              var L = this._getItemLayoutPosition(I);
              L.item = I, L.isInstant = S || I.isLayoutInstant, w.push(L);
            }, this), this._processLayoutQueue(w);
          }
        }, h._getItemLayoutPosition = function() {
          return { x: 0, y: 0 };
        }, h._processLayoutQueue = function(p) {
          this.updateStagger(), p.forEach(function(S, w) {
            this._positionItem(S.item, S.x, S.y, S.isInstant, w);
          }, this);
        }, h.updateStagger = function() {
          var p = this.options.stagger;
          if (p == null) {
            this.stagger = 0;
            return;
          }
          return this.stagger = _(p), this.stagger;
        }, h._positionItem = function(p, S, w, I, L) {
          I ? p.goTo(S, w) : (p.stagger(L * this.stagger), p.moveTo(S, w));
        }, h._postLayout = function() {
          this.resizeContainer();
        }, h.resizeContainer = function() {
          var p = this._getOption("resizeContainer");
          if (p) {
            var S = this._getContainerSize();
            S && (this._setContainerMeasure(S.width, true), this._setContainerMeasure(S.height, false));
          }
        }, h._getContainerSize = m, h._setContainerMeasure = function(p, S) {
          if (p !== void 0) {
            var w = this.size;
            w.isBorderBox && (p += S ? w.paddingLeft + w.paddingRight + w.borderLeftWidth + w.borderRightWidth : w.paddingBottom + w.paddingTop + w.borderTopWidth + w.borderBottomWidth), p = Math.max(p, 0), this.element.style[S ? "width" : "height"] = p + "px";
          }
        }, h._emitCompleteOnItems = function(p, S) {
          var w = this;
          function I() {
            w.dispatchEvent(p + "Complete", null, [S]);
          }
          var L = S.length;
          if (!S || !L) {
            I();
            return;
          }
          var f = 0;
          function P() {
            f++, f == L && I();
          }
          S.forEach(function(D) {
            D.once(p, P);
          });
        }, h.dispatchEvent = function(p, S, w) {
          var I = S ? [S].concat(w) : w;
          if (this.emitEvent(p, I), l) if (this.$element = this.$element || l(this.element), S) {
            var L = l.Event(S);
            L.type = p, this.$element.trigger(L, w);
          } else this.$element.trigger(p, w);
        }, h.ignore = function(p) {
          var S = this.getItem(p);
          S && (S.isIgnored = true);
        }, h.unignore = function(p) {
          var S = this.getItem(p);
          S && delete S.isIgnored;
        }, h.stamp = function(p) {
          p = this._find(p), p && (this.stamps = this.stamps.concat(p), p.forEach(this.ignore, this));
        }, h.unstamp = function(p) {
          p = this._find(p), p && p.forEach(function(S) {
            o.removeFrom(this.stamps, S), this.unignore(S);
          }, this);
        }, h._find = function(p) {
          if (p) return typeof p == "string" && (p = this.element.querySelectorAll(p)), p = o.makeArray(p), p;
        }, h._manageStamps = function() {
          !this.stamps || !this.stamps.length || (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
        }, h._getBoundingRect = function() {
          var p = this.element.getBoundingClientRect(), S = this.size;
          this._boundingRect = { left: p.left + S.paddingLeft + S.borderLeftWidth, top: p.top + S.paddingTop + S.borderTopWidth, right: p.right - (S.paddingRight + S.borderRightWidth), bottom: p.bottom - (S.paddingBottom + S.borderBottomWidth) };
        }, h._manageStamp = m, h._getElementOffset = function(p) {
          var S = p.getBoundingClientRect(), w = this._boundingRect, I = r(p), L = { left: S.left - w.left - I.marginLeft, top: S.top - w.top - I.marginTop, right: w.right - S.right - I.marginRight, bottom: w.bottom - S.bottom - I.marginBottom };
          return L;
        }, h.handleEvent = o.handleEvent, h.bindResize = function() {
          i.addEventListener("resize", this), this.isResizeBound = true;
        }, h.unbindResize = function() {
          i.removeEventListener("resize", this), this.isResizeBound = false;
        }, h.onresize = function() {
          this.resize();
        }, o.debounceMethod(E, "onresize", 100), h.resize = function() {
          !this.isResizeBound || !this.needsResizeLayout() || this.layout();
        }, h.needsResizeLayout = function() {
          var p = r(this.element), S = this.size && p;
          return S && p.innerWidth !== this.size.innerWidth;
        }, h.addItems = function(p) {
          var S = this._itemize(p);
          return S.length && (this.items = this.items.concat(S)), S;
        }, h.appended = function(p) {
          var S = this.addItems(p);
          S.length && (this.layoutItems(S, true), this.reveal(S));
        }, h.prepended = function(p) {
          var S = this._itemize(p);
          if (S.length) {
            var w = this.items.slice(0);
            this.items = S.concat(w), this._resetLayout(), this._manageStamps(), this.layoutItems(S, true), this.reveal(S), this.layoutItems(w);
          }
        }, h.reveal = function(p) {
          if (this._emitCompleteOnItems("reveal", p), !(!p || !p.length)) {
            var S = this.updateStagger();
            p.forEach(function(w, I) {
              w.stagger(I * S), w.reveal();
            });
          }
        }, h.hide = function(p) {
          if (this._emitCompleteOnItems("hide", p), !(!p || !p.length)) {
            var S = this.updateStagger();
            p.forEach(function(w, I) {
              w.stagger(I * S), w.hide();
            });
          }
        }, h.revealItemElements = function(p) {
          var S = this.getItems(p);
          this.reveal(S);
        }, h.hideItemElements = function(p) {
          var S = this.getItems(p);
          this.hide(S);
        }, h.getItem = function(p) {
          for (var S = 0; S < this.items.length; S++) {
            var w = this.items[S];
            if (w.element == p) return w;
          }
        }, h.getItems = function(p) {
          p = o.makeArray(p);
          var S = [];
          return p.forEach(function(w) {
            var I = this.getItem(w);
            I && S.push(I);
          }, this), S;
        }, h.remove = function(p) {
          var S = this.getItems(p);
          this._emitCompleteOnItems("remove", S), !(!S || !S.length) && S.forEach(function(w) {
            w.remove(), o.removeFrom(this.items, w);
          }, this);
        }, h.destroy = function() {
          var p = this.element.style;
          p.height = "", p.position = "", p.width = "", this.items.forEach(function(w) {
            w.destroy();
          }), this.unbindResize();
          var S = this.element.outlayerGUID;
          delete y[S], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace);
        }, E.data = function(p) {
          p = o.getQueryElement(p);
          var S = p && p.outlayerGUID;
          return S && y[S];
        }, E.create = function(p, S) {
          var w = g(E);
          return w.defaults = o.extend({}, E.defaults), o.extend(w.defaults, S), w.compatOptions = o.extend({}, E.compatOptions), w.namespace = p, w.data = E.data, w.Item = g(c), o.htmlInit(w, p), l && l.bridget && l.bridget(p, w), w;
        };
        function g(p) {
          function S() {
            p.apply(this, arguments);
          }
          return S.prototype = Object.create(p.prototype), S.prototype.constructor = S, S;
        }
        var C = { ms: 1, s: 1e3 };
        function _(p) {
          if (typeof p == "number") return p;
          var S = p.match(/(^\d*\.?\d*)(\w*)/), w = S && S[1], I = S && S[2];
          if (!w.length) return 0;
          w = parseFloat(w);
          var L = C[I] || 1;
          return w * L;
        }
        return E.Item = c, E;
      });
    })(Ys)), Ys.exports;
  }
  var Zs = { exports: {} }, Ta;
  function uv() {
    return Ta || (Ta = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Jn()) : (t.Isotope = t.Isotope || {}, t.Isotope.Item = i(t.Outlayer));
      })(window, function(i) {
        function n() {
          i.Item.apply(this, arguments);
        }
        var r = n.prototype = Object.create(i.Item.prototype), o = r._create;
        r._create = function() {
          this.id = this.layout.itemGUID++, o.call(this), this.sortData = {};
        }, r.updateSortData = function() {
          if (!this.isIgnored) {
            this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
            var u = this.layout.options.getSortData, l = this.layout._sorters;
            for (var m in u) {
              var v = l[m];
              this.sortData[m] = v(this.element, this);
            }
          }
        };
        var c = r.destroy;
        return r.destroy = function() {
          c.apply(this, arguments), this.css({ display: "" });
        }, n;
      });
    })(Zs)), Zs.exports;
  }
  var Qs = { exports: {} }, _a;
  function es() {
    return _a || (_a = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(on(), Jn()) : (t.Isotope = t.Isotope || {}, t.Isotope.LayoutMode = i(t.getSize, t.Outlayer));
      })(window, function(i, n) {
        function r(u) {
          this.isotope = u, u && (this.options = u.options[this.namespace], this.element = u.element, this.items = u.filteredItems, this.size = u.size);
        }
        var o = r.prototype, c = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"];
        return c.forEach(function(u) {
          o[u] = function() {
            return n.prototype[u].apply(this.isotope, arguments);
          };
        }), o.needsVerticalResizeLayout = function() {
          var u = i(this.isotope.element), l = this.isotope.size && u;
          return l && u.innerHeight != this.isotope.size.innerHeight;
        }, o._getMeasurement = function() {
          this.isotope._getMeasurement.apply(this, arguments);
        }, o.getColumnWidth = function() {
          this.getSegmentSize("column", "Width");
        }, o.getRowHeight = function() {
          this.getSegmentSize("row", "Height");
        }, o.getSegmentSize = function(u, l) {
          var m = u + l, v = "outer" + l;
          if (this._getMeasurement(m, v), !this[m]) {
            var y = this.getFirstItemSize();
            this[m] = y && y[v] || this.isotope.size["inner" + l];
          }
        }, o.getFirstItemSize = function() {
          var u = this.isotope.filteredItems[0];
          return u && u.element && i(u.element);
        }, o.layout = function() {
          this.isotope.layout.apply(this.isotope, arguments);
        }, o.getSize = function() {
          this.isotope.getSize(), this.size = this.isotope.size;
        }, r.modes = {}, r.create = function(u, l) {
          function m() {
            r.apply(this, arguments);
          }
          return m.prototype = Object.create(o), m.prototype.constructor = m, l && (m.options = l), m.prototype.namespace = u, r.modes[u] = m, m;
        }, r;
      });
    })(Qs)), Qs.exports;
  }
  var Js = { exports: {} }, er = { exports: {} };
  var xa;
  function dv() {
    return xa || (xa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Jn(), on()) : t.Masonry = i(t.Outlayer, t.getSize);
      })(window, function(i, n) {
        var r = i.create("masonry");
        r.compatOptions.fitWidth = "isFitWidth";
        var o = r.prototype;
        return o._resetLayout = function() {
          this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
          for (var c = 0; c < this.cols; c++) this.colYs.push(0);
          this.maxY = 0, this.horizontalColIndex = 0;
        }, o.measureColumns = function() {
          if (this.getContainerWidth(), !this.columnWidth) {
            var c = this.items[0], u = c && c.element;
            this.columnWidth = u && n(u).outerWidth || this.containerWidth;
          }
          var l = this.columnWidth += this.gutter, m = this.containerWidth + this.gutter, v = m / l, y = l - m % l, E = y && y < 1 ? "round" : "floor";
          v = Math[E](v), this.cols = Math.max(v, 1);
        }, o.getContainerWidth = function() {
          var c = this._getOption("fitWidth"), u = c ? this.element.parentNode : this.element, l = n(u);
          this.containerWidth = l && l.innerWidth;
        }, o._getItemLayoutPosition = function(c) {
          c.getSize();
          var u = c.size.outerWidth % this.columnWidth, l = u && u < 1 ? "round" : "ceil", m = Math[l](c.size.outerWidth / this.columnWidth);
          m = Math.min(m, this.cols);
          for (var v = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", y = this[v](m, c), E = { x: this.columnWidth * y.col, y: y.y }, h = y.y + c.size.outerHeight, g = m + y.col, C = y.col; C < g; C++) this.colYs[C] = h;
          return E;
        }, o._getTopColPosition = function(c) {
          var u = this._getTopColGroup(c), l = Math.min.apply(Math, u);
          return { col: u.indexOf(l), y: l };
        }, o._getTopColGroup = function(c) {
          if (c < 2) return this.colYs;
          for (var u = [], l = this.cols + 1 - c, m = 0; m < l; m++) u[m] = this._getColGroupY(m, c);
          return u;
        }, o._getColGroupY = function(c, u) {
          if (u < 2) return this.colYs[c];
          var l = this.colYs.slice(c, c + u);
          return Math.max.apply(Math, l);
        }, o._getHorizontalColPosition = function(c, u) {
          var l = this.horizontalColIndex % this.cols, m = c > 1 && l + c > this.cols;
          l = m ? 0 : l;
          var v = u.size.outerWidth && u.size.outerHeight;
          return this.horizontalColIndex = v ? l + c : this.horizontalColIndex, { col: l, y: this._getColGroupY(l, c) };
        }, o._manageStamp = function(c) {
          var u = n(c), l = this._getElementOffset(c), m = this._getOption("originLeft"), v = m ? l.left : l.right, y = v + u.outerWidth, E = Math.floor(v / this.columnWidth);
          E = Math.max(0, E);
          var h = Math.floor(y / this.columnWidth);
          h -= y % this.columnWidth ? 0 : 1, h = Math.min(this.cols - 1, h);
          for (var g = this._getOption("originTop"), C = (g ? l.top : l.bottom) + u.outerHeight, _ = E; _ <= h; _++) this.colYs[_] = Math.max(C, this.colYs[_]);
        }, o._getContainerSize = function() {
          this.maxY = Math.max.apply(Math, this.colYs);
          var c = { height: this.maxY };
          return this._getOption("fitWidth") && (c.width = this._getContainerFitWidth()), c;
        }, o._getContainerFitWidth = function() {
          for (var c = 0, u = this.cols; --u && this.colYs[u] === 0; ) c++;
          return (this.cols - c) * this.columnWidth - this.gutter;
        }, o.needsResizeLayout = function() {
          var c = this.containerWidth;
          return this.getContainerWidth(), c != this.containerWidth;
        }, r;
      });
    })(er)), er.exports;
  }
  var Ca;
  function fv() {
    return Ca || (Ca = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(es(), dv()) : i(t.Isotope.LayoutMode, t.Masonry);
      })(window, function(i, n) {
        var r = i.create("masonry"), o = r.prototype, c = { _getElementOffset: true, layout: true, _getMeasurement: true };
        for (var u in n.prototype) c[u] || (o[u] = n.prototype[u]);
        var l = o.measureColumns;
        o.measureColumns = function() {
          this.items = this.isotope.filteredItems, l.call(this);
        };
        var m = o._getOption;
        return o._getOption = function(v) {
          return v == "fitWidth" ? this.options.isFitWidth !== void 0 ? this.options.isFitWidth : this.options.fitWidth : m.apply(this.isotope, arguments);
        }, r;
      });
    })(Js)), Js.exports;
  }
  var tr = { exports: {} }, wa;
  function hv() {
    return wa || (wa = 1, (function(e, t) {
      (function(i, n) {
        e.exports = n(es());
      })(window, function(n) {
        var r = n.create("fitRows"), o = r.prototype;
        return o._resetLayout = function() {
          this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth");
        }, o._getItemLayoutPosition = function(c) {
          c.getSize();
          var u = c.size.outerWidth + this.gutter, l = this.isotope.size.innerWidth + this.gutter;
          this.x !== 0 && u + this.x > l && (this.x = 0, this.y = this.maxY);
          var m = { x: this.x, y: this.y };
          return this.maxY = Math.max(this.maxY, this.y + c.size.outerHeight), this.x += u, m;
        }, o._getContainerSize = function() {
          return { height: this.maxY };
        }, r;
      });
    })(tr)), tr.exports;
  }
  var ir = { exports: {} }, Aa;
  function pv() {
    return Aa || (Aa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(es()) : i(t.Isotope.LayoutMode);
      })(window, function(i) {
        var n = i.create("vertical", { horizontalAlignment: 0 }), r = n.prototype;
        return r._resetLayout = function() {
          this.y = 0;
        }, r._getItemLayoutPosition = function(o) {
          o.getSize();
          var c = (this.isotope.size.innerWidth - o.size.outerWidth) * this.options.horizontalAlignment, u = this.y;
          return this.y += o.size.outerHeight, { x: c, y: u };
        }, r._getContainerSize = function() {
          return { height: this.y };
        }, n;
      });
    })(ir)), ir.exports;
  }
  var Ia;
  function mv() {
    return Ia || (Ia = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, Jn(), on(), ql(), Ul(), uv(), es(), fv(), hv(), pv()) : t.Isotope = i(t, t.Outlayer, t.getSize, t.matchesSelector, t.fizzyUIUtils, t.Isotope.Item, t.Isotope.LayoutMode);
      })(window, function(i, n, r, o, c, u, l) {
        var m = i.jQuery, v = String.prototype.trim ? function(_) {
          return _.trim();
        } : function(_) {
          return _.replace(/^\s+|\s+$/g, "");
        }, y = n.create("isotope", { layoutMode: "masonry", isJQueryFiltering: true, sortAscending: true });
        y.Item = u, y.LayoutMode = l;
        var E = y.prototype;
        E._create = function() {
          this.itemGUID = 0, this._sorters = {}, this._getSorters(), n.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"];
          for (var _ in l.modes) this._initLayoutMode(_);
        }, E.reloadItems = function() {
          this.itemGUID = 0, n.prototype.reloadItems.call(this);
        }, E._itemize = function() {
          for (var _ = n.prototype._itemize.apply(this, arguments), p = 0; p < _.length; p++) {
            var S = _[p];
            S.id = this.itemGUID++;
          }
          return this._updateItemsSortData(_), _;
        }, E._initLayoutMode = function(_) {
          var p = l.modes[_], S = this.options[_] || {};
          this.options[_] = p.options ? c.extend(p.options, S) : S, this.modes[_] = new p(this);
        }, E.layout = function() {
          if (!this._isLayoutInited && this._getOption("initLayout")) {
            this.arrange();
            return;
          }
          this._layout();
        }, E._layout = function() {
          var _ = this._getIsInstant();
          this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, _), this._isLayoutInited = true;
        }, E.arrange = function(_) {
          this.option(_), this._getIsInstant();
          var p = this._filter(this.items);
          this.filteredItems = p.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [p]) : this._hideReveal(p), this._sort(), this._layout();
        }, E._init = E.arrange, E._hideReveal = function(_) {
          this.reveal(_.needReveal), this.hide(_.needHide);
        }, E._getIsInstant = function() {
          var _ = this._getOption("layoutInstant"), p = _ !== void 0 ? _ : !this._isLayoutInited;
          return this._isInstant = p, p;
        }, E._bindArrangeComplete = function() {
          var _, p, S, w = this;
          function I() {
            _ && p && S && w.dispatchEvent("arrangeComplete", null, [w.filteredItems]);
          }
          this.once("layoutComplete", function() {
            _ = true, I();
          }), this.once("hideComplete", function() {
            p = true, I();
          }), this.once("revealComplete", function() {
            S = true, I();
          });
        }, E._filter = function(_) {
          var p = this.options.filter;
          p = p || "*";
          for (var S = [], w = [], I = [], L = this._getFilterTest(p), f = 0; f < _.length; f++) {
            var P = _[f];
            if (!P.isIgnored) {
              var D = L(P);
              D && S.push(P), D && P.isHidden ? w.push(P) : !D && !P.isHidden && I.push(P);
            }
          }
          return { matches: S, needReveal: w, needHide: I };
        }, E._getFilterTest = function(_) {
          return m && this.options.isJQueryFiltering ? function(p) {
            return m(p.element).is(_);
          } : typeof _ == "function" ? function(p) {
            return _(p.element);
          } : function(p) {
            return o(p.element, _);
          };
        }, E.updateSortData = function(_) {
          var p;
          _ ? (_ = c.makeArray(_), p = this.getItems(_)) : p = this.items, this._getSorters(), this._updateItemsSortData(p);
        }, E._getSorters = function() {
          var _ = this.options.getSortData;
          for (var p in _) {
            var S = _[p];
            this._sorters[p] = h(S);
          }
        }, E._updateItemsSortData = function(_) {
          for (var p = _ && _.length, S = 0; p && S < p; S++) {
            var w = _[S];
            w.updateSortData();
          }
        };
        var h = /* @__PURE__ */ (function() {
          function _(S) {
            if (typeof S != "string") return S;
            var w = v(S).split(" "), I = w[0], L = I.match(/^\[(.+)\]$/), f = L && L[1], P = p(f, I), D = y.sortDataParsers[w[1]];
            return S = D ? function(R) {
              return R && D(P(R));
            } : function(R) {
              return R && P(R);
            }, S;
          }
          function p(S, w) {
            return S ? function(L) {
              return L.getAttribute(S);
            } : function(L) {
              var f = L.querySelector(w);
              return f && f.textContent;
            };
          }
          return _;
        })();
        y.sortDataParsers = { parseInt: function(_) {
          return parseInt(_, 10);
        }, parseFloat: function(_) {
          return parseFloat(_);
        } }, E._sort = function() {
          if (this.options.sortBy) {
            var _ = c.makeArray(this.options.sortBy);
            this._getIsSameSortBy(_) || (this.sortHistory = _.concat(this.sortHistory));
            var p = g(this.sortHistory, this.options.sortAscending);
            this.filteredItems.sort(p);
          }
        }, E._getIsSameSortBy = function(_) {
          for (var p = 0; p < _.length; p++) if (_[p] != this.sortHistory[p]) return false;
          return true;
        };
        function g(_, p) {
          return function(w, I) {
            for (var L = 0; L < _.length; L++) {
              var f = _[L], P = w.sortData[f], D = I.sortData[f];
              if (P > D || P < D) {
                var R = p[f] !== void 0 ? p[f] : p, N = R ? 1 : -1;
                return (P > D ? 1 : -1) * N;
              }
            }
            return 0;
          };
        }
        E._mode = function() {
          var _ = this.options.layoutMode, p = this.modes[_];
          if (!p) throw new Error("No layout mode: " + _);
          return p.options = this.options[_], p;
        }, E._resetLayout = function() {
          n.prototype._resetLayout.call(this), this._mode()._resetLayout();
        }, E._getItemLayoutPosition = function(_) {
          return this._mode()._getItemLayoutPosition(_);
        }, E._manageStamp = function(_) {
          this._mode()._manageStamp(_);
        }, E._getContainerSize = function() {
          return this._mode()._getContainerSize();
        }, E.needsResizeLayout = function() {
          return this._mode().needsResizeLayout();
        }, E.appended = function(_) {
          var p = this.addItems(_);
          if (p.length) {
            var S = this._filterRevealAdded(p);
            this.filteredItems = this.filteredItems.concat(S);
          }
        }, E.prepended = function(_) {
          var p = this._itemize(_);
          if (p.length) {
            this._resetLayout(), this._manageStamps();
            var S = this._filterRevealAdded(p);
            this.layoutItems(this.filteredItems), this.filteredItems = S.concat(this.filteredItems), this.items = p.concat(this.items);
          }
        }, E._filterRevealAdded = function(_) {
          var p = this._filter(_);
          return this.hide(p.needHide), this.reveal(p.matches), this.layoutItems(p.matches, true), p.matches;
        }, E.insert = function(_) {
          var p = this.addItems(_);
          if (p.length) {
            var S, w, I = p.length;
            for (S = 0; S < I; S++) w = p[S], this.element.appendChild(w.element);
            var L = this._filter(p).matches;
            for (S = 0; S < I; S++) p[S].isLayoutInstant = true;
            for (this.arrange(), S = 0; S < I; S++) delete p[S].isLayoutInstant;
            this.reveal(L);
          }
        };
        var C = E.remove;
        return E.remove = function(_) {
          _ = c.makeArray(_);
          var p = this.getItems(_);
          C.call(this, _);
          for (var S = p && p.length, w = 0; S && w < S; w++) {
            var I = p[w];
            c.removeFrom(this.filteredItems, I);
          }
        }, E.shuffle = function() {
          for (var _ = 0; _ < this.items.length; _++) {
            var p = this.items[_];
            p.sortData.random = Math.random();
          }
          this.options.sortBy = "random", this._sort(), this._layout();
        }, E._noTransition = function(_, p) {
          var S = this.options.transitionDuration;
          this.options.transitionDuration = 0;
          var w = _.apply(this, p);
          return this.options.transitionDuration = S, w;
        }, E.getFilteredItemElements = function() {
          return this.filteredItems.map(function(_) {
            return _.element;
          });
        }, y;
      });
    })(js)), js.exports;
  }
  var gv = mv();
  const Kl = Yl(gv);
  window.jQuery && (function(e) {
    e.bridget = e.bridget || function(t, i) {
      e.fn[t] = function(n) {
        return this.each(function() {
          new i(this, n);
        });
      };
    }, e.bridget("isotope", Kl);
  })(window.jQuery);
  window.Isotope = Kl;
  var Rt = function() {
    return Rt = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Rt.apply(this, arguments);
  };
  function vv() {
    for (var e = 0, t = 0, i = arguments.length; t < i; t++) e += arguments[t].length;
    for (var n = Array(e), r = 0, t = 0; t < i; t++) for (var o = arguments[t], c = 0, u = o.length; c < u; c++, r++) n[r] = o[c];
    return n;
  }
  var me = { afterAppendSlide: "lgAfterAppendSlide", init: "lgInit", hasVideo: "lgHasVideo", containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", afterAppendSubHtml: "lgAfterAppendSubHtml", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick", dragStart: "lgDragStart", dragMove: "lgDragMove", dragEnd: "lgDragEnd", beforeNextSlide: "lgBeforeNextSlide", beforePrevSlide: "lgBeforePrevSlide", beforeClose: "lgBeforeClose", afterClose: "lgAfterClose" }, yv = { mode: "lg-slide", easing: "ease", speed: 400, licenseKey: "0000-0000-000-0000", height: "100%", width: "100%", addClass: "", startClass: "lg-start-zoom", backdropDuration: 300, container: "", startAnimationDuration: 400, zoomFromOrigin: true, hideBarsDelay: 0, showBarsAfter: 1e4, slideDelay: 0, supportLegacyBrowser: true, allowMediaOverlap: false, videoMaxSize: "1280-720", loadYouTubePoster: true, defaultCaptionHeight: 0, ariaLabelledby: "", ariaDescribedby: "", resetScrollPosition: true, hideScrollbar: false, closable: true, swipeToClose: true, closeOnTap: true, showCloseIcon: true, showMaximizeIcon: false, loop: true, escKey: true, keyPress: true, trapFocus: true, controls: true, slideEndAnimation: true, hideControlOnEnd: false, mousewheel: false, getCaptionFromTitleOrAlt: true, appendSubHtmlTo: ".lg-sub-html", subHtmlSelectorRelative: false, preload: 2, numberOfSlideItemsInDom: 10, selector: "", selectWithin: "", nextHtml: "", prevHtml: "", index: 0, iframeWidth: "100%", iframeHeight: "100%", iframeMaxWidth: "100%", iframeMaxHeight: "100%", download: true, counter: true, appendCounterTo: ".lg-toolbar", swipeThreshold: 50, enableSwipe: true, enableDrag: true, dynamic: false, dynamicEl: [], extraProps: [], exThumbImage: "", isMobile: void 0, mobileSettings: { controls: false, showCloseIcon: false, download: false }, plugins: [], strings: { closeGallery: "Close gallery", toggleMaximize: "Toggle maximize", previousSlide: "Previous slide", nextSlide: "Next slide", download: "Download", playVideo: "Play video", mediaLoadingFailed: "Oops... Failed to load content..." } };
  function bv() {
    (function() {
      if (typeof window.CustomEvent == "function") return false;
      function e(t, i) {
        i = i || { bubbles: false, cancelable: false, detail: null };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), n;
      }
      window.CustomEvent = e;
    })(), (function() {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    })();
  }
  var Zl = (function() {
    function e(t) {
      return this.cssVenderPrefixes = ["TransitionDuration", "TransitionTimingFunction", "Transform", "Transition"], this.selector = this._getSelector(t), this.firstElement = this._getFirstEl(), this;
    }
    return e.generateUUID = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
        var i = Math.random() * 16 | 0, n = t == "x" ? i : i & 3 | 8;
        return n.toString(16);
      });
    }, e.prototype._getSelector = function(t, i) {
      if (i === void 0 && (i = document), typeof t != "string") return t;
      i = i || document;
      var n = t.substring(0, 1);
      return n === "#" ? i.querySelector(t) : i.querySelectorAll(t);
    }, e.prototype._each = function(t) {
      return this.selector ? (this.selector.length !== void 0 ? [].forEach.call(this.selector, t) : t(this.selector, 0), this) : this;
    }, e.prototype._setCssVendorPrefix = function(t, i, n) {
      var r = i.replace(/-([a-z])/gi, function(o, c) {
        return c.toUpperCase();
      });
      this.cssVenderPrefixes.indexOf(r) !== -1 ? (t.style[r.charAt(0).toLowerCase() + r.slice(1)] = n, t.style["webkit" + r] = n, t.style["moz" + r] = n, t.style["ms" + r] = n, t.style["o" + r] = n) : t.style[r] = n;
    }, e.prototype._getFirstEl = function() {
      return this.selector && this.selector.length !== void 0 ? this.selector[0] : this.selector;
    }, e.prototype.isEventMatched = function(t, i) {
      var n = i.split(".");
      return t.split(".").filter(function(r) {
        return r;
      }).every(function(r) {
        return n.indexOf(r) !== -1;
      });
    }, e.prototype.attr = function(t, i) {
      return i === void 0 ? this.firstElement ? this.firstElement.getAttribute(t) : "" : (this._each(function(n) {
        n.setAttribute(t, i);
      }), this);
    }, e.prototype.find = function(t) {
      return re(this._getSelector(t, this.selector));
    }, e.prototype.first = function() {
      return this.selector && this.selector.length !== void 0 ? re(this.selector[0]) : re(this.selector);
    }, e.prototype.eq = function(t) {
      return re(this.selector[t]);
    }, e.prototype.parent = function() {
      return re(this.selector.parentElement);
    }, e.prototype.get = function() {
      return this._getFirstEl();
    }, e.prototype.removeAttr = function(t) {
      var i = t.split(" ");
      return this._each(function(n) {
        i.forEach(function(r) {
          return n.removeAttribute(r);
        });
      }), this;
    }, e.prototype.wrap = function(t) {
      if (!this.firstElement) return this;
      var i = document.createElement("div");
      return i.className = t, this.firstElement.parentNode.insertBefore(i, this.firstElement), this.firstElement.parentNode.removeChild(this.firstElement), i.appendChild(this.firstElement), this;
    }, e.prototype.addClass = function(t) {
      return t === void 0 && (t = ""), this._each(function(i) {
        t.split(" ").forEach(function(n) {
          n && i.classList.add(n);
        });
      }), this;
    }, e.prototype.removeClass = function(t) {
      return this._each(function(i) {
        t.split(" ").forEach(function(n) {
          n && i.classList.remove(n);
        });
      }), this;
    }, e.prototype.hasClass = function(t) {
      return this.firstElement ? this.firstElement.classList.contains(t) : false;
    }, e.prototype.hasAttribute = function(t) {
      return this.firstElement ? this.firstElement.hasAttribute(t) : false;
    }, e.prototype.toggleClass = function(t) {
      return this.firstElement ? (this.hasClass(t) ? this.removeClass(t) : this.addClass(t), this) : this;
    }, e.prototype.css = function(t, i) {
      var n = this;
      return this._each(function(r) {
        n._setCssVendorPrefix(r, t, i);
      }), this;
    }, e.prototype.on = function(t, i) {
      var n = this;
      return this.selector ? (t.split(" ").forEach(function(r) {
        Array.isArray(e.eventListeners[r]) || (e.eventListeners[r] = []), e.eventListeners[r].push(i), n.selector.addEventListener(r.split(".")[0], i);
      }), this) : this;
    }, e.prototype.once = function(t, i) {
      var n = this;
      return this.on(t, function() {
        n.off(t), i(t);
      }), this;
    }, e.prototype.off = function(t) {
      var i = this;
      return this.selector ? (Object.keys(e.eventListeners).forEach(function(n) {
        i.isEventMatched(t, n) && (e.eventListeners[n].forEach(function(r) {
          i.selector.removeEventListener(n.split(".")[0], r);
        }), e.eventListeners[n] = []);
      }), this) : this;
    }, e.prototype.trigger = function(t, i) {
      if (!this.firstElement) return this;
      var n = new CustomEvent(t.split(".")[0], { detail: i || null });
      return this.firstElement.dispatchEvent(n), this;
    }, e.prototype.load = function(t) {
      var i = this;
      return fetch(t).then(function(n) {
        return n.text();
      }).then(function(n) {
        i.selector.innerHTML = n;
      }), this;
    }, e.prototype.html = function(t) {
      return t === void 0 ? this.firstElement ? this.firstElement.innerHTML : "" : (this._each(function(i) {
        i.innerHTML = t;
      }), this);
    }, e.prototype.append = function(t) {
      return this._each(function(i) {
        typeof t == "string" ? i.insertAdjacentHTML("beforeend", t) : i.appendChild(t);
      }), this;
    }, e.prototype.prepend = function(t) {
      return this._each(function(i) {
        typeof t == "string" ? i.insertAdjacentHTML("afterbegin", t) : t instanceof HTMLElement && i.insertBefore(t.cloneNode(true), i.firstChild);
      }), this;
    }, e.prototype.remove = function() {
      return this._each(function(t) {
        t.parentNode.removeChild(t);
      }), this;
    }, e.prototype.empty = function() {
      return this._each(function(t) {
        t.innerHTML = "";
      }), this;
    }, e.prototype.scrollTop = function(t) {
      return t !== void 0 ? (document.body.scrollTop = t, document.documentElement.scrollTop = t, this) : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }, e.prototype.scrollLeft = function(t) {
      return t !== void 0 ? (document.body.scrollLeft = t, document.documentElement.scrollLeft = t, this) : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    }, e.prototype.offset = function() {
      if (!this.firstElement) return { left: 0, top: 0 };
      var t = this.firstElement.getBoundingClientRect(), i = re("body").style().marginLeft;
      return { left: t.left - parseFloat(i) + this.scrollLeft(), top: t.top + this.scrollTop() };
    }, e.prototype.style = function() {
      return this.firstElement ? this.firstElement.currentStyle || window.getComputedStyle(this.firstElement) : {};
    }, e.prototype.width = function() {
      var t = this.style();
      return this.firstElement.clientWidth - parseFloat(t.paddingLeft) - parseFloat(t.paddingRight);
    }, e.prototype.height = function() {
      var t = this.style();
      return this.firstElement.clientHeight - parseFloat(t.paddingTop) - parseFloat(t.paddingBottom);
    }, e.eventListeners = {}, e;
  })();
  function re(e) {
    return bv(), new Zl(e);
  }
  var Ev = ["src", "sources", "subHtml", "subHtmlUrl", "html", "video", "poster", "slideName", "responsive", "srcset", "sizes", "iframe", "downloadUrl", "download", "width", "facebookShareUrl", "tweetText", "iframeTitle", "twitterShareUrl", "pinterestShareUrl", "pinterestText", "fbHtml", "disqusIdentifier", "disqusUrl"];
  function Sv(e) {
    return e === "href" ? "src" : (e = e.replace("data-", ""), e = e.charAt(0).toLowerCase() + e.slice(1), e = e.replace(/-([a-z])/g, function(t) {
      return t[1].toUpperCase();
    }), e);
  }
  var Ie = { fetchCaptionFromUrl: function(e, t, i) {
    fetch(e).then(function(n) {
      return n.text();
    }).then(function(n) {
      if (i === "append") {
        var r = '<div class="lg-sub-html">' + n + "</div>";
        t.append(r);
      } else t.html(n);
    });
  }, getSize: function(e, t, i, n) {
    i === void 0 && (i = 0);
    var r = re(e), o = r.attr("data-lg-size") || n;
    if (o) {
      var c = o.split(",");
      if (c[1]) for (var u = window.innerWidth, l = 0; l < c.length; l++) {
        var m = c[l], v = parseInt(m.split("-")[2], 10);
        if (v > u) {
          o = m;
          break;
        }
        l === c.length - 1 && (o = m);
      }
      var y = o.split("-"), E = parseInt(y[0], 10), h = parseInt(y[1], 10), g = t.width(), C = t.height() - i, _ = Math.min(g, E), p = Math.min(C, h), S = Math.min(_ / E, p / h);
      return { width: E * S, height: h * S };
    }
  }, getTransform: function(e, t, i, n, r) {
    if (r) {
      var o = re(e).find("img").first();
      if (o.get()) {
        var c = t.get().getBoundingClientRect(), u = c.width, l = t.height() - (i + n), m = o.width(), v = o.height(), y = o.style(), E = (u - m) / 2 - o.offset().left + (parseFloat(y.paddingLeft) || 0) + (parseFloat(y.borderLeft) || 0) + re(window).scrollLeft() + c.left, h = (l - v) / 2 - o.offset().top + (parseFloat(y.paddingTop) || 0) + (parseFloat(y.borderTop) || 0) + re(window).scrollTop() + i, g = m / r.width, C = v / r.height, _ = "translate3d(" + (E *= -1) + "px, " + (h *= -1) + "px, 0) scale3d(" + g + ", " + C + ", 1)";
        return _;
      }
    }
  }, getIframeMarkup: function(e, t, i, n, r, o) {
    var c = o ? 'title="' + o + '"' : "";
    return '<div class="lg-media-cont lg-has-iframe" style="width:' + e + "; max-width:" + i + "; height: " + t + "; max-height:" + n + `">
                    <iframe class="lg-object" frameborder="0" ` + c + ' src="' + r + `"  allowfullscreen="true"></iframe>
                </div>`;
  }, getImgMarkup: function(e, t, i, n, r, o) {
    var c = n ? 'srcset="' + n + '"' : "", u = r ? 'sizes="' + r + '"' : "", l = "<img " + i + " " + c + "  " + u + ' class="lg-object lg-image" data-index="' + e + '" src="' + t + '" />', m = "";
    if (o) {
      var v = typeof o == "string" ? JSON.parse(o) : o;
      m = v.map(function(y) {
        var E = "";
        return Object.keys(y).forEach(function(h) {
          E += " " + h + '="' + y[h] + '"';
        }), "<source " + E + "></source>";
      });
    }
    return "" + m + l;
  }, getResponsiveSrc: function(e) {
    for (var t = [], i = [], n = "", r = 0; r < e.length; r++) {
      var o = e[r].split(" ");
      o[0] === "" && o.splice(0, 1), i.push(o[0]), t.push(o[1]);
    }
    for (var c = window.innerWidth, u = 0; u < t.length; u++) if (parseInt(t[u], 10) > c) {
      n = i[u];
      break;
    }
    return n;
  }, isImageLoaded: function(e) {
    return !(!e || !e.complete || e.naturalWidth === 0);
  }, getVideoPosterMarkup: function(e, t, i, n, r) {
    var o = "";
    r && r.youtube ? o = "lg-has-youtube" : r && r.vimeo ? o = "lg-has-vimeo" : o = "lg-has-html5";
    var c = t;
    return typeof t != "string" && (c = t.outerHTML), '<div class="lg-video-cont ' + o + '" style="' + i + `">
                <div class="lg-video-play-button">
                <svg
                    viewBox="0 0 20 20"
                    preserveAspectRatio="xMidYMid"
                    focusable="false"
                    aria-labelledby="` + n + `"
                    role="img"
                    class="lg-video-play-icon"
                >
                    <title>` + n + `</title>
                    <polygon class="lg-video-play-icon-inner" points="1,0 20,10 1,20"></polygon>
                </svg>
                <svg class="lg-video-play-icon-bg" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle></svg>
                <svg class="lg-video-play-icon-circle" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle>
                </svg>
            </div>
            ` + c + `
            <img class="lg-object lg-video-poster" src="` + e + `" />
        </div>`;
  }, getFocusableElements: function(e) {
    var t = e.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), i = [].filter.call(t, function(n) {
      var r = window.getComputedStyle(n);
      return r.display !== "none" && r.visibility !== "hidden";
    });
    return i;
  }, getDynamicOptions: function(e, t, i, n) {
    var r = [], o = vv(Ev, t);
    return [].forEach.call(e, function(c) {
      for (var u = {}, l = 0; l < c.attributes.length; l++) {
        var m = c.attributes[l];
        if (m.specified) {
          var v = Sv(m.name), y = "";
          o.indexOf(v) > -1 && (y = v), y && (u[y] = m.value);
        }
      }
      var E = re(c), h = E.find("img").first().attr("alt"), g = E.attr("title"), C = n ? E.attr(n) : E.find("img").first().attr("src");
      u.thumb = C, i && !u.subHtml && (u.subHtml = g || h || ""), u.alt = h || g || "", r.push(u);
    }), r;
  }, isMobile: function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }, isVideo: function(e, t, i) {
    if (!e) {
      if (t) return { html5: true };
      console.error("lightGallery :- data-src is not provided on slide item " + (i + 1) + ". Please make sure the selector property is properly configured. More info - https://www.lightgalleryjs.com/demos/html-markup/");
      return;
    }
    var n = e.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)([\&|?][\S]*)*/i), r = e.match(/\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:video\/)?([0-9a-z\-_]+)(.*)?/i), o = e.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/([0-9a-z\-_]+)(.*)/);
    if (n) return { youtube: n };
    if (r) return { vimeo: r };
    if (o) return { wistia: o };
  } }, Oa = 0, Tv = (function() {
    function e(t, i) {
      if (this.lgOpened = false, this.index = 0, this.plugins = [], this.lGalleryOn = false, this.lgBusy = false, this.currentItemsInDom = [], this.prevScrollTop = 0, this.bodyPaddingRight = 0, this.isDummyImageRemoved = false, this.dragOrSwipeEnabled = false, this.mediaContainerPosition = { top: 0, bottom: 0 }, !t) return this;
      if (Oa++, this.lgId = Oa, this.el = t, this.LGel = re(t), this.generateSettings(i), this.buildModules(), this.settings.dynamic && this.settings.dynamicEl !== void 0 && !Array.isArray(this.settings.dynamicEl)) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
      return this.galleryItems = this.getItems(), this.normalizeSettings(), this.init(), this.validateLicense(), this;
    }
    return e.prototype.generateSettings = function(t) {
      if (this.settings = Rt(Rt({}, yv), t), this.settings.isMobile && typeof this.settings.isMobile == "function" ? this.settings.isMobile() : Ie.isMobile()) {
        var i = Rt(Rt({}, this.settings.mobileSettings), this.settings.mobileSettings);
        this.settings = Rt(Rt({}, this.settings), i);
      }
    }, e.prototype.normalizeSettings = function() {
      if (this.settings.slideEndAnimation && (this.settings.hideControlOnEnd = false), this.settings.closable || (this.settings.swipeToClose = false), this.zoomFromOrigin = this.settings.zoomFromOrigin, this.settings.dynamic && (this.zoomFromOrigin = false), this.settings.container) {
        var t = this.settings.container;
        if (typeof t == "function") this.settings.container = t();
        else if (typeof t == "string") {
          var i = document.querySelector(t);
          this.settings.container = i != null ? i : document.body;
        }
      } else this.settings.container = document.body;
      this.settings.preload = Math.min(this.settings.preload, this.galleryItems.length);
    }, e.prototype.init = function() {
      var t = this;
      this.addSlideVideoInfo(this.galleryItems), this.buildStructure(), this.LGel.trigger(me.init, { instance: this }), this.settings.keyPress && this.keyPress(), setTimeout(function() {
        t.enableDrag(), t.enableSwipe(), t.triggerPosterClick();
      }, 50), this.arrow(), this.settings.mousewheel && this.mousewheel(), this.settings.dynamic || this.openGalleryOnItemClick();
    }, e.prototype.openGalleryOnItemClick = function() {
      for (var t = this, i = function(o) {
        var c = n.items[o], u = re(c), l = Zl.generateUUID();
        u.attr("data-lg-id", l).on("click.lgcustom-item-" + l, function(m) {
          m.preventDefault();
          var v = t.settings.index || o;
          t.openGallery(v, c);
        });
      }, n = this, r = 0; r < this.items.length; r++) i(r);
    }, e.prototype.buildModules = function() {
      var t = this;
      this.settings.plugins.forEach(function(i) {
        t.plugins.push(new i(t, re));
      });
    }, e.prototype.validateLicense = function() {
      this.settings.licenseKey ? this.settings.licenseKey === "0000-0000-000-0000" && console.warn("lightGallery: " + this.settings.licenseKey + " license key is not valid for production use") : console.error("Please provide a valid license key");
    }, e.prototype.getSlideItem = function(t) {
      return re(this.getSlideItemId(t));
    }, e.prototype.getSlideItemId = function(t) {
      return "#lg-item-" + this.lgId + "-" + t;
    }, e.prototype.getIdName = function(t) {
      return t + "-" + this.lgId;
    }, e.prototype.getElementById = function(t) {
      return re("#" + this.getIdName(t));
    }, e.prototype.manageSingleSlideClassName = function() {
      this.galleryItems.length < 2 ? this.outer.addClass("lg-single-item") : this.outer.removeClass("lg-single-item");
    }, e.prototype.buildStructure = function() {
      var t = this, i = this.$container && this.$container.get();
      if (!i) {
        var n = "", r = "";
        this.settings.controls && (n = '<button type="button" id="' + this.getIdName("lg-prev") + '" aria-label="' + this.settings.strings.previousSlide + '" class="lg-prev lg-icon"> ' + this.settings.prevHtml + ` </button>
                <button type="button" id="` + this.getIdName("lg-next") + '" aria-label="' + this.settings.strings.nextSlide + '" class="lg-next lg-icon"> ' + this.settings.nextHtml + " </button>"), this.settings.appendSubHtmlTo !== ".lg-item" && (r = '<div class="lg-sub-html" role="status" aria-live="polite"></div>');
        var o = "";
        this.settings.allowMediaOverlap && (o += "lg-media-overlap ");
        var c = this.settings.ariaLabelledby ? 'aria-labelledby="' + this.settings.ariaLabelledby + '"' : "", u = this.settings.ariaDescribedby ? 'aria-describedby="' + this.settings.ariaDescribedby + '"' : "", l = "lg-container " + this.settings.addClass + " " + (document.body !== this.settings.container ? "lg-inline" : ""), m = this.settings.closable && this.settings.showCloseIcon ? '<button type="button" aria-label="' + this.settings.strings.closeGallery + '" id="' + this.getIdName("lg-close") + '" class="lg-close lg-icon"></button>' : "", v = this.settings.showMaximizeIcon ? '<button type="button" aria-label="' + this.settings.strings.toggleMaximize + '" id="' + this.getIdName("lg-maximize") + '" class="lg-maximize lg-icon"></button>' : "", y = `
        <div class="` + l + '" id="' + this.getIdName("lg-container") + '" tabindex="-1" aria-modal="true" ' + c + " " + u + ` role="dialog"
        >
            <div id="` + this.getIdName("lg-backdrop") + `" class="lg-backdrop"></div>

            <div id="` + this.getIdName("lg-outer") + '" class="lg-outer lg-use-css3 lg-css3 lg-hide-items ' + o + ` ">

              <div id="` + this.getIdName("lg-content") + `" class="lg-content">
                <div id="` + this.getIdName("lg-inner") + `" class="lg-inner">
                </div>
                ` + n + `
              </div>
                <div id="` + this.getIdName("lg-toolbar") + `" class="lg-toolbar lg-group">
                    ` + v + `
                    ` + m + `
                    </div>
                    ` + (this.settings.appendSubHtmlTo === ".lg-outer" ? r : "") + `
                <div id="` + this.getIdName("lg-components") + `" class="lg-components">
                    ` + (this.settings.appendSubHtmlTo === ".lg-sub-html" ? r : "") + `
                </div>
            </div>
        </div>
        `;
        re(this.settings.container).append(y), document.body !== this.settings.container && re(this.settings.container).css("position", "relative"), this.outer = this.getElementById("lg-outer"), this.$lgComponents = this.getElementById("lg-components"), this.$backdrop = this.getElementById("lg-backdrop"), this.$container = this.getElementById("lg-container"), this.$inner = this.getElementById("lg-inner"), this.$content = this.getElementById("lg-content"), this.$toolbar = this.getElementById("lg-toolbar"), this.$backdrop.css("transition-duration", this.settings.backdropDuration + "ms");
        var E = this.settings.mode + " ";
        this.manageSingleSlideClassName(), this.settings.enableDrag && (E += "lg-grab "), this.outer.addClass(E), this.$inner.css("transition-timing-function", this.settings.easing), this.$inner.css("transition-duration", this.settings.speed + "ms"), this.settings.download && this.$toolbar.append('<a id="' + this.getIdName("lg-download") + '" target="_blank" rel="noopener" aria-label="' + this.settings.strings.download + '" download class="lg-download lg-icon"></a>'), this.counter(), re(window).on("resize.lg.global" + this.lgId + " orientationchange.lg.global" + this.lgId, function() {
          t.refreshOnResize();
        }), this.hideBars(), this.manageCloseGallery(), this.toggleMaximize(), this.initModules();
      }
    }, e.prototype.refreshOnResize = function() {
      if (this.lgOpened) {
        var t = this.galleryItems[this.index], i = t.__slideVideoInfo;
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var n = this.mediaContainerPosition, r = n.top, o = n.bottom;
        if (this.currentImageSize = Ie.getSize(this.items[this.index], this.outer, r + o, i && this.settings.videoMaxSize), i && this.resizeVideoSlide(this.index, this.currentImageSize), this.zoomFromOrigin && !this.isDummyImageRemoved) {
          var c = this.getDummyImgStyles(this.currentImageSize);
          this.outer.find(".lg-current .lg-dummy-img").first().attr("style", c);
        }
        this.LGel.trigger(me.containerResize);
      }
    }, e.prototype.resizeVideoSlide = function(t, i) {
      var n = this.getVideoContStyle(i), r = this.getSlideItem(t);
      r.find(".lg-video-cont").attr("style", n);
    }, e.prototype.updateSlides = function(t, i) {
      if (this.index > t.length - 1 && (this.index = t.length - 1), t.length === 1 && (this.index = 0), !t.length) {
        this.closeGallery();
        return;
      }
      var n = this.galleryItems[i].src;
      this.galleryItems = t, this.updateControls(), this.$inner.empty(), this.currentItemsInDom = [];
      var r = 0;
      this.galleryItems.some(function(o, c) {
        return o.src === n ? (r = c, true) : false;
      }), this.currentItemsInDom = this.organizeSlideItems(r, -1), this.loadContent(r, true), this.getSlideItem(r).addClass("lg-current"), this.index = r, this.updateCurrentCounter(r), this.LGel.trigger(me.updateSlides);
    }, e.prototype.getItems = function() {
      if (this.items = [], this.settings.dynamic) return this.settings.dynamicEl || [];
      if (this.settings.selector === "this") this.items.push(this.el);
      else if (this.settings.selector) if (typeof this.settings.selector == "string") if (this.settings.selectWithin) {
        var t = re(this.settings.selectWithin);
        this.items = t.find(this.settings.selector).get();
      } else this.items = this.el.querySelectorAll(this.settings.selector);
      else this.items = this.settings.selector;
      else this.items = this.el.children;
      return Ie.getDynamicOptions(this.items, this.settings.extraProps, this.settings.getCaptionFromTitleOrAlt, this.settings.exThumbImage);
    }, e.prototype.shouldHideScrollbar = function() {
      return this.settings.hideScrollbar && document.body === this.settings.container;
    }, e.prototype.hideScrollbar = function() {
      if (this.shouldHideScrollbar()) {
        this.bodyPaddingRight = parseFloat(re("body").style().paddingRight);
        var t = document.documentElement.getBoundingClientRect(), i = window.innerWidth - t.width;
        re(document.body).css("padding-right", i + this.bodyPaddingRight + "px"), re(document.body).addClass("lg-overlay-open");
      }
    }, e.prototype.resetScrollBar = function() {
      this.shouldHideScrollbar() && (re(document.body).css("padding-right", this.bodyPaddingRight + "px"), re(document.body).removeClass("lg-overlay-open"));
    }, e.prototype.openGallery = function(t, i) {
      var n = this;
      if (t === void 0 && (t = this.settings.index), !this.lgOpened) {
        this.lgOpened = true, this.outer.removeClass("lg-hide-items"), this.hideScrollbar(), this.$container.addClass("lg-show");
        var r = this.getItemsToBeInsertedToDom(t, t);
        this.currentItemsInDom = r;
        var o = "";
        r.forEach(function(E) {
          o = o + ('<div id="' + E + '" class="lg-item"></div>');
        }), this.$inner.append(o), this.addHtml(t);
        var c = "";
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var u = this.mediaContainerPosition, l = u.top, m = u.bottom;
        this.settings.allowMediaOverlap || this.setMediaContainerPosition(l, m);
        var v = this.galleryItems[t].__slideVideoInfo;
        this.zoomFromOrigin && i && (this.currentImageSize = Ie.getSize(i, this.outer, l + m, v && this.settings.videoMaxSize), c = Ie.getTransform(i, this.outer, l, m, this.currentImageSize)), (!this.zoomFromOrigin || !c) && (this.outer.addClass(this.settings.startClass), this.getSlideItem(t).removeClass("lg-complete"));
        var y = this.settings.zoomFromOrigin ? 100 : this.settings.backdropDuration;
        setTimeout(function() {
          n.outer.addClass("lg-components-open");
        }, y), this.index = t, this.LGel.trigger(me.beforeOpen), this.getSlideItem(t).addClass("lg-current"), this.lGalleryOn = false, this.prevScrollTop = re(window).scrollTop(), setTimeout(function() {
          if (n.zoomFromOrigin && c) {
            var E = n.getSlideItem(t);
            E.css("transform", c), setTimeout(function() {
              E.addClass("lg-start-progress lg-start-end-progress").css("transition-duration", n.settings.startAnimationDuration + "ms"), n.outer.addClass("lg-zoom-from-image");
            }), setTimeout(function() {
              E.css("transform", "translate3d(0, 0, 0)");
            }, 100);
          }
          setTimeout(function() {
            n.$backdrop.addClass("in"), n.$container.addClass("lg-show-in");
          }, 10), setTimeout(function() {
            n.settings.trapFocus && document.body === n.settings.container && n.trapFocus();
          }, n.settings.backdropDuration + 50), (!n.zoomFromOrigin || !c) && setTimeout(function() {
            n.outer.addClass("lg-visible");
          }, n.settings.backdropDuration), n.slide(t, false, false, false), n.LGel.trigger(me.afterOpen);
        }), document.body === this.settings.container && re("html").addClass("lg-on");
      }
    }, e.prototype.getMediaContainerPosition = function() {
      if (this.settings.allowMediaOverlap) return { top: 0, bottom: 0 };
      var t = this.$toolbar.get().clientHeight || 0, i = this.outer.find(".lg-components .lg-sub-html").get(), n = this.settings.defaultCaptionHeight || i && i.clientHeight || 0, r = this.outer.find(".lg-thumb-outer").get(), o = r ? r.clientHeight : 0, c = o + n;
      return { top: t, bottom: c };
    }, e.prototype.setMediaContainerPosition = function(t, i) {
      t === void 0 && (t = 0), i === void 0 && (i = 0), this.$content.css("top", t + "px").css("bottom", i + "px");
    }, e.prototype.hideBars = function() {
      var t = this;
      setTimeout(function() {
        t.outer.removeClass("lg-hide-items"), t.settings.hideBarsDelay > 0 && (t.outer.on("mousemove.lg click.lg touchstart.lg", function() {
          t.outer.removeClass("lg-hide-items"), clearTimeout(t.hideBarTimeout), t.hideBarTimeout = setTimeout(function() {
            t.outer.addClass("lg-hide-items");
          }, t.settings.hideBarsDelay);
        }), t.outer.trigger("mousemove.lg"));
      }, this.settings.showBarsAfter);
    }, e.prototype.initPictureFill = function(t) {
      if (this.settings.supportLegacyBrowser) try {
        picturefill({ elements: [t.get()] });
      } catch (i) {
        console.warn("lightGallery :- If you want srcset or picture tag to be supported for older browser please include picturefil javascript library in your document.");
      }
    }, e.prototype.counter = function() {
      if (this.settings.counter) {
        var t = `<div class="lg-counter" role="status" aria-live="polite">
                <span id="` + this.getIdName("lg-counter-current") + '" class="lg-counter-current">' + (this.index + 1) + ` </span> /
                <span id="` + this.getIdName("lg-counter-all") + '" class="lg-counter-all">' + this.galleryItems.length + " </span></div>";
        this.outer.find(this.settings.appendCounterTo).append(t);
      }
    }, e.prototype.addHtml = function(t) {
      var i, n;
      if (this.galleryItems[t].subHtmlUrl ? n = this.galleryItems[t].subHtmlUrl : i = this.galleryItems[t].subHtml, !n) if (i) {
        var r = i.substring(0, 1);
        if (r === "." || r === "#") try {
          this.settings.subHtmlSelectorRelative && !this.settings.dynamic ? i = re(this.items).eq(t).find(i).first().html() : i = re(i).first().html();
        } catch (c) {
          console.warn('Error processing subHtml selector "' + i + '"'), i = "";
        }
      } else i = "";
      if (this.settings.appendSubHtmlTo !== ".lg-item") n ? Ie.fetchCaptionFromUrl(n, this.outer.find(".lg-sub-html"), "replace") : this.outer.find(".lg-sub-html").html(i);
      else {
        var o = re(this.getSlideItemId(t));
        n ? Ie.fetchCaptionFromUrl(n, o, "append") : o.append('<div class="lg-sub-html">' + i + "</div>");
      }
      typeof i != "undefined" && i !== null && (i === "" ? this.outer.find(this.settings.appendSubHtmlTo).addClass("lg-empty-html") : this.outer.find(this.settings.appendSubHtmlTo).removeClass("lg-empty-html")), this.LGel.trigger(me.afterAppendSubHtml, { index: t });
    }, e.prototype.preload = function(t) {
      for (var i = 1; i <= this.settings.preload && !(i >= this.galleryItems.length - t); i++) this.loadContent(t + i, false);
      for (var n = 1; n <= this.settings.preload && !(t - n < 0); n++) this.loadContent(t - n, false);
    }, e.prototype.getDummyImgStyles = function(t) {
      return t ? "width:" + t.width + `px;
                margin-left: -` + t.width / 2 + `px;
                margin-top: -` + t.height / 2 + `px;
                height:` + t.height + "px" : "";
    }, e.prototype.getVideoContStyle = function(t) {
      return t ? "width:" + t.width + `px;
                height:` + t.height + "px" : "";
    }, e.prototype.getDummyImageContent = function(t, i, n) {
      var r;
      if (this.settings.dynamic || (r = re(this.items).eq(i)), r) {
        var o = void 0;
        if (this.settings.exThumbImage ? o = r.attr(this.settings.exThumbImage) : o = r.find("img").first().attr("src"), !o) return "";
        var c = this.getDummyImgStyles(this.currentImageSize), u = document.createElement("img");
        return u.alt = n || "", u.src = o, u.className = "lg-dummy-img", u.style.cssText = c, t.addClass("lg-first-slide"), this.outer.addClass("lg-first-slide-loading"), u;
      }
      return "";
    }, e.prototype.setImgMarkup = function(t, i, n) {
      var r = this.galleryItems[n], o = r.alt, c = r.srcset, u = r.sizes, l = r.sources, m = "", v = o ? 'alt="' + o + '"' : "";
      this.isFirstSlideWithZoomAnimation() ? m = this.getDummyImageContent(i, n, v) : m = Ie.getImgMarkup(n, t, v, c, u, l);
      var y = document.createElement("picture");
      y.className = "lg-img-wrap", re(y).append(m), i.prepend(y);
    }, e.prototype.onSlideObjectLoad = function(t, i, n, r) {
      var o = t.find(".lg-object").first();
      Ie.isImageLoaded(o.get()) || i ? n() : (o.on("load.lg error.lg", function() {
        n && n();
      }), o.on("error.lg", function() {
        r && r();
      }));
    }, e.prototype.onLgObjectLoad = function(t, i, n, r, o, c) {
      var u = this;
      this.onSlideObjectLoad(t, c, function() {
        u.triggerSlideItemLoad(t, i, n, r, o);
      }, function() {
        t.addClass("lg-complete lg-complete_"), t.html('<span class="lg-error-msg">' + u.settings.strings.mediaLoadingFailed + "</span>");
      });
    }, e.prototype.triggerSlideItemLoad = function(t, i, n, r, o) {
      var c = this, u = this.galleryItems[i], l = o && this.getSlideType(u) === "video" && !u.poster ? r : 0;
      setTimeout(function() {
        t.addClass("lg-complete lg-complete_"), c.LGel.trigger(me.slideItemLoad, { index: i, delay: n || 0, isFirstSlide: o });
      }, l);
    }, e.prototype.isFirstSlideWithZoomAnimation = function() {
      return !!(!this.lGalleryOn && this.zoomFromOrigin && this.currentImageSize);
    }, e.prototype.addSlideVideoInfo = function(t) {
      var i = this;
      t.forEach(function(n, r) {
        n.__slideVideoInfo = Ie.isVideo(n.src, !!n.video, r), n.__slideVideoInfo && i.settings.loadYouTubePoster && !n.poster && n.__slideVideoInfo.youtube && (n.poster = "//img.youtube.com/vi/" + n.__slideVideoInfo.youtube[1] + "/maxresdefault.jpg");
      });
    }, e.prototype.loadContent = function(t, i) {
      var n = this, r = this.galleryItems[t], o = re(this.getSlideItemId(t)), c = r.poster, u = r.srcset, l = r.sizes, m = r.sources, v = r.src, y = r.video, E = y && typeof y == "string" ? JSON.parse(y) : y;
      if (r.responsive) {
        var h = r.responsive.split(",");
        v = Ie.getResponsiveSrc(h) || v;
      }
      var g = r.__slideVideoInfo, C = "", _ = !!r.iframe, p = !this.lGalleryOn, S = 0;
      if (p && (this.zoomFromOrigin && this.currentImageSize ? S = this.settings.startAnimationDuration + 10 : S = this.settings.backdropDuration + 10), !o.hasClass("lg-loaded")) {
        if (g) {
          var w = this.mediaContainerPosition, I = w.top, L = w.bottom, f = Ie.getSize(this.items[t], this.outer, I + L, g && this.settings.videoMaxSize);
          C = this.getVideoContStyle(f);
        }
        if (_) {
          var P = Ie.getIframeMarkup(this.settings.iframeWidth, this.settings.iframeHeight, this.settings.iframeMaxWidth, this.settings.iframeMaxHeight, v, r.iframeTitle);
          o.prepend(P);
        } else if (c) {
          var D = "", R = p && this.zoomFromOrigin && this.currentImageSize;
          R && (D = this.getDummyImageContent(o, t, ""));
          var P = Ie.getVideoPosterMarkup(c, D || "", C, this.settings.strings.playVideo, g);
          o.prepend(P);
        } else if (g) {
          var P = '<div class="lg-video-cont " style="' + C + '"></div>';
          o.prepend(P);
        } else if (this.setImgMarkup(v, o, t), u || m) {
          var N = o.find(".lg-object");
          this.initPictureFill(N);
        }
        (c || g) && this.LGel.trigger(me.hasVideo, { index: t, src: v, html5Video: E, hasPoster: !!c }), this.LGel.trigger(me.afterAppendSlide, { index: t }), this.lGalleryOn && this.settings.appendSubHtmlTo === ".lg-item" && this.addHtml(t);
      }
      var $ = 0;
      S && !re(document.body).hasClass("lg-from-hash") && ($ = S), this.isFirstSlideWithZoomAnimation() && (setTimeout(function() {
        o.removeClass("lg-start-end-progress lg-start-progress").removeAttr("style");
      }, this.settings.startAnimationDuration + 100), o.hasClass("lg-loaded") || setTimeout(function() {
        if (n.getSlideType(r) === "image") {
          var V = r.alt, B = V ? 'alt="' + V + '"' : "";
          if (o.find(".lg-img-wrap").append(Ie.getImgMarkup(t, v, B, u, l, r.sources)), u || m) {
            var X = o.find(".lg-object");
            n.initPictureFill(X);
          }
        }
        (n.getSlideType(r) === "image" || n.getSlideType(r) === "video" && c) && (n.onLgObjectLoad(o, t, S, $, true, false), n.onSlideObjectLoad(o, !!(g && g.html5 && !c), function() {
          n.loadContentOnFirstSlideLoad(t, o, $);
        }, function() {
          n.loadContentOnFirstSlideLoad(t, o, $);
        }));
      }, this.settings.startAnimationDuration + 100)), o.addClass("lg-loaded"), (!this.isFirstSlideWithZoomAnimation() || this.getSlideType(r) === "video" && !c) && this.onLgObjectLoad(o, t, S, $, p, !!(g && g.html5 && !c)), (!this.zoomFromOrigin || !this.currentImageSize) && o.hasClass("lg-complete_") && !this.lGalleryOn && setTimeout(function() {
        o.addClass("lg-complete");
      }, this.settings.backdropDuration), this.lGalleryOn = true, i === true && (o.hasClass("lg-complete_") ? this.preload(t) : o.find(".lg-object").first().on("load.lg error.lg", function() {
        n.preload(t);
      }));
    }, e.prototype.loadContentOnFirstSlideLoad = function(t, i, n) {
      var r = this;
      setTimeout(function() {
        i.find(".lg-dummy-img").remove(), i.removeClass("lg-first-slide"), r.outer.removeClass("lg-first-slide-loading"), r.isDummyImageRemoved = true, r.preload(t);
      }, n + 300);
    }, e.prototype.getItemsToBeInsertedToDom = function(t, i, n) {
      var r = this;
      n === void 0 && (n = 0);
      var o = [], c = Math.max(n, 3);
      c = Math.min(c, this.galleryItems.length);
      var u = "lg-item-" + this.lgId + "-" + i;
      if (this.galleryItems.length <= 3) return this.galleryItems.forEach(function(v, y) {
        o.push("lg-item-" + r.lgId + "-" + y);
      }), o;
      if (t < (this.galleryItems.length - 1) / 2) {
        for (var l = t; l > t - c / 2 && l >= 0; l--) o.push("lg-item-" + this.lgId + "-" + l);
        for (var m = o.length, l = 0; l < c - m; l++) o.push("lg-item-" + this.lgId + "-" + (t + l + 1));
      } else {
        for (var l = t; l <= this.galleryItems.length - 1 && l < t + c / 2; l++) o.push("lg-item-" + this.lgId + "-" + l);
        for (var m = o.length, l = 0; l < c - m; l++) o.push("lg-item-" + this.lgId + "-" + (t - l - 1));
      }
      return this.settings.loop && (t === this.galleryItems.length - 1 ? o.push("lg-item-" + this.lgId + "-0") : t === 0 && o.push("lg-item-" + this.lgId + "-" + (this.galleryItems.length - 1))), o.indexOf(u) === -1 && o.push("lg-item-" + this.lgId + "-" + i), o;
    }, e.prototype.organizeSlideItems = function(t, i) {
      var n = this, r = this.getItemsToBeInsertedToDom(t, i, this.settings.numberOfSlideItemsInDom);
      return r.forEach(function(o) {
        n.currentItemsInDom.indexOf(o) === -1 && n.$inner.append('<div id="' + o + '" class="lg-item"></div>');
      }), this.currentItemsInDom.forEach(function(o) {
        r.indexOf(o) === -1 && re("#" + o).remove();
      }), r;
    }, e.prototype.getPreviousSlideIndex = function() {
      var t = 0;
      try {
        var i = this.outer.find(".lg-current").first().attr("id");
        t = parseInt(i.split("-")[3]) || 0;
      } catch (n) {
        t = 0;
      }
      return t;
    }, e.prototype.setDownloadValue = function(t) {
      if (this.settings.download) {
        var i = this.galleryItems[t], n = i.downloadUrl === false || i.downloadUrl === "false";
        if (n) this.outer.addClass("lg-hide-download");
        else {
          var r = this.getElementById("lg-download");
          this.outer.removeClass("lg-hide-download"), r.attr("href", i.downloadUrl || i.src), i.download && r.attr("download", i.download);
        }
      }
    }, e.prototype.makeSlideAnimation = function(t, i, n) {
      var r = this;
      this.lGalleryOn && n.addClass("lg-slide-progress"), setTimeout(function() {
        r.outer.addClass("lg-no-trans"), r.outer.find(".lg-item").removeClass("lg-prev-slide lg-next-slide"), t === "prev" ? (i.addClass("lg-prev-slide"), n.addClass("lg-next-slide")) : (i.addClass("lg-next-slide"), n.addClass("lg-prev-slide")), setTimeout(function() {
          r.outer.find(".lg-item").removeClass("lg-current"), i.addClass("lg-current"), r.outer.removeClass("lg-no-trans");
        }, 50);
      }, this.lGalleryOn ? this.settings.slideDelay : 0);
    }, e.prototype.slide = function(t, i, n, r) {
      var o = this, c = this.getPreviousSlideIndex();
      if (this.currentItemsInDom = this.organizeSlideItems(t, c), !(this.lGalleryOn && c === t)) {
        var u = this.galleryItems.length;
        if (!this.lgBusy) {
          this.settings.counter && this.updateCurrentCounter(t);
          var l = this.getSlideItem(t), m = this.getSlideItem(c), v = this.galleryItems[t], y = v.__slideVideoInfo;
          if (this.outer.attr("data-lg-slide-type", this.getSlideType(v)), this.setDownloadValue(t), y) {
            var E = this.mediaContainerPosition, h = E.top, g = E.bottom, C = Ie.getSize(this.items[t], this.outer, h + g, y && this.settings.videoMaxSize);
            this.resizeVideoSlide(t, C);
          }
          if (this.LGel.trigger(me.beforeSlide, { prevIndex: c, index: t, fromTouch: !!i, fromThumb: !!n }), this.lgBusy = true, clearTimeout(this.hideBarTimeout), this.arrowDisable(t), r || (t < c ? r = "prev" : t > c && (r = "next")), !i) this.makeSlideAnimation(r, l, m);
          else {
            this.outer.find(".lg-item").removeClass("lg-prev-slide lg-current lg-next-slide");
            var _ = void 0, p = void 0;
            u > 2 ? (_ = t - 1, p = t + 1, (t === 0 && c === u - 1 || t === u - 1 && c === 0) && (p = 0, _ = u - 1)) : (_ = 0, p = 1), r === "prev" ? this.getSlideItem(p).addClass("lg-next-slide") : this.getSlideItem(_).addClass("lg-prev-slide"), l.addClass("lg-current");
          }
          this.lGalleryOn ? setTimeout(function() {
            o.loadContent(t, true), o.settings.appendSubHtmlTo !== ".lg-item" && o.addHtml(t);
          }, this.settings.speed + 50 + (i ? 0 : this.settings.slideDelay)) : this.loadContent(t, true), setTimeout(function() {
            o.lgBusy = false, m.removeClass("lg-slide-progress"), o.LGel.trigger(me.afterSlide, { prevIndex: c, index: t, fromTouch: i, fromThumb: n });
          }, (this.lGalleryOn ? this.settings.speed + 100 : 100) + (i ? 0 : this.settings.slideDelay));
        }
        this.index = t;
      }
    }, e.prototype.updateCurrentCounter = function(t) {
      this.getElementById("lg-counter-current").html(t + 1 + "");
    }, e.prototype.updateCounterTotal = function() {
      this.getElementById("lg-counter-all").html(this.galleryItems.length + "");
    }, e.prototype.getSlideType = function(t) {
      return t.__slideVideoInfo ? "video" : t.iframe ? "iframe" : "image";
    }, e.prototype.touchMove = function(t, i, n) {
      var r = i.pageX - t.pageX, o = i.pageY - t.pageY, c = false;
      if (this.swipeDirection ? c = true : Math.abs(r) > 15 ? (this.swipeDirection = "horizontal", c = true) : Math.abs(o) > 15 && (this.swipeDirection = "vertical", c = true), !!c) {
        var u = this.getSlideItem(this.index);
        if (this.swipeDirection === "horizontal") {
          n == null || n.preventDefault(), this.outer.addClass("lg-dragging"), this.setTranslate(u, r, 0);
          var l = u.get().offsetWidth, m = l * 15 / 100, v = m - Math.abs(r * 10 / 100);
          this.setTranslate(this.outer.find(".lg-prev-slide").first(), -l + r - v, 0), this.setTranslate(this.outer.find(".lg-next-slide").first(), l + r + v, 0);
        } else if (this.swipeDirection === "vertical" && this.settings.swipeToClose) {
          n == null || n.preventDefault(), this.$container.addClass("lg-dragging-vertical");
          var y = 1 - Math.abs(o) / window.innerHeight;
          this.$backdrop.css("opacity", y);
          var E = 1 - Math.abs(o) / (window.innerWidth * 2);
          this.setTranslate(u, 0, o, E, E), Math.abs(o) > 100 && this.outer.addClass("lg-hide-items").removeClass("lg-components-open");
        }
      }
    }, e.prototype.touchEnd = function(t, i, n) {
      var r = this, o;
      this.settings.mode !== "lg-slide" && this.outer.addClass("lg-slide"), setTimeout(function() {
        r.$container.removeClass("lg-dragging-vertical"), r.outer.removeClass("lg-dragging lg-hide-items").addClass("lg-components-open");
        var c = true;
        if (r.swipeDirection === "horizontal") {
          o = t.pageX - i.pageX;
          var u = Math.abs(t.pageX - i.pageX);
          o < 0 && u > r.settings.swipeThreshold ? (r.goToNextSlide(true), c = false) : o > 0 && u > r.settings.swipeThreshold && (r.goToPrevSlide(true), c = false);
        } else if (r.swipeDirection === "vertical") if (o = Math.abs(t.pageY - i.pageY), r.settings.closable && r.settings.swipeToClose && o > 100) {
          r.closeGallery();
          return;
        } else r.$backdrop.css("opacity", 1);
        if (r.outer.find(".lg-item").removeAttr("style"), c && Math.abs(t.pageX - i.pageX) < 5) {
          var l = re(n.target);
          r.isPosterElement(l) && r.LGel.trigger(me.posterClick);
        }
        r.swipeDirection = void 0;
      }), setTimeout(function() {
        !r.outer.hasClass("lg-dragging") && r.settings.mode !== "lg-slide" && r.outer.removeClass("lg-slide");
      }, this.settings.speed + 100);
    }, e.prototype.enableSwipe = function() {
      var t = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableSwipe && (this.$inner.on("touchstart.lg", function(c) {
        t.dragOrSwipeEnabled = true;
        var u = t.getSlideItem(t.index);
        (re(c.target).hasClass("lg-item") || u.get().contains(c.target)) && !t.outer.hasClass("lg-zoomed") && !t.lgBusy && c.touches.length === 1 && (o = true, t.touchAction = "swipe", t.manageSwipeClass(), i = { pageX: c.touches[0].pageX, pageY: c.touches[0].pageY });
      }), this.$inner.on("touchmove.lg", function(c) {
        o && t.touchAction === "swipe" && c.touches.length === 1 && (n = { pageX: c.touches[0].pageX, pageY: c.touches[0].pageY }, t.touchMove(i, n, c), r = true);
      }), this.$inner.on("touchend.lg", function(c) {
        if (t.touchAction === "swipe") {
          if (r) r = false, t.touchEnd(n, i, c);
          else if (o) {
            var u = re(c.target);
            t.isPosterElement(u) && t.LGel.trigger(me.posterClick);
          }
          t.touchAction = void 0, o = false;
        }
      }));
    }, e.prototype.enableDrag = function() {
      var t = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableDrag && (this.outer.on("mousedown.lg", function(c) {
        t.dragOrSwipeEnabled = true;
        var u = t.getSlideItem(t.index);
        (re(c.target).hasClass("lg-item") || u.get().contains(c.target)) && !t.outer.hasClass("lg-zoomed") && !t.lgBusy && (c.preventDefault(), t.lgBusy || (t.manageSwipeClass(), i = { pageX: c.pageX, pageY: c.pageY }, r = true, t.outer.get().scrollLeft += 1, t.outer.get().scrollLeft -= 1, t.outer.removeClass("lg-grab").addClass("lg-grabbing"), t.LGel.trigger(me.dragStart)));
      }), re(window).on("mousemove.lg.global" + this.lgId, function(c) {
        r && t.lgOpened && (o = true, n = { pageX: c.pageX, pageY: c.pageY }, t.touchMove(i, n), t.LGel.trigger(me.dragMove));
      }), re(window).on("mouseup.lg.global" + this.lgId, function(c) {
        if (t.lgOpened) {
          var u = re(c.target);
          o ? (o = false, t.touchEnd(n, i, c), t.LGel.trigger(me.dragEnd)) : t.isPosterElement(u) && t.LGel.trigger(me.posterClick), r && (r = false, t.outer.removeClass("lg-grabbing").addClass("lg-grab"));
        }
      }));
    }, e.prototype.triggerPosterClick = function() {
      var t = this;
      this.$inner.on("click.lg", function(i) {
        !t.dragOrSwipeEnabled && t.isPosterElement(re(i.target)) && t.LGel.trigger(me.posterClick);
      });
    }, e.prototype.manageSwipeClass = function() {
      var t = this.index + 1, i = this.index - 1;
      this.settings.loop && this.galleryItems.length > 2 && (this.index === 0 ? i = this.galleryItems.length - 1 : this.index === this.galleryItems.length - 1 && (t = 0)), this.outer.find(".lg-item").removeClass("lg-next-slide lg-prev-slide"), i > -1 && this.getSlideItem(i).addClass("lg-prev-slide"), this.getSlideItem(t).addClass("lg-next-slide");
    }, e.prototype.goToNextSlide = function(t) {
      var i = this, n = this.settings.loop;
      t && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index + 1 < this.galleryItems.length ? (this.index++, this.LGel.trigger(me.beforeNextSlide, { index: this.index }), this.slide(this.index, !!t, false, "next")) : n ? (this.index = 0, this.LGel.trigger(me.beforeNextSlide, { index: this.index }), this.slide(this.index, !!t, false, "next")) : this.settings.slideEndAnimation && !t && (this.outer.addClass("lg-right-end"), setTimeout(function() {
        i.outer.removeClass("lg-right-end");
      }, 400)));
    }, e.prototype.goToPrevSlide = function(t) {
      var i = this, n = this.settings.loop;
      t && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index > 0 ? (this.index--, this.LGel.trigger(me.beforePrevSlide, { index: this.index, fromTouch: t }), this.slide(this.index, !!t, false, "prev")) : n ? (this.index = this.galleryItems.length - 1, this.LGel.trigger(me.beforePrevSlide, { index: this.index, fromTouch: t }), this.slide(this.index, !!t, false, "prev")) : this.settings.slideEndAnimation && !t && (this.outer.addClass("lg-left-end"), setTimeout(function() {
        i.outer.removeClass("lg-left-end");
      }, 400)));
    }, e.prototype.keyPress = function() {
      var t = this;
      re(window).on("keydown.lg.global" + this.lgId, function(i) {
        t.lgOpened && t.settings.escKey === true && i.keyCode === 27 && (i.preventDefault(), t.settings.allowMediaOverlap && t.outer.hasClass("lg-can-toggle") && t.outer.hasClass("lg-components-open") ? t.outer.removeClass("lg-components-open") : t.closeGallery()), t.lgOpened && t.galleryItems.length > 1 && (i.keyCode === 37 && (i.preventDefault(), t.goToPrevSlide()), i.keyCode === 39 && (i.preventDefault(), t.goToNextSlide()));
      });
    }, e.prototype.arrow = function() {
      var t = this;
      this.getElementById("lg-prev").on("click.lg", function() {
        t.goToPrevSlide();
      }), this.getElementById("lg-next").on("click.lg", function() {
        t.goToNextSlide();
      });
    }, e.prototype.arrowDisable = function(t) {
      if (!this.settings.loop && this.settings.hideControlOnEnd) {
        var i = this.getElementById("lg-prev"), n = this.getElementById("lg-next");
        t + 1 === this.galleryItems.length ? n.attr("disabled", "disabled").addClass("disabled") : n.removeAttr("disabled").removeClass("disabled"), t === 0 ? i.attr("disabled", "disabled").addClass("disabled") : i.removeAttr("disabled").removeClass("disabled");
      }
    }, e.prototype.setTranslate = function(t, i, n, r, o) {
      r === void 0 && (r = 1), o === void 0 && (o = 1), t.css("transform", "translate3d(" + i + "px, " + n + "px, 0px) scale3d(" + r + ", " + o + ", 1)");
    }, e.prototype.mousewheel = function() {
      var t = this, i = 0;
      this.outer.on("wheel.lg", function(n) {
        if (!(!n.deltaY || t.galleryItems.length < 2)) {
          n.preventDefault();
          var r = (/* @__PURE__ */ new Date()).getTime();
          r - i < 1e3 || (i = r, n.deltaY > 0 ? t.goToNextSlide() : n.deltaY < 0 && t.goToPrevSlide());
        }
      });
    }, e.prototype.isSlideElement = function(t) {
      return t.hasClass("lg-outer") || t.hasClass("lg-item") || t.hasClass("lg-img-wrap") || t.hasClass("lg-img-rotate");
    }, e.prototype.isPosterElement = function(t) {
      var i = this.getSlideItem(this.index).find(".lg-video-play-button").get();
      return t.hasClass("lg-video-poster") || t.hasClass("lg-video-play-button") || i && i.contains(t.get());
    }, e.prototype.toggleMaximize = function() {
      var t = this;
      this.getElementById("lg-maximize").on("click.lg", function() {
        t.$container.toggleClass("lg-inline"), t.refreshOnResize();
      });
    }, e.prototype.invalidateItems = function() {
      for (var t = 0; t < this.items.length; t++) {
        var i = this.items[t], n = re(i);
        n.off("click.lgcustom-item-" + n.attr("data-lg-id"));
      }
    }, e.prototype.trapFocus = function() {
      var t = this;
      this.$container.get().focus({ preventScroll: true }), re(window).on("keydown.lg.global" + this.lgId, function(i) {
        if (t.lgOpened) {
          var n = i.key === "Tab" || i.keyCode === 9;
          if (n) {
            var r = Ie.getFocusableElements(t.$container.get()), o = r[0], c = r[r.length - 1];
            i.shiftKey ? document.activeElement === o && (c.focus(), i.preventDefault()) : document.activeElement === c && (o.focus(), i.preventDefault());
          }
        }
      });
    }, e.prototype.manageCloseGallery = function() {
      var t = this;
      if (this.settings.closable) {
        var i = false;
        this.getElementById("lg-close").on("click.lg", function() {
          t.closeGallery();
        }), this.settings.closeOnTap && (this.outer.on("mousedown.lg", function(n) {
          var r = re(n.target);
          t.isSlideElement(r) ? i = true : i = false;
        }), this.outer.on("mousemove.lg", function() {
          i = false;
        }), this.outer.on("mouseup.lg", function(n) {
          var r = re(n.target);
          t.isSlideElement(r) && i && (t.outer.hasClass("lg-dragging") || t.closeGallery());
        }));
      }
    }, e.prototype.closeGallery = function(t) {
      var i = this;
      if (!this.lgOpened || !this.settings.closable && !t) return 0;
      this.LGel.trigger(me.beforeClose), this.settings.resetScrollPosition && !this.settings.hideScrollbar && re(window).scrollTop(this.prevScrollTop);
      var n = this.items[this.index], r;
      if (this.zoomFromOrigin && n) {
        var o = this.mediaContainerPosition, c = o.top, u = o.bottom, l = this.galleryItems[this.index], m = l.__slideVideoInfo, v = l.poster, y = Ie.getSize(n, this.outer, c + u, m && v && this.settings.videoMaxSize);
        r = Ie.getTransform(n, this.outer, c, u, y);
      }
      this.zoomFromOrigin && r ? (this.outer.addClass("lg-closing lg-zoom-from-image"), this.getSlideItem(this.index).addClass("lg-start-end-progress").css("transition-duration", this.settings.startAnimationDuration + "ms").css("transform", r)) : (this.outer.addClass("lg-hide-items"), this.outer.removeClass("lg-zoom-from-image")), this.destroyModules(), this.lGalleryOn = false, this.isDummyImageRemoved = false, this.zoomFromOrigin = this.settings.zoomFromOrigin, clearTimeout(this.hideBarTimeout), this.hideBarTimeout = false, re("html").removeClass("lg-on"), this.outer.removeClass("lg-visible lg-components-open"), this.$backdrop.removeClass("in").css("opacity", 0);
      var E = this.zoomFromOrigin && r ? Math.max(this.settings.startAnimationDuration, this.settings.backdropDuration) : this.settings.backdropDuration;
      return this.$container.removeClass("lg-show-in"), setTimeout(function() {
        i.zoomFromOrigin && r && i.outer.removeClass("lg-zoom-from-image"), i.$container.removeClass("lg-show"), i.resetScrollBar(), i.$backdrop.removeAttr("style").css("transition-duration", i.settings.backdropDuration + "ms"), i.outer.removeClass("lg-closing " + i.settings.startClass), i.getSlideItem(i.index).removeClass("lg-start-end-progress"), i.$inner.empty(), i.lgOpened && i.LGel.trigger(me.afterClose, { instance: i }), i.$container.get() && i.$container.get().blur(), i.lgOpened = false;
      }, E + 100), E + 100;
    }, e.prototype.initModules = function() {
      this.plugins.forEach(function(t) {
        try {
          t.init();
        } catch (i) {
          console.warn("lightGallery:- make sure lightGallery module is properly initiated");
        }
      });
    }, e.prototype.destroyModules = function(t) {
      this.plugins.forEach(function(i) {
        try {
          t ? i.destroy() : i.closeGallery && i.closeGallery();
        } catch (n) {
          console.warn("lightGallery:- make sure lightGallery module is properly destroyed");
        }
      });
    }, e.prototype.refresh = function(t) {
      this.settings.dynamic || this.invalidateItems(), t ? this.galleryItems = t : this.galleryItems = this.getItems(), this.updateControls(), this.openGalleryOnItemClick(), this.LGel.trigger(me.updateSlides);
    }, e.prototype.updateControls = function() {
      this.addSlideVideoInfo(this.galleryItems), this.updateCounterTotal(), this.manageSingleSlideClassName();
    }, e.prototype.destroyGallery = function() {
      this.destroyModules(true), this.settings.dynamic || this.invalidateItems(), re(window).off(".lg.global" + this.lgId), this.LGel.off(".lg"), this.$container.remove();
    }, e.prototype.destroy = function() {
      var t = this.closeGallery(true);
      return t ? setTimeout(this.destroyGallery.bind(this), t) : this.destroyGallery(), t;
    }, e;
  })();
  function _v(e, t) {
    return new Tv(e, t);
  }
  var Vn = function() {
    return Vn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Vn.apply(this, arguments);
  }, xv = { thumbnail: true, animateThumb: true, currentPagerPosition: "middle", alignThumbnails: "middle", thumbWidth: 100, thumbHeight: "80px", thumbMargin: 5, appendThumbnailsTo: ".lg-components", toggleThumb: false, enableThumbDrag: true, enableThumbSwipe: true, thumbnailSwipeThreshold: 10, loadYouTubeThumbnail: true, youTubeThumbSize: 1, thumbnailPluginStrings: { toggleThumbnails: "Toggle thumbnails" } }, Yi = { containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", beforeOpen: "lgBeforeOpen", beforeSlide: "lgBeforeSlide" }, Cv = (function() {
    function e(t, i) {
      return this.thumbOuterWidth = 0, this.thumbTotalWidth = 0, this.translateX = 0, this.thumbClickable = false, this.core = t, this.$LG = i, this;
    }
    return e.prototype.init = function() {
      this.settings = Vn(Vn({}, xv), this.core.settings), this.thumbOuterWidth = 0, this.thumbTotalWidth = this.core.galleryItems.length * (this.settings.thumbWidth + this.settings.thumbMargin), this.translateX = 0, this.setAnimateThumbStyles(), this.core.settings.allowMediaOverlap || (this.settings.toggleThumb = false), this.settings.thumbnail && (this.build(), this.settings.animateThumb ? (this.settings.enableThumbDrag && this.enableThumbDrag(), this.settings.enableThumbSwipe && this.enableThumbSwipe(), this.thumbClickable = false) : this.thumbClickable = true, this.toggleThumbBar(), this.thumbKeyPress());
    }, e.prototype.build = function() {
      var t = this;
      this.setThumbMarkup(), this.manageActiveClassOnSlideChange(), this.$lgThumb.first().on("click.lg touchend.lg", function(i) {
        var n = t.$LG(i.target);
        n.hasAttribute("data-lg-item-id") && setTimeout(function() {
          if (t.thumbClickable && !t.core.lgBusy) {
            var r = parseInt(n.attr("data-lg-item-id"));
            t.core.slide(r, false, true, false);
          }
        }, 50);
      }), this.core.LGel.on(Yi.beforeSlide + ".thumb", function(i) {
        var n = i.detail.index;
        t.animateThumb(n);
      }), this.core.LGel.on(Yi.beforeOpen + ".thumb", function() {
        t.thumbOuterWidth = t.core.outer.get().offsetWidth;
      }), this.core.LGel.on(Yi.updateSlides + ".thumb", function() {
        t.rebuildThumbnails();
      }), this.core.LGel.on(Yi.containerResize + ".thumb", function() {
        t.core.lgOpened && setTimeout(function() {
          t.thumbOuterWidth = t.core.outer.get().offsetWidth, t.animateThumb(t.core.index), t.thumbOuterWidth = t.core.outer.get().offsetWidth;
        }, 50);
      });
    }, e.prototype.setThumbMarkup = function() {
      var t = "lg-thumb-outer ";
      this.settings.alignThumbnails && (t += "lg-thumb-align-" + this.settings.alignThumbnails);
      var i = '<div class="' + t + `">
        <div class="lg-thumb lg-group">
        </div>
        </div>`;
      this.core.outer.addClass("lg-has-thumb"), this.settings.appendThumbnailsTo === ".lg-components" ? this.core.$lgComponents.append(i) : this.core.outer.append(i), this.$thumbOuter = this.core.outer.find(".lg-thumb-outer").first(), this.$lgThumb = this.core.outer.find(".lg-thumb").first(), this.settings.animateThumb && this.core.outer.find(".lg-thumb").css("transition-duration", this.core.settings.speed + "ms").css("width", this.thumbTotalWidth + "px").css("position", "relative"), this.setThumbItemHtml(this.core.galleryItems);
    }, e.prototype.enableThumbDrag = function() {
      var t = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 }, n = false;
      this.$thumbOuter.addClass("lg-grab"), this.core.outer.find(".lg-thumb").first().on("mousedown.lg.thumb", function(r) {
        t.thumbTotalWidth > t.thumbOuterWidth && (r.preventDefault(), i.cords.startX = r.pageX, i.startTime = /* @__PURE__ */ new Date(), t.thumbClickable = false, n = true, t.core.outer.get().scrollLeft += 1, t.core.outer.get().scrollLeft -= 1, t.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"));
      }), this.$LG(window).on("mousemove.lg.thumb.global" + this.core.lgId, function(r) {
        t.core.lgOpened && n && (i.cords.endX = r.pageX, i = t.onThumbTouchMove(i));
      }), this.$LG(window).on("mouseup.lg.thumb.global" + this.core.lgId, function() {
        t.core.lgOpened && (i.isMoved ? i = t.onThumbTouchEnd(i) : t.thumbClickable = true, n && (n = false, t.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab")));
      });
    }, e.prototype.enableThumbSwipe = function() {
      var t = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 };
      this.$lgThumb.on("touchstart.lg", function(n) {
        t.thumbTotalWidth > t.thumbOuterWidth && (n.preventDefault(), i.cords.startX = n.targetTouches[0].pageX, t.thumbClickable = false, i.startTime = /* @__PURE__ */ new Date());
      }), this.$lgThumb.on("touchmove.lg", function(n) {
        t.thumbTotalWidth > t.thumbOuterWidth && (n.preventDefault(), i.cords.endX = n.targetTouches[0].pageX, i = t.onThumbTouchMove(i));
      }), this.$lgThumb.on("touchend.lg", function() {
        i.isMoved ? i = t.onThumbTouchEnd(i) : t.thumbClickable = true;
      });
    }, e.prototype.rebuildThumbnails = function() {
      var t = this;
      this.$thumbOuter.addClass("lg-rebuilding-thumbnails"), setTimeout(function() {
        t.thumbTotalWidth = t.core.galleryItems.length * (t.settings.thumbWidth + t.settings.thumbMargin), t.$lgThumb.css("width", t.thumbTotalWidth + "px"), t.$lgThumb.empty(), t.setThumbItemHtml(t.core.galleryItems), t.animateThumb(t.core.index);
      }, 50), setTimeout(function() {
        t.$thumbOuter.removeClass("lg-rebuilding-thumbnails");
      }, 200);
    }, e.prototype.setTranslate = function(t) {
      this.$lgThumb.css("transform", "translate3d(-" + t + "px, 0px, 0px)");
    }, e.prototype.getPossibleTransformX = function(t) {
      return t > this.thumbTotalWidth - this.thumbOuterWidth && (t = this.thumbTotalWidth - this.thumbOuterWidth), t < 0 && (t = 0), t;
    }, e.prototype.animateThumb = function(t) {
      if (this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms"), this.settings.animateThumb) {
        var i = 0;
        switch (this.settings.currentPagerPosition) {
          case "left":
            i = 0;
            break;
          case "middle":
            i = this.thumbOuterWidth / 2 - this.settings.thumbWidth / 2;
            break;
          case "right":
            i = this.thumbOuterWidth - this.settings.thumbWidth;
        }
        this.translateX = (this.settings.thumbWidth + this.settings.thumbMargin) * t - 1 - i, this.translateX > this.thumbTotalWidth - this.thumbOuterWidth && (this.translateX = this.thumbTotalWidth - this.thumbOuterWidth), this.translateX < 0 && (this.translateX = 0), this.setTranslate(this.translateX);
      }
    }, e.prototype.onThumbTouchMove = function(t) {
      return t.newTranslateX = this.translateX, t.isMoved = true, t.touchMoveTime = (/* @__PURE__ */ new Date()).valueOf(), t.newTranslateX -= t.cords.endX - t.cords.startX, t.newTranslateX = this.getPossibleTransformX(t.newTranslateX), this.setTranslate(t.newTranslateX), this.$thumbOuter.addClass("lg-dragging"), t;
    }, e.prototype.onThumbTouchEnd = function(t) {
      t.isMoved = false, t.endTime = /* @__PURE__ */ new Date(), this.$thumbOuter.removeClass("lg-dragging");
      var i = t.endTime.valueOf() - t.startTime.valueOf(), n = t.cords.endX - t.cords.startX, r = Math.abs(n) / i;
      return r > 0.15 && t.endTime.valueOf() - t.touchMoveTime < 30 ? (r += 1, r > 2 && (r += 1), r = r + r * (Math.abs(n) / this.thumbOuterWidth), this.$lgThumb.css("transition-duration", Math.min(r - 1, 2) + "settings"), n = n * r, this.translateX = this.getPossibleTransformX(this.translateX - n), this.setTranslate(this.translateX)) : this.translateX = t.newTranslateX, Math.abs(t.cords.endX - t.cords.startX) < this.settings.thumbnailSwipeThreshold && (this.thumbClickable = true), t;
    }, e.prototype.getThumbHtml = function(t, i, n) {
      var r = this.core.galleryItems[i].__slideVideoInfo || {}, o;
      r.youtube && this.settings.loadYouTubeThumbnail ? o = "//img.youtube.com/vi/" + r.youtube[1] + "/" + this.settings.youTubeThumbSize + ".jpg" : o = t;
      var c = document.createElement("div");
      c.setAttribute("data-lg-item-id", i + ""), c.className = "lg-thumb-item " + (i === this.core.index ? "active" : ""), c.style.cssText = "width: " + this.settings.thumbWidth + "px; height: " + this.settings.thumbHeight + "; margin-right: " + this.settings.thumbMargin + "px;";
      var u = document.createElement("img");
      return u.alt = n || "", u.setAttribute("data-lg-item-id", i + ""), u.src = o, c.appendChild(u), c;
    }, e.prototype.setThumbItemHtml = function(t) {
      for (var i = 0; i < t.length; i++) {
        var n = this.getThumbHtml(t[i].thumb, i, t[i].alt);
        this.$lgThumb.append(n);
      }
    }, e.prototype.setAnimateThumbStyles = function() {
      this.settings.animateThumb && this.core.outer.addClass("lg-animate-thumb");
    }, e.prototype.manageActiveClassOnSlideChange = function() {
      var t = this;
      this.core.LGel.on(Yi.beforeSlide + ".thumb", function(i) {
        var n = t.core.outer.find(".lg-thumb-item"), r = i.detail.index;
        n.removeClass("active"), n.eq(r).addClass("active");
      });
    }, e.prototype.toggleThumbBar = function() {
      var t = this;
      this.settings.toggleThumb && (this.core.outer.addClass("lg-can-toggle"), this.core.$toolbar.append('<button type="button" aria-label="' + this.settings.thumbnailPluginStrings.toggleThumbnails + '" class="lg-toggle-thumb lg-icon"></button>'), this.core.outer.find(".lg-toggle-thumb").first().on("click.lg", function() {
        t.core.outer.toggleClass("lg-components-open");
      }));
    }, e.prototype.thumbKeyPress = function() {
      var t = this;
      this.$LG(window).on("keydown.lg.thumb.global" + this.core.lgId, function(i) {
        !t.core.lgOpened || !t.settings.toggleThumb || (i.keyCode === 38 ? (i.preventDefault(), t.core.outer.addClass("lg-components-open")) : i.keyCode === 40 && (i.preventDefault(), t.core.outer.removeClass("lg-components-open")));
      });
    }, e.prototype.destroy = function() {
      this.settings.thumbnail && (this.$LG(window).off(".lg.thumb.global" + this.core.lgId), this.core.LGel.off(".lg.thumb"), this.core.LGel.off(".thumb"), this.$thumbOuter.remove(), this.core.outer.removeClass("lg-has-thumb"));
    }, e;
  })();
  var Bn = function() {
    return Bn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Bn.apply(this, arguments);
  }, wv = { scale: 1, zoom: true, infiniteZoom: true, actualSize: true, showZoomInOutIcons: false, actualSizeIcons: { zoomIn: "lg-zoom-in", zoomOut: "lg-zoom-out" }, enableZoomAfter: 300, zoomPluginStrings: { zoomIn: "Zoom in", zoomOut: "Zoom out", viewActualSize: "View actual size" } }, _t = { containerResize: "lgContainerResize", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", afterSlide: "lgAfterSlide", rotateLeft: "lgRotateLeft", rotateRight: "lgRotateRight", flipHorizontal: "lgFlipHorizontal", flipVertical: "lgFlipVertical" }, nr = 500, Av = (function() {
    function e(t, i) {
      return this.core = t, this.$LG = i, this.settings = Bn(Bn({}, wv), this.core.settings), this;
    }
    return e.prototype.buildTemplates = function() {
      var t = this.settings.showZoomInOutIcons ? '<button id="' + this.core.getIdName("lg-zoom-in") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomIn + '" class="lg-zoom-in lg-icon"></button><button id="' + this.core.getIdName("lg-zoom-out") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomOut + '" class="lg-zoom-out lg-icon"></button>' : "";
      this.settings.actualSize && (t += '<button id="' + this.core.getIdName("lg-actual-size") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.viewActualSize + '" class="' + this.settings.actualSizeIcons.zoomIn + ' lg-icon"></button>'), this.core.outer.addClass("lg-use-transition-for-zoom"), this.core.$toolbar.first().append(t);
    }, e.prototype.enableZoom = function(t) {
      var i = this, n = this.settings.enableZoomAfter + t.detail.delay;
      this.$LG("body").first().hasClass("lg-from-hash") && t.detail.delay ? n = 0 : this.$LG("body").first().removeClass("lg-from-hash"), this.zoomableTimeout = setTimeout(function() {
        i.isImageSlide(i.core.index) && (i.core.getSlideItem(t.detail.index).addClass("lg-zoomable"), t.detail.index === i.core.index && i.setZoomEssentials());
      }, n + 30);
    }, e.prototype.enableZoomOnSlideItemLoad = function() {
      this.core.LGel.on(_t.slideItemLoad + ".zoom", this.enableZoom.bind(this));
    }, e.prototype.getDragCords = function(t) {
      return { x: t.pageX, y: t.pageY };
    }, e.prototype.getSwipeCords = function(t) {
      var i = t.touches[0].pageX, n = t.touches[0].pageY;
      return { x: i, y: n };
    }, e.prototype.getDragAllowedAxises = function(t, i) {
      if (!this.containerRect) return { allowX: false, allowY: false };
      var n = this.core.getSlideItem(this.core.index).find(".lg-image").first().get(), r = 0, o = 0, c = n.getBoundingClientRect();
      t ? (r = n.offsetHeight * t, o = n.offsetWidth * t) : i ? (r = c.height + i * c.height, o = c.width + i * c.width) : (r = c.height, o = c.width);
      var u = r > this.containerRect.height, l = o > this.containerRect.width;
      return { allowX: l, allowY: u };
    }, e.prototype.setZoomEssentials = function() {
      this.containerRect = this.core.$content.get().getBoundingClientRect();
    }, e.prototype.zoomImage = function(t, i, n, r) {
      if (!(!this.containerRect || Math.abs(i) <= 0)) {
        var o = this.containerRect.width / 2 + this.containerRect.left, c = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop, u, l;
        t === 1 && (this.positionChanged = false);
        var m = this.getDragAllowedAxises(0, i), v = m.allowY, y = m.allowX;
        this.positionChanged && (u = this.left / (this.scale - i), l = this.top / (this.scale - i), this.pageX = o - u, this.pageY = c - l, this.positionChanged = false);
        var E = this.getPossibleSwipeDragCords(i), h, g, C = o - this.pageX, _ = c - this.pageY;
        if (t - i > 1) {
          var p = (t - i) / Math.abs(i);
          C = (i < 0 ? -C : C) + this.left * (p + (i < 0 ? -1 : 1)), _ = (i < 0 ? -_ : _) + this.top * (p + (i < 0 ? -1 : 1)), h = C / p, g = _ / p;
        } else {
          var p = (t - i) * i;
          h = C * p, g = _ * p;
        }
        n && (y ? this.isBeyondPossibleLeft(h, E.minX) ? h = E.minX : this.isBeyondPossibleRight(h, E.maxX) && (h = E.maxX) : t > 1 && (h < E.minX ? h = E.minX : h > E.maxX && (h = E.maxX)), v ? this.isBeyondPossibleTop(g, E.minY) ? g = E.minY : this.isBeyondPossibleBottom(g, E.maxY) && (g = E.maxY) : t > 1 && (g < E.minY ? g = E.minY : g > E.maxY && (g = E.maxY))), this.setZoomStyles({ x: h, y: g, scale: t }), this.left = h, this.top = g, r && this.setZoomImageSize();
      }
    }, e.prototype.resetImageTranslate = function(t) {
      if (this.isImageSlide(t)) {
        var i = this.core.getSlideItem(t).find(".lg-image").first();
        this.imageReset = false, i.removeClass("reset-transition reset-transition-y reset-transition-x"), this.core.outer.removeClass("lg-actual-size"), i.css("width", "auto").css("height", "auto"), setTimeout(function() {
          i.removeClass("no-transition");
        }, 10);
      }
    }, e.prototype.setZoomImageSize = function() {
      var t = this, i = this.core.getSlideItem(this.core.index).find(".lg-image").first();
      setTimeout(function() {
        var n = t.getCurrentImageActualSizeScale();
        t.scale >= n && (i.addClass("no-transition"), t.imageReset = true);
      }, nr), setTimeout(function() {
        var n = t.getCurrentImageActualSizeScale();
        if (t.scale >= n) {
          var r = t.getDragAllowedAxises(t.scale);
          i.css("width", i.get().naturalWidth + "px").css("height", i.get().naturalHeight + "px"), t.core.outer.addClass("lg-actual-size"), r.allowX && r.allowY ? i.addClass("reset-transition") : r.allowX && !r.allowY ? i.addClass("reset-transition-x") : !r.allowX && r.allowY && i.addClass("reset-transition-y");
        }
      }, nr + 50);
    }, e.prototype.setZoomStyles = function(t) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), n = this.core.getSlideItem(this.core.index).find(".lg-image").first(), r = this.core.outer.find(".lg-current .lg-dummy-img").first();
      this.scale = t.scale, n.css("transform", "scale3d(" + t.scale + ", " + t.scale + ", 1)"), r.css("transform", "scale3d(" + t.scale + ", " + t.scale + ", 1)");
      var o = "translate3d(" + t.x + "px, " + t.y + "px, 0)";
      i.css("transform", o);
    }, e.prototype.setActualSize = function(t, i) {
      var n = this;
      if (!this.zoomInProgress) {
        this.zoomInProgress = true;
        var r = this.core.galleryItems[this.core.index];
        this.resetImageTranslate(t), setTimeout(function() {
          if (!(!r.src || n.core.outer.hasClass("lg-first-slide-loading"))) {
            var o = n.getCurrentImageActualSizeScale(), c = n.scale;
            n.core.outer.hasClass("lg-zoomed") ? n.scale = 1 : n.scale = n.getScale(o), n.setPageCords(i), n.beginZoom(n.scale), n.zoomImage(n.scale, n.scale - c, true, true);
          }
        }, 50), setTimeout(function() {
          n.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
        }, 60), setTimeout(function() {
          n.zoomInProgress = false;
        }, nr + 110);
      }
    }, e.prototype.getNaturalWidth = function(t) {
      var i = this.core.getSlideItem(t).find(".lg-image").first(), n = this.core.galleryItems[t].width;
      return n ? parseFloat(n) : i.get().naturalWidth;
    }, e.prototype.getActualSizeScale = function(t, i) {
      var n, r;
      return t >= i ? (n = t / i, r = n || 2) : r = 1, r;
    }, e.prototype.getCurrentImageActualSizeScale = function() {
      var t = this.core.getSlideItem(this.core.index).find(".lg-image").first(), i = t.get().offsetWidth, n = this.getNaturalWidth(this.core.index) || i;
      return this.getActualSizeScale(n, i);
    }, e.prototype.getPageCords = function(t) {
      var i = {};
      if (t) i.x = t.pageX || t.touches[0].pageX, i.y = t.pageY || t.touches[0].pageY;
      else {
        var n = this.core.$content.get().getBoundingClientRect();
        i.x = n.width / 2 + n.left, i.y = n.height / 2 + this.scrollTop + n.top;
      }
      return i;
    }, e.prototype.setPageCords = function(t) {
      var i = this.getPageCords(t);
      this.pageX = i.x, this.pageY = i.y;
    }, e.prototype.manageActualPixelClassNames = function() {
      var t = this.core.getElementById("lg-actual-size");
      t.removeClass(this.settings.actualSizeIcons.zoomIn).addClass(this.settings.actualSizeIcons.zoomOut);
    }, e.prototype.beginZoom = function(t) {
      return this.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), t > 1 ? (this.core.outer.addClass("lg-zoomed"), this.manageActualPixelClassNames()) : this.resetZoom(), t > 1;
    }, e.prototype.getScale = function(t) {
      var i = this.getCurrentImageActualSizeScale();
      return t < 1 ? t = 1 : t > i && (t = i), t;
    }, e.prototype.init = function() {
      var t = this;
      if (this.settings.zoom) {
        this.buildTemplates(), this.enableZoomOnSlideItemLoad();
        var i = null;
        this.core.outer.on("dblclick.lg", function(n) {
          t.$LG(n.target).hasClass("lg-image") && t.setActualSize(t.core.index, n);
        }), this.core.outer.on("touchstart.lg", function(n) {
          var r = t.$LG(n.target);
          n.touches.length === 1 && r.hasClass("lg-image") && (i ? (clearTimeout(i), i = null, n.preventDefault(), t.setActualSize(t.core.index, n)) : i = setTimeout(function() {
            i = null;
          }, 300));
        }), this.core.LGel.on(_t.containerResize + ".zoom " + _t.rotateRight + ".zoom " + _t.rotateLeft + ".zoom " + _t.flipHorizontal + ".zoom " + _t.flipVertical + ".zoom", function() {
          if (!(!t.core.lgOpened || !t.isImageSlide(t.core.index) || t.core.touchAction)) {
            var n = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
            t.top = 0, t.left = 0, t.setZoomEssentials(), t.setZoomSwipeStyles(n, { x: 0, y: 0 }), t.positionChanged = true;
          }
        }), this.$LG(window).on("scroll.lg.zoom.global" + this.core.lgId, function() {
          t.core.lgOpened && (t.scrollTop = t.$LG(window).scrollTop());
        }), this.core.getElementById("lg-zoom-out").on("click.lg", function() {
          if (t.isImageSlide(t.core.index)) {
            var n = 0;
            t.imageReset && (t.resetImageTranslate(t.core.index), n = 50), setTimeout(function() {
              var r = t.scale - t.settings.scale;
              r < 1 && (r = 1), t.beginZoom(r), t.zoomImage(r, -t.settings.scale, true, !t.settings.infiniteZoom);
            }, n);
          }
        }), this.core.getElementById("lg-zoom-in").on("click.lg", function() {
          t.zoomIn();
        }), this.core.getElementById("lg-actual-size").on("click.lg", function() {
          t.setActualSize(t.core.index);
        }), this.core.LGel.on(_t.beforeOpen + ".zoom", function() {
          t.core.outer.find(".lg-item").removeClass("lg-zoomable");
        }), this.core.LGel.on(_t.afterOpen + ".zoom", function() {
          t.scrollTop = t.$LG(window).scrollTop(), t.pageX = t.core.outer.width() / 2, t.pageY = t.core.outer.height() / 2 + t.scrollTop, t.scale = 1;
        }), this.core.LGel.on(_t.afterSlide + ".zoom", function(n) {
          var r = n.detail.prevIndex;
          t.scale = 1, t.positionChanged = false, t.zoomInProgress = false, t.resetZoom(r), t.resetImageTranslate(r), t.isImageSlide(t.core.index) && t.setZoomEssentials();
        }), this.zoomDrag(), this.pinchZoom(), this.zoomSwipe(), this.zoomableTimeout = false, this.positionChanged = false, this.zoomInProgress = false;
      }
    }, e.prototype.zoomIn = function() {
      if (this.isImageSlide(this.core.index)) {
        var t = this.scale + this.settings.scale;
        this.settings.infiniteZoom || (t = this.getScale(t)), this.beginZoom(t), this.zoomImage(t, Math.min(this.settings.scale, t - this.scale), true, !this.settings.infiniteZoom);
      }
    }, e.prototype.resetZoom = function(t) {
      this.core.outer.removeClass("lg-zoomed lg-zoom-drag-transition");
      var i = this.core.getElementById("lg-actual-size"), n = this.core.getSlideItem(t !== void 0 ? t : this.core.index);
      i.removeClass(this.settings.actualSizeIcons.zoomOut).addClass(this.settings.actualSizeIcons.zoomIn), n.find(".lg-img-wrap").first().removeAttr("style"), n.find(".lg-image").first().removeAttr("style"), this.scale = 1, this.left = 0, this.top = 0, this.setPageCords();
    }, e.prototype.getTouchDistance = function(t) {
      return Math.sqrt((t.touches[0].pageX - t.touches[1].pageX) * (t.touches[0].pageX - t.touches[1].pageX) + (t.touches[0].pageY - t.touches[1].pageY) * (t.touches[0].pageY - t.touches[1].pageY));
    }, e.prototype.pinchZoom = function() {
      var t = this, i = 0, n = false, r = 1, o = 0, c = this.core.getSlideItem(this.core.index);
      this.core.outer.on("touchstart.lg", function(u) {
        if (c = t.core.getSlideItem(t.core.index), !!t.isImageSlide(t.core.index) && u.touches.length === 2) {
          if (u.preventDefault(), t.core.outer.hasClass("lg-first-slide-loading")) return;
          r = t.scale || 1, t.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), t.setPageCords(u), t.resetImageTranslate(t.core.index), t.core.touchAction = "pinch", i = t.getTouchDistance(u);
        }
      }), this.core.$inner.on("touchmove.lg", function(u) {
        if (u.touches.length === 2 && t.core.touchAction === "pinch" && (t.$LG(u.target).hasClass("lg-item") || c.get().contains(u.target))) {
          u.preventDefault();
          var l = t.getTouchDistance(u), m = i - l;
          if (!n && Math.abs(m) > 5 && (n = true), n) {
            o = t.scale;
            var v = Math.max(1, r + -m * 0.02);
            t.scale = Math.round((v + Number.EPSILON) * 100) / 100;
            var y = t.scale - o;
            t.zoomImage(t.scale, Math.round((y + Number.EPSILON) * 100) / 100, false, false);
          }
        }
      }), this.core.$inner.on("touchend.lg", function(u) {
        if (t.core.touchAction === "pinch" && (t.$LG(u.target).hasClass("lg-item") || c.get().contains(u.target))) {
          if (n = false, i = 0, t.scale <= 1) t.resetZoom();
          else {
            var l = t.getCurrentImageActualSizeScale();
            if (t.scale >= l) {
              var m = l - t.scale;
              m === 0 && (m = 0.01), t.zoomImage(l, m, false, true);
            }
            t.manageActualPixelClassNames(), t.core.outer.addClass("lg-zoomed");
          }
          t.core.touchAction = void 0;
        }
      });
    }, e.prototype.touchendZoom = function(t, i, n, r, o) {
      var c = i.x - t.x, u = i.y - t.y, l = Math.abs(c) / o + 1, m = Math.abs(u) / o + 1;
      l > 2 && (l += 1), m > 2 && (m += 1), c = c * l, u = u * m;
      var v = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), y = {};
      y.x = this.left + c, y.y = this.top + u;
      var E = this.getPossibleSwipeDragCords();
      (Math.abs(c) > 15 || Math.abs(u) > 15) && (r && (this.isBeyondPossibleTop(y.y, E.minY) ? y.y = E.minY : this.isBeyondPossibleBottom(y.y, E.maxY) && (y.y = E.maxY)), n && (this.isBeyondPossibleLeft(y.x, E.minX) ? y.x = E.minX : this.isBeyondPossibleRight(y.x, E.maxX) && (y.x = E.maxX)), r ? this.top = y.y : y.y = this.top, n ? this.left = y.x : y.x = this.left, this.setZoomSwipeStyles(v, y), this.positionChanged = true);
    }, e.prototype.getZoomSwipeCords = function(t, i, n, r, o) {
      var c = {};
      if (r) {
        if (c.y = this.top + (i.y - t.y), this.isBeyondPossibleTop(c.y, o.minY)) {
          var u = o.minY - c.y;
          c.y = o.minY - u / 6;
        } else if (this.isBeyondPossibleBottom(c.y, o.maxY)) {
          var l = c.y - o.maxY;
          c.y = o.maxY + l / 6;
        }
      } else c.y = this.top;
      if (n) {
        if (c.x = this.left + (i.x - t.x), this.isBeyondPossibleLeft(c.x, o.minX)) {
          var m = o.minX - c.x;
          c.x = o.minX - m / 6;
        } else if (this.isBeyondPossibleRight(c.x, o.maxX)) {
          var v = c.x - o.maxX;
          c.x = o.maxX + v / 6;
        }
      } else c.x = this.left;
      return c;
    }, e.prototype.isBeyondPossibleLeft = function(t, i) {
      return t >= i;
    }, e.prototype.isBeyondPossibleRight = function(t, i) {
      return t <= i;
    }, e.prototype.isBeyondPossibleTop = function(t, i) {
      return t >= i;
    }, e.prototype.isBeyondPossibleBottom = function(t, i) {
      return t <= i;
    }, e.prototype.isImageSlide = function(t) {
      var i = this.core.galleryItems[t];
      return this.core.getSlideType(i) === "image";
    }, e.prototype.getPossibleSwipeDragCords = function(t) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-image").first(), n = this.core.mediaContainerPosition.bottom, r = i.get().getBoundingClientRect(), o = r.height, c = r.width;
      t && (o = o + t * o, c = c + t * c);
      var u = (o - this.containerRect.height) / 2, l = (this.containerRect.height - o) / 2 + n, m = (c - this.containerRect.width) / 2, v = (this.containerRect.width - c) / 2, y = { minY: u, maxY: l, minX: m, maxX: v };
      return y;
    }, e.prototype.setZoomSwipeStyles = function(t, i) {
      t.css("transform", "translate3d(" + i.x + "px, " + i.y + "px, 0)");
    }, e.prototype.zoomSwipe = function() {
      var t = this, i = {}, n = {}, r = false, o = false, c = false, u = /* @__PURE__ */ new Date(), l = /* @__PURE__ */ new Date(), m, v, y = this.core.getSlideItem(this.core.index);
      this.core.$inner.on("touchstart.lg", function(E) {
        if (t.isImageSlide(t.core.index) && (y = t.core.getSlideItem(t.core.index), (t.$LG(E.target).hasClass("lg-item") || y.get().contains(E.target)) && E.touches.length === 1 && t.core.outer.hasClass("lg-zoomed"))) {
          E.preventDefault(), u = /* @__PURE__ */ new Date(), t.core.touchAction = "zoomSwipe", v = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
          var h = t.getDragAllowedAxises(0);
          c = h.allowY, o = h.allowX, (o || c) && (i = t.getSwipeCords(E)), m = t.getPossibleSwipeDragCords(), t.core.outer.addClass("lg-zoom-dragging lg-zoom-drag-transition");
        }
      }), this.core.$inner.on("touchmove.lg", function(E) {
        if (E.touches.length === 1 && t.core.touchAction === "zoomSwipe" && (t.$LG(E.target).hasClass("lg-item") || y.get().contains(E.target))) {
          E.preventDefault(), t.core.touchAction = "zoomSwipe", n = t.getSwipeCords(E);
          var h = t.getZoomSwipeCords(i, n, o, c, m);
          (Math.abs(n.x - i.x) > 15 || Math.abs(n.y - i.y) > 15) && (r = true, t.setZoomSwipeStyles(v, h));
        }
      }), this.core.$inner.on("touchend.lg", function(E) {
        if (t.core.touchAction === "zoomSwipe" && (t.$LG(E.target).hasClass("lg-item") || y.get().contains(E.target))) {
          if (E.preventDefault(), t.core.touchAction = void 0, t.core.outer.removeClass("lg-zoom-dragging"), !r) return;
          r = false, l = /* @__PURE__ */ new Date();
          var h = l.valueOf() - u.valueOf();
          t.touchendZoom(i, n, o, c, h);
        }
      });
    }, e.prototype.zoomDrag = function() {
      var t = this, i = {}, n = {}, r = false, o = false, c = false, u = false, l, m, v, y;
      this.core.outer.on("mousedown.lg.zoom", function(E) {
        if (t.isImageSlide(t.core.index)) {
          var h = t.core.getSlideItem(t.core.index);
          if (t.$LG(E.target).hasClass("lg-item") || h.get().contains(E.target)) {
            l = /* @__PURE__ */ new Date(), y = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
            var g = t.getDragAllowedAxises(0);
            u = g.allowY, c = g.allowX, t.core.outer.hasClass("lg-zoomed") && t.$LG(E.target).hasClass("lg-object") && (c || u) && (E.preventDefault(), i = t.getDragCords(E), v = t.getPossibleSwipeDragCords(), r = true, t.core.outer.removeClass("lg-grab").addClass("lg-grabbing lg-zoom-drag-transition lg-zoom-dragging"));
          }
        }
      }), this.$LG(window).on("mousemove.lg.zoom.global" + this.core.lgId, function(E) {
        if (r) {
          o = true, n = t.getDragCords(E);
          var h = t.getZoomSwipeCords(i, n, c, u, v);
          t.setZoomSwipeStyles(y, h);
        }
      }), this.$LG(window).on("mouseup.lg.zoom.global" + this.core.lgId, function(E) {
        if (r) {
          if (m = /* @__PURE__ */ new Date(), r = false, t.core.outer.removeClass("lg-zoom-dragging"), o && (i.x !== n.x || i.y !== n.y)) {
            n = t.getDragCords(E);
            var h = m.valueOf() - l.valueOf();
            t.touchendZoom(i, n, c, u, h);
          }
          o = false;
        }
        t.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
      });
    }, e.prototype.closeGallery = function() {
      this.resetZoom(), this.zoomInProgress = false;
    }, e.prototype.destroy = function() {
      this.$LG(window).off(".lg.zoom.global" + this.core.lgId), this.core.LGel.off(".lg.zoom"), this.core.LGel.off(".zoom"), clearTimeout(this.zoomableTimeout), this.zoomableTimeout = false;
    }, e;
  })();
  var Jt = function() {
    return Jt = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Jt.apply(this, arguments);
  }, Iv = { autoplayFirstVideo: true, youTubePlayerParams: false, vimeoPlayerParams: false, wistiaPlayerParams: false, gotoNextSlideOnVideoEnd: true, autoplayVideoOnSlide: false, videojs: false, videojsTheme: "", videojsOptions: {} }, Xi = { hasVideo: "lgHasVideo", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick" }, Pr = function(e) {
    return Object.keys(e).map(function(t) {
      return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
  }, Ov = function(e) {
    var t = e.slice(1).split("&").map(function(i) {
      return i.split("=");
    }).reduce(function(i, n) {
      var r = n.map(decodeURIComponent), o = r[0], c = r[1];
      return i[o] = c, i;
    }, {});
    return t;
  }, Mv = function(e, t) {
    if (!e.youtube) return "";
    var i = e.youtube[2] ? Ov(e.youtube[2]) : "", n = { wmode: "opaque", autoplay: 0, mute: 1, enablejsapi: 1 }, r = t || {}, o = Jt(Jt(Jt({}, n), r), i), c = "?" + Pr(o);
    return c;
  }, Lv = function(e) {
    return e.includes("youtube-nocookie.com");
  }, Pv = function(e, t) {
    if (!t || !t.vimeo) return "";
    var i = t.vimeo[2] || "", n = Object.assign({}, { autoplay: 0, muted: 1 }, e), r = n && Object.keys(n).length !== 0 ? Pr(n) : "", o = t.vimeo[0].split("/").pop() || "", c = o.split("?")[0] || "", u = c.split("#")[0], l = t.vimeo[1] !== u;
    l && (i = i.replace("/" + u, "")), i = i[0] == "?" ? "&" + i.slice(1) : i || "";
    var m = l ? "h=" + u : "";
    r = m ? "&" + r : r;
    var v = "?" + m + r + i;
    return v;
  }, Dv = (function() {
    function e(t) {
      return this.core = t, this.settings = Jt(Jt({}, Iv), this.core.settings), this;
    }
    return e.prototype.init = function() {
      var t = this;
      this.core.LGel.on(Xi.hasVideo + ".video", this.onHasVideo.bind(this)), this.core.LGel.on(Xi.posterClick + ".video", function() {
        var i = t.core.getSlideItem(t.core.index);
        t.loadVideoOnPosterClick(i);
      }), this.core.LGel.on(Xi.slideItemLoad + ".video", this.onSlideItemLoad.bind(this)), this.core.LGel.on(Xi.beforeSlide + ".video", this.onBeforeSlide.bind(this)), this.core.LGel.on(Xi.afterSlide + ".video", this.onAfterSlide.bind(this));
    }, e.prototype.onSlideItemLoad = function(t) {
      var i = this, n = t.detail, r = n.isFirstSlide, o = n.index;
      this.settings.autoplayFirstVideo && r && o === this.core.index && setTimeout(function() {
        i.loadAndPlayVideo(o);
      }, 200), !r && this.settings.autoplayVideoOnSlide && o === this.core.index && this.loadAndPlayVideo(o);
    }, e.prototype.onHasVideo = function(t) {
      var i = t.detail, n = i.index, r = i.src, o = i.html5Video, c = i.hasPoster;
      c || (this.appendVideos(this.core.getSlideItem(n), { src: r, addClass: "lg-object", index: n, html5Video: o }), this.gotoNextSlideOnVideoEnd(r, n));
    }, e.prototype.onBeforeSlide = function(t) {
      if (this.core.lGalleryOn) {
        var i = t.detail.prevIndex;
        this.pauseVideo(i);
      }
    }, e.prototype.onAfterSlide = function(t) {
      var i = this, n = t.detail, r = n.index, o = n.prevIndex, c = this.core.getSlideItem(r);
      this.settings.autoplayVideoOnSlide && r !== o && c.hasClass("lg-complete") && setTimeout(function() {
        i.loadAndPlayVideo(r);
      }, 100);
    }, e.prototype.loadAndPlayVideo = function(t) {
      var i = this.core.getSlideItem(t), n = this.core.galleryItems[t];
      n.poster ? this.loadVideoOnPosterClick(i, true) : this.playVideo(t);
    }, e.prototype.playVideo = function(t) {
      this.controlVideo(t, "play");
    }, e.prototype.pauseVideo = function(t) {
      this.controlVideo(t, "pause");
    }, e.prototype.getVideoHtml = function(t, i, n, r) {
      var o = "", c = this.core.galleryItems[n].__slideVideoInfo || {}, u = this.core.galleryItems[n], l = u.title || u.alt;
      l = l ? 'title="' + l + '"' : "";
      var m = `allowtransparency="true"
            frameborder="0"
            scrolling="no"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen`;
      if (c.youtube) {
        var v = "lg-youtube" + n, y = Mv(c, this.settings.youTubePlayerParams), E = Lv(t), h = E ? "//www.youtube-nocookie.com/" : "//www.youtube.com/";
        o = '<iframe allow="autoplay" id=' + v + ' class="lg-video-object lg-youtube ' + i + '" ' + l + ' src="' + h + "embed/" + (c.youtube[1] + y) + '" ' + m + "></iframe>";
      } else if (c.vimeo) {
        var v = "lg-vimeo" + n, g = Pv(this.settings.vimeoPlayerParams, c);
        o = '<iframe allow="autoplay" id=' + v + ' class="lg-video-object lg-vimeo ' + i + '" ' + l + ' src="//player.vimeo.com/video/' + (c.vimeo[1] + g) + '" ' + m + "></iframe>";
      } else if (c.wistia) {
        var C = "lg-wistia" + n, g = Pr(this.settings.wistiaPlayerParams);
        g = g ? "?" + g : "", o = '<iframe allow="autoplay" id="' + C + '" src="//fast.wistia.net/embed/iframe/' + (c.wistia[4] + g) + '" ' + l + ' class="wistia_embed lg-video-object lg-wistia ' + i + '" name="wistia_embed" ' + m + "></iframe>";
      } else if (c.html5) {
        for (var _ = "", p = 0; p < r.source.length; p++) {
          var S = r.source[p].type, w = S ? 'type="' + S + '"' : "";
          _ += '<source src="' + r.source[p].src + '" ' + w + ">";
        }
        if (r.tracks) for (var I = function(P) {
          var D = "", R = r.tracks[P];
          Object.keys(R || {}).forEach(function(N) {
            D += N + '="' + R[N] + '" ';
          }), _ += "<track " + D + ">";
        }, p = 0; p < r.tracks.length; p++) I(p);
        var L = "", f = r.attributes || {};
        Object.keys(f || {}).forEach(function(P) {
          L += P + '="' + f[P] + '" ';
        }), o = '<video class="lg-video-object lg-html5 ' + (this.settings.videojs && this.settings.videojsTheme ? this.settings.videojsTheme + " " : "") + " " + (this.settings.videojs ? " video-js" : "") + '" ' + L + `>
                ` + _ + `
                Your browser does not support HTML5 video.
            </video>`;
      }
      return o;
    }, e.prototype.appendVideos = function(t, i) {
      var n, r = this.getVideoHtml(i.src, i.addClass, i.index, i.html5Video);
      t.find(".lg-video-cont").append(r);
      var o = t.find(".lg-video-object").first();
      if (i.html5Video && o.on("mousedown.lg.video", function(c) {
        c.stopPropagation();
      }), this.settings.videojs && (!((n = this.core.galleryItems[i.index].__slideVideoInfo) === null || n === void 0) && n.html5)) try {
        return videojs(o.get(), this.settings.videojsOptions);
      } catch (c) {
        console.error("lightGallery:- Make sure you have included videojs");
      }
    }, e.prototype.gotoNextSlideOnVideoEnd = function(t, i) {
      var n = this, r = this.core.getSlideItem(i).find(".lg-video-object").first(), o = this.core.galleryItems[i].__slideVideoInfo || {};
      if (this.settings.gotoNextSlideOnVideoEnd) {
        if (o.html5) r.on("ended", function() {
          n.core.goToNextSlide();
        });
        else if (o.vimeo) try {
          new Vimeo.Player(r.get()).on("ended", function() {
            n.core.goToNextSlide();
          });
        } catch (c) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (o.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: r.attr("id"), onReady: function(c) {
            c.bind("end", function() {
              n.core.goToNextSlide();
            });
          } });
        } catch (c) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, e.prototype.controlVideo = function(t, i) {
      var n = this.core.getSlideItem(t).find(".lg-video-object").first(), r = this.core.galleryItems[t].__slideVideoInfo || {};
      if (n.get()) {
        if (r.youtube) try {
          n.get().contentWindow.postMessage('{"event":"command","func":"' + i + 'Video","args":""}', "*");
        } catch (o) {
          console.error("lightGallery:- " + o);
        }
        else if (r.vimeo) try {
          new Vimeo.Player(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (r.html5) if (this.settings.videojs) try {
          videojs(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included videojs");
        }
        else n.get()[i]();
        else if (r.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: n.attr("id"), onReady: function(o) {
            o[i]();
          } });
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, e.prototype.loadVideoOnPosterClick = function(t, i) {
      var n = this;
      if (t.hasClass("lg-video-loaded")) i && this.playVideo(this.core.index);
      else if (t.hasClass("lg-has-video")) this.playVideo(this.core.index);
      else {
        t.addClass("lg-has-video");
        var r = void 0, o = this.core.galleryItems[this.core.index].src, c = this.core.galleryItems[this.core.index].video;
        c && (r = typeof c == "string" ? JSON.parse(c) : c);
        var u = this.appendVideos(t, { src: o, addClass: "", index: this.core.index, html5Video: r });
        this.gotoNextSlideOnVideoEnd(o, this.core.index);
        var l = t.find(".lg-object").first().get();
        t.find(".lg-video-cont").first().append(l), t.addClass("lg-video-loading"), u && u.ready(function() {
          u.on("loadedmetadata", function() {
            n.onVideoLoadAfterPosterClick(t, n.core.index);
          });
        }), t.find(".lg-video-object").first().on("load.lg error.lg loadedmetadata.lg", function() {
          setTimeout(function() {
            n.onVideoLoadAfterPosterClick(t, n.core.index);
          }, 50);
        });
      }
    }, e.prototype.onVideoLoadAfterPosterClick = function(t, i) {
      t.addClass("lg-video-loaded"), this.playVideo(i);
    }, e.prototype.destroy = function() {
      this.core.LGel.off(".lg.video"), this.core.LGel.off(".video");
    }, e;
  })();
  var Wn = function() {
    return Wn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Wn.apply(this, arguments);
  };
  function zv(e, t, i, n) {
    function r(o) {
      return o instanceof i ? o : new i(function(c) {
        c(o);
      });
    }
    return new (i || (i = Promise))(function(o, c) {
      function u(v) {
        try {
          m(n.next(v));
        } catch (y) {
          c(y);
        }
      }
      function l(v) {
        try {
          m(n.throw(v));
        } catch (y) {
          c(y);
        }
      }
      function m(v) {
        v.done ? o(v.value) : r(v.value).then(u, l);
      }
      m((n = n.apply(e, [])).next());
    });
  }
  function $v(e, t) {
    var i = { label: 0, sent: function() {
      if (o[0] & 1) throw o[1];
      return o[1];
    }, trys: [], ops: [] }, n, r, o, c;
    return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
      return this;
    }), c;
    function u(m) {
      return function(v) {
        return l([m, v]);
      };
    }
    function l(m) {
      if (n) throw new TypeError("Generator is already executing.");
      for (; i; ) try {
        if (n = 1, r && (o = m[0] & 2 ? r.return : m[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, m[1])).done) return o;
        switch (r = 0, o && (m = [m[0] & 2, o.value]), m[0]) {
          case 0:
          case 1:
            o = m;
            break;
          case 4:
            return i.label++, { value: m[1], done: false };
          case 5:
            i.label++, r = m[1], m = [0];
            continue;
          case 7:
            m = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (o = i.trys, !(o = o.length > 0 && o[o.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              i = 0;
              continue;
            }
            if (m[0] === 3 && (!o || m[1] > o[0] && m[1] < o[3])) {
              i.label = m[1];
              break;
            }
            if (m[0] === 6 && i.label < o[1]) {
              i.label = o[1], o = m;
              break;
            }
            if (o && i.label < o[2]) {
              i.label = o[2], i.ops.push(m);
              break;
            }
            o[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        m = t.call(e, i);
      } catch (v) {
        m = [6, v], r = 0;
      } finally {
        n = o = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: true };
    }
  }
  var Nv = { init: "lgInit" }, kv = { showVimeoThumbnails: true, showThumbnailWithPlayButton: false }, Rv = (function() {
    function e(t) {
      return this.core = t, this.settings = Wn(Wn({}, kv), this.core.settings), this;
    }
    return e.prototype.init = function() {
      var t = this;
      this.settings.showVimeoThumbnails && this.core.LGel.on(Nv.init + ".vimeothumbnails", function(i) {
        var n = i.detail.instance, r = n.$container.find(".lg-thumb-outer").get();
        r && t.setVimeoThumbnails(n);
      });
    }, e.prototype.setVimeoThumbnails = function(t) {
      return zv(this, void 0, void 0, function() {
        var i, n, r, o, c;
        return $v(this, function(u) {
          switch (u.label) {
            case 0:
              i = 0, u.label = 1;
            case 1:
              return i < t.galleryItems.length ? (n = t.galleryItems[i], r = n.__slideVideoInfo || {}, r.vimeo ? [4, fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(n.src))] : [3, 4]) : [3, 5];
            case 2:
              return o = u.sent(), [4, o.json()];
            case 3:
              c = u.sent(), t.$container.find(".lg-thumb-item").eq(i).find("img").attr("src", this.settings.showThumbnailWithPlayButton ? c.thumbnail_url_with_play_button : c.thumbnail_url), u.label = 4;
            case 4:
              return i++, [3, 1];
            case 5:
              return [2];
          }
        });
      });
    }, e.prototype.destroy = function() {
      this.core.LGel.off(".lg.vimeothumbnails"), this.core.LGel.off(".vimeothumbnails");
    }, e;
  })();
  window.lightGallery = _v;
  window.lgThumbnail = Cv;
  window.lgZoom = Av;
  window.lgVideo = Dv;
  window.lgVimeoThumbnail = Rv;
  function Fn(e) {
    "@babel/helpers - typeof";
    return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Fn(e);
  }
  var Hv = (typeof HTMLElement == "undefined" ? "undefined" : Fn(HTMLElement)) === "object";
  function sr(e) {
    return Hv ? e instanceof HTMLElement : e && Fn(e) === "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
  }
  function xt(e, t) {
    t.forEach(function(i) {
      e.classList.add(i);
    });
  }
  function gt(e, t) {
    t.forEach(function(i) {
      e.classList.remove(i);
    });
  }
  var Vv = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
  function Bv() {
    if (!document.querySelector(".drift-base-styles")) {
      var e = document.createElement("style");
      e.type = "text/css", e.classList.add("drift-base-styles"), e.appendChild(document.createTextNode(Vv));
      var t = document.head;
      t.insertBefore(e, t.firstChild);
    }
  }
  function We() {
    throw new Error("Missing parameter");
  }
  function Wv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Fv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function Gv(e, t, i) {
    return t && Fv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var jv = (function() {
    function e(t) {
      Wv(this, e), this.isShowing = false;
      var i = t.namespace, n = i === void 0 ? null : i, r = t.zoomFactor, o = r === void 0 ? We() : r, c = t.containerEl, u = c === void 0 ? We() : c;
      this.settings = { namespace: n, zoomFactor: o, containerEl: u }, this.openClasses = this._buildClasses("open"), this._buildElement();
    }
    return Gv(e, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), xt(this.el, this._buildClasses("bounding-box"));
    } }, { key: "show", value: function(i, n) {
      this.isShowing = true, this.settings.containerEl.appendChild(this.el);
      var r = this.el.style;
      r.width = "".concat(Math.round(i / this.settings.zoomFactor), "px"), r.height = "".concat(Math.round(n / this.settings.zoomFactor), "px"), xt(this.el, this.openClasses);
    } }, { key: "hide", value: function() {
      this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = false, gt(this.el, this.openClasses);
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = window.pageXOffset, c = window.pageYOffset, u = r.left + i * r.width - this.el.clientWidth / 2 + o, l = r.top + n * r.height - this.el.clientHeight / 2 + c;
      u < r.left + o ? u = r.left + o : u + this.el.clientWidth > r.left + r.width + o && (u = r.left + r.width - this.el.clientWidth + o), l < r.top + c ? l = r.top + c : l + this.el.clientHeight > r.top + r.height + c && (l = r.top + r.height - this.el.clientHeight + c), this.el.style.left = "".concat(u, "px"), this.el.style.top = "".concat(l, "px");
    } }]), e;
  })();
  function Yv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Xv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function qv(e, t, i) {
    return t && Xv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var Uv = (function() {
    function e() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Yv(this, e), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
      var i = t.el, n = i === void 0 ? We() : i, r = t.zoomPane, o = r === void 0 ? We() : r, c = t.sourceAttribute, u = c === void 0 ? We() : c, l = t.handleTouch, m = l === void 0 ? We() : l, v = t.onShow, y = v === void 0 ? null : v, E = t.onHide, h = E === void 0 ? null : E, g = t.hoverDelay, C = g === void 0 ? 0 : g, _ = t.touchDelay, p = _ === void 0 ? 0 : _, S = t.hoverBoundingBox, w = S === void 0 ? We() : S, I = t.touchBoundingBox, L = I === void 0 ? We() : I, f = t.namespace, P = f === void 0 ? null : f, D = t.zoomFactor, R = D === void 0 ? We() : D, N = t.boundingBoxContainer, $ = N === void 0 ? We() : N, V = t.passive, B = V === void 0 ? false : V;
      this.settings = { el: n, zoomPane: o, sourceAttribute: u, handleTouch: m, onShow: y, onHide: h, hoverDelay: C, touchDelay: p, hoverBoundingBox: w, touchBoundingBox: L, namespace: P, zoomFactor: R, boundingBoxContainer: $, passive: B }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new jv({ namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, containerEl: this.settings.boundingBoxContainer })), this.enabled = true, this._bindEvents();
    }
    return qv(e, [{ key: "_preventDefault", value: function(i) {
      i.preventDefault();
    } }, { key: "_preventDefaultAllowTouchScroll", value: function(i) {
      (!this.settings.touchDelay || !this._isTouchEvent(i) || this.isShowing) && i.preventDefault();
    } }, { key: "_isTouchEvent", value: function(i) {
      return !!i.touches;
    } }, { key: "_bindEvents", value: function() {
      this.settings.el.addEventListener("mouseenter", this._handleEntry), this.settings.el.addEventListener("mouseleave", this._hide), this.settings.el.addEventListener("mousemove", this._handleMovement);
      var i = { passive: this.settings.passive };
      this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, i), this.settings.el.addEventListener("touchend", this._hide), this.settings.el.addEventListener("touchmove", this._handleMovement, i)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, i), this.settings.el.addEventListener("touchend", this._preventDefault), this.settings.el.addEventListener("touchmove", this._preventDefault, i));
    } }, { key: "_unbindEvents", value: function() {
      this.settings.el.removeEventListener("mouseenter", this._handleEntry), this.settings.el.removeEventListener("mouseleave", this._hide), this.settings.el.removeEventListener("mousemove", this._handleMovement), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry), this.settings.el.removeEventListener("touchend", this._hide), this.settings.el.removeEventListener("touchmove", this._handleMovement)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault), this.settings.el.removeEventListener("touchend", this._preventDefault), this.settings.el.removeEventListener("touchmove", this._preventDefault));
    } }, { key: "_handleEntry", value: function(i) {
      this._preventDefaultAllowTouchScroll(i), this._lastMovement = i, i.type == "mouseenter" && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show();
    } }, { key: "_show", value: function() {
      if (this.enabled) {
        var i = this.settings.onShow;
        if (i && typeof i == "function" && i(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
          var n = this._lastMovement.touches;
          (n && this.settings.touchBoundingBox || !n && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
        }
        this._handleMovement();
      }
    } }, { key: "_hide", value: function(i) {
      i && this._preventDefaultAllowTouchScroll(i), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
      var n = this.settings.onHide;
      n && typeof n == "function" && n(), this.settings.zoomPane.hide();
    } }, { key: "_handleMovement", value: function(i) {
      if (i) this._preventDefaultAllowTouchScroll(i), this._lastMovement = i;
      else if (this._lastMovement) i = this._lastMovement;
      else return;
      var n, r;
      if (i.touches) {
        var o = i.touches[0];
        n = o.clientX, r = o.clientY;
      } else n = i.clientX, r = i.clientY;
      var c = this.settings.el, u = c.getBoundingClientRect(), l = n - u.left, m = r - u.top, v = l / this.settings.el.clientWidth, y = m / this.settings.el.clientHeight;
      this.boundingBox && this.boundingBox.setPosition(v, y, u), this.settings.zoomPane.setPosition(v, y, u);
    } }, { key: "isShowing", get: function() {
      return this.settings.zoomPane.isShowing;
    } }]), e;
  })();
  function Kv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Zv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function Qv(e, t, i) {
    return t && Zv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var Jv = (function() {
    function e() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (Kv(this, e), this.HAS_ANIMATION = false, typeof document != "undefined") {
        var i = document.createElement("div").style;
        this.HAS_ANIMATION = "animation" in i || "webkitAnimation" in i;
      }
      this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = false;
      var n = t.container, r = n === void 0 ? null : n, o = t.zoomFactor, c = o === void 0 ? We() : o, u = t.inline, l = u === void 0 ? We() : u, m = t.namespace, v = m === void 0 ? null : m, y = t.showWhitespaceAtEdges, E = y === void 0 ? We() : y, h = t.containInline, g = h === void 0 ? We() : h, C = t.inlineOffsetX, _ = C === void 0 ? 0 : C, p = t.inlineOffsetY, S = p === void 0 ? 0 : p, w = t.inlineContainer, I = w === void 0 ? document.body : w;
      this.settings = { container: r, zoomFactor: c, inline: l, namespace: v, showWhitespaceAtEdges: E, containInline: g, inlineOffsetX: _, inlineOffsetY: S, inlineContainer: I }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement();
    }
    return Qv(e, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), xt(this.el, this._buildClasses("zoom-pane"));
      var i = document.createElement("div");
      xt(i, this._buildClasses("zoom-pane-loader")), this.el.appendChild(i), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl);
    } }, { key: "_setImageURL", value: function(i) {
      this.imgEl.setAttribute("src", i);
    } }, { key: "_setImageSize", value: function(i, n) {
      this.imgEl.style.width = "".concat(i * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(n * this.settings.zoomFactor, "px");
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = this.imgEl.offsetWidth, c = this.imgEl.offsetHeight, u = this.el.offsetWidth, l = this.el.offsetHeight, m = u / 2, v = l / 2, y = o * i, E = c * n, h = m - y, g = v - E, C = u - o, _ = l - c, p = C > 0, S = _ > 0, w = p ? C / 2 : 0, I = S ? _ / 2 : 0, L = p ? C / 2 : C, f = S ? _ / 2 : _;
      if (this.el.parentElement === this.settings.inlineContainer) {
        var P = window.pageXOffset, D = window.pageYOffset, R = r.left + i * r.width - u / 2 + this.settings.inlineOffsetX + P, N = r.top + n * r.height - l / 2 + this.settings.inlineOffsetY + D;
        this.settings.containInline && (R < r.left + P ? R = r.left + P : R + u > r.left + r.width + P && (R = r.left + r.width - u + P), N < r.top + D ? N = r.top + D : N + l > r.top + r.height + D && (N = r.top + r.height - l + D)), this.el.style.left = "".concat(R, "px"), this.el.style.top = "".concat(N, "px");
      }
      this.settings.showWhitespaceAtEdges || (h > w ? h = w : h < L && (h = L), g > I ? g = I : g < f && (g = f)), this.imgEl.style.transform = "translate(".concat(h, "px, ").concat(g, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(h, "px, ").concat(g, "px)");
    } }, { key: "_removeListenersAndResetClasses", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses);
    } }, { key: "show", value: function(i, n, r) {
      this._removeListenersAndResetClasses(), this.isShowing = true, xt(this.el, this.openClasses), this.imgEl.getAttribute("src") != i && (xt(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad), this._setImageURL(i)), this._setImageSize(n, r), this._isInline ? this._showInline() : this._showInContainer(), this.HAS_ANIMATION && (this.el.addEventListener("animationend", this._completeShow), this.el.addEventListener("webkitAnimationEnd", this._completeShow), xt(this.el, this.openingClasses));
    } }, { key: "_showInline", value: function() {
      this.settings.inlineContainer.appendChild(this.el), xt(this.el, this.inlineClasses);
    } }, { key: "_showInContainer", value: function() {
      this.settings.container.appendChild(this.el);
    } }, { key: "hide", value: function() {
      this._removeListenersAndResetClasses(), this.isShowing = false, this.HAS_ANIMATION ? (this.el.addEventListener("animationend", this._completeHide), this.el.addEventListener("webkitAnimationEnd", this._completeHide), xt(this.el, this.closingClasses)) : (gt(this.el, this.openClasses), gt(this.el, this.inlineClasses));
    } }, { key: "_completeShow", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), gt(this.el, this.openingClasses);
    } }, { key: "_completeHide", value: function() {
      this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses), gt(this.el, this.inlineClasses), this.el.style.left = "", this.el.style.top = "", this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el);
    } }, { key: "_handleLoad", value: function() {
      this.imgEl.removeEventListener("load", this._handleLoad), gt(this.el, this.loadingClasses);
    } }, { key: "_isInline", get: function() {
      var i = this.settings.inline;
      return i === true || typeof i == "number" && window.innerWidth <= i;
    } }]), e;
  })();
  function ey(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function ty(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function iy(e, t, i) {
    return t && ty(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var ct = (function() {
    function e(t) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (ey(this, e), this.VERSION = "1.5.1", this.triggerEl = t, this.destroy = this.destroy.bind(this), !sr(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
      var n = i.namespace || null, r = i.showWhitespaceAtEdges || false, o = i.containInline || false, c = i.inlineOffsetX || 0, u = i.inlineOffsetY || 0, l = i.inlineContainer || document.body, m = i.sourceAttribute || "data-zoom", v = i.zoomFactor || 3, y = i.paneContainer === void 0 ? document.body : i.paneContainer, E = i.inlinePane || 375, h = "handleTouch" in i ? !!i.handleTouch : true, g = i.onShow || null, C = i.onHide || null, _ = "injectBaseStyles" in i ? !!i.injectBaseStyles : true, p = i.hoverDelay || 0, S = i.touchDelay || 0, w = i.hoverBoundingBox || false, I = i.touchBoundingBox || false, L = i.boundingBoxContainer || document.body, f = i.passive || false;
      if (E !== true && !sr(y)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
      if (!sr(l)) throw new TypeError("`inlineContainer` must be a DOM element");
      this.settings = { namespace: n, showWhitespaceAtEdges: r, containInline: o, inlineOffsetX: c, inlineOffsetY: u, inlineContainer: l, sourceAttribute: m, zoomFactor: v, paneContainer: y, inlinePane: E, handleTouch: h, onShow: g, onHide: C, injectBaseStyles: _, hoverDelay: p, touchDelay: S, hoverBoundingBox: w, touchBoundingBox: I, boundingBoxContainer: L, passive: f }, this.settings.injectBaseStyles && Bv(), this._buildZoomPane(), this._buildTrigger();
    }
    return iy(e, [{ key: "_buildZoomPane", value: function() {
      this.zoomPane = new Jv({ container: this.settings.paneContainer, zoomFactor: this.settings.zoomFactor, showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges, containInline: this.settings.containInline, inline: this.settings.inlinePane, namespace: this.settings.namespace, inlineOffsetX: this.settings.inlineOffsetX, inlineOffsetY: this.settings.inlineOffsetY, inlineContainer: this.settings.inlineContainer });
    } }, { key: "_buildTrigger", value: function() {
      this.trigger = new Uv({ el: this.triggerEl, zoomPane: this.zoomPane, handleTouch: this.settings.handleTouch, onShow: this.settings.onShow, onHide: this.settings.onHide, sourceAttribute: this.settings.sourceAttribute, hoverDelay: this.settings.hoverDelay, touchDelay: this.settings.touchDelay, hoverBoundingBox: this.settings.hoverBoundingBox, touchBoundingBox: this.settings.touchBoundingBox, namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, boundingBoxContainer: this.settings.boundingBoxContainer, passive: this.settings.passive });
    } }, { key: "setZoomImageURL", value: function(i) {
      this.zoomPane._setImageURL(i);
    } }, { key: "disable", value: function() {
      this.trigger.enabled = false;
    } }, { key: "enable", value: function() {
      this.trigger.enabled = true;
    } }, { key: "destroy", value: function() {
      this.trigger._hide(), this.trigger._unbindEvents();
    } }, { key: "isShowing", get: function() {
      return this.zoomPane.isShowing;
    } }, { key: "zoomFactor", get: function() {
      return this.settings.zoomFactor;
    }, set: function(i) {
      this.settings.zoomFactor = i, this.zoomPane.settings.zoomFactor = i, this.trigger.settings.zoomFactor = i, this.boundingBox.settings.zoomFactor = i;
    } }]), e;
  })();
  Object.defineProperty(ct.prototype, "isShowing", { get: function() {
    return this.isShowing;
  } });
  Object.defineProperty(ct.prototype, "zoomFactor", { get: function() {
    return this.zoomFactor;
  }, set: function(t) {
    this.zoomFactor = t;
  } });
  ct.prototype.setZoomImageURL = ct.prototype.setZoomImageURL;
  ct.prototype.disable = ct.prototype.disable;
  ct.prototype.enable = ct.prototype.enable;
  ct.prototype.destroy = ct.prototype.destroy;
  window.Drift = ct;
  var Ma = "1.3.25";
  function Ql(e, t, i) {
    return Math.max(e, Math.min(t, i));
  }
  function ny(e, t, i) {
    return (1 - i) * e + i * t;
  }
  function sy(e, t, i, n) {
    return ny(e, t, 1 - Math.exp(-i * n));
  }
  function ry(e, t) {
    return (e % t + t) % t;
  }
  var oy = class {
    constructor() {
      ie(this, "isRunning", false);
      ie(this, "value", 0);
      ie(this, "from", 0);
      ie(this, "to", 0);
      ie(this, "currentTime", 0);
      ie(this, "lerp");
      ie(this, "duration");
      ie(this, "easing");
      ie(this, "onUpdate");
    }
    advance(e) {
      var i;
      if (!this.isRunning) return;
      let t = false;
      if (this.duration && this.easing) {
        this.currentTime += e;
        const n = Ql(0, this.currentTime / this.duration, 1);
        t = n >= 1;
        const r = t ? 1 : this.easing(n);
        this.value = this.from + (this.to - this.from) * r;
      } else this.lerp ? (this.value = sy(this.value, this.to, this.lerp * 60, e), Math.round(this.value) === Math.round(this.to) && (this.value = this.to, t = true)) : (this.value = this.to, t = true);
      t && this.stop(), (i = this.onUpdate) == null || i.call(this, this.value, t);
    }
    stop() {
      this.isRunning = false;
    }
    fromTo(e, t, { lerp: i, duration: n, easing: r, onStart: o, onUpdate: c }) {
      this.from = this.value = e, this.to = t, this.lerp = i, this.duration = n, this.easing = r, this.currentTime = 0, this.isRunning = true, o == null || o(), this.onUpdate = c;
    }
  };
  function ay(e, t) {
    let i;
    return function(...n) {
      clearTimeout(i), i = setTimeout(() => {
        i = void 0, e.apply(this, n);
      }, t);
    };
  }
  var ly = class {
    constructor(e, t, { autoResize: i = true, debounce: n = 250 } = {}) {
      ie(this, "width", 0);
      ie(this, "height", 0);
      ie(this, "scrollHeight", 0);
      ie(this, "scrollWidth", 0);
      ie(this, "debouncedResize");
      ie(this, "wrapperResizeObserver");
      ie(this, "contentResizeObserver");
      ie(this, "resize", () => {
        this.onWrapperResize(), this.onContentResize();
      });
      ie(this, "onWrapperResize", () => {
        this.wrapper instanceof Window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
      });
      ie(this, "onContentResize", () => {
        this.wrapper instanceof Window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
      });
      this.wrapper = e, this.content = t, i && (this.debouncedResize = ay(this.resize, n), this.wrapper instanceof Window ? window.addEventListener("resize", this.debouncedResize) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
    destroy() {
      var e, t;
      (e = this.wrapperResizeObserver) == null || e.disconnect(), (t = this.contentResizeObserver) == null || t.disconnect(), this.wrapper === window && this.debouncedResize && window.removeEventListener("resize", this.debouncedResize);
    }
    get limit() {
      return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
  }, Jl = class {
    constructor() {
      ie(this, "events", {});
    }
    emit(e, ...t) {
      var n;
      const i = this.events[e] || [];
      for (let r = 0, o = i.length; r < o; r++) (n = i[r]) == null || n.call(i, ...t);
    }
    on(e, t) {
      return this.events[e] ? this.events[e].push(t) : this.events[e] = [t], () => {
        var i;
        this.events[e] = (i = this.events[e]) == null ? void 0 : i.filter((n) => t !== n);
      };
    }
    off(e, t) {
      var i;
      this.events[e] = (i = this.events[e]) == null ? void 0 : i.filter((n) => t !== n);
    }
    destroy() {
      this.events = {};
    }
  };
  const cy = 100 / 6, Nt = { passive: false };
  function La(e, t) {
    return e === 1 ? cy : e === 2 ? t : 1;
  }
  var uy = class {
    constructor(e, t = { wheelMultiplier: 1, touchMultiplier: 1 }) {
      ie(this, "touchStart", { x: 0, y: 0 });
      ie(this, "lastDelta", { x: 0, y: 0 });
      ie(this, "window", { width: 0, height: 0 });
      ie(this, "emitter", new Jl());
      ie(this, "onTouchStart", (e2) => {
        const { clientX: t2, clientY: i } = e2.targetTouches ? e2.targetTouches[0] : e2;
        this.touchStart.x = t2, this.touchStart.y = i, this.lastDelta = { x: 0, y: 0 }, this.emitter.emit("scroll", { deltaX: 0, deltaY: 0, event: e2 });
      });
      ie(this, "onTouchMove", (e2) => {
        const { clientX: t2, clientY: i } = e2.targetTouches ? e2.targetTouches[0] : e2, n = -(t2 - this.touchStart.x) * this.options.touchMultiplier, r = -(i - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = t2, this.touchStart.y = i, this.lastDelta = { x: n, y: r }, this.emitter.emit("scroll", { deltaX: n, deltaY: r, event: e2 });
      });
      ie(this, "onTouchEnd", (e2) => {
        this.emitter.emit("scroll", { deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: e2 });
      });
      ie(this, "onWheel", (e2) => {
        let { deltaX: t2, deltaY: i, deltaMode: n } = e2;
        const r = La(n, this.window.width), o = La(n, this.window.height);
        t2 *= r, i *= o, t2 *= this.options.wheelMultiplier, i *= this.options.wheelMultiplier, this.emitter.emit("scroll", { deltaX: t2, deltaY: i, event: e2 });
      });
      ie(this, "onWindowResize", () => {
        this.window = { width: window.innerWidth, height: window.innerHeight };
      });
      this.element = e, this.options = t, window.addEventListener("resize", this.onWindowResize), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, Nt), this.element.addEventListener("touchstart", this.onTouchStart, Nt), this.element.addEventListener("touchmove", this.onTouchMove, Nt), this.element.addEventListener("touchend", this.onTouchEnd, Nt);
    }
    on(e, t) {
      return this.emitter.on(e, t);
    }
    destroy() {
      this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize), this.element.removeEventListener("wheel", this.onWheel, Nt), this.element.removeEventListener("touchstart", this.onTouchStart, Nt), this.element.removeEventListener("touchmove", this.onTouchMove, Nt), this.element.removeEventListener("touchend", this.onTouchEnd, Nt);
    }
  };
  const Pa = (e) => Math.min(1, 1.001 - Me(2, -10 * e));
  var dy = class {
    constructor({ wrapper: e = window, content: t = document.documentElement, eventsTarget: i = e, smoothWheel: n = true, syncTouch: r = false, syncTouchLerp: o = 0.075, touchInertiaExponent: c = 1.7, duration: u, easing: l, lerp: m = 0.1, infinite: v = false, orientation: y = "vertical", gestureOrientation: E = y === "horizontal" ? "both" : "vertical", touchMultiplier: h = 1, wheelMultiplier: g = 1, autoResize: C = true, prevent: _, virtualScroll: p, overscroll: S = true, autoRaf: w = false, anchors: I = false, autoToggle: L = false, allowNestedScroll: f = false, __experimental__naiveDimensions: P = false, naiveDimensions: D = P, stopInertiaOnNavigate: R = false } = {}) {
      ie(this, "_isScrolling", false);
      ie(this, "_isStopped", false);
      ie(this, "_isLocked", false);
      ie(this, "_preventNextNativeScrollEvent", false);
      ie(this, "_resetVelocityTimeout", null);
      ie(this, "_rafId", null);
      ie(this, "_isDraggingSelection", false);
      ie(this, "isTouching");
      ie(this, "isIos");
      ie(this, "time", 0);
      ie(this, "userData", {});
      ie(this, "lastVelocity", 0);
      ie(this, "velocity", 0);
      ie(this, "direction", 0);
      ie(this, "options");
      ie(this, "targetScroll");
      ie(this, "animatedScroll");
      ie(this, "animate", new oy());
      ie(this, "emitter", new Jl());
      ie(this, "dimensions");
      ie(this, "virtualScroll");
      ie(this, "onScrollEnd", (e2) => {
        e2 instanceof CustomEvent || (this.isScrolling === "smooth" || this.isScrolling === false) && e2.stopPropagation();
      });
      ie(this, "dispatchScrollendEvent", () => {
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", { bubbles: this.options.wrapper === window, detail: { lenisScrollEnd: true } }));
      });
      ie(this, "onTransitionEnd", (e2) => {
        var t2;
        (t2 = e2.propertyName) != null && t2.includes("overflow") && e2.target === this.rootElement && this.checkOverflow();
      });
      ie(this, "onClick", (e2) => {
        const t2 = e2.composedPath().filter((n2) => n2 instanceof HTMLAnchorElement && n2.href).map((n2) => new URL(n2.href)), i2 = new URL(window.location.href);
        if (this.options.anchors) {
          const n2 = t2.find((r2) => i2.host === r2.host && i2.pathname === r2.pathname && r2.hash);
          if (n2) {
            const r2 = typeof this.options.anchors == "object" && this.options.anchors ? this.options.anchors : void 0, o2 = decodeURIComponent(n2.hash);
            this.scrollTo(o2, r2);
            return;
          }
        }
        if (this.options.stopInertiaOnNavigate && t2.some((n2) => i2.host === n2.host && i2.pathname !== n2.pathname)) {
          this.reset();
          return;
        }
      });
      ie(this, "onPointerDown", (e2) => {
        e2.button === 1 && this.reset();
      });
      ie(this, "onVirtualScroll", (e2) => {
        if (typeof this.options.virtualScroll == "function" && this.options.virtualScroll(e2) === false) return;
        const { deltaX: t2, deltaY: i2, event: n2 } = e2;
        if (this.emitter.emit("virtual-scroll", { deltaX: t2, deltaY: i2, event: n2 }), n2.ctrlKey || n2.lenisStopPropagation) return;
        const r2 = n2.type.includes("touch"), o2 = n2.type.includes("wheel");
        if (r2 && this.isIos && (n2.type === "touchstart" && (this._isDraggingSelection = this.isTouchOnSelectionHandle(n2)), this._isDraggingSelection)) {
          n2.type === "touchend" && (this._isDraggingSelection = false);
          return;
        }
        this.isTouching = n2.type === "touchstart" || n2.type === "touchmove";
        const c2 = t2 === 0 && i2 === 0;
        if (this.options.syncTouch && r2 && n2.type === "touchstart" && c2 && !this.isStopped && !this.isLocked) {
          this.reset();
          return;
        }
        const u2 = this.options.gestureOrientation === "vertical" && i2 === 0 || this.options.gestureOrientation === "horizontal" && t2 === 0;
        if (c2 || u2) return;
        let l2 = n2.composedPath();
        l2 = l2.slice(0, l2.indexOf(this.rootElement));
        const m2 = this.options.prevent, v2 = Math.abs(t2) >= Math.abs(i2) ? "horizontal" : "vertical";
        if (l2.find((g2) => {
          var C2, _2, p2, S2, w2;
          return g2 instanceof HTMLElement && (typeof m2 == "function" && (m2 == null ? void 0 : m2(g2)) || ((C2 = g2.hasAttribute) == null ? void 0 : C2.call(g2, "data-lenis-prevent")) || v2 === "vertical" && ((_2 = g2.hasAttribute) == null ? void 0 : _2.call(g2, "data-lenis-prevent-vertical")) || v2 === "horizontal" && ((p2 = g2.hasAttribute) == null ? void 0 : p2.call(g2, "data-lenis-prevent-horizontal")) || r2 && ((S2 = g2.hasAttribute) == null ? void 0 : S2.call(g2, "data-lenis-prevent-touch")) || o2 && ((w2 = g2.hasAttribute) == null ? void 0 : w2.call(g2, "data-lenis-prevent-wheel")) || this.options.allowNestedScroll && this.hasNestedScroll(g2, { deltaX: t2, deltaY: i2 }));
        })) return;
        if (this.isStopped || this.isLocked) {
          n2.cancelable && n2.preventDefault();
          return;
        }
        if (!(this.options.syncTouch && r2 || this.options.smoothWheel && o2)) {
          this.isScrolling = "native", this.animate.stop(), n2.lenisStopPropagation = true;
          return;
        }
        let y2 = i2;
        this.options.gestureOrientation === "both" ? y2 = Math.abs(i2) > Math.abs(t2) ? i2 : t2 : this.options.gestureOrientation === "horizontal" && (y2 = t2), (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && i2 > 0 || this.animatedScroll === this.limit && i2 < 0)) && (n2.lenisStopPropagation = true), n2.cancelable && n2.preventDefault();
        const E2 = r2 && this.options.syncTouch, h2 = r2 && n2.type === "touchend";
        h2 && (y2 = Math.sign(y2) * Me(Math.abs(this.velocity), this.options.touchInertiaExponent)), this.scrollTo(this.targetScroll + y2, Ae({ programmatic: false }, E2 ? { lerp: h2 ? this.options.syncTouchLerp : 1 } : { lerp: this.options.lerp, duration: this.options.duration, easing: this.options.easing }));
      });
      ie(this, "onNativeScroll", () => {
        if (this._resetVelocityTimeout !== null && (clearTimeout(this._resetVelocityTimeout), this._resetVelocityTimeout = null), this._preventNextNativeScrollEvent) {
          this._preventNextNativeScrollEvent = false;
          return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
          const e2 = this.animatedScroll;
          this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity, this.velocity = this.animatedScroll - e2, this.direction = Math.sign(this.animatedScroll - e2), this.isStopped || (this.isScrolling = "native"), this.emit(), this.velocity !== 0 && (this._resetVelocityTimeout = setTimeout(() => {
            this.lastVelocity = this.velocity, this.velocity = 0, this.isScrolling = false, this.emit();
          }, 400));
        }
      });
      ie(this, "raf", (e2) => {
        const t2 = e2 - (this.time || e2);
        this.time = e2, this.animate.advance(t2 * 1e-3), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
      });
      window.lenisVersion = Ma, window.lenis || (window.lenis = {}), window.lenis.version = Ma, y === "horizontal" && (window.lenis.horizontal = true), r === true && (window.lenis.touch = true), this.isIos = /(iPad|iPhone|iPod)/g.test(navigator.userAgent), (!e || e === document.documentElement) && (e = window), typeof u == "number" && typeof l != "function" ? l = Pa : typeof l == "function" && typeof u != "number" && (u = 1), this.options = { wrapper: e, content: t, eventsTarget: i, smoothWheel: n, syncTouch: r, syncTouchLerp: o, touchInertiaExponent: c, duration: u, easing: l, lerp: m, infinite: v, gestureOrientation: E, orientation: y, touchMultiplier: h, wheelMultiplier: g, autoResize: C, prevent: _, virtualScroll: p, overscroll: S, autoRaf: w, anchors: I, autoToggle: L, allowNestedScroll: f, naiveDimensions: D, stopInertiaOnNavigate: R }, this.dimensions = new ly(e, t, { autoResize: C }), this.updateClassName(), this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll), this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, { capture: true }), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.addEventListener("click", this.onClick), this.options.wrapper.addEventListener("pointerdown", this.onPointerDown), this.virtualScroll = new uy(i, { touchMultiplier: h, wheelMultiplier: g }), this.virtualScroll.on("scroll", this.onVirtualScroll), this.options.autoToggle && (this.checkOverflow(), this.rootElement.addEventListener("transitionend", this.onTransitionEnd)), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
    }
    destroy() {
      this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll), this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, { capture: true }), this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.removeEventListener("click", this.onClick), this.virtualScroll.destroy(), this.dimensions.destroy(), this.cleanUpClassName(), this._rafId && cancelAnimationFrame(this._rafId);
    }
    on(e, t) {
      return this.emitter.on(e, t);
    }
    off(e, t) {
      return this.emitter.off(e, t);
    }
    get overflow() {
      const e = this.isHorizontal ? "overflow-x" : "overflow-y";
      return getComputedStyle(this.rootElement)[e];
    }
    checkOverflow() {
      ["hidden", "clip"].includes(this.overflow) ? this.internalStop() : this.internalStart();
    }
    setScroll(e) {
      this.isHorizontal ? this.options.wrapper.scrollTo({ left: e, behavior: "instant" }) : this.options.wrapper.scrollTo({ top: e, behavior: "instant" });
    }
    isTouchOnSelectionHandle(e) {
      var m;
      const t = window.getSelection();
      if (!t || t.isCollapsed || t.rangeCount === 0) return false;
      const i = (m = e.targetTouches[0]) != null ? m : e.changedTouches[0];
      if (!i) return false;
      const n = t.getRangeAt(0).getClientRects();
      if (n.length === 0) return false;
      const r = n[0], o = n[n.length - 1], c = 40, u = Math.hypot(i.clientX - r.left, i.clientY - r.top) <= c, l = Math.hypot(i.clientX - o.right, i.clientY - o.bottom) <= c;
      return u || l;
    }
    resize() {
      this.dimensions.resize(), this.animatedScroll = this.targetScroll = this.actualScroll, this.emit();
    }
    emit() {
      this.emitter.emit("scroll", this);
    }
    reset() {
      this.isLocked = false, this.isScrolling = false, this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity = 0, this.animate.stop();
    }
    start() {
      if (this.isStopped) {
        if (this.options.autoToggle) {
          this.rootElement.style.removeProperty("overflow");
          return;
        }
        this.internalStart();
      }
    }
    internalStart() {
      this.isStopped && (this.reset(), this.isStopped = false, this.emit());
    }
    stop() {
      if (!this.isStopped) {
        if (this.options.autoToggle) {
          this.rootElement.style.setProperty("overflow", "clip");
          return;
        }
        this.internalStop();
      }
    }
    internalStop() {
      this.isStopped || (this.reset(), this.isStopped = true, this.emit());
    }
    scrollTo(e, { offset: t = 0, immediate: i = false, lock: n = false, programmatic: r = true, lerp: o = r ? this.options.lerp : void 0, duration: c = r ? this.options.duration : void 0, easing: u = r ? this.options.easing : void 0, onStart: l, onComplete: m, force: v = false, userData: y } = {}) {
      if ((this.isStopped || this.isLocked) && !v) return;
      let E = e, h = t;
      if (typeof E == "string" && ["top", "left", "start", "#"].includes(E)) E = 0;
      else if (typeof E == "string" && ["bottom", "right", "end"].includes(E)) E = this.limit;
      else {
        let g = null;
        if (typeof E == "string" ? (g = E.startsWith("#") ? document.getElementById(E.slice(1)) : document.querySelector(E), g || (E === "#top" ? E = 0 : console.warn("Lenis: Target not found", E))) : E instanceof HTMLElement && (E != null && E.nodeType) && (g = E), g) {
          if (this.options.wrapper !== window) {
            const I = this.rootElement.getBoundingClientRect();
            h -= this.isHorizontal ? I.left : I.top;
          }
          const C = g.getBoundingClientRect(), _ = getComputedStyle(g), p = this.isHorizontal ? Number.parseFloat(_.scrollMarginLeft) : Number.parseFloat(_.scrollMarginTop), S = getComputedStyle(this.rootElement), w = this.isHorizontal ? Number.parseFloat(S.scrollPaddingLeft) : Number.parseFloat(S.scrollPaddingTop);
          E = (this.isHorizontal ? C.left : C.top) + this.animatedScroll - (Number.isNaN(p) ? 0 : p) - (Number.isNaN(w) ? 0 : w);
        }
      }
      if (typeof E == "number") {
        if (E += h, this.options.infinite) {
          if (r) {
            this.targetScroll = this.animatedScroll = this.scroll;
            const g = E - this.animatedScroll;
            g > this.limit / 2 ? E -= this.limit : g < -this.limit / 2 && (E += this.limit);
          }
        } else E = Ql(0, E, this.limit);
        if (E === this.targetScroll) {
          l == null || l(this), m == null || m(this);
          return;
        }
        if (this.userData = y != null ? y : {}, i) {
          this.animatedScroll = this.targetScroll = E, this.setScroll(this.scroll), this.reset(), this.preventNextNativeScrollEvent(), this.emit(), m == null || m(this), this.userData = {}, requestAnimationFrame(() => {
            this.dispatchScrollendEvent();
          });
          return;
        }
        r || (this.targetScroll = E), typeof c == "number" && typeof u != "function" ? u = Pa : typeof u == "function" && typeof c != "number" && (c = 1), this.animate.fromTo(this.animatedScroll, E, { duration: c, easing: u, lerp: o, onStart: () => {
          n && (this.isLocked = true), this.isScrolling = "smooth", l == null || l(this);
        }, onUpdate: (g, C) => {
          this.isScrolling = "smooth", this.lastVelocity = this.velocity, this.velocity = g - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = g, this.setScroll(this.scroll), r && (this.targetScroll = g), C || this.emit(), C && (this.reset(), this.emit(), m == null || m(this), this.userData = {}, requestAnimationFrame(() => {
            this.dispatchScrollendEvent();
          }), this.preventNextNativeScrollEvent());
        } });
      }
    }
    preventNextNativeScrollEvent() {
      this._preventNextNativeScrollEvent = true, requestAnimationFrame(() => {
        this._preventNextNativeScrollEvent = false;
      });
    }
    hasNestedScroll(e, { deltaX: t, deltaY: i }) {
      var f;
      const n = Date.now();
      e._lenis || (e._lenis = {});
      const r = e._lenis;
      let o, c, u, l, m, v, y, E, h, g;
      if (n - ((f = r.time) != null ? f : 0) > 2e3) {
        r.time = Date.now();
        const P = window.getComputedStyle(e);
        if (r.computedStyle = P, o = ["auto", "overlay", "scroll"].includes(P.overflowX), c = ["auto", "overlay", "scroll"].includes(P.overflowY), m = ["auto"].includes(P.overscrollBehaviorX), v = ["auto"].includes(P.overscrollBehaviorY), r.hasOverflowX = o, r.hasOverflowY = c, !(o || c)) return false;
        y = e.scrollWidth, E = e.scrollHeight, h = e.clientWidth, g = e.clientHeight, u = y > h, l = E > g, r.isScrollableX = u, r.isScrollableY = l, r.scrollWidth = y, r.scrollHeight = E, r.clientWidth = h, r.clientHeight = g, r.hasOverscrollBehaviorX = m, r.hasOverscrollBehaviorY = v;
      } else u = r.isScrollableX, l = r.isScrollableY, o = r.hasOverflowX, c = r.hasOverflowY, y = r.scrollWidth, E = r.scrollHeight, h = r.clientWidth, g = r.clientHeight, m = r.hasOverscrollBehaviorX, v = r.hasOverscrollBehaviorY;
      if (!(o && u || c && l)) return false;
      const C = Math.abs(t) >= Math.abs(i) ? "horizontal" : "vertical";
      let _, p, S, w, I, L;
      if (C === "horizontal") _ = Math.round(e.scrollLeft), p = y - h, S = t, w = o, I = u, L = m;
      else if (C === "vertical") _ = Math.round(e.scrollTop), p = E - g, S = i, w = c, I = l, L = v;
      else return false;
      return !L && (_ >= p || _ <= 0) ? true : (S > 0 ? _ < p : _ > 0) && w && I;
    }
    get rootElement() {
      return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
      return this.options.naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
      return this.options.orientation === "horizontal";
    }
    get actualScroll() {
      var t, i;
      const e = this.options.wrapper;
      return this.isHorizontal ? (t = e.scrollX) != null ? t : e.scrollLeft : (i = e.scrollY) != null ? i : e.scrollTop;
    }
    get scroll() {
      return this.options.infinite ? ry(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    get progress() {
      return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    get isScrolling() {
      return this._isScrolling;
    }
    set isScrolling(e) {
      this._isScrolling !== e && (this._isScrolling = e, this.updateClassName());
    }
    get isStopped() {
      return this._isStopped;
    }
    set isStopped(e) {
      this._isStopped !== e && (this._isStopped = e, this.updateClassName());
    }
    get isLocked() {
      return this._isLocked;
    }
    set isLocked(e) {
      this._isLocked !== e && (this._isLocked = e, this.updateClassName());
    }
    get isSmooth() {
      return this.isScrolling === "smooth";
    }
    get className() {
      let e = "lenis";
      return this.options.autoToggle && (e += " lenis-autoToggle"), this.isStopped && (e += " lenis-stopped"), this.isLocked && (e += " lenis-locked"), this.isScrolling && (e += " lenis-scrolling"), this.isScrolling === "smooth" && (e += " lenis-smooth"), e;
    }
    updateClassName() {
      this.cleanUpClassName(), this.className.split(" ").forEach((e) => {
        this.rootElement.classList.add(e);
      });
    }
    cleanUpClassName() {
      for (const e of Array.from(this.rootElement.classList)) (e === "lenis" || e.startsWith("lenis-")) && this.rootElement.classList.remove(e);
    }
  };
  window.Lenis = dy;
  var rr = { exports: {} };
  var Da;
  function fy() {
    return Da || (Da = 1, (function(e, t) {
      (function() {
        function i(l) {
          if (typeof l == "undefined") throw new Error('Pathformer [constructor]: "element" parameter is required');
          if (l.constructor === String && (l = document.getElementById(l), !l)) throw new Error('Pathformer [constructor]: "element" parameter is not related to an existing ID');
          if (l instanceof window.SVGElement || l instanceof window.SVGGElement || /^svg$/i.test(l.nodeName)) this.el = l;
          else throw new Error('Pathformer [constructor]: "element" parameter must be a string or a SVGelement');
          this.scan(l);
        }
        i.prototype.TYPES = ["line", "ellipse", "circle", "polygon", "polyline", "rect"], i.prototype.ATTR_WATCH = ["cx", "cy", "points", "r", "rx", "ry", "x", "x1", "x2", "y", "y1", "y2"], i.prototype.scan = function(l) {
          for (var m, v, y, E, h = l.querySelectorAll(this.TYPES.join(",")), g = 0; g < h.length; g++) v = h[g], m = this[v.tagName.toLowerCase() + "ToPath"], y = m(this.parseAttr(v.attributes)), E = this.pathMaker(v, y), v.parentNode.replaceChild(E, v);
        }, i.prototype.lineToPath = function(l) {
          var m = {}, v = l.x1 || 0, y = l.y1 || 0, E = l.x2 || 0, h = l.y2 || 0;
          return m.d = "M" + v + "," + y + "L" + E + "," + h, m;
        }, i.prototype.rectToPath = function(l) {
          var m = {}, v = parseFloat(l.x) || 0, y = parseFloat(l.y) || 0, E = parseFloat(l.width) || 0, h = parseFloat(l.height) || 0;
          if (l.rx || l.ry) {
            var g = parseInt(l.rx, 10) || -1, C = parseInt(l.ry, 10) || -1;
            g = Math.min(Math.max(g < 0 ? C : g, 0), E / 2), C = Math.min(Math.max(C < 0 ? g : C, 0), h / 2), m.d = "M " + (v + g) + "," + y + " L " + (v + E - g) + "," + y + " A " + g + "," + C + ",0,0,1," + (v + E) + "," + (y + C) + " L " + (v + E) + "," + (y + h - C) + " A " + g + "," + C + ",0,0,1," + (v + E - g) + "," + (y + h) + " L " + (v + g) + "," + (y + h) + " A " + g + "," + C + ",0,0,1," + v + "," + (y + h - C) + " L " + v + "," + (y + C) + " A " + g + "," + C + ",0,0,1," + (v + g) + "," + y;
          } else m.d = "M" + v + " " + y + " L" + (v + E) + " " + y + " L" + (v + E) + " " + (y + h) + " L" + v + " " + (y + h) + " Z";
          return m;
        }, i.prototype.polylineToPath = function(l) {
          var m = {}, v = l.points.trim().split(" "), y, E;
          if (l.points.indexOf(",") === -1) {
            var h = [];
            for (y = 0; y < v.length; y += 2) h.push(v[y] + "," + v[y + 1]);
            v = h;
          }
          for (E = "M" + v[0], y = 1; y < v.length; y++) v[y].indexOf(",") !== -1 && (E += "L" + v[y]);
          return m.d = E, m;
        }, i.prototype.polygonToPath = function(l) {
          var m = i.prototype.polylineToPath(l);
          return m.d += "Z", m;
        }, i.prototype.ellipseToPath = function(l) {
          var m = {}, v = parseFloat(l.rx) || 0, y = parseFloat(l.ry) || 0, E = parseFloat(l.cx) || 0, h = parseFloat(l.cy) || 0, g = E - v, C = h, _ = parseFloat(E) + parseFloat(v), p = h;
          return m.d = "M" + g + "," + C + "A" + v + "," + y + " 0,1,1 " + _ + "," + p + "A" + v + "," + y + " 0,1,1 " + g + "," + p, m;
        }, i.prototype.circleToPath = function(l) {
          var m = {}, v = parseFloat(l.r) || 0, y = parseFloat(l.cx) || 0, E = parseFloat(l.cy) || 0, h = y - v, g = E, C = parseFloat(y) + parseFloat(v), _ = E;
          return m.d = "M" + h + "," + g + "A" + v + "," + v + " 0,1,1 " + C + "," + _ + "A" + v + "," + v + " 0,1,1 " + h + "," + _, m;
        }, i.prototype.pathMaker = function(l, m) {
          var v, y, E = document.createElementNS("http://www.w3.org/2000/svg", "path");
          for (v = 0; v < l.attributes.length; v++) y = l.attributes[v], this.ATTR_WATCH.indexOf(y.name) === -1 && E.setAttribute(y.name, y.value);
          for (v in m) E.setAttribute(v, m[v]);
          return E;
        }, i.prototype.parseAttr = function(l) {
          for (var m, v = {}, y = 0; y < l.length; y++) {
            if (m = l[y], this.ATTR_WATCH.indexOf(m.name) !== -1 && m.value.indexOf("%") !== -1) throw new Error("Pathformer [parseAttr]: a SVG shape got values in percentage. This cannot be transformed into 'path' tags. Please use 'viewBox'.");
            v[m.name] = m.value;
          }
          return v;
        };
        var n, r, o, c;
        function u(l, m, v) {
          n(), this.isReady = false, this.setElement(l, m), this.setOptions(m), this.setCallback(v), this.isReady && this.init();
        }
        u.LINEAR = function(l) {
          return l;
        }, u.EASE = function(l) {
          return -Math.cos(l * Math.PI) / 2 + 0.5;
        }, u.EASE_OUT = function(l) {
          return 1 - Math.pow(1 - l, 3);
        }, u.EASE_IN = function(l) {
          return Math.pow(l, 3);
        }, u.EASE_OUT_BOUNCE = function(l) {
          var m = -Math.cos(l * (0.5 * Math.PI)) + 1, v = Math.pow(m, 1.5), y = Math.pow(1 - l, 2), E = -Math.abs(Math.cos(v * (2.5 * Math.PI))) + 1;
          return 1 - y + E * y;
        }, u.prototype.setElement = function(l, m) {
          var v, y;
          if (typeof l == "undefined") throw new Error('Vivus [constructor]: "element" parameter is required');
          if (l.constructor === String && (l = document.getElementById(l), !l)) throw new Error('Vivus [constructor]: "element" parameter is not related to an existing ID');
          if (this.parentEl = l, m && m.file) {
            y = this, v = function() {
              var h = document.createElement("div");
              h.innerHTML = this.responseText;
              var g = h.querySelector("svg");
              if (!g) throw new Error("Vivus [load]: Cannot find the SVG in the loaded file : " + m.file);
              y.el = g, y.el.setAttribute("width", "100%"), y.el.setAttribute("height", "100%"), y.parentEl.appendChild(y.el), y.isReady = true, y.init(), y = null;
            };
            var E = new window.XMLHttpRequest();
            E.addEventListener("load", v), E.open("GET", m.file), E.send();
            return;
          }
          switch (l.constructor) {
            case window.SVGSVGElement:
            case window.SVGElement:
            case window.SVGGElement:
              this.el = l, this.isReady = true;
              break;
            case window.HTMLObjectElement:
              y = this, v = function(h) {
                if (!y.isReady) {
                  if (y.el = l.contentDocument && l.contentDocument.querySelector("svg"), !y.el && h) throw new Error("Vivus [constructor]: object loaded does not contain any SVG");
                  y.el && (l.getAttribute("built-by-vivus") && (y.parentEl.insertBefore(y.el, l), y.parentEl.removeChild(l), y.el.setAttribute("width", "100%"), y.el.setAttribute("height", "100%")), y.isReady = true, y.init(), y = null);
                }
              }, v() || l.addEventListener("load", v);
              break;
            default:
              throw new Error('Vivus [constructor]: "element" parameter is not valid (or miss the "file" attribute)');
          }
        }, u.prototype.setOptions = function(l) {
          var m = ["delayed", "sync", "async", "nsync", "oneByOne", "scenario", "scenario-sync"], v = ["inViewport", "manual", "autostart"];
          if (l !== void 0 && l.constructor !== Object) throw new Error('Vivus [constructor]: "options" parameter must be an object');
          if (l = l || {}, l.type && m.indexOf(l.type) === -1) throw new Error("Vivus [constructor]: " + l.type + " is not an existing animation `type`");
          if (this.type = l.type || m[0], l.start && v.indexOf(l.start) === -1) throw new Error("Vivus [constructor]: " + l.start + " is not an existing `start` option");
          if (this.start = l.start || v[0], this.isIE = window.navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf("Trident/") !== -1 || window.navigator.userAgent.indexOf("Edge/") !== -1, this.duration = c(l.duration, 120), this.delay = c(l.delay, null), this.dashGap = c(l.dashGap, 1), this.forceRender = l.hasOwnProperty("forceRender") ? !!l.forceRender : this.isIE, this.reverseStack = !!l.reverseStack, this.selfDestroy = !!l.selfDestroy, this.onReady = l.onReady, this.map = [], this.frameLength = this.currentFrame = this.delayUnit = this.speed = this.handle = null, this.ignoreInvisible = l.hasOwnProperty("ignoreInvisible") ? !!l.ignoreInvisible : false, this.animTimingFunction = l.animTimingFunction || u.LINEAR, this.pathTimingFunction = l.pathTimingFunction || u.LINEAR, this.delay >= this.duration) throw new Error("Vivus [constructor]: delay must be shorter than duration");
        }, u.prototype.setCallback = function(l) {
          if (l && l.constructor !== Function) throw new Error('Vivus [constructor]: "callback" parameter must be a function');
          this.callback = l || function() {
          };
        }, u.prototype.mapping = function() {
          var l, m, v, y, E, h, g, C, _, p;
          for (C = h = g = 0, m = this.el.querySelectorAll("path"), p = false, l = 0; l < m.length; l++) if (v = m[l], !this.isInvisible(v)) {
            if (E = { el: v, length: 0, startAt: 0, duration: 0, isResizeSensitive: false }, v.getAttribute("vector-effect") === "non-scaling-stroke") {
              var S = v.getBoundingClientRect(), w = v.getBBox();
              _ = Math.max(S.width / w.width, S.height / w.height), E.isResizeSensitive = true, p = true;
            } else _ = 1;
            if (E.length = Math.ceil(v.getTotalLength() * _), isNaN(E.length)) {
              window.console && console.warn && console.warn("Vivus [mapping]: cannot retrieve a path element length", v);
              continue;
            }
            this.map.push(E), v.style.strokeDasharray = E.length + " " + (E.length + this.dashGap * 2), v.style.strokeDashoffset = E.length + this.dashGap, E.length += this.dashGap, h += E.length, this.renderPath(l);
          }
          for (p && console.warn("Vivus: this SVG contains non-scaling-strokes. You should call instance.recalc() when the SVG is resized or you will encounter unwanted behaviour. See https://github.com/maxwellito/vivus#non-scaling for more info."), h = h === 0 ? 1 : h, this.delay = this.delay === null ? this.duration / 3 : this.delay, this.delayUnit = this.delay / (m.length > 1 ? m.length - 1 : 1), this.reverseStack && this.map.reverse(), l = 0; l < this.map.length; l++) {
            switch (E = this.map[l], this.type) {
              case "delayed":
                E.startAt = this.delayUnit * l, E.duration = this.duration - this.delay;
                break;
              case "oneByOne":
                E.startAt = g / h * this.duration, E.duration = E.length / h * this.duration;
                break;
              case "sync":
              case "async":
              case "nsync":
                E.startAt = 0, E.duration = this.duration;
                break;
              case "scenario-sync":
                v = E.el, y = this.parseAttr(v), E.startAt = C + (c(y["data-delay"], this.delayUnit) || 0), E.duration = c(y["data-duration"], this.duration), C = y["data-async"] !== void 0 ? E.startAt : E.startAt + E.duration, this.frameLength = Math.max(this.frameLength, E.startAt + E.duration);
                break;
              case "scenario":
                v = E.el, y = this.parseAttr(v), E.startAt = c(y["data-start"], this.delayUnit) || 0, E.duration = c(y["data-duration"], this.duration), this.frameLength = Math.max(this.frameLength, E.startAt + E.duration);
                break;
            }
            g += E.length, this.frameLength = this.frameLength || this.duration;
          }
        }, u.prototype.recalc = function() {
          this.mustRecalcScale || (this.mustRecalcScale = r((function() {
            this.performLineRecalc();
          }).bind(this)));
        }, u.prototype.performLineRecalc = function() {
          for (var l, m, v, y, E, h = 0; h < this.map.length; h++) l = this.map[h], l.isResizeSensitive && (m = l.el, v = m.getBoundingClientRect(), y = m.getBBox(), E = Math.max(v.width / y.width, v.height / y.height), l.length = Math.ceil(m.getTotalLength() * E), m.style.strokeDasharray = l.length + " " + (l.length + this.dashGap * 2));
          this.trace(), this.mustRecalcScale = null;
        }, u.prototype.draw = function() {
          var l = this;
          if (this.currentFrame += this.speed, this.currentFrame <= 0) this.stop(), this.reset();
          else if (this.currentFrame >= this.frameLength) this.stop(), this.currentFrame = this.frameLength, this.trace(), this.selfDestroy && this.destroy();
          else {
            this.trace(), this.handle = r(function() {
              l.draw();
            });
            return;
          }
          this.callback(this), this.instanceCallback && (this.instanceCallback(this), this.instanceCallback = null);
        }, u.prototype.trace = function() {
          var l, m, v, y;
          for (y = this.animTimingFunction(this.currentFrame / this.frameLength) * this.frameLength, l = 0; l < this.map.length; l++) v = this.map[l], m = (y - v.startAt) / v.duration, m = this.pathTimingFunction(Math.max(0, Math.min(1, m))), v.progress !== m && (v.progress = m, v.el.style.strokeDashoffset = Math.floor(v.length * (1 - m)), this.renderPath(l));
        }, u.prototype.renderPath = function(l) {
          if (this.forceRender && this.map && this.map[l]) {
            var m = this.map[l], v = m.el.cloneNode(true);
            m.el.parentNode.replaceChild(v, m.el), m.el = v;
          }
        }, u.prototype.init = function() {
          this.frameLength = 0, this.currentFrame = 0, this.map = [], new i(this.el), this.mapping(), this.starter(), this.onReady && this.onReady(this);
        }, u.prototype.starter = function() {
          switch (this.start) {
            case "manual":
              return;
            case "autostart":
              this.play();
              break;
            case "inViewport":
              var l = this, m = function() {
                l.isInViewport(l.parentEl, 1) && (l.play(), window.removeEventListener("scroll", m));
              };
              window.addEventListener("scroll", m), m();
              break;
          }
        }, u.prototype.getStatus = function() {
          return this.currentFrame === 0 ? "start" : this.currentFrame === this.frameLength ? "end" : "progress";
        }, u.prototype.reset = function() {
          return this.setFrameProgress(0);
        }, u.prototype.finish = function() {
          return this.setFrameProgress(1);
        }, u.prototype.setFrameProgress = function(l) {
          return l = Math.min(1, Math.max(0, l)), this.currentFrame = Math.round(this.frameLength * l), this.trace(), this;
        }, u.prototype.play = function(l, m) {
          if (this.instanceCallback = null, l && typeof l == "function") this.instanceCallback = l, l = null;
          else if (l && typeof l != "number") throw new Error("Vivus [play]: invalid speed");
          return m && typeof m == "function" && !this.instanceCallback && (this.instanceCallback = m), this.speed = l || 1, this.handle || this.draw(), this;
        }, u.prototype.stop = function() {
          return this.handle && (o(this.handle), this.handle = null), this;
        }, u.prototype.destroy = function() {
          this.stop();
          var l, m;
          for (l = 0; l < this.map.length; l++) m = this.map[l], m.el.style.strokeDashoffset = null, m.el.style.strokeDasharray = null, this.renderPath(l);
        }, u.prototype.isInvisible = function(l) {
          var m, v = l.getAttribute("data-ignore");
          return v !== null ? v !== "false" : this.ignoreInvisible ? (m = l.getBoundingClientRect(), !m.width && !m.height) : false;
        }, u.prototype.parseAttr = function(l) {
          var m, v = {};
          if (l && l.attributes) for (var y = 0; y < l.attributes.length; y++) m = l.attributes[y], v[m.name] = m.value;
          return v;
        }, u.prototype.isInViewport = function(l, m) {
          var v = this.scrollY(), y = v + this.getViewportH(), E = l.getBoundingClientRect(), h = E.height, g = v + E.top, C = g + h;
          return m = m || 0, g + h * m <= y && C >= v;
        }, u.prototype.getViewportH = function() {
          var l = this.docElem.clientHeight, m = window.innerHeight;
          return l < m ? m : l;
        }, u.prototype.scrollY = function() {
          return window.pageYOffset || this.docElem.scrollTop;
        }, n = function() {
          u.prototype.docElem || (u.prototype.docElem = window.document.documentElement, r = (function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(l) {
              return window.setTimeout(l, 1e3 / 60);
            };
          })(), o = (function() {
            return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || function(l) {
              return window.clearTimeout(l);
            };
          })());
        }, c = function(l, m) {
          var v = parseInt(l, 10);
          return v >= 0 ? v : m;
        }, e.exports = u;
      })();
    })(rr)), rr.exports;
  }
  var hy = fy();
  const py = Yl(hy);
  window.GSP = window.GSP || {};
  window.GSP.Vivus = py;
})();
